{
  "iconDefinitions": {
    "_file": { "iconPath": "../../icons/default_file.svg" },
    "_folder": { "iconPath": "../../icons/default_folder.svg" },
    "_folder_open": { "iconPath": "../../icons/default_folder_opened.svg" },
    "_root_folder": { "iconPath": "../../icons/default_root_folder.svg" },
    "_root_folder_open": { "iconPath": "../../icons/default_root_folder_opened.svg" },
    "_file_light": { "iconPath": "" },
    "_folder_light": { "iconPath": "" },
    "_folder_light_open": { "iconPath": "" },
    "_root_folder_light": { "iconPath": "" },
    "_root_folder_light_open": { "iconPath": "" },
    "_fd_android": { "iconPath": "../../icons/folder_type_android.svg" },
    "_fd_android_open": { "iconPath": "../../icons/folder_type_android_opened.svg" },
    "_fd_angular": { "iconPath": "../../icons/folder_type_angular.svg" },
    "_fd_angular_open": { "iconPath": "../../icons/folder_type_angular_opened.svg" },
    "_fd_apache": { "iconPath": "../../icons/folder_type_apache.svg" },
    "_fd_apache_open": { "iconPath": "../../icons/folder_type_apache_opened.svg" },
    "_fd_api": { "iconPath": "../../icons/folder_type_api.svg" },
    "_fd_api_open": { "iconPath": "../../icons/folder_type_api_opened.svg" },
    "_fd_app": { "iconPath": "../../icons/folder_type_app.svg" },
    "_fd_app_open": { "iconPath": "../../icons/folder_type_app_opened.svg" },
    "_fd_arangodb": { "iconPath": "../../icons/folder_type_arangodb.svg" },
    "_fd_arangodb_open": { "iconPath": "../../icons/folder_type_arangodb_opened.svg" },
    "_fd_asset": { "iconPath": "../../icons/folder_type_asset.svg" },
    "_fd_asset_open": { "iconPath": "../../icons/folder_type_asset_opened.svg" },
    "_fd_astro": { "iconPath": "../../icons/folder_type_astro.svg" },
    "_fd_astro_open": { "iconPath": "../../icons/folder_type_astro_opened.svg" },
    "_fd_audio": { "iconPath": "../../icons/folder_type_audio.svg" },
    "_fd_audio_open": { "iconPath": "../../icons/folder_type_audio_opened.svg" },
    "_fd_aurelia": { "iconPath": "../../icons/folder_type_aurelia.svg" },
    "_fd_aurelia_open": { "iconPath": "../../icons/folder_type_aurelia_opened.svg" },
    "_fd_aws": { "iconPath": "../../icons/folder_type_aws.svg" },
    "_fd_aws_open": { "iconPath": "../../icons/folder_type_aws_opened.svg" },
    "_fd_azure": { "iconPath": "../../icons/folder_type_azure.svg" },
    "_fd_azure_open": { "iconPath": "../../icons/folder_type_azure_opened.svg" },
    "_fd_azurepipelines": { "iconPath": "../../icons/folder_type_azurepipelines.svg" },
    "_fd_azurepipelines_open": { "iconPath": "../../icons/folder_type_azurepipelines_opened.svg" },
    "_fd_binary": { "iconPath": "../../icons/folder_type_binary.svg" },
    "_fd_binary_open": { "iconPath": "../../icons/folder_type_binary_opened.svg" },
    "_fd_bloc": { "iconPath": "../../icons/folder_type_bloc.svg" },
    "_fd_bloc_open": { "iconPath": "../../icons/folder_type_bloc_opened.svg" },
    "_fd_blueprint": { "iconPath": "../../icons/folder_type_blueprint.svg" },
    "_fd_blueprint_open": { "iconPath": "../../icons/folder_type_blueprint_opened.svg" },
    "_fd_bot": { "iconPath": "../../icons/folder_type_bot.svg" },
    "_fd_bot_open": { "iconPath": "../../icons/folder_type_bot_opened.svg" },
    "_fd_bower": { "iconPath": "../../icons/folder_type_bower.svg" },
    "_fd_bower_open": { "iconPath": "../../icons/folder_type_bower_opened.svg" },
    "_fd_buildkite": { "iconPath": "../../icons/folder_type_buildkite.svg" },
    "_fd_buildkite_open": { "iconPath": "../../icons/folder_type_buildkite_opened.svg" },
    "_fd_cake": { "iconPath": "../../icons/folder_type_cake.svg" },
    "_fd_cake_open": { "iconPath": "../../icons/folder_type_cake_opened.svg" },
    "_fd_cargo": { "iconPath": "../../icons/folder_type_cargo.svg" },
    "_fd_cargo_open": { "iconPath": "../../icons/folder_type_cargo_opened.svg" },
    "_fd_certificate": { "iconPath": "../../icons/folder_type_certificate.svg" },
    "_fd_certificate_open": { "iconPath": "../../icons/folder_type_certificate_opened.svg" },
    "_fd_changesets": { "iconPath": "../../icons/folder_type_changesets.svg" },
    "_fd_changesets_open": { "iconPath": "../../icons/folder_type_changesets_opened.svg" },
    "_fd_chef": { "iconPath": "../../icons/folder_type_chef.svg" },
    "_fd_chef_open": { "iconPath": "../../icons/folder_type_chef_opened.svg" },
    "_fd_circleci": { "iconPath": "../../icons/folder_type_circleci.svg" },
    "_fd_circleci_open": { "iconPath": "../../icons/folder_type_circleci_opened.svg" },
    "_fd_claude": { "iconPath": "../../icons/folder_type_claude.svg" },
    "_fd_claude_open": { "iconPath": "../../icons/folder_type_claude_opened.svg" },
    "_fd_cli": { "iconPath": "../../icons/folder_type_cli.svg" },
    "_fd_cli_open": { "iconPath": "../../icons/folder_type_cli_opened.svg" },
    "_fd_client": { "iconPath": "../../icons/folder_type_client.svg" },
    "_fd_client_open": { "iconPath": "../../icons/folder_type_client_opened.svg" },
    "_fd_cloudflare": { "iconPath": "../../icons/folder_type_cloudflare.svg" },
    "_fd_cloudflare_open": { "iconPath": "../../icons/folder_type_cloudflare_opened.svg" },
    "_fd_cmake": { "iconPath": "../../icons/folder_type_cmake.svg" },
    "_fd_cmake_open": { "iconPath": "../../icons/folder_type_cmake_opened.svg" },
    "_fd_common": { "iconPath": "../../icons/folder_type_common.svg" },
    "_fd_common_open": { "iconPath": "../../icons/folder_type_common_opened.svg" },
    "_fd_component": { "iconPath": "../../icons/folder_type_component.svg" },
    "_fd_component_open": { "iconPath": "../../icons/folder_type_component_opened.svg" },
    "_fd_composer": { "iconPath": "../../icons/folder_type_composer.svg" },
    "_fd_composer_open": { "iconPath": "../../icons/folder_type_composer_opened.svg" },
    "_fd_config": { "iconPath": "../../icons/folder_type_config.svg" },
    "_fd_config_open": { "iconPath": "../../icons/folder_type_config_opened.svg" },
    "_fd_controller": { "iconPath": "../../icons/folder_type_controller.svg" },
    "_fd_controller_open": { "iconPath": "../../icons/folder_type_controller_opened.svg" },
    "_fd_coverage": { "iconPath": "../../icons/folder_type_coverage.svg" },
    "_fd_coverage_open": { "iconPath": "../../icons/folder_type_coverage_opened.svg" },
    "_fd_css": { "iconPath": "../../icons/folder_type_css.svg" },
    "_fd_css_open": { "iconPath": "../../icons/folder_type_css_opened.svg" },
    "_fd_cubit": { "iconPath": "../../icons/folder_type_cubit.svg" },
    "_fd_cubit_open": { "iconPath": "../../icons/folder_type_cubit_opened.svg" },
    "_fd_cursor": { "iconPath": "../../icons/folder_type_cursor.svg" },
    "_fd_cursor_open": { "iconPath": "../../icons/folder_type_cursor_opened.svg" },
    "_fd_light_cursor": { "iconPath": "../../icons/folder_type_light_cursor.svg" },
    "_fd_light_cursor_open": { "iconPath": "../../icons/folder_type_light_cursor_opened.svg" },
    "_fd_cypress": { "iconPath": "../../icons/folder_type_cypress.svg" },
    "_fd_cypress_open": { "iconPath": "../../icons/folder_type_cypress_opened.svg" },
    "_fd_light_cypress": { "iconPath": "../../icons/folder_type_light_cypress.svg" },
    "_fd_light_cypress_open": { "iconPath": "../../icons/folder_type_light_cypress_opened.svg" },
    "_fd_dapr": { "iconPath": "../../icons/folder_type_dapr.svg" },
    "_fd_dapr_open": { "iconPath": "../../icons/folder_type_dapr_opened.svg" },
    "_fd_dart": { "iconPath": "../../icons/folder_type_dart.svg" },
    "_fd_dart_open": { "iconPath": "../../icons/folder_type_dart_opened.svg" },
    "_fd_datadog": { "iconPath": "../../icons/folder_type_datadog.svg" },
    "_fd_datadog_open": { "iconPath": "../../icons/folder_type_datadog_opened.svg" },
    "_fd_db": { "iconPath": "../../icons/folder_type_db.svg" },
    "_fd_db_open": { "iconPath": "../../icons/folder_type_db_opened.svg" },
    "_fd_debian": { "iconPath": "../../icons/folder_type_debian.svg" },
    "_fd_debian_open": { "iconPath": "../../icons/folder_type_debian_opened.svg" },
    "_fd_dependabot": { "iconPath": "../../icons/folder_type_dependabot.svg" },
    "_fd_dependabot_open": { "iconPath": "../../icons/folder_type_dependabot_opened.svg" },
    "_fd_devcontainer": { "iconPath": "../../icons/folder_type_devcontainer.svg" },
    "_fd_devcontainer_open": { "iconPath": "../../icons/folder_type_devcontainer_opened.svg" },
    "_fd_dist": { "iconPath": "../../icons/folder_type_dist.svg" },
    "_fd_dist_open": { "iconPath": "../../icons/folder_type_dist_opened.svg" },
    "_fd_docker": { "iconPath": "../../icons/folder_type_docker.svg" },
    "_fd_docker_open": { "iconPath": "../../icons/folder_type_docker_opened.svg" },
    "_fd_docs": { "iconPath": "../../icons/folder_type_docs.svg" },
    "_fd_docs_open": { "iconPath": "../../icons/folder_type_docs_opened.svg" },
    "_fd_e2e": { "iconPath": "../../icons/folder_type_e2e.svg" },
    "_fd_e2e_open": { "iconPath": "../../icons/folder_type_e2e_opened.svg" },
    "_fd_elasticbeanstalk": { "iconPath": "../../icons/folder_type_elasticbeanstalk.svg" },
    "_fd_elasticbeanstalk_open": {
      "iconPath": "../../icons/folder_type_elasticbeanstalk_opened.svg"
    },
    "_fd_electron": { "iconPath": "../../icons/folder_type_electron.svg" },
    "_fd_electron_open": { "iconPath": "../../icons/folder_type_electron_opened.svg" },
    "_fd_light_electron": { "iconPath": "../../icons/folder_type_light_electron.svg" },
    "_fd_light_electron_open": { "iconPath": "../../icons/folder_type_light_electron_opened.svg" },
    "_fd_expo": { "iconPath": "../../icons/folder_type_expo.svg" },
    "_fd_expo_open": { "iconPath": "../../icons/folder_type_expo_opened.svg" },
    "_fd_light_expo": { "iconPath": "../../icons/folder_type_light_expo.svg" },
    "_fd_light_expo_open": { "iconPath": "../../icons/folder_type_light_expo_opened.svg" },
    "_fd_favicon": { "iconPath": "../../icons/folder_type_favicon.svg" },
    "_fd_favicon_open": { "iconPath": "../../icons/folder_type_favicon_opened.svg" },
    "_fd_flow": { "iconPath": "../../icons/folder_type_flow.svg" },
    "_fd_flow_open": { "iconPath": "../../icons/folder_type_flow_opened.svg" },
    "_fd_flutter": { "iconPath": "../../icons/folder_type_flutter.svg" },
    "_fd_flutter_open": { "iconPath": "../../icons/folder_type_flutter_opened.svg" },
    "_fd_fonts": { "iconPath": "../../icons/folder_type_fonts.svg" },
    "_fd_fonts_open": { "iconPath": "../../icons/folder_type_fonts_opened.svg" },
    "_fd_light_fonts": { "iconPath": "../../icons/folder_type_light_fonts.svg" },
    "_fd_light_fonts_open": { "iconPath": "../../icons/folder_type_light_fonts_opened.svg" },
    "_fd_frontcommerce": { "iconPath": "../../icons/folder_type_frontcommerce.svg" },
    "_fd_frontcommerce_open": { "iconPath": "../../icons/folder_type_frontcommerce_opened.svg" },
    "_fd_gcp": { "iconPath": "../../icons/folder_type_gcp.svg" },
    "_fd_gcp_open": { "iconPath": "../../icons/folder_type_gcp_opened.svg" },
    "_fd_gemini": { "iconPath": "../../icons/folder_type_gemini.svg" },
    "_fd_gemini_open": { "iconPath": "../../icons/folder_type_gemini_opened.svg" },
    "_fd_git": { "iconPath": "../../icons/folder_type_git.svg" },
    "_fd_git_open": { "iconPath": "../../icons/folder_type_git_opened.svg" },
    "_fd_github": { "iconPath": "../../icons/folder_type_github.svg" },
    "_fd_github_open": { "iconPath": "../../icons/folder_type_github_opened.svg" },
    "_fd_gitlab": { "iconPath": "../../icons/folder_type_gitlab.svg" },
    "_fd_gitlab_open": { "iconPath": "../../icons/folder_type_gitlab_opened.svg" },
    "_fd_godot": { "iconPath": "../../icons/folder_type_godot.svg" },
    "_fd_godot_open": { "iconPath": "../../icons/folder_type_godot_opened.svg" },
    "_fd_gradle": { "iconPath": "../../icons/folder_type_gradle.svg" },
    "_fd_gradle_open": { "iconPath": "../../icons/folder_type_gradle_opened.svg" },
    "_fd_light_gradle": { "iconPath": "../../icons/folder_type_light_gradle.svg" },
    "_fd_light_gradle_open": { "iconPath": "../../icons/folder_type_light_gradle_opened.svg" },
    "_fd_graphql": { "iconPath": "../../icons/folder_type_graphql.svg" },
    "_fd_graphql_open": { "iconPath": "../../icons/folder_type_graphql_opened.svg" },
    "_fd_grunt": { "iconPath": "../../icons/folder_type_grunt.svg" },
    "_fd_grunt_open": { "iconPath": "../../icons/folder_type_grunt_opened.svg" },
    "_fd_gulp": { "iconPath": "../../icons/folder_type_gulp.svg" },
    "_fd_gulp_open": { "iconPath": "../../icons/folder_type_gulp_opened.svg" },
    "_fd_haxelib": { "iconPath": "../../icons/folder_type_haxelib.svg" },
    "_fd_haxelib_open": { "iconPath": "../../icons/folder_type_haxelib_opened.svg" },
    "_fd_helper": { "iconPath": "../../icons/folder_type_helper.svg" },
    "_fd_helper_open": { "iconPath": "../../icons/folder_type_helper_opened.svg" },
    "_fd_histoire": { "iconPath": "../../icons/folder_type_histoire.svg" },
    "_fd_histoire_open": { "iconPath": "../../icons/folder_type_histoire_opened.svg" },
    "_fd_hook": { "iconPath": "../../icons/folder_type_hook.svg" },
    "_fd_hook_open": { "iconPath": "../../icons/folder_type_hook_opened.svg" },
    "_fd_husky": { "iconPath": "../../icons/folder_type_husky.svg" },
    "_fd_husky_open": { "iconPath": "../../icons/folder_type_husky_opened.svg" },
    "_fd_idea": { "iconPath": "../../icons/folder_type_idea.svg" },
    "_fd_idea_open": { "iconPath": "../../icons/folder_type_idea_opened.svg" },
    "_fd_images": { "iconPath": "../../icons/folder_type_images.svg" },
    "_fd_images_open": { "iconPath": "../../icons/folder_type_images_opened.svg" },
    "_fd_include": { "iconPath": "../../icons/folder_type_include.svg" },
    "_fd_include_open": { "iconPath": "../../icons/folder_type_include_opened.svg" },
    "_fd_interfaces": { "iconPath": "../../icons/folder_type_interfaces.svg" },
    "_fd_interfaces_open": { "iconPath": "../../icons/folder_type_interfaces_opened.svg" },
    "_fd_ios": { "iconPath": "../../icons/folder_type_ios.svg" },
    "_fd_ios_open": { "iconPath": "../../icons/folder_type_ios_opened.svg" },
    "_fd_js": { "iconPath": "../../icons/folder_type_js.svg" },
    "_fd_js_open": { "iconPath": "../../icons/folder_type_js_opened.svg" },
    "_fd_json": { "iconPath": "../../icons/folder_type_json.svg" },
    "_fd_json_open": { "iconPath": "../../icons/folder_type_json_opened.svg" },
    "_fd_junie": { "iconPath": "../../icons/folder_type_junie.svg" },
    "_fd_junie_open": { "iconPath": "../../icons/folder_type_junie_opened.svg" },
    "_fd_kotlin": { "iconPath": "../../icons/folder_type_kotlin.svg" },
    "_fd_kotlin_open": { "iconPath": "../../icons/folder_type_kotlin_opened.svg" },
    "_fd_kubernetes": { "iconPath": "../../icons/folder_type_kubernetes.svg" },
    "_fd_kubernetes_open": { "iconPath": "../../icons/folder_type_kubernetes_opened.svg" },
    "_fd_less": { "iconPath": "../../icons/folder_type_less.svg" },
    "_fd_less_open": { "iconPath": "../../icons/folder_type_less_opened.svg" },
    "_fd_library": { "iconPath": "../../icons/folder_type_library.svg" },
    "_fd_library_open": { "iconPath": "../../icons/folder_type_library_opened.svg" },
    "_fd_linux": { "iconPath": "../../icons/folder_type_linux.svg" },
    "_fd_linux_open": { "iconPath": "../../icons/folder_type_linux_opened.svg" },
    "_fd_locale": { "iconPath": "../../icons/folder_type_locale.svg" },
    "_fd_locale_open": { "iconPath": "../../icons/folder_type_locale_opened.svg" },
    "_fd_log": { "iconPath": "../../icons/folder_type_log.svg" },
    "_fd_log_open": { "iconPath": "../../icons/folder_type_log_opened.svg" },
    "_fd_macos": { "iconPath": "../../icons/folder_type_macos.svg" },
    "_fd_macos_open": { "iconPath": "../../icons/folder_type_macos_opened.svg" },
    "_fd_mariadb": { "iconPath": "../../icons/folder_type_mariadb.svg" },
    "_fd_mariadb_open": { "iconPath": "../../icons/folder_type_mariadb_opened.svg" },
    "_fd_maven": { "iconPath": "../../icons/folder_type_maven.svg" },
    "_fd_maven_open": { "iconPath": "../../icons/folder_type_maven_opened.svg" },
    "_fd_mediawiki": { "iconPath": "../../icons/folder_type_mediawiki.svg" },
    "_fd_mediawiki_open": { "iconPath": "../../icons/folder_type_mediawiki_opened.svg" },
    "_fd_memcached": { "iconPath": "../../icons/folder_type_memcached.svg" },
    "_fd_memcached_open": { "iconPath": "../../icons/folder_type_memcached_opened.svg" },
    "_fd_meteor": { "iconPath": "../../icons/folder_type_meteor.svg" },
    "_fd_meteor_open": { "iconPath": "../../icons/folder_type_meteor_opened.svg" },
    "_fd_light_meteor": { "iconPath": "../../icons/folder_type_light_meteor.svg" },
    "_fd_light_meteor_open": { "iconPath": "../../icons/folder_type_light_meteor_opened.svg" },
    "_fd_middleware": { "iconPath": "../../icons/folder_type_middleware.svg" },
    "_fd_middleware_open": { "iconPath": "../../icons/folder_type_middleware_opened.svg" },
    "_fd_minecraft": { "iconPath": "../../icons/folder_type_minecraft.svg" },
    "_fd_minecraft_open": { "iconPath": "../../icons/folder_type_minecraft_opened.svg" },
    "_fd_minikube": { "iconPath": "../../icons/folder_type_minikube.svg" },
    "_fd_minikube_open": { "iconPath": "../../icons/folder_type_minikube_opened.svg" },
    "_fd_mjml": { "iconPath": "../../icons/folder_type_mjml.svg" },
    "_fd_mjml_open": { "iconPath": "../../icons/folder_type_mjml_opened.svg" },
    "_fd_mock": { "iconPath": "../../icons/folder_type_mock.svg" },
    "_fd_mock_open": { "iconPath": "../../icons/folder_type_mock_opened.svg" },
    "_fd_model": { "iconPath": "../../icons/folder_type_model.svg" },
    "_fd_model_open": { "iconPath": "../../icons/folder_type_model_opened.svg" },
    "_fd_module": { "iconPath": "../../icons/folder_type_module.svg" },
    "_fd_module_open": { "iconPath": "../../icons/folder_type_module_opened.svg" },
    "_fd_mojo": { "iconPath": "../../icons/folder_type_mojo.svg" },
    "_fd_mojo_open": { "iconPath": "../../icons/folder_type_mojo_opened.svg" },
    "_fd_mongodb": { "iconPath": "../../icons/folder_type_mongodb.svg" },
    "_fd_mongodb_open": { "iconPath": "../../icons/folder_type_mongodb_opened.svg" },
    "_fd_mypy": { "iconPath": "../../icons/folder_type_mypy.svg" },
    "_fd_mypy_open": { "iconPath": "../../icons/folder_type_mypy_opened.svg" },
    "_fd_light_mypy": { "iconPath": "../../icons/folder_type_light_mypy.svg" },
    "_fd_light_mypy_open": { "iconPath": "../../icons/folder_type_light_mypy_opened.svg" },
    "_fd_mysql": { "iconPath": "../../icons/folder_type_mysql.svg" },
    "_fd_mysql_open": { "iconPath": "../../icons/folder_type_mysql_opened.svg" },
    "_fd_light_mysql": { "iconPath": "../../icons/folder_type_light_mysql.svg" },
    "_fd_light_mysql_open": { "iconPath": "../../icons/folder_type_light_mysql_opened.svg" },
    "_fd_netlify": { "iconPath": "../../icons/folder_type_netlify.svg" },
    "_fd_netlify_open": { "iconPath": "../../icons/folder_type_netlify_opened.svg" },
    "_fd_next": { "iconPath": "../../icons/folder_type_next.svg" },
    "_fd_next_open": { "iconPath": "../../icons/folder_type_next_opened.svg" },
    "_fd_nginx": { "iconPath": "../../icons/folder_type_nginx.svg" },
    "_fd_nginx_open": { "iconPath": "../../icons/folder_type_nginx_opened.svg" },
    "_fd_nix": { "iconPath": "../../icons/folder_type_nix.svg" },
    "_fd_nix_open": { "iconPath": "../../icons/folder_type_nix_opened.svg" },
    "_fd_node": { "iconPath": "../../icons/folder_type_node.svg" },
    "_fd_node_open": { "iconPath": "../../icons/folder_type_node_opened.svg" },
    "_fd_light_node": { "iconPath": "../../icons/folder_type_light_node.svg" },
    "_fd_light_node_open": { "iconPath": "../../icons/folder_type_light_node_opened.svg" },
    "_fd_notebooks": { "iconPath": "../../icons/folder_type_notebooks.svg" },
    "_fd_notebooks_open": { "iconPath": "../../icons/folder_type_notebooks_opened.svg" },
    "_fd_notification": { "iconPath": "../../icons/folder_type_notification.svg" },
    "_fd_notification_open": { "iconPath": "../../icons/folder_type_notification_opened.svg" },
    "_fd_nuget": { "iconPath": "../../icons/folder_type_nuget.svg" },
    "_fd_nuget_open": { "iconPath": "../../icons/folder_type_nuget_opened.svg" },
    "_fd_nuxt": { "iconPath": "../../icons/folder_type_nuxt.svg" },
    "_fd_nuxt_open": { "iconPath": "../../icons/folder_type_nuxt_opened.svg" },
    "_fd_package": { "iconPath": "../../icons/folder_type_package.svg" },
    "_fd_package_open": { "iconPath": "../../icons/folder_type_package_opened.svg" },
    "_fd_paket": { "iconPath": "../../icons/folder_type_paket.svg" },
    "_fd_paket_open": { "iconPath": "../../icons/folder_type_paket_opened.svg" },
    "_fd_php": { "iconPath": "../../icons/folder_type_php.svg" },
    "_fd_php_open": { "iconPath": "../../icons/folder_type_php_opened.svg" },
    "_fd_platformio": { "iconPath": "../../icons/folder_type_platformio.svg" },
    "_fd_platformio_open": { "iconPath": "../../icons/folder_type_platformio_opened.svg" },
    "_fd_plugin": { "iconPath": "../../icons/folder_type_plugin.svg" },
    "_fd_plugin_open": { "iconPath": "../../icons/folder_type_plugin_opened.svg" },
    "_fd_prisma": { "iconPath": "../../icons/folder_type_prisma.svg" },
    "_fd_prisma_open": { "iconPath": "../../icons/folder_type_prisma_opened.svg" },
    "_fd_private": { "iconPath": "../../icons/folder_type_private.svg" },
    "_fd_private_open": { "iconPath": "../../icons/folder_type_private_opened.svg" },
    "_fd_public": { "iconPath": "../../icons/folder_type_public.svg" },
    "_fd_public_open": { "iconPath": "../../icons/folder_type_public_opened.svg" },
    "_fd_pytest": { "iconPath": "../../icons/folder_type_pytest.svg" },
    "_fd_pytest_open": { "iconPath": "../../icons/folder_type_pytest_opened.svg" },
    "_fd_python": { "iconPath": "../../icons/folder_type_python.svg" },
    "_fd_python_open": { "iconPath": "../../icons/folder_type_python_opened.svg" },
    "_fd_ravendb": { "iconPath": "../../icons/folder_type_ravendb.svg" },
    "_fd_ravendb_open": { "iconPath": "../../icons/folder_type_ravendb_opened.svg" },
    "_fd_redis": { "iconPath": "../../icons/folder_type_redis.svg" },
    "_fd_redis_open": { "iconPath": "../../icons/folder_type_redis_opened.svg" },
    "_fd_redux": { "iconPath": "../../icons/folder_type_redux.svg" },
    "_fd_redux_open": { "iconPath": "../../icons/folder_type_redux_opened.svg" },
    "_fd_light_redux": { "iconPath": "../../icons/folder_type_light_redux.svg" },
    "_fd_light_redux_open": { "iconPath": "../../icons/folder_type_light_redux_opened.svg" },
    "_fd_route": { "iconPath": "../../icons/folder_type_route.svg" },
    "_fd_route_open": { "iconPath": "../../icons/folder_type_route_opened.svg" },
    "_fd_sass": { "iconPath": "../../icons/folder_type_sass.svg" },
    "_fd_sass_open": { "iconPath": "../../icons/folder_type_sass_opened.svg" },
    "_fd_light_sass": { "iconPath": "../../icons/folder_type_light_sass.svg" },
    "_fd_light_sass_open": { "iconPath": "../../icons/folder_type_light_sass_opened.svg" },
    "_fd_script": { "iconPath": "../../icons/folder_type_script.svg" },
    "_fd_script_open": { "iconPath": "../../icons/folder_type_script_opened.svg" },
    "_fd_seedkit": { "iconPath": "../../icons/folder_type_seedkit.svg" },
    "_fd_seedkit_open": { "iconPath": "../../icons/folder_type_seedkit_opened.svg" },
    "_fd_server": { "iconPath": "../../icons/folder_type_server.svg" },
    "_fd_server_open": { "iconPath": "../../icons/folder_type_server_opened.svg" },
    "_fd_services": { "iconPath": "../../icons/folder_type_services.svg" },
    "_fd_services_open": { "iconPath": "../../icons/folder_type_services_opened.svg" },
    "_fd_shared": { "iconPath": "../../icons/folder_type_shared.svg" },
    "_fd_shared_open": { "iconPath": "../../icons/folder_type_shared_opened.svg" },
    "_fd_snaplet": { "iconPath": "../../icons/folder_type_snaplet.svg" },
    "_fd_snaplet_open": { "iconPath": "../../icons/folder_type_snaplet_opened.svg" },
    "_fd_spin": { "iconPath": "../../icons/folder_type_spin.svg" },
    "_fd_spin_open": { "iconPath": "../../icons/folder_type_spin_opened.svg" },
    "_fd_src": { "iconPath": "../../icons/folder_type_src.svg" },
    "_fd_src_open": { "iconPath": "../../icons/folder_type_src_opened.svg" },
    "_fd_sso": { "iconPath": "../../icons/folder_type_sso.svg" },
    "_fd_sso_open": { "iconPath": "../../icons/folder_type_sso_opened.svg" },
    "_fd_story": { "iconPath": "../../icons/folder_type_story.svg" },
    "_fd_story_open": { "iconPath": "../../icons/folder_type_story_opened.svg" },
    "_fd_style": { "iconPath": "../../icons/folder_type_style.svg" },
    "_fd_style_open": { "iconPath": "../../icons/folder_type_style_opened.svg" },
    "_fd_supabase": { "iconPath": "../../icons/folder_type_supabase.svg" },
    "_fd_supabase_open": { "iconPath": "../../icons/folder_type_supabase_opened.svg" },
    "_fd_svelte": { "iconPath": "../../icons/folder_type_svelte.svg" },
    "_fd_svelte_open": { "iconPath": "../../icons/folder_type_svelte_opened.svg" },
    "_fd_tauri": { "iconPath": "../../icons/folder_type_tauri.svg" },
    "_fd_tauri_open": { "iconPath": "../../icons/folder_type_tauri_opened.svg" },
    "_fd_temp": { "iconPath": "../../icons/folder_type_temp.svg" },
    "_fd_temp_open": { "iconPath": "../../icons/folder_type_temp_opened.svg" },
    "_fd_template": { "iconPath": "../../icons/folder_type_template.svg" },
    "_fd_template_open": { "iconPath": "../../icons/folder_type_template_opened.svg" },
    "_fd_test": { "iconPath": "../../icons/folder_type_test.svg" },
    "_fd_test_open": { "iconPath": "../../icons/folder_type_test_opened.svg" },
    "_fd_theme": { "iconPath": "../../icons/folder_type_theme.svg" },
    "_fd_theme_open": { "iconPath": "../../icons/folder_type_theme_opened.svg" },
    "_fd_tools": { "iconPath": "../../icons/folder_type_tools.svg" },
    "_fd_tools_open": { "iconPath": "../../icons/folder_type_tools_opened.svg" },
    "_fd_travis": { "iconPath": "../../icons/folder_type_travis.svg" },
    "_fd_travis_open": { "iconPath": "../../icons/folder_type_travis_opened.svg" },
    "_fd_trunk": { "iconPath": "../../icons/folder_type_trunk.svg" },
    "_fd_trunk_open": { "iconPath": "../../icons/folder_type_trunk_opened.svg" },
    "_fd_turbo": { "iconPath": "../../icons/folder_type_turbo.svg" },
    "_fd_turbo_open": { "iconPath": "../../icons/folder_type_turbo_opened.svg" },
    "_fd_typescript": { "iconPath": "../../icons/folder_type_typescript.svg" },
    "_fd_typescript_open": { "iconPath": "../../icons/folder_type_typescript_opened.svg" },
    "_fd_typings": { "iconPath": "../../icons/folder_type_typings.svg" },
    "_fd_typings_open": { "iconPath": "../../icons/folder_type_typings_opened.svg" },
    "_fd_vagrant": { "iconPath": "../../icons/folder_type_vagrant.svg" },
    "_fd_vagrant_open": { "iconPath": "../../icons/folder_type_vagrant_opened.svg" },
    "_fd_vercel": { "iconPath": "../../icons/folder_type_vercel.svg" },
    "_fd_vercel_open": { "iconPath": "../../icons/folder_type_vercel_opened.svg" },
    "_fd_video": { "iconPath": "../../icons/folder_type_video.svg" },
    "_fd_video_open": { "iconPath": "../../icons/folder_type_video_opened.svg" },
    "_fd_view": { "iconPath": "../../icons/folder_type_view.svg" },
    "_fd_view_open": { "iconPath": "../../icons/folder_type_view_opened.svg" },
    "_fd_vitepress": { "iconPath": "../../icons/folder_type_vitepress.svg" },
    "_fd_vitepress_open": { "iconPath": "../../icons/folder_type_vitepress_opened.svg" },
    "_fd_vs": { "iconPath": "../../icons/folder_type_vs.svg" },
    "_fd_vs_open": { "iconPath": "../../icons/folder_type_vs_opened.svg" },
    "_fd_vscode": { "iconPath": "../../icons/folder_type_vscode.svg" },
    "_fd_vscode_open": { "iconPath": "../../icons/folder_type_vscode_opened.svg" },
    "_fd_vscode_test": { "iconPath": "../../icons/folder_type_vscode_test.svg" },
    "_fd_vscode_test_open": { "iconPath": "../../icons/folder_type_vscode_test_opened.svg" },
    "_fd_wasm": { "iconPath": "../../icons/folder_type_wasm.svg" },
    "_fd_wasm_open": { "iconPath": "../../icons/folder_type_wasm_opened.svg" },
    "_fd_webpack": { "iconPath": "../../icons/folder_type_webpack.svg" },
    "_fd_webpack_open": { "iconPath": "../../icons/folder_type_webpack_opened.svg" },
    "_fd_windows": { "iconPath": "../../icons/folder_type_windows.svg" },
    "_fd_windows_open": { "iconPath": "../../icons/folder_type_windows_opened.svg" },
    "_fd_windsurf": { "iconPath": "../../icons/folder_type_windsurf.svg" },
    "_fd_windsurf_open": { "iconPath": "../../icons/folder_type_windsurf_opened.svg" },
    "_fd_wit": { "iconPath": "../../icons/folder_type_wit.svg" },
    "_fd_wit_open": { "iconPath": "../../icons/folder_type_wit_opened.svg" },
    "_fd_www": { "iconPath": "../../icons/folder_type_www.svg" },
    "_fd_www_open": { "iconPath": "../../icons/folder_type_www_opened.svg" },
    "_fd_yarn": { "iconPath": "../../icons/folder_type_yarn.svg" },
    "_fd_yarn_open": { "iconPath": "../../icons/folder_type_yarn_opened.svg" },
    "_fd_zed": { "iconPath": "../../icons/folder_type_zed.svg" },
    "_fd_zed_open": { "iconPath": "../../icons/folder_type_zed_opened.svg" },
    "_fd_light_zed": { "iconPath": "../../icons/folder_type_light_zed.svg" },
    "_fd_light_zed_open": { "iconPath": "../../icons/folder_type_light_zed_opened.svg" },
    "_f_access": { "iconPath": "../../icons/file_type_access.svg" },
    "_f_actionscript": { "iconPath": "../../icons/file_type_actionscript.svg" },
    "_f_ada": { "iconPath": "../../icons/file_type_ada.svg" },
    "_f_light_ada": { "iconPath": "../../icons/file_type_light_ada.svg" },
    "_f_advpl": { "iconPath": "../../icons/file_type_advpl.svg" },
    "_f_affectscript": { "iconPath": "../../icons/file_type_affectscript.svg" },
    "_f_affinity": { "iconPath": "../../icons/file_type_affinity.svg" },
    "_f_affinitydesigner": { "iconPath": "../../icons/file_type_affinitydesigner.svg" },
    "_f_affinityphoto": { "iconPath": "../../icons/file_type_affinityphoto.svg" },
    "_f_affinitypublisher": { "iconPath": "../../icons/file_type_affinitypublisher.svg" },
    "_f_agda": { "iconPath": "../../icons/file_type_agda.svg" },
    "_f_light_agda": { "iconPath": "../../icons/file_type_light_agda.svg" },
    "_f_agents": { "iconPath": "../../icons/file_type_agents.svg" },
    "_f_light_agents": { "iconPath": "../../icons/file_type_light_agents.svg" },
    "_f_ai": { "iconPath": "../../icons/file_type_ai.svg" },
    "_f_al": { "iconPath": "../../icons/file_type_al.svg" },
    "_f_al_dal": { "iconPath": "../../icons/file_type_al_dal.svg" },
    "_f_alchemy": { "iconPath": "../../icons/file_type_alchemy.svg" },
    "_f_allcontributors": { "iconPath": "../../icons/file_type_allcontributors.svg" },
    "_f_alloy": { "iconPath": "../../icons/file_type_alloy.svg" },
    "_f_allure": { "iconPath": "../../icons/file_type_allure.svg" },
    "_f_angular": { "iconPath": "../../icons/file_type_angular.svg" },
    "_f_ansible": { "iconPath": "../../icons/file_type_ansible.svg" },
    "_f_antlers_html": { "iconPath": "../../icons/file_type_antlers_html.svg" },
    "_f_antlr": { "iconPath": "../../icons/file_type_antlr.svg" },
    "_f_anyscript": { "iconPath": "../../icons/file_type_anyscript.svg" },
    "_f_apache": { "iconPath": "../../icons/file_type_apache.svg" },
    "_f_apex": { "iconPath": "../../icons/file_type_apex.svg" },
    "_f_api_extractor": { "iconPath": "../../icons/file_type_api_extractor.svg" },
    "_f_apib": { "iconPath": "../../icons/file_type_apib.svg" },
    "_f_apl": { "iconPath": "../../icons/file_type_apl.svg" },
    "_f_light_apl": { "iconPath": "../../icons/file_type_light_apl.svg" },
    "_f_applescript": { "iconPath": "../../icons/file_type_applescript.svg" },
    "_f_appscript": { "iconPath": "../../icons/file_type_appscript.svg" },
    "_f_appsemble": { "iconPath": "../../icons/file_type_appsemble.svg" },
    "_f_appveyor": { "iconPath": "../../icons/file_type_appveyor.svg" },
    "_f_arduino": { "iconPath": "../../icons/file_type_arduino.svg" },
    "_f_asciidoc": { "iconPath": "../../icons/file_type_asciidoc.svg" },
    "_f_aseprite": { "iconPath": "../../icons/file_type_aseprite.svg" },
    "_f_asp": { "iconPath": "../../icons/file_type_asp.svg" },
    "_f_aspx": { "iconPath": "../../icons/file_type_aspx.svg" },
    "_f_assembly": { "iconPath": "../../icons/file_type_assembly.svg" },
    "_f_assembly_script": { "iconPath": "../../icons/file_type_assembly_script.svg" },
    "_f_astro": { "iconPath": "../../icons/file_type_astro.svg" },
    "_f_light_astro": { "iconPath": "../../icons/file_type_light_astro.svg" },
    "_f_astroconfig": { "iconPath": "../../icons/file_type_astroconfig.svg" },
    "_f_light_astroconfig": { "iconPath": "../../icons/file_type_light_astroconfig.svg" },
    "_f_atom": { "iconPath": "../../icons/file_type_atom.svg" },
    "_f_ats": { "iconPath": "../../icons/file_type_ats.svg" },
    "_f_attw": { "iconPath": "../../icons/file_type_attw.svg" },
    "_f_audio": { "iconPath": "../../icons/file_type_audio.svg" },
    "_f_aurelia": { "iconPath": "../../icons/file_type_aurelia.svg" },
    "_f_autohotkey": { "iconPath": "../../icons/file_type_autohotkey.svg" },
    "_f_autoit": { "iconPath": "../../icons/file_type_autoit.svg" },
    "_f_avif": { "iconPath": "../../icons/file_type_avif.svg" },
    "_f_avro": { "iconPath": "../../icons/file_type_avro.svg" },
    "_f_awk": { "iconPath": "../../icons/file_type_awk.svg" },
    "_f_aws": { "iconPath": "../../icons/file_type_aws.svg" },
    "_f_azure": { "iconPath": "../../icons/file_type_azure.svg" },
    "_f_azurepipelines": { "iconPath": "../../icons/file_type_azurepipelines.svg" },
    "_f_babel": { "iconPath": "../../icons/file_type_babel.svg" },
    "_f_light_babel": { "iconPath": "../../icons/file_type_light_babel.svg" },
    "_f_bak": { "iconPath": "../../icons/file_type_bak.svg" },
    "_f_ballerina": { "iconPath": "../../icons/file_type_ballerina.svg" },
    "_f_bat": { "iconPath": "../../icons/file_type_bat.svg" },
    "_f_bats": { "iconPath": "../../icons/file_type_bats.svg" },
    "_f_bazaar": { "iconPath": "../../icons/file_type_bazaar.svg" },
    "_f_bazel": { "iconPath": "../../icons/file_type_bazel.svg" },
    "_f_bazel_ignore": { "iconPath": "../../icons/file_type_bazel_ignore.svg" },
    "_f_bazel_version": { "iconPath": "../../icons/file_type_bazel_version.svg" },
    "_f_befunge": { "iconPath": "../../icons/file_type_befunge.svg" },
    "_f_bicep": { "iconPath": "../../icons/file_type_bicep.svg" },
    "_f_biml": { "iconPath": "../../icons/file_type_biml.svg" },
    "_f_binary": { "iconPath": "../../icons/file_type_binary.svg" },
    "_f_biome": { "iconPath": "../../icons/file_type_biome.svg" },
    "_f_bitbucketpipeline": { "iconPath": "../../icons/file_type_bitbucketpipeline.svg" },
    "_f_bithound": { "iconPath": "../../icons/file_type_bithound.svg" },
    "_f_blade": { "iconPath": "../../icons/file_type_blade.svg" },
    "_f_blender": { "iconPath": "../../icons/file_type_blender.svg" },
    "_f_blitzbasic": { "iconPath": "../../icons/file_type_blitzbasic.svg" },
    "_f_bolt": { "iconPath": "../../icons/file_type_bolt.svg" },
    "_f_bosque": { "iconPath": "../../icons/file_type_bosque.svg" },
    "_f_bower": { "iconPath": "../../icons/file_type_bower.svg" },
    "_f_browserslist": { "iconPath": "../../icons/file_type_browserslist.svg" },
    "_f_bruno": { "iconPath": "../../icons/file_type_bruno.svg" },
    "_f_buckbuild": { "iconPath": "../../icons/file_type_buckbuild.svg" },
    "_f_buf": { "iconPath": "../../icons/file_type_buf.svg" },
    "_f_bun": { "iconPath": "../../icons/file_type_bun.svg" },
    "_f_bundlemon": { "iconPath": "../../icons/file_type_bundlemon.svg" },
    "_f_bundler": { "iconPath": "../../icons/file_type_bundler.svg" },
    "_f_bunfig": { "iconPath": "../../icons/file_type_bunfig.svg" },
    "_f_c": { "iconPath": "../../icons/file_type_c.svg" },
    "_f_c3": { "iconPath": "../../icons/file_type_c3.svg" },
    "_f_c_al": { "iconPath": "../../icons/file_type_c_al.svg" },
    "_f_cabal": { "iconPath": "../../icons/file_type_cabal.svg" },
    "_f_caddy": { "iconPath": "../../icons/file_type_caddy.svg" },
    "_f_cake": { "iconPath": "../../icons/file_type_cake.svg" },
    "_f_cakephp": { "iconPath": "../../icons/file_type_cakephp.svg" },
    "_f_capacitor": { "iconPath": "../../icons/file_type_capacitor.svg" },
    "_f_capnp": { "iconPath": "../../icons/file_type_capnp.svg" },
    "_f_cargo": { "iconPath": "../../icons/file_type_cargo.svg" },
    "_f_casc": { "iconPath": "../../icons/file_type_casc.svg" },
    "_f_cddl": { "iconPath": "../../icons/file_type_cddl.svg" },
    "_f_cert": { "iconPath": "../../icons/file_type_cert.svg" },
    "_f_ceylon": { "iconPath": "../../icons/file_type_ceylon.svg" },
    "_f_cf": { "iconPath": "../../icons/file_type_cf.svg" },
    "_f_cfc": { "iconPath": "../../icons/file_type_cfc.svg" },
    "_f_cfm": { "iconPath": "../../icons/file_type_cfm.svg" },
    "_f_changie": { "iconPath": "../../icons/file_type_changie.svg" },
    "_f_cheader": { "iconPath": "../../icons/file_type_cheader.svg" },
    "_f_chef": { "iconPath": "../../icons/file_type_chef.svg" },
    "_f_chef_cookbook": { "iconPath": "../../icons/file_type_chef_cookbook.svg" },
    "_f_circleci": { "iconPath": "../../icons/file_type_circleci.svg" },
    "_f_light_circleci": { "iconPath": "../../icons/file_type_light_circleci.svg" },
    "_f_circom": { "iconPath": "../../icons/file_type_circom.svg" },
    "_f_class": { "iconPath": "../../icons/file_type_class.svg" },
    "_f_claude": { "iconPath": "../../icons/file_type_claude.svg" },
    "_f_clojure": { "iconPath": "../../icons/file_type_clojure.svg" },
    "_f_clojurescript": { "iconPath": "../../icons/file_type_clojurescript.svg" },
    "_f_cloudflare": { "iconPath": "../../icons/file_type_cloudflare.svg" },
    "_f_cloudfoundry": { "iconPath": "../../icons/file_type_cloudfoundry.svg" },
    "_f_light_cloudfoundry": { "iconPath": "../../icons/file_type_light_cloudfoundry.svg" },
    "_f_cmake": { "iconPath": "../../icons/file_type_cmake.svg" },
    "_f_cobol": { "iconPath": "../../icons/file_type_cobol.svg" },
    "_f_codacy": { "iconPath": "../../icons/file_type_codacy.svg" },
    "_f_light_codacy": { "iconPath": "../../icons/file_type_light_codacy.svg" },
    "_f_codeclimate": { "iconPath": "../../icons/file_type_codeclimate.svg" },
    "_f_light_codeclimate": { "iconPath": "../../icons/file_type_light_codeclimate.svg" },
    "_f_codecov": { "iconPath": "../../icons/file_type_codecov.svg" },
    "_f_codekit": { "iconPath": "../../icons/file_type_codekit.svg" },
    "_f_codemagic": { "iconPath": "../../icons/file_type_codemagic.svg" },
    "_f_codeowners": { "iconPath": "../../icons/file_type_codeowners.svg" },
    "_f_light_codeowners": { "iconPath": "../../icons/file_type_light_codeowners.svg" },
    "_f_codeql": { "iconPath": "../../icons/file_type_codeql.svg" },
    "_f_coderabbit": { "iconPath": "../../icons/file_type_coderabbit.svg" },
    "_f_coffeelint": { "iconPath": "../../icons/file_type_coffeelint.svg" },
    "_f_coffeescript": { "iconPath": "../../icons/file_type_coffeescript.svg" },
    "_f_commitizen": { "iconPath": "../../icons/file_type_commitizen.svg" },
    "_f_commitlint": { "iconPath": "../../icons/file_type_commitlint.svg" },
    "_f_compass": { "iconPath": "../../icons/file_type_compass.svg" },
    "_f_composer": { "iconPath": "../../icons/file_type_composer.svg" },
    "_f_conan": { "iconPath": "../../icons/file_type_conan.svg" },
    "_f_conda": { "iconPath": "../../icons/file_type_conda.svg" },
    "_f_config": { "iconPath": "../../icons/file_type_config.svg" },
    "_f_light_config": { "iconPath": "../../icons/file_type_light_config.svg" },
    "_f_confluence": { "iconPath": "../../icons/file_type_confluence.svg" },
    "_f_copilot": { "iconPath": "../../icons/file_type_copilot.svg" },
    "_f_light_copilot": { "iconPath": "../../icons/file_type_light_copilot.svg" },
    "_f_coverage": { "iconPath": "../../icons/file_type_coverage.svg" },
    "_f_coveralls": { "iconPath": "../../icons/file_type_coveralls.svg" },
    "_f_cpp": { "iconPath": "../../icons/file_type_cpp.svg" },
    "_f_cppheader": { "iconPath": "../../icons/file_type_cppheader.svg" },
    "_f_craco": { "iconPath": "../../icons/file_type_craco.svg" },
    "_f_crowdin": { "iconPath": "../../icons/file_type_crowdin.svg" },
    "_f_crystal": { "iconPath": "../../icons/file_type_crystal.svg" },
    "_f_light_crystal": { "iconPath": "../../icons/file_type_light_crystal.svg" },
    "_f_csharp": { "iconPath": "../../icons/file_type_csharp.svg" },
    "_f_cspell": { "iconPath": "../../icons/file_type_cspell.svg" },
    "_f_csproj": { "iconPath": "../../icons/file_type_csproj.svg" },
    "_f_css": { "iconPath": "../../icons/file_type_css.svg" },
    "_f_csscomb": { "iconPath": "../../icons/file_type_csscomb.svg" },
    "_f_csslint": { "iconPath": "../../icons/file_type_csslint.svg" },
    "_f_cssmap": { "iconPath": "../../icons/file_type_cssmap.svg" },
    "_f_cucumber": { "iconPath": "../../icons/file_type_cucumber.svg" },
    "_f_cuda": { "iconPath": "../../icons/file_type_cuda.svg" },
    "_f_cursorrules": { "iconPath": "../../icons/file_type_cursorrules.svg" },
    "_f_cvs": { "iconPath": "../../icons/file_type_cvs.svg" },
    "_f_cypress": { "iconPath": "../../icons/file_type_cypress.svg" },
    "_f_light_cypress": { "iconPath": "../../icons/file_type_light_cypress.svg" },
    "_f_cypress_spec": { "iconPath": "../../icons/file_type_cypress_spec.svg" },
    "_f_light_cypress_spec": { "iconPath": "../../icons/file_type_light_cypress_spec.svg" },
    "_f_cython": { "iconPath": "../../icons/file_type_cython.svg" },
    "_f_dal": { "iconPath": "../../icons/file_type_dal.svg" },
    "_f_darcs": { "iconPath": "../../icons/file_type_darcs.svg" },
    "_f_dartlang": { "iconPath": "../../icons/file_type_dartlang.svg" },
    "_f_dartlang_generated": { "iconPath": "../../icons/file_type_dartlang_generated.svg" },
    "_f_dartlang_ignore": { "iconPath": "../../icons/file_type_dartlang_ignore.svg" },
    "_f_datadog": { "iconPath": "../../icons/file_type_datadog.svg" },
    "_f_db": { "iconPath": "../../icons/file_type_db.svg" },
    "_f_light_db": { "iconPath": "../../icons/file_type_light_db.svg" },
    "_f_debian": { "iconPath": "../../icons/file_type_debian.svg" },
    "_f_delphi": { "iconPath": "../../icons/file_type_delphi.svg" },
    "_f_deno": { "iconPath": "../../icons/file_type_deno.svg" },
    "_f_denoify": { "iconPath": "../../icons/file_type_denoify.svg" },
    "_f_dependabot": { "iconPath": "../../icons/file_type_dependabot.svg" },
    "_f_dependencies": { "iconPath": "../../icons/file_type_dependencies.svg" },
    "_f_design_tokens": { "iconPath": "../../icons/file_type_design_tokens.svg" },
    "_f_devcontainer": { "iconPath": "../../icons/file_type_devcontainer.svg" },
    "_f_devvit": { "iconPath": "../../icons/file_type_devvit.svg" },
    "_f_dhall": { "iconPath": "../../icons/file_type_dhall.svg" },
    "_f_light_dhall": { "iconPath": "../../icons/file_type_light_dhall.svg" },
    "_f_diff": { "iconPath": "../../icons/file_type_diff.svg" },
    "_f_django": { "iconPath": "../../icons/file_type_django.svg" },
    "_f_dlang": { "iconPath": "../../icons/file_type_dlang.svg" },
    "_f_docker": { "iconPath": "../../icons/file_type_docker.svg" },
    "_f_dockertest": { "iconPath": "../../icons/file_type_dockertest.svg" },
    "_f_docpad": { "iconPath": "../../icons/file_type_docpad.svg" },
    "_f_light_docpad": { "iconPath": "../../icons/file_type_light_docpad.svg" },
    "_f_docusaurus": { "iconPath": "../../icons/file_type_docusaurus.svg" },
    "_f_docz": { "iconPath": "../../icons/file_type_docz.svg" },
    "_f_dojo": { "iconPath": "../../icons/file_type_dojo.svg" },
    "_f_doppler": { "iconPath": "../../icons/file_type_doppler.svg" },
    "_f_dotenv": { "iconPath": "../../icons/file_type_dotenv.svg" },
    "_f_dotjs": { "iconPath": "../../icons/file_type_dotjs.svg" },
    "_f_doxygen": { "iconPath": "../../icons/file_type_doxygen.svg" },
    "_f_drawio": { "iconPath": "../../icons/file_type_drawio.svg" },
    "_f_drone": { "iconPath": "../../icons/file_type_drone.svg" },
    "_f_light_drone": { "iconPath": "../../icons/file_type_light_drone.svg" },
    "_f_drools": { "iconPath": "../../icons/file_type_drools.svg" },
    "_f_dtd": { "iconPath": "../../icons/file_type_dtd.svg" },
    "_f_dune": { "iconPath": "../../icons/file_type_dune.svg" },
    "_f_dustjs": { "iconPath": "../../icons/file_type_dustjs.svg" },
    "_f_dvc": { "iconPath": "../../icons/file_type_dvc.svg" },
    "_f_dylan": { "iconPath": "../../icons/file_type_dylan.svg" },
    "_f_earthly": { "iconPath": "../../icons/file_type_earthly.svg" },
    "_f_eas-metadata": { "iconPath": "../../icons/file_type_eas-metadata.svg" },
    "_f_light_eas-metadata": { "iconPath": "../../icons/file_type_light_eas-metadata.svg" },
    "_f_edge": { "iconPath": "../../icons/file_type_edge.svg" },
    "_f_editorconfig": { "iconPath": "../../icons/file_type_editorconfig.svg" },
    "_f_eex": { "iconPath": "../../icons/file_type_eex.svg" },
    "_f_ejs": { "iconPath": "../../icons/file_type_ejs.svg" },
    "_f_elastic": { "iconPath": "../../icons/file_type_elastic.svg" },
    "_f_elasticbeanstalk": { "iconPath": "../../icons/file_type_elasticbeanstalk.svg" },
    "_f_electron": { "iconPath": "../../icons/file_type_electron.svg" },
    "_f_eleventy": { "iconPath": "../../icons/file_type_eleventy.svg" },
    "_f_light_eleventy": { "iconPath": "../../icons/file_type_light_eleventy.svg" },
    "_f_elixir": { "iconPath": "../../icons/file_type_elixir.svg" },
    "_f_elm": { "iconPath": "../../icons/file_type_elm.svg" },
    "_f_emacs": { "iconPath": "../../icons/file_type_emacs.svg" },
    "_f_ember": { "iconPath": "../../icons/file_type_ember.svg" },
    "_f_ensime": { "iconPath": "../../icons/file_type_ensime.svg" },
    "_f_eps": { "iconPath": "../../icons/file_type_eps.svg" },
    "_f_epub": { "iconPath": "../../icons/file_type_epub.svg" },
    "_f_erb": { "iconPath": "../../icons/file_type_erb.svg" },
    "_f_erlang": { "iconPath": "../../icons/file_type_erlang.svg" },
    "_f_esbuild": { "iconPath": "../../icons/file_type_esbuild.svg" },
    "_f_eslint": { "iconPath": "../../icons/file_type_eslint.svg" },
    "_f_esphome": { "iconPath": "../../icons/file_type_esphome.svg" },
    "_f_light_esphome": { "iconPath": "../../icons/file_type_light_esphome.svg" },
    "_f_excalidraw": { "iconPath": "../../icons/file_type_excalidraw.svg" },
    "_f_excel": { "iconPath": "../../icons/file_type_excel.svg" },
    "_f_expo": { "iconPath": "../../icons/file_type_expo.svg" },
    "_f_light_expo": { "iconPath": "../../icons/file_type_light_expo.svg" },
    "_f_falcon": { "iconPath": "../../icons/file_type_falcon.svg" },
    "_f_fantasticon": { "iconPath": "../../icons/file_type_fantasticon.svg" },
    "_f_fastly": { "iconPath": "../../icons/file_type_fastly.svg" },
    "_f_fauna": { "iconPath": "../../icons/file_type_fauna.svg" },
    "_f_favicon": { "iconPath": "../../icons/file_type_favicon.svg" },
    "_f_fbx": { "iconPath": "../../icons/file_type_fbx.svg" },
    "_f_firebase": { "iconPath": "../../icons/file_type_firebase.svg" },
    "_f_firebasehosting": { "iconPath": "../../icons/file_type_firebasehosting.svg" },
    "_f_light_firebasehosting": { "iconPath": "../../icons/file_type_light_firebasehosting.svg" },
    "_f_firebasestorage": { "iconPath": "../../icons/file_type_firebasestorage.svg" },
    "_f_firestore": { "iconPath": "../../icons/file_type_firestore.svg" },
    "_f_fitbit": { "iconPath": "../../icons/file_type_fitbit.svg" },
    "_f_fla": { "iconPath": "../../icons/file_type_fla.svg" },
    "_f_light_fla": { "iconPath": "../../icons/file_type_light_fla.svg" },
    "_f_flareact": { "iconPath": "../../icons/file_type_flareact.svg" },
    "_f_flash": { "iconPath": "../../icons/file_type_flash.svg" },
    "_f_floobits": { "iconPath": "../../icons/file_type_floobits.svg" },
    "_f_flow": { "iconPath": "../../icons/file_type_flow.svg" },
    "_f_flutter": { "iconPath": "../../icons/file_type_flutter.svg" },
    "_f_flutter_package": { "iconPath": "../../icons/file_type_flutter_package.svg" },
    "_f_flyio": { "iconPath": "../../icons/file_type_flyio.svg" },
    "_f_font": { "iconPath": "../../icons/file_type_font.svg" },
    "_f_light_font": { "iconPath": "../../icons/file_type_light_font.svg" },
    "_f_formkit": { "iconPath": "../../icons/file_type_formkit.svg" },
    "_f_fortran": { "iconPath": "../../icons/file_type_fortran.svg" },
    "_f_fossa": { "iconPath": "../../icons/file_type_fossa.svg" },
    "_f_fossil": { "iconPath": "../../icons/file_type_fossil.svg" },
    "_f_freemarker": { "iconPath": "../../icons/file_type_freemarker.svg" },
    "_f_frontcommerce": { "iconPath": "../../icons/file_type_frontcommerce.svg" },
    "_f_fsharp": { "iconPath": "../../icons/file_type_fsharp.svg" },
    "_f_fsproj": { "iconPath": "../../icons/file_type_fsproj.svg" },
    "_f_fthtml": { "iconPath": "../../icons/file_type_fthtml.svg" },
    "_f_funding": { "iconPath": "../../icons/file_type_funding.svg" },
    "_f_fusebox": { "iconPath": "../../icons/file_type_fusebox.svg" },
    "_f_galen": { "iconPath": "../../icons/file_type_galen.svg" },
    "_f_gamemaker": { "iconPath": "../../icons/file_type_gamemaker.svg" },
    "_f_gamemaker2": { "iconPath": "../../icons/file_type_gamemaker2.svg" },
    "_f_light_gamemaker2": { "iconPath": "../../icons/file_type_light_gamemaker2.svg" },
    "_f_gamemaker81": { "iconPath": "../../icons/file_type_gamemaker81.svg" },
    "_f_gatsby": { "iconPath": "../../icons/file_type_gatsby.svg" },
    "_f_gcloud": { "iconPath": "../../icons/file_type_gcloud.svg" },
    "_f_gcode": { "iconPath": "../../icons/file_type_gcode.svg" },
    "_f_gdscript": { "iconPath": "../../icons/file_type_gdscript.svg" },
    "_f_gduid": { "iconPath": "../../icons/file_type_gduid.svg" },
    "_f_gemini": { "iconPath": "../../icons/file_type_gemini.svg" },
    "_f_genstat": { "iconPath": "../../icons/file_type_genstat.svg" },
    "_f_geojson": { "iconPath": "../../icons/file_type_geojson.svg" },
    "_f_gimp": { "iconPath": "../../icons/file_type_gimp.svg" },
    "_f_git": { "iconPath": "../../icons/file_type_git.svg" },
    "_f_gitlab": { "iconPath": "../../icons/file_type_gitlab.svg" },
    "_f_gitpod": { "iconPath": "../../icons/file_type_gitpod.svg" },
    "_f_gleam": { "iconPath": "../../icons/file_type_gleam.svg" },
    "_f_gleamconfig": { "iconPath": "../../icons/file_type_gleamconfig.svg" },
    "_f_glide": { "iconPath": "../../icons/file_type_glide.svg" },
    "_f_glimmer": { "iconPath": "../../icons/file_type_glimmer.svg" },
    "_f_glitter": { "iconPath": "../../icons/file_type_glitter.svg" },
    "_f_glsl": { "iconPath": "../../icons/file_type_glsl.svg" },
    "_f_gltf": { "iconPath": "../../icons/file_type_gltf.svg" },
    "_f_glyphs": { "iconPath": "../../icons/file_type_glyphs.svg" },
    "_f_gnu": { "iconPath": "../../icons/file_type_gnu.svg" },
    "_f_gnuplot": { "iconPath": "../../icons/file_type_gnuplot.svg" },
    "_f_go": { "iconPath": "../../icons/file_type_go.svg" },
    "_f_go_package": { "iconPath": "../../icons/file_type_go_package.svg" },
    "_f_go_work": { "iconPath": "../../icons/file_type_go_work.svg" },
    "_f_goctl": { "iconPath": "../../icons/file_type_goctl.svg" },
    "_f_godot": { "iconPath": "../../icons/file_type_godot.svg" },
    "_f_gpg": { "iconPath": "../../icons/file_type_gpg.svg" },
    "_f_gradle": { "iconPath": "../../icons/file_type_gradle.svg" },
    "_f_light_gradle": { "iconPath": "../../icons/file_type_light_gradle.svg" },
    "_f_grain": { "iconPath": "../../icons/file_type_grain.svg" },
    "_f_graphql": { "iconPath": "../../icons/file_type_graphql.svg" },
    "_f_graphql_config": { "iconPath": "../../icons/file_type_graphql_config.svg" },
    "_f_graphviz": { "iconPath": "../../icons/file_type_graphviz.svg" },
    "_f_greenkeeper": { "iconPath": "../../icons/file_type_greenkeeper.svg" },
    "_f_gridsome": { "iconPath": "../../icons/file_type_gridsome.svg" },
    "_f_grit": { "iconPath": "../../icons/file_type_grit.svg" },
    "_f_groovy": { "iconPath": "../../icons/file_type_groovy.svg" },
    "_f_grunt": { "iconPath": "../../icons/file_type_grunt.svg" },
    "_f_gulp": { "iconPath": "../../icons/file_type_gulp.svg" },
    "_f_haml": { "iconPath": "../../icons/file_type_haml.svg" },
    "_f_handlebars": { "iconPath": "../../icons/file_type_handlebars.svg" },
    "_f_harbour": { "iconPath": "../../icons/file_type_harbour.svg" },
    "_f_hardhat": { "iconPath": "../../icons/file_type_hardhat.svg" },
    "_f_hashicorp": { "iconPath": "../../icons/file_type_hashicorp.svg" },
    "_f_light_hashicorp": { "iconPath": "../../icons/file_type_light_hashicorp.svg" },
    "_f_haskell": { "iconPath": "../../icons/file_type_haskell.svg" },
    "_f_haxe": { "iconPath": "../../icons/file_type_haxe.svg" },
    "_f_haxecheckstyle": { "iconPath": "../../icons/file_type_haxecheckstyle.svg" },
    "_f_haxedevelop": { "iconPath": "../../icons/file_type_haxedevelop.svg" },
    "_f_helix": { "iconPath": "../../icons/file_type_helix.svg" },
    "_f_helm": { "iconPath": "../../icons/file_type_helm.svg" },
    "_f_histoire": { "iconPath": "../../icons/file_type_histoire.svg" },
    "_f_hjson": { "iconPath": "../../icons/file_type_hjson.svg" },
    "_f_light_hjson": { "iconPath": "../../icons/file_type_light_hjson.svg" },
    "_f_hlsl": { "iconPath": "../../icons/file_type_hlsl.svg" },
    "_f_homeassistant": { "iconPath": "../../icons/file_type_homeassistant.svg" },
    "_f_horusec": { "iconPath": "../../icons/file_type_horusec.svg" },
    "_f_host": { "iconPath": "../../icons/file_type_host.svg" },
    "_f_html": { "iconPath": "../../icons/file_type_html.svg" },
    "_f_htmlhint": { "iconPath": "../../icons/file_type_htmlhint.svg" },
    "_f_htmlvalidate": { "iconPath": "../../icons/file_type_htmlvalidate.svg" },
    "_f_http": { "iconPath": "../../icons/file_type_http.svg" },
    "_f_hugo": { "iconPath": "../../icons/file_type_hugo.svg" },
    "_f_humanstxt": { "iconPath": "../../icons/file_type_humanstxt.svg" },
    "_f_hunspell": { "iconPath": "../../icons/file_type_hunspell.svg" },
    "_f_husky": { "iconPath": "../../icons/file_type_husky.svg" },
    "_f_hy": { "iconPath": "../../icons/file_type_hy.svg" },
    "_f_hygen": { "iconPath": "../../icons/file_type_hygen.svg" },
    "_f_hypr": { "iconPath": "../../icons/file_type_hypr.svg" },
    "_f_icl": { "iconPath": "../../icons/file_type_icl.svg" },
    "_f_idris": { "iconPath": "../../icons/file_type_idris.svg" },
    "_f_idrisbin": { "iconPath": "../../icons/file_type_idrisbin.svg" },
    "_f_idrispkg": { "iconPath": "../../icons/file_type_idrispkg.svg" },
    "_f_image": { "iconPath": "../../icons/file_type_image.svg" },
    "_f_imba": { "iconPath": "../../icons/file_type_imba.svg" },
    "_f_inc": { "iconPath": "../../icons/file_type_inc.svg" },
    "_f_infopath": { "iconPath": "../../icons/file_type_infopath.svg" },
    "_f_informix": { "iconPath": "../../icons/file_type_informix.svg" },
    "_f_ini": { "iconPath": "../../icons/file_type_ini.svg" },
    "_f_light_ini": { "iconPath": "../../icons/file_type_light_ini.svg" },
    "_f_ink": { "iconPath": "../../icons/file_type_ink.svg" },
    "_f_innosetup": { "iconPath": "../../icons/file_type_innosetup.svg" },
    "_f_io": { "iconPath": "../../icons/file_type_io.svg" },
    "_f_light_io": { "iconPath": "../../icons/file_type_light_io.svg" },
    "_f_iodine": { "iconPath": "../../icons/file_type_iodine.svg" },
    "_f_ionic": { "iconPath": "../../icons/file_type_ionic.svg" },
    "_f_jake": { "iconPath": "../../icons/file_type_jake.svg" },
    "_f_janet": { "iconPath": "../../icons/file_type_janet.svg" },
    "_f_jar": { "iconPath": "../../icons/file_type_jar.svg" },
    "_f_jasmine": { "iconPath": "../../icons/file_type_jasmine.svg" },
    "_f_java": { "iconPath": "../../icons/file_type_java.svg" },
    "_f_jbuilder": { "iconPath": "../../icons/file_type_jbuilder.svg" },
    "_f_jekyll": { "iconPath": "../../icons/file_type_jekyll.svg" },
    "_f_jenkins": { "iconPath": "../../icons/file_type_jenkins.svg" },
    "_f_jest": { "iconPath": "../../icons/file_type_jest.svg" },
    "_f_jest_snapshot": { "iconPath": "../../icons/file_type_jest_snapshot.svg" },
    "_f_jetbrains": { "iconPath": "../../icons/file_type_jetbrains.svg" },
    "_f_jinja": { "iconPath": "../../icons/file_type_jinja.svg" },
    "_f_jpm": { "iconPath": "../../icons/file_type_jpm.svg" },
    "_f_js": { "iconPath": "../../icons/file_type_js.svg" },
    "_f_light_js": { "iconPath": "../../icons/file_type_light_js.svg" },
    "_f_jsbeautify": { "iconPath": "../../icons/file_type_jsbeautify.svg" },
    "_f_jsconfig": { "iconPath": "../../icons/file_type_jsconfig.svg" },
    "_f_light_jsconfig": { "iconPath": "../../icons/file_type_light_jsconfig.svg" },
    "_f_jscpd": { "iconPath": "../../icons/file_type_jscpd.svg" },
    "_f_jshint": { "iconPath": "../../icons/file_type_jshint.svg" },
    "_f_jsmap": { "iconPath": "../../icons/file_type_jsmap.svg" },
    "_f_light_jsmap": { "iconPath": "../../icons/file_type_light_jsmap.svg" },
    "_f_json": { "iconPath": "../../icons/file_type_json.svg" },
    "_f_light_json": { "iconPath": "../../icons/file_type_light_json.svg" },
    "_f_json5": { "iconPath": "../../icons/file_type_json5.svg" },
    "_f_light_json5": { "iconPath": "../../icons/file_type_light_json5.svg" },
    "_f_json_schema": { "iconPath": "../../icons/file_type_json_schema.svg" },
    "_f_light_json_schema": { "iconPath": "../../icons/file_type_light_json_schema.svg" },
    "_f_jsonld": { "iconPath": "../../icons/file_type_jsonld.svg" },
    "_f_light_jsonld": { "iconPath": "../../icons/file_type_light_jsonld.svg" },
    "_f_jsonnet": { "iconPath": "../../icons/file_type_jsonnet.svg" },
    "_f_jsp": { "iconPath": "../../icons/file_type_jsp.svg" },
    "_f_jsr": { "iconPath": "../../icons/file_type_jsr.svg" },
    "_f_jss": { "iconPath": "../../icons/file_type_jss.svg" },
    "_f_juice": { "iconPath": "../../icons/file_type_juice.svg" },
    "_f_julia": { "iconPath": "../../icons/file_type_julia.svg" },
    "_f_jupyter": { "iconPath": "../../icons/file_type_jupyter.svg" },
    "_f_just": { "iconPath": "../../icons/file_type_just.svg" },
    "_f_k": { "iconPath": "../../icons/file_type_k.svg" },
    "_f_karma": { "iconPath": "../../icons/file_type_karma.svg" },
    "_f_key": { "iconPath": "../../icons/file_type_key.svg" },
    "_f_kitchenci": { "iconPath": "../../icons/file_type_kitchenci.svg" },
    "_f_kite": { "iconPath": "../../icons/file_type_kite.svg" },
    "_f_light_kite": { "iconPath": "../../icons/file_type_light_kite.svg" },
    "_f_kivy": { "iconPath": "../../icons/file_type_kivy.svg" },
    "_f_knip": { "iconPath": "../../icons/file_type_knip.svg" },
    "_f_kos": { "iconPath": "../../icons/file_type_kos.svg" },
    "_f_kotlin": { "iconPath": "../../icons/file_type_kotlin.svg" },
    "_f_kusto": { "iconPath": "../../icons/file_type_kusto.svg" },
    "_f_language_configuration": { "iconPath": "../../icons/file_type_language_configuration.svg" },
    "_f_lark": { "iconPath": "../../icons/file_type_lark.svg" },
    "_f_light_lark": { "iconPath": "../../icons/file_type_light_lark.svg" },
    "_f_latino": { "iconPath": "../../icons/file_type_latino.svg" },
    "_f_layout": { "iconPath": "../../icons/file_type_layout.svg" },
    "_f_lean": { "iconPath": "../../icons/file_type_lean.svg" },
    "_f_light_lean": { "iconPath": "../../icons/file_type_light_lean.svg" },
    "_f_leanconfig": { "iconPath": "../../icons/file_type_leanconfig.svg" },
    "_f_light_leanconfig": { "iconPath": "../../icons/file_type_light_leanconfig.svg" },
    "_f_lefthook": { "iconPath": "../../icons/file_type_lefthook.svg" },
    "_f_lerna": { "iconPath": "../../icons/file_type_lerna.svg" },
    "_f_light_lerna": { "iconPath": "../../icons/file_type_light_lerna.svg" },
    "_f_less": { "iconPath": "../../icons/file_type_less.svg" },
    "_f_lex": { "iconPath": "../../icons/file_type_lex.svg" },
    "_f_liara": { "iconPath": "../../icons/file_type_liara.svg" },
    "_f_libreoffice_base": { "iconPath": "../../icons/file_type_libreoffice_base.svg" },
    "_f_libreoffice_calc": { "iconPath": "../../icons/file_type_libreoffice_calc.svg" },
    "_f_libreoffice_draw": { "iconPath": "../../icons/file_type_libreoffice_draw.svg" },
    "_f_libreoffice_impress": { "iconPath": "../../icons/file_type_libreoffice_impress.svg" },
    "_f_libreoffice_math": { "iconPath": "../../icons/file_type_libreoffice_math.svg" },
    "_f_libreoffice_writer": { "iconPath": "../../icons/file_type_libreoffice_writer.svg" },
    "_f_license": { "iconPath": "../../icons/file_type_license.svg" },
    "_f_licensebat": { "iconPath": "../../icons/file_type_licensebat.svg" },
    "_f_lighthouse": { "iconPath": "../../icons/file_type_lighthouse.svg" },
    "_f_lilypond": { "iconPath": "../../icons/file_type_lilypond.svg" },
    "_f_lime": { "iconPath": "../../icons/file_type_lime.svg" },
    "_f_lintstagedrc": { "iconPath": "../../icons/file_type_lintstagedrc.svg" },
    "_f_liquid": { "iconPath": "../../icons/file_type_liquid.svg" },
    "_f_lisp": { "iconPath": "../../icons/file_type_lisp.svg" },
    "_f_livescript": { "iconPath": "../../icons/file_type_livescript.svg" },
    "_f_lnk": { "iconPath": "../../icons/file_type_lnk.svg" },
    "_f_locale": { "iconPath": "../../icons/file_type_locale.svg" },
    "_f_log": { "iconPath": "../../icons/file_type_log.svg" },
    "_f_lolcode": { "iconPath": "../../icons/file_type_lolcode.svg" },
    "_f_lsl": { "iconPath": "../../icons/file_type_lsl.svg" },
    "_f_lua": { "iconPath": "../../icons/file_type_lua.svg" },
    "_f_luau": { "iconPath": "../../icons/file_type_luau.svg" },
    "_f_lync": { "iconPath": "../../icons/file_type_lync.svg" },
    "_f_mailing": { "iconPath": "../../icons/file_type_mailing.svg" },
    "_f_light_mailing": { "iconPath": "../../icons/file_type_light_mailing.svg" },
    "_f_manifest": { "iconPath": "../../icons/file_type_manifest.svg" },
    "_f_manifest_bak": { "iconPath": "../../icons/file_type_manifest_bak.svg" },
    "_f_manifest_skip": { "iconPath": "../../icons/file_type_manifest_skip.svg" },
    "_f_map": { "iconPath": "../../icons/file_type_map.svg" },
    "_f_markdown": { "iconPath": "../../icons/file_type_markdown.svg" },
    "_f_markdownlint": { "iconPath": "../../icons/file_type_markdownlint.svg" },
    "_f_markdownlint_ignore": { "iconPath": "../../icons/file_type_markdownlint_ignore.svg" },
    "_f_marko": { "iconPath": "../../icons/file_type_marko.svg" },
    "_f_markojs": { "iconPath": "../../icons/file_type_markojs.svg" },
    "_f_markuplint": { "iconPath": "../../icons/file_type_markuplint.svg" },
    "_f_light_markuplint": { "iconPath": "../../icons/file_type_light_markuplint.svg" },
    "_f_master-co": { "iconPath": "../../icons/file_type_master-co.svg" },
    "_f_matlab": { "iconPath": "../../icons/file_type_matlab.svg" },
    "_f_maven": { "iconPath": "../../icons/file_type_maven.svg" },
    "_f_maxscript": { "iconPath": "../../icons/file_type_maxscript.svg" },
    "_f_maya": { "iconPath": "../../icons/file_type_maya.svg" },
    "_f_mcp": { "iconPath": "../../icons/file_type_mcp.svg" },
    "_f_light_mcp": { "iconPath": "../../icons/file_type_light_mcp.svg" },
    "_f_mdx": { "iconPath": "../../icons/file_type_mdx.svg" },
    "_f_light_mdx": { "iconPath": "../../icons/file_type_light_mdx.svg" },
    "_f_mdx-components": { "iconPath": "../../icons/file_type_mdx-components.svg" },
    "_f_light_mdx-components": { "iconPath": "../../icons/file_type_light_mdx-components.svg" },
    "_f_mdxlint": { "iconPath": "../../icons/file_type_mdxlint.svg" },
    "_f_mediawiki": { "iconPath": "../../icons/file_type_mediawiki.svg" },
    "_f_mercurial": { "iconPath": "../../icons/file_type_mercurial.svg" },
    "_f_mermaid": { "iconPath": "../../icons/file_type_mermaid.svg" },
    "_f_meson": { "iconPath": "../../icons/file_type_meson.svg" },
    "_f_metal": { "iconPath": "../../icons/file_type_metal.svg" },
    "_f_meteor": { "iconPath": "../../icons/file_type_meteor.svg" },
    "_f_minecraft": { "iconPath": "../../icons/file_type_minecraft.svg" },
    "_f_mivascript": { "iconPath": "../../icons/file_type_mivascript.svg" },
    "_f_mjml": { "iconPath": "../../icons/file_type_mjml.svg" },
    "_f_mlang": { "iconPath": "../../icons/file_type_mlang.svg" },
    "_f_light_mlang": { "iconPath": "../../icons/file_type_light_mlang.svg" },
    "_f_mocha": { "iconPath": "../../icons/file_type_mocha.svg" },
    "_f_modernizr": { "iconPath": "../../icons/file_type_modernizr.svg" },
    "_f_mojo": { "iconPath": "../../icons/file_type_mojo.svg" },
    "_f_mojolicious": { "iconPath": "../../icons/file_type_mojolicious.svg" },
    "_f_moleculer": { "iconPath": "../../icons/file_type_moleculer.svg" },
    "_f_mondoo": { "iconPath": "../../icons/file_type_mondoo.svg" },
    "_f_mongo": { "iconPath": "../../icons/file_type_mongo.svg" },
    "_f_monotone": { "iconPath": "../../icons/file_type_monotone.svg" },
    "_f_motif": { "iconPath": "../../icons/file_type_motif.svg" },
    "_f_mson": { "iconPath": "../../icons/file_type_mson.svg" },
    "_f_mustache": { "iconPath": "../../icons/file_type_mustache.svg" },
    "_f_light_mustache": { "iconPath": "../../icons/file_type_light_mustache.svg" },
    "_f_mvt": { "iconPath": "../../icons/file_type_mvt.svg" },
    "_f_mvtcss": { "iconPath": "../../icons/file_type_mvtcss.svg" },
    "_f_mvtjs": { "iconPath": "../../icons/file_type_mvtjs.svg" },
    "_f_mypy": { "iconPath": "../../icons/file_type_mypy.svg" },
    "_f_light_mypy": { "iconPath": "../../icons/file_type_light_mypy.svg" },
    "_f_nanostaged": { "iconPath": "../../icons/file_type_nanostaged.svg" },
    "_f_ndst": { "iconPath": "../../icons/file_type_ndst.svg" },
    "_f_nearly": { "iconPath": "../../icons/file_type_nearly.svg" },
    "_f_neo4j": { "iconPath": "../../icons/file_type_neo4j.svg" },
    "_f_light_neo4j": { "iconPath": "../../icons/file_type_light_neo4j.svg" },
    "_f_nestjs": { "iconPath": "../../icons/file_type_nestjs.svg" },
    "_f_netlify": { "iconPath": "../../icons/file_type_netlify.svg" },
    "_f_light_netlify": { "iconPath": "../../icons/file_type_light_netlify.svg" },
    "_f_next": { "iconPath": "../../icons/file_type_next.svg" },
    "_f_light_next": { "iconPath": "../../icons/file_type_light_next.svg" },
    "_f_nextflow": { "iconPath": "../../icons/file_type_nextflow.svg" },
    "_f_ng_tailwind": { "iconPath": "../../icons/file_type_ng_tailwind.svg" },
    "_f_nginx": { "iconPath": "../../icons/file_type_nginx.svg" },
    "_f_nim": { "iconPath": "../../icons/file_type_nim.svg" },
    "_f_nimble": { "iconPath": "../../icons/file_type_nimble.svg" },
    "_f_ninja": { "iconPath": "../../icons/file_type_ninja.svg" },
    "_f_nix": { "iconPath": "../../icons/file_type_nix.svg" },
    "_f_njsproj": { "iconPath": "../../icons/file_type_njsproj.svg" },
    "_f_noc": { "iconPath": "../../icons/file_type_noc.svg" },
    "_f_node": { "iconPath": "../../icons/file_type_node.svg" },
    "_f_nodemon": { "iconPath": "../../icons/file_type_nodemon.svg" },
    "_f_npm": { "iconPath": "../../icons/file_type_npm.svg" },
    "_f_npmpackagejsonlint": { "iconPath": "../../icons/file_type_npmpackagejsonlint.svg" },
    "_f_nsi": { "iconPath": "../../icons/file_type_nsi.svg" },
    "_f_nsri": { "iconPath": "../../icons/file_type_nsri.svg" },
    "_f_nsri-integrity": { "iconPath": "../../icons/file_type_nsri-integrity.svg" },
    "_f_nuget": { "iconPath": "../../icons/file_type_nuget.svg" },
    "_f_numpy": { "iconPath": "../../icons/file_type_numpy.svg" },
    "_f_nunjucks": { "iconPath": "../../icons/file_type_nunjucks.svg" },
    "_f_nushell": { "iconPath": "../../icons/file_type_nushell.svg" },
    "_f_nuxt": { "iconPath": "../../icons/file_type_nuxt.svg" },
    "_f_nx": { "iconPath": "../../icons/file_type_nx.svg" },
    "_f_light_nx": { "iconPath": "../../icons/file_type_light_nx.svg" },
    "_f_nyc": { "iconPath": "../../icons/file_type_nyc.svg" },
    "_f_objectivec": { "iconPath": "../../icons/file_type_objectivec.svg" },
    "_f_objectivecpp": { "iconPath": "../../icons/file_type_objectivecpp.svg" },
    "_f_objidconfig": { "iconPath": "../../icons/file_type_objidconfig.svg" },
    "_f_light_objidconfig": { "iconPath": "../../icons/file_type_light_objidconfig.svg" },
    "_f_ocaml": { "iconPath": "../../icons/file_type_ocaml.svg" },
    "_f_ocaml_intf": { "iconPath": "../../icons/file_type_ocaml_intf.svg" },
    "_f_ogone": { "iconPath": "../../icons/file_type_ogone.svg" },
    "_f_onenote": { "iconPath": "../../icons/file_type_onenote.svg" },
    "_f_opam": { "iconPath": "../../icons/file_type_opam.svg" },
    "_f_openHAB": { "iconPath": "../../icons/file_type_openHAB.svg" },
    "_f_light_openHAB": { "iconPath": "../../icons/file_type_light_openHAB.svg" },
    "_f_opencl": { "iconPath": "../../icons/file_type_opencl.svg" },
    "_f_openscad": { "iconPath": "../../icons/file_type_openscad.svg" },
    "_f_opentofu": { "iconPath": "../../icons/file_type_opentofu.svg" },
    "_f_org": { "iconPath": "../../icons/file_type_org.svg" },
    "_f_outlook": { "iconPath": "../../icons/file_type_outlook.svg" },
    "_f_ovpn": { "iconPath": "../../icons/file_type_ovpn.svg" },
    "_f_oxc": { "iconPath": "../../icons/file_type_oxc.svg" },
    "_f_light_oxc": { "iconPath": "../../icons/file_type_light_oxc.svg" },
    "_f_package": { "iconPath": "../../icons/file_type_package.svg" },
    "_f_packship": { "iconPath": "../../icons/file_type_packship.svg" },
    "_f_light_packship": { "iconPath": "../../icons/file_type_light_packship.svg" },
    "_f_paket": { "iconPath": "../../icons/file_type_paket.svg" },
    "_f_pandacss": { "iconPath": "../../icons/file_type_pandacss.svg" },
    "_f_patch": { "iconPath": "../../icons/file_type_patch.svg" },
    "_f_pcl": { "iconPath": "../../icons/file_type_pcl.svg" },
    "_f_light_pcl": { "iconPath": "../../icons/file_type_light_pcl.svg" },
    "_f_pddl": { "iconPath": "../../icons/file_type_pddl.svg" },
    "_f_pddl_happenings": { "iconPath": "../../icons/file_type_pddl_happenings.svg" },
    "_f_pddl_plan": { "iconPath": "../../icons/file_type_pddl_plan.svg" },
    "_f_pdf": { "iconPath": "../../icons/file_type_pdf.svg" },
    "_f_pdm": { "iconPath": "../../icons/file_type_pdm.svg" },
    "_f_peeky": { "iconPath": "../../icons/file_type_peeky.svg" },
    "_f_perl": { "iconPath": "../../icons/file_type_perl.svg" },
    "_f_perl6": { "iconPath": "../../icons/file_type_perl6.svg" },
    "_f_pgsql": { "iconPath": "../../icons/file_type_pgsql.svg" },
    "_f_photoshop": { "iconPath": "../../icons/file_type_photoshop.svg" },
    "_f_php": { "iconPath": "../../icons/file_type_php.svg" },
    "_f_phpcsfixer": { "iconPath": "../../icons/file_type_phpcsfixer.svg" },
    "_f_phpstan": { "iconPath": "../../icons/file_type_phpstan.svg" },
    "_f_phpunit": { "iconPath": "../../icons/file_type_phpunit.svg" },
    "_f_phraseapp": { "iconPath": "../../icons/file_type_phraseapp.svg" },
    "_f_pine": { "iconPath": "../../icons/file_type_pine.svg" },
    "_f_pip": { "iconPath": "../../icons/file_type_pip.svg" },
    "_f_pipeline": { "iconPath": "../../icons/file_type_pipeline.svg" },
    "_f_plantuml": { "iconPath": "../../icons/file_type_plantuml.svg" },
    "_f_platformio": { "iconPath": "../../icons/file_type_platformio.svg" },
    "_f_playwright": { "iconPath": "../../icons/file_type_playwright.svg" },
    "_f_plsql": { "iconPath": "../../icons/file_type_plsql.svg" },
    "_f_plsql_package": { "iconPath": "../../icons/file_type_plsql_package.svg" },
    "_f_plsql_package_body": { "iconPath": "../../icons/file_type_plsql_package_body.svg" },
    "_f_plsql_package_header": { "iconPath": "../../icons/file_type_plsql_package_header.svg" },
    "_f_plsql_package_spec": { "iconPath": "../../icons/file_type_plsql_package_spec.svg" },
    "_f_pm2": { "iconPath": "../../icons/file_type_pm2.svg" },
    "_f_pnpm": { "iconPath": "../../icons/file_type_pnpm.svg" },
    "_f_light_pnpm": { "iconPath": "../../icons/file_type_light_pnpm.svg" },
    "_f_poedit": { "iconPath": "../../icons/file_type_poedit.svg" },
    "_f_poetry": { "iconPath": "../../icons/file_type_poetry.svg" },
    "_f_polyglot": { "iconPath": "../../icons/file_type_polyglot.svg" },
    "_f_polymer": { "iconPath": "../../icons/file_type_polymer.svg" },
    "_f_pony": { "iconPath": "../../icons/file_type_pony.svg" },
    "_f_postcss": { "iconPath": "../../icons/file_type_postcss.svg" },
    "_f_postcssconfig": { "iconPath": "../../icons/file_type_postcssconfig.svg" },
    "_f_postman": { "iconPath": "../../icons/file_type_postman.svg" },
    "_f_postscript": { "iconPath": "../../icons/file_type_postscript.svg" },
    "_f_powerpoint": { "iconPath": "../../icons/file_type_powerpoint.svg" },
    "_f_powershell": { "iconPath": "../../icons/file_type_powershell.svg" },
    "_f_powershell_format": { "iconPath": "../../icons/file_type_powershell_format.svg" },
    "_f_powershell_psd": { "iconPath": "../../icons/file_type_powershell_psd.svg" },
    "_f_powershell_psm": { "iconPath": "../../icons/file_type_powershell_psm.svg" },
    "_f_powershell_types": { "iconPath": "../../icons/file_type_powershell_types.svg" },
    "_f_preact": { "iconPath": "../../icons/file_type_preact.svg" },
    "_f_precommit": { "iconPath": "../../icons/file_type_precommit.svg" },
    "_f_prettier": { "iconPath": "../../icons/file_type_prettier.svg" },
    "_f_light_prettier": { "iconPath": "../../icons/file_type_light_prettier.svg" },
    "_f_prisma": { "iconPath": "../../icons/file_type_prisma.svg" },
    "_f_light_prisma": { "iconPath": "../../icons/file_type_light_prisma.svg" },
    "_f_prismaconfig": { "iconPath": "../../icons/file_type_prismaconfig.svg" },
    "_f_processinglang": { "iconPath": "../../icons/file_type_processinglang.svg" },
    "_f_procfile": { "iconPath": "../../icons/file_type_procfile.svg" },
    "_f_progress": { "iconPath": "../../icons/file_type_progress.svg" },
    "_f_prolog": { "iconPath": "../../icons/file_type_prolog.svg" },
    "_f_prometheus": { "iconPath": "../../icons/file_type_prometheus.svg" },
    "_f_protobuf": { "iconPath": "../../icons/file_type_protobuf.svg" },
    "_f_protractor": { "iconPath": "../../icons/file_type_protractor.svg" },
    "_f_publiccode": { "iconPath": "../../icons/file_type_publiccode.svg" },
    "_f_publisher": { "iconPath": "../../icons/file_type_publisher.svg" },
    "_f_pug": { "iconPath": "../../icons/file_type_pug.svg" },
    "_f_pulumi": { "iconPath": "../../icons/file_type_pulumi.svg" },
    "_f_puppet": { "iconPath": "../../icons/file_type_puppet.svg" },
    "_f_purescript": { "iconPath": "../../icons/file_type_purescript.svg" },
    "_f_light_purescript": { "iconPath": "../../icons/file_type_light_purescript.svg" },
    "_f_purgecss": { "iconPath": "../../icons/file_type_purgecss.svg" },
    "_f_pyenv": { "iconPath": "../../icons/file_type_pyenv.svg" },
    "_f_pypi": { "iconPath": "../../icons/file_type_pypi.svg" },
    "_f_pyret": { "iconPath": "../../icons/file_type_pyret.svg" },
    "_f_pyscript": { "iconPath": "../../icons/file_type_pyscript.svg" },
    "_f_pytest": { "iconPath": "../../icons/file_type_pytest.svg" },
    "_f_python": { "iconPath": "../../icons/file_type_python.svg" },
    "_f_pythowo": { "iconPath": "../../icons/file_type_pythowo.svg" },
    "_f_pytyped": { "iconPath": "../../icons/file_type_pytyped.svg" },
    "_f_pyup": { "iconPath": "../../icons/file_type_pyup.svg" },
    "_f_q": { "iconPath": "../../icons/file_type_q.svg" },
    "_f_qbs": { "iconPath": "../../icons/file_type_qbs.svg" },
    "_f_qlikview": { "iconPath": "../../icons/file_type_qlikview.svg" },
    "_f_qml": { "iconPath": "../../icons/file_type_qml.svg" },
    "_f_qmldir": { "iconPath": "../../icons/file_type_qmldir.svg" },
    "_f_qsharp": { "iconPath": "../../icons/file_type_qsharp.svg" },
    "_f_quasar": { "iconPath": "../../icons/file_type_quasar.svg" },
    "_f_light_quasar": { "iconPath": "../../icons/file_type_light_quasar.svg" },
    "_f_r": { "iconPath": "../../icons/file_type_r.svg" },
    "_f_ra_syntax_tree": { "iconPath": "../../icons/file_type_ra_syntax_tree.svg" },
    "_f_racket": { "iconPath": "../../icons/file_type_racket.svg" },
    "_f_rails": { "iconPath": "../../icons/file_type_rails.svg" },
    "_f_rake": { "iconPath": "../../icons/file_type_rake.svg" },
    "_f_raku": { "iconPath": "../../icons/file_type_raku.svg" },
    "_f_light_raku": { "iconPath": "../../icons/file_type_light_raku.svg" },
    "_f_raml": { "iconPath": "../../icons/file_type_raml.svg" },
    "_f_razor": { "iconPath": "../../icons/file_type_razor.svg" },
    "_f_razzle": { "iconPath": "../../icons/file_type_razzle.svg" },
    "_f_light_razzle": { "iconPath": "../../icons/file_type_light_razzle.svg" },
    "_f_reactjs": { "iconPath": "../../icons/file_type_reactjs.svg" },
    "_f_reactrouter": { "iconPath": "../../icons/file_type_reactrouter.svg" },
    "_f_light_reactrouter": { "iconPath": "../../icons/file_type_light_reactrouter.svg" },
    "_f_reacttemplate": { "iconPath": "../../icons/file_type_reacttemplate.svg" },
    "_f_reactts": { "iconPath": "../../icons/file_type_reactts.svg" },
    "_f_reason": { "iconPath": "../../icons/file_type_reason.svg" },
    "_f_red": { "iconPath": "../../icons/file_type_red.svg" },
    "_f_registry": { "iconPath": "../../icons/file_type_registry.svg" },
    "_f_rego": { "iconPath": "../../icons/file_type_rego.svg" },
    "_f_rehype": { "iconPath": "../../icons/file_type_rehype.svg" },
    "_f_light_rehype": { "iconPath": "../../icons/file_type_light_rehype.svg" },
    "_f_remark": { "iconPath": "../../icons/file_type_remark.svg" },
    "_f_light_remark": { "iconPath": "../../icons/file_type_light_remark.svg" },
    "_f_renovate": { "iconPath": "../../icons/file_type_renovate.svg" },
    "_f_replit": { "iconPath": "../../icons/file_type_replit.svg" },
    "_f_light_replit": { "iconPath": "../../icons/file_type_light_replit.svg" },
    "_f_rescript": { "iconPath": "../../icons/file_type_rescript.svg" },
    "_f_rest": { "iconPath": "../../icons/file_type_rest.svg" },
    "_f_retext": { "iconPath": "../../icons/file_type_retext.svg" },
    "_f_light_retext": { "iconPath": "../../icons/file_type_light_retext.svg" },
    "_f_rexx": { "iconPath": "../../icons/file_type_rexx.svg" },
    "_f_riot": { "iconPath": "../../icons/file_type_riot.svg" },
    "_f_ripple": { "iconPath": "../../icons/file_type_ripple.svg" },
    "_f_rmd": { "iconPath": "../../icons/file_type_rmd.svg" },
    "_f_rnc": { "iconPath": "../../icons/file_type_rnc.svg" },
    "_f_robotframework": { "iconPath": "../../icons/file_type_robotframework.svg" },
    "_f_robots": { "iconPath": "../../icons/file_type_robots.svg" },
    "_f_rolldown": { "iconPath": "../../icons/file_type_rolldown.svg" },
    "_f_light_rolldown": { "iconPath": "../../icons/file_type_light_rolldown.svg" },
    "_f_rollup": { "iconPath": "../../icons/file_type_rollup.svg" },
    "_f_rome": { "iconPath": "../../icons/file_type_rome.svg" },
    "_f_light_rome": { "iconPath": "../../icons/file_type_light_rome.svg" },
    "_f_ron": { "iconPath": "../../icons/file_type_ron.svg" },
    "_f_rproj": { "iconPath": "../../icons/file_type_rproj.svg" },
    "_f_rspec": { "iconPath": "../../icons/file_type_rspec.svg" },
    "_f_rss": { "iconPath": "../../icons/file_type_rss.svg" },
    "_f_rubocop": { "iconPath": "../../icons/file_type_rubocop.svg" },
    "_f_light_rubocop": { "iconPath": "../../icons/file_type_light_rubocop.svg" },
    "_f_ruby": { "iconPath": "../../icons/file_type_ruby.svg" },
    "_f_rust": { "iconPath": "../../icons/file_type_rust.svg" },
    "_f_light_rust": { "iconPath": "../../icons/file_type_light_rust.svg" },
    "_f_rust_toolchain": { "iconPath": "../../icons/file_type_rust_toolchain.svg" },
    "_f_light_rust_toolchain": { "iconPath": "../../icons/file_type_light_rust_toolchain.svg" },
    "_f_s-lang": { "iconPath": "../../icons/file_type_s-lang.svg" },
    "_f_safetensors": { "iconPath": "../../icons/file_type_safetensors.svg" },
    "_f_light_safetensors": { "iconPath": "../../icons/file_type_light_safetensors.svg" },
    "_f_sails": { "iconPath": "../../icons/file_type_sails.svg" },
    "_f_saltstack": { "iconPath": "../../icons/file_type_saltstack.svg" },
    "_f_san": { "iconPath": "../../icons/file_type_san.svg" },
    "_f_sapphire_framework_cli": { "iconPath": "../../icons/file_type_sapphire_framework_cli.svg" },
    "_f_sas": { "iconPath": "../../icons/file_type_sas.svg" },
    "_f_sass": { "iconPath": "../../icons/file_type_sass.svg" },
    "_f_sbt": { "iconPath": "../../icons/file_type_sbt.svg" },
    "_f_scala": { "iconPath": "../../icons/file_type_scala.svg" },
    "_f_scilab": { "iconPath": "../../icons/file_type_scilab.svg" },
    "_f_script": { "iconPath": "../../icons/file_type_script.svg" },
    "_f_scss": { "iconPath": "../../icons/file_type_scss.svg" },
    "_f_sdlang": { "iconPath": "../../icons/file_type_sdlang.svg" },
    "_f_search_result": { "iconPath": "../../icons/file_type_search_result.svg" },
    "_f_seedkit": { "iconPath": "../../icons/file_type_seedkit.svg" },
    "_f_sentry": { "iconPath": "../../icons/file_type_sentry.svg" },
    "_f_sequelize": { "iconPath": "../../icons/file_type_sequelize.svg" },
    "_f_serverless": { "iconPath": "../../icons/file_type_serverless.svg" },
    "_f_shadcn": { "iconPath": "../../icons/file_type_shadcn.svg" },
    "_f_light_shadcn": { "iconPath": "../../icons/file_type_light_shadcn.svg" },
    "_f_shaderlab": { "iconPath": "../../icons/file_type_shaderlab.svg" },
    "_f_light_shaderlab": { "iconPath": "../../icons/file_type_light_shaderlab.svg" },
    "_f_shell": { "iconPath": "../../icons/file_type_shell.svg" },
    "_f_shellcheck": { "iconPath": "../../icons/file_type_shellcheck.svg" },
    "_f_shuttle": { "iconPath": "../../icons/file_type_shuttle.svg" },
    "_f_silverstripe": { "iconPath": "../../icons/file_type_silverstripe.svg" },
    "_f_sino": { "iconPath": "../../icons/file_type_sino.svg" },
    "_f_sitemap": { "iconPath": "../../icons/file_type_sitemap.svg" },
    "_f_siyuan": { "iconPath": "../../icons/file_type_siyuan.svg" },
    "_f_sketch": { "iconPath": "../../icons/file_type_sketch.svg" },
    "_f_skipper": { "iconPath": "../../icons/file_type_skipper.svg" },
    "_f_slang": { "iconPath": "../../icons/file_type_slang.svg" },
    "_f_slashup": { "iconPath": "../../icons/file_type_slashup.svg" },
    "_f_slice": { "iconPath": "../../icons/file_type_slice.svg" },
    "_f_slim": { "iconPath": "../../icons/file_type_slim.svg" },
    "_f_slint": { "iconPath": "../../icons/file_type_slint.svg" },
    "_f_sln": { "iconPath": "../../icons/file_type_sln.svg" },
    "_f_smarty": { "iconPath": "../../icons/file_type_smarty.svg" },
    "_f_smithery": { "iconPath": "../../icons/file_type_smithery.svg" },
    "_f_snakemake": { "iconPath": "../../icons/file_type_snakemake.svg" },
    "_f_snapcraft": { "iconPath": "../../icons/file_type_snapcraft.svg" },
    "_f_snaplet": { "iconPath": "../../icons/file_type_snaplet.svg" },
    "_f_snort": { "iconPath": "../../icons/file_type_snort.svg" },
    "_f_snyk": { "iconPath": "../../icons/file_type_snyk.svg" },
    "_f_solidarity": { "iconPath": "../../icons/file_type_solidarity.svg" },
    "_f_solidity": { "iconPath": "../../icons/file_type_solidity.svg" },
    "_f_light_solidity": { "iconPath": "../../icons/file_type_light_solidity.svg" },
    "_f_source": { "iconPath": "../../icons/file_type_source.svg" },
    "_f_spacengine": { "iconPath": "../../icons/file_type_spacengine.svg" },
    "_f_sparql": { "iconPath": "../../icons/file_type_sparql.svg" },
    "_f_spin": { "iconPath": "../../icons/file_type_spin.svg" },
    "_f_light_spin": { "iconPath": "../../icons/file_type_light_spin.svg" },
    "_f_sqf": { "iconPath": "../../icons/file_type_sqf.svg" },
    "_f_sql": { "iconPath": "../../icons/file_type_sql.svg" },
    "_f_sqlite": { "iconPath": "../../icons/file_type_sqlite.svg" },
    "_f_squirrel": { "iconPath": "../../icons/file_type_squirrel.svg" },
    "_f_sss": { "iconPath": "../../icons/file_type_sss.svg" },
    "_f_sst": { "iconPath": "../../icons/file_type_sst.svg" },
    "_f_stackblitz": { "iconPath": "../../icons/file_type_stackblitz.svg" },
    "_f_stan": { "iconPath": "../../icons/file_type_stan.svg" },
    "_f_stata": { "iconPath": "../../icons/file_type_stata.svg" },
    "_f_stencil": { "iconPath": "../../icons/file_type_stencil.svg" },
    "_f_storyboard": { "iconPath": "../../icons/file_type_storyboard.svg" },
    "_f_storybook": { "iconPath": "../../icons/file_type_storybook.svg" },
    "_f_stryker": { "iconPath": "../../icons/file_type_stryker.svg" },
    "_f_stylable": { "iconPath": "../../icons/file_type_stylable.svg" },
    "_f_style": { "iconPath": "../../icons/file_type_style.svg" },
    "_f_styled": { "iconPath": "../../icons/file_type_styled.svg" },
    "_f_stylelint": { "iconPath": "../../icons/file_type_stylelint.svg" },
    "_f_light_stylelint": { "iconPath": "../../icons/file_type_light_stylelint.svg" },
    "_f_stylish_haskell": { "iconPath": "../../icons/file_type_stylish_haskell.svg" },
    "_f_stylus": { "iconPath": "../../icons/file_type_stylus.svg" },
    "_f_light_stylus": { "iconPath": "../../icons/file_type_light_stylus.svg" },
    "_f_sublime": { "iconPath": "../../icons/file_type_sublime.svg" },
    "_f_subversion": { "iconPath": "../../icons/file_type_subversion.svg" },
    "_f_svelte": { "iconPath": "../../icons/file_type_svelte.svg" },
    "_f_svelteconfig": { "iconPath": "../../icons/file_type_svelteconfig.svg" },
    "_f_svg": { "iconPath": "../../icons/file_type_svg.svg" },
    "_f_svgo": { "iconPath": "../../icons/file_type_svgo.svg" },
    "_f_swagger": { "iconPath": "../../icons/file_type_swagger.svg" },
    "_f_swc": { "iconPath": "../../icons/file_type_swc.svg" },
    "_f_swift": { "iconPath": "../../icons/file_type_swift.svg" },
    "_f_swig": { "iconPath": "../../icons/file_type_swig.svg" },
    "_f_symfony": { "iconPath": "../../icons/file_type_symfony.svg" },
    "_f_light_symfony": { "iconPath": "../../icons/file_type_light_symfony.svg" },
    "_f_syncpack": { "iconPath": "../../icons/file_type_syncpack.svg" },
    "_f_systemd": { "iconPath": "../../icons/file_type_systemd.svg" },
    "_f_light_systemd": { "iconPath": "../../icons/file_type_light_systemd.svg" },
    "_f_systemverilog": { "iconPath": "../../icons/file_type_systemverilog.svg" },
    "_f_light_systemverilog": { "iconPath": "../../icons/file_type_light_systemverilog.svg" },
    "_f_t4tt": { "iconPath": "../../icons/file_type_t4tt.svg" },
    "_f_tailwind": { "iconPath": "../../icons/file_type_tailwind.svg" },
    "_f_tamagui": { "iconPath": "../../icons/file_type_tamagui.svg" },
    "_f_taplo": { "iconPath": "../../icons/file_type_taplo.svg" },
    "_f_taskfile": { "iconPath": "../../icons/file_type_taskfile.svg" },
    "_f_tauri": { "iconPath": "../../icons/file_type_tauri.svg" },
    "_f_tcl": { "iconPath": "../../icons/file_type_tcl.svg" },
    "_f_teal": { "iconPath": "../../icons/file_type_teal.svg" },
    "_f_templ": { "iconPath": "../../icons/file_type_templ.svg" },
    "_f_tera": { "iconPath": "../../icons/file_type_tera.svg" },
    "_f_terraform": { "iconPath": "../../icons/file_type_terraform.svg" },
    "_f_test": { "iconPath": "../../icons/file_type_test.svg" },
    "_f_testcafe": { "iconPath": "../../icons/file_type_testcafe.svg" },
    "_f_light_testcafe": { "iconPath": "../../icons/file_type_light_testcafe.svg" },
    "_f_testjs": { "iconPath": "../../icons/file_type_testjs.svg" },
    "_f_light_testjs": { "iconPath": "../../icons/file_type_light_testjs.svg" },
    "_f_testplane": { "iconPath": "../../icons/file_type_testplane.svg" },
    "_f_testts": { "iconPath": "../../icons/file_type_testts.svg" },
    "_f_tex": { "iconPath": "../../icons/file_type_tex.svg" },
    "_f_light_tex": { "iconPath": "../../icons/file_type_light_tex.svg" },
    "_f_text": { "iconPath": "../../icons/file_type_text.svg" },
    "_f_textile": { "iconPath": "../../icons/file_type_textile.svg" },
    "_f_tfs": { "iconPath": "../../icons/file_type_tfs.svg" },
    "_f_tiltfile": { "iconPath": "../../icons/file_type_tiltfile.svg" },
    "_f_tm": { "iconPath": "../../icons/file_type_tm.svg" },
    "_f_light_tm": { "iconPath": "../../icons/file_type_light_tm.svg" },
    "_f_tmux": { "iconPath": "../../icons/file_type_tmux.svg" },
    "_f_light_tmux": { "iconPath": "../../icons/file_type_light_tmux.svg" },
    "_f_todo": { "iconPath": "../../icons/file_type_todo.svg" },
    "_f_light_todo": { "iconPath": "../../icons/file_type_light_todo.svg" },
    "_f_toit": { "iconPath": "../../icons/file_type_toit.svg" },
    "_f_light_toit": { "iconPath": "../../icons/file_type_light_toit.svg" },
    "_f_toml": { "iconPath": "../../icons/file_type_toml.svg" },
    "_f_light_toml": { "iconPath": "../../icons/file_type_light_toml.svg" },
    "_f_toon": { "iconPath": "../../icons/file_type_toon.svg" },
    "_f_light_toon": { "iconPath": "../../icons/file_type_light_toon.svg" },
    "_f_tox": { "iconPath": "../../icons/file_type_tox.svg" },
    "_f_travis": { "iconPath": "../../icons/file_type_travis.svg" },
    "_f_tree": { "iconPath": "../../icons/file_type_tree.svg" },
    "_f_light_tree": { "iconPath": "../../icons/file_type_light_tree.svg" },
    "_f_tres": { "iconPath": "../../icons/file_type_tres.svg" },
    "_f_truffle": { "iconPath": "../../icons/file_type_truffle.svg" },
    "_f_trunk": { "iconPath": "../../icons/file_type_trunk.svg" },
    "_f_tsbuildinfo": { "iconPath": "../../icons/file_type_tsbuildinfo.svg" },
    "_f_tscn": { "iconPath": "../../icons/file_type_tscn.svg" },
    "_f_tsconfig": { "iconPath": "../../icons/file_type_tsconfig.svg" },
    "_f_tsdoc": { "iconPath": "../../icons/file_type_tsdoc.svg" },
    "_f_tsdown": { "iconPath": "../../icons/file_type_tsdown.svg" },
    "_f_tslint": { "iconPath": "../../icons/file_type_tslint.svg" },
    "_f_tt": { "iconPath": "../../icons/file_type_tt.svg" },
    "_f_ttcn": { "iconPath": "../../icons/file_type_ttcn.svg" },
    "_f_tuc": { "iconPath": "../../icons/file_type_tuc.svg" },
    "_f_turbo": { "iconPath": "../../icons/file_type_turbo.svg" },
    "_f_light_turbo": { "iconPath": "../../icons/file_type_light_turbo.svg" },
    "_f_twig": { "iconPath": "../../icons/file_type_twig.svg" },
    "_f_typedoc": { "iconPath": "../../icons/file_type_typedoc.svg" },
    "_f_typescript": { "iconPath": "../../icons/file_type_typescript.svg" },
    "_f_typescriptdef": { "iconPath": "../../icons/file_type_typescriptdef.svg" },
    "_f_typo3": { "iconPath": "../../icons/file_type_typo3.svg" },
    "_f_uiua": { "iconPath": "../../icons/file_type_uiua.svg" },
    "_f_unibeautify": { "iconPath": "../../icons/file_type_unibeautify.svg" },
    "_f_light_unibeautify": { "iconPath": "../../icons/file_type_light_unibeautify.svg" },
    "_f_unison": { "iconPath": "../../icons/file_type_unison.svg" },
    "_f_unlicense": { "iconPath": "../../icons/file_type_unlicense.svg" },
    "_f_unocss": { "iconPath": "../../icons/file_type_unocss.svg" },
    "_f_uv": { "iconPath": "../../icons/file_type_uv.svg" },
    "_f_vagrant": { "iconPath": "../../icons/file_type_vagrant.svg" },
    "_f_vala": { "iconPath": "../../icons/file_type_vala.svg" },
    "_f_vanilla_extract": { "iconPath": "../../icons/file_type_vanilla_extract.svg" },
    "_f_vapi": { "iconPath": "../../icons/file_type_vapi.svg" },
    "_f_vapor": { "iconPath": "../../icons/file_type_vapor.svg" },
    "_f_vash": { "iconPath": "../../icons/file_type_vash.svg" },
    "_f_light_vash": { "iconPath": "../../icons/file_type_light_vash.svg" },
    "_f_vb": { "iconPath": "../../icons/file_type_vb.svg" },
    "_f_vba": { "iconPath": "../../icons/file_type_vba.svg" },
    "_f_vbhtml": { "iconPath": "../../icons/file_type_vbhtml.svg" },
    "_f_vbproj": { "iconPath": "../../icons/file_type_vbproj.svg" },
    "_f_vcxproj": { "iconPath": "../../icons/file_type_vcxproj.svg" },
    "_f_velocity": { "iconPath": "../../icons/file_type_velocity.svg" },
    "_f_vento": { "iconPath": "../../icons/file_type_vento.svg" },
    "_f_vercel": { "iconPath": "../../icons/file_type_vercel.svg" },
    "_f_light_vercel": { "iconPath": "../../icons/file_type_light_vercel.svg" },
    "_f_verilog": { "iconPath": "../../icons/file_type_verilog.svg" },
    "_f_vhdl": { "iconPath": "../../icons/file_type_vhdl.svg" },
    "_f_video": { "iconPath": "../../icons/file_type_video.svg" },
    "_f_view": { "iconPath": "../../icons/file_type_view.svg" },
    "_f_vim": { "iconPath": "../../icons/file_type_vim.svg" },
    "_f_vite": { "iconPath": "../../icons/file_type_vite.svg" },
    "_f_light_vite": { "iconPath": "../../icons/file_type_light_vite.svg" },
    "_f_vitest": { "iconPath": "../../icons/file_type_vitest.svg" },
    "_f_light_vitest": { "iconPath": "../../icons/file_type_light_vitest.svg" },
    "_f_vlang": { "iconPath": "../../icons/file_type_vlang.svg" },
    "_f_volt": { "iconPath": "../../icons/file_type_volt.svg" },
    "_f_vroom": { "iconPath": "../../icons/file_type_vroom.svg" },
    "_f_vscode": { "iconPath": "../../icons/file_type_vscode.svg" },
    "_f_vscode_test": { "iconPath": "../../icons/file_type_vscode_test.svg" },
    "_f_vsix": { "iconPath": "../../icons/file_type_vsix.svg" },
    "_f_light_vsix": { "iconPath": "../../icons/file_type_light_vsix.svg" },
    "_f_vsixmanifest": { "iconPath": "../../icons/file_type_vsixmanifest.svg" },
    "_f_light_vsixmanifest": { "iconPath": "../../icons/file_type_light_vsixmanifest.svg" },
    "_f_vue": { "iconPath": "../../icons/file_type_vue.svg" },
    "_f_vueconfig": { "iconPath": "../../icons/file_type_vueconfig.svg" },
    "_f_vvvvvv": { "iconPath": "../../icons/file_type_vvvvvv.svg" },
    "_f_vyper": { "iconPath": "../../icons/file_type_vyper.svg" },
    "_f_wallaby": { "iconPath": "../../icons/file_type_wallaby.svg" },
    "_f_wally": { "iconPath": "../../icons/file_type_wally.svg" },
    "_f_wasm": { "iconPath": "../../icons/file_type_wasm.svg" },
    "_f_watchmanconfig": { "iconPath": "../../icons/file_type_watchmanconfig.svg" },
    "_f_wdio": { "iconPath": "../../icons/file_type_wdio.svg" },
    "_f_weblate": { "iconPath": "../../icons/file_type_weblate.svg" },
    "_f_webpack": { "iconPath": "../../icons/file_type_webpack.svg" },
    "_f_wenyan": { "iconPath": "../../icons/file_type_wenyan.svg" },
    "_f_wercker": { "iconPath": "../../icons/file_type_wercker.svg" },
    "_f_wgsl": { "iconPath": "../../icons/file_type_wgsl.svg" },
    "_f_wikitext": { "iconPath": "../../icons/file_type_wikitext.svg" },
    "_f_windi": { "iconPath": "../../icons/file_type_windi.svg" },
    "_f_wit": { "iconPath": "../../icons/file_type_wit.svg" },
    "_f_wolfram": { "iconPath": "../../icons/file_type_wolfram.svg" },
    "_f_word": { "iconPath": "../../icons/file_type_word.svg" },
    "_f_wpml": { "iconPath": "../../icons/file_type_wpml.svg" },
    "_f_wurst": { "iconPath": "../../icons/file_type_wurst.svg" },
    "_f_wxml": { "iconPath": "../../icons/file_type_wxml.svg" },
    "_f_wxss": { "iconPath": "../../icons/file_type_wxss.svg" },
    "_f_wxt": { "iconPath": "../../icons/file_type_wxt.svg" },
    "_f_xaml": { "iconPath": "../../icons/file_type_xaml.svg" },
    "_f_xcode": { "iconPath": "../../icons/file_type_xcode.svg" },
    "_f_xfl": { "iconPath": "../../icons/file_type_xfl.svg" },
    "_f_light_xfl": { "iconPath": "../../icons/file_type_light_xfl.svg" },
    "_f_xib": { "iconPath": "../../icons/file_type_xib.svg" },
    "_f_xliff": { "iconPath": "../../icons/file_type_xliff.svg" },
    "_f_xmake": { "iconPath": "../../icons/file_type_xmake.svg" },
    "_f_xml": { "iconPath": "../../icons/file_type_xml.svg" },
    "_f_xo": { "iconPath": "../../icons/file_type_xo.svg" },
    "_f_xorg": { "iconPath": "../../icons/file_type_xorg.svg" },
    "_f_light_xorg": { "iconPath": "../../icons/file_type_light_xorg.svg" },
    "_f_xquery": { "iconPath": "../../icons/file_type_xquery.svg" },
    "_f_xsl": { "iconPath": "../../icons/file_type_xsl.svg" },
    "_f_yacc": { "iconPath": "../../icons/file_type_yacc.svg" },
    "_f_yaml": { "iconPath": "../../icons/file_type_yaml.svg" },
    "_f_light_yaml": { "iconPath": "../../icons/file_type_light_yaml.svg" },
    "_f_yamllint": { "iconPath": "../../icons/file_type_yamllint.svg" },
    "_f_yandex": { "iconPath": "../../icons/file_type_yandex.svg" },
    "_f_yang": { "iconPath": "../../icons/file_type_yang.svg" },
    "_f_yarn": { "iconPath": "../../icons/file_type_yarn.svg" },
    "_f_yeoman": { "iconPath": "../../icons/file_type_yeoman.svg" },
    "_f_zig": { "iconPath": "../../icons/file_type_zig.svg" },
    "_f_zip": { "iconPath": "../../icons/file_type_zip.svg" }
  },
  "file": "_file",
  "folder": "_folder",
  "folderExpanded": "_folder_open",
  "rootFolder": "_root_folder",
  "rootFolderExpanded": "_root_folder_open",
  "folderNames": {
    "android": "_fd_android",
    ".angular": "_fd_angular",
    "apache": "_fd_apache",
    "apache2": "_fd_apache",
    "httpd": "_fd_apache",
    "api": "_fd_api",
    ".api": "_fd_api",
    "apis": "_fd_api",
    ".apis": "_fd_api",
    "app": "_fd_app",
    "apps": "_fd_app",
    ".app": "_fd_app",
    "application": "_fd_app",
    "applications": "_fd_app",
    "arangodb": "_fd_arangodb",
    "arango": "_fd_arangodb",
    "assets": "_fd_asset",
    ".assets": "_fd_asset",
    ".astro": "_fd_astro",
    "audio": "_fd_audio",
    ".audio": "_fd_audio",
    "audios": "_fd_audio",
    ".audios": "_fd_audio",
    "sound": "_fd_audio",
    ".sound": "_fd_audio",
    "sounds": "_fd_audio",
    ".sounds": "_fd_audio",
    "aurelia_project": "_fd_aurelia",
    "aws": "_fd_aws",
    ".aws": "_fd_aws",
    "azure": "_fd_azure",
    ".azure": "_fd_azure",
    "azure-pipelines": "_fd_azurepipelines",
    ".azure-pipelines": "_fd_azurepipelines",
    "bin": "_fd_binary",
    ".bin": "_fd_binary",
    "blocs": "_fd_bloc",
    "bloc": "_fd_bloc",
    "blueprint": "_fd_blueprint",
    ".blueprint": "_fd_blueprint",
    "blueprints": "_fd_blueprint",
    ".blueprints": "_fd_blueprint",
    "bot": "_fd_bot",
    ".bot": "_fd_bot",
    "bower_components": "_fd_bower",
    ".buildkite": "_fd_buildkite",
    "cake": "_fd_cake",
    ".cake": "_fd_cake",
    "cargo": "_fd_cargo",
    ".cargo": "_fd_cargo",
    "crates": "_fd_cargo",
    "certificates": "_fd_certificate",
    ".certificates": "_fd_certificate",
    "certs": "_fd_certificate",
    "certs.": "_fd_certificate",
    ".changeset": "_fd_changesets",
    "chef": "_fd_chef",
    ".chef": "_fd_chef",
    ".circleci": "_fd_circleci",
    ".claude": "_fd_claude",
    "cli": "_fd_cli",
    "cmd": "_fd_cli",
    "command": "_fd_cli",
    "commands": "_fd_cli",
    "commandline": "_fd_cli",
    "console": "_fd_cli",
    "client": "_fd_client",
    "clients": "_fd_client",
    ".cloudflare": "_fd_cloudflare",
    "cloudflare": "_fd_cloudflare",
    ".cmake": "_fd_cmake",
    "cmake": "_fd_cmake",
    "common": "_fd_common",
    "component": "_fd_component",
    "components": "_fd_component",
    ".components": "_fd_component",
    "gui": "_fd_component",
    "src-ui": "_fd_component",
    "ui": "_fd_component",
    "widgets": "_fd_component",
    "composer": "_fd_composer",
    ".composer": "_fd_composer",
    "conf": "_fd_config",
    ".conf": "_fd_config",
    "config": "_fd_config",
    ".config": "_fd_config",
    "configs": "_fd_config",
    ".configs": "_fd_config",
    "configuration": "_fd_config",
    ".configuration": "_fd_config",
    "configurations": "_fd_config",
    ".configurations": "_fd_config",
    "setting": "_fd_config",
    ".setting": "_fd_config",
    "settings": "_fd_config",
    ".settings": "_fd_config",
    "ini": "_fd_config",
    ".ini": "_fd_config",
    "initializers": "_fd_config",
    ".initializers": "_fd_config",
    "__controller__": "_fd_controller",
    "__controllers__": "_fd_controller",
    "controller": "_fd_controller",
    "controllers": "_fd_controller",
    ".controllers": "_fd_controller",
    "__handler__": "_fd_controller",
    "__handlers__": "_fd_controller",
    "handler": "_fd_controller",
    ".handler": "_fd_controller",
    "handlers": "_fd_controller",
    ".handlers": "_fd_controller",
    "coverage": "_fd_coverage",
    "css": "_fd_css",
    "_css": "_fd_css",
    "cubits": "_fd_cubit",
    "cubit": "_fd_cubit",
    ".cursor": "_fd_cursor",
    "cypress": "_fd_cypress",
    ".dapr": "_fd_dapr",
    "dapr": "_fd_dapr",
    "dart": "_fd_dart",
    ".dart_tool": "_fd_dart",
    "datadog": "_fd_datadog",
    ".datadog": "_fd_datadog",
    "db": "_fd_db",
    "database": "_fd_db",
    "sql": "_fd_db",
    "data": "_fd_db",
    "repo": "_fd_db",
    "repository": "_fd_db",
    "repositories": "_fd_db",
    "store": "_fd_db",
    "stores": "_fd_db",
    "debian": "_fd_debian",
    "deb": "_fd_debian",
    ".dependabot": "_fd_dependabot",
    ".devcontainer": "_fd_devcontainer",
    "dist": "_fd_dist",
    ".dist": "_fd_dist",
    "dists": "_fd_dist",
    "out": "_fd_dist",
    "outs": "_fd_dist",
    "export": "_fd_dist",
    "exports": "_fd_dist",
    "build": "_fd_dist",
    ".build": "_fd_dist",
    "builds": "_fd_dist",
    "release": "_fd_dist",
    "releases": "_fd_dist",
    "target": "_fd_dist",
    "targets": "_fd_dist",
    "docker": "_fd_docker",
    ".docker": "_fd_docker",
    "docs": "_fd_docs",
    "doc": "_fd_docs",
    "document": "_fd_docs",
    "documents": "_fd_docs",
    "e2e": "_fd_e2e",
    ".elasticbeanstalk": "_fd_elasticbeanstalk",
    ".ebextensions": "_fd_elasticbeanstalk",
    "electron": "_fd_electron",
    ".expo": "_fd_expo",
    ".expo-shared": "_fd_expo",
    "favicon": "_fd_favicon",
    "favicons": "_fd_favicon",
    "flow": "_fd_flow",
    "flow-typed": "_fd_flow",
    "flutter": "_fd_flutter",
    "Flutter": "_fd_flutter",
    "fonts": "_fd_fonts",
    "font": "_fd_fonts",
    "fnt": "_fd_fonts",
    "webfonts": "_fd_fonts",
    ".front-commerce": "_fd_frontcommerce",
    "gcp": "_fd_gcp",
    ".gcp": "_fd_gcp",
    ".gemini": "_fd_gemini",
    ".git": "_fd_git",
    "submodules": "_fd_git",
    ".submodules": "_fd_git",
    ".github": "_fd_github",
    ".gitlab": "_fd_gitlab",
    "godot": "_fd_godot",
    ".godot": "_fd_godot",
    "gradle": "_fd_gradle",
    ".gradle": "_fd_gradle",
    "graphql": "_fd_graphql",
    "grunt": "_fd_grunt",
    "gulp": "_fd_gulp",
    "gulpfile.js": "_fd_gulp",
    "gulpfile.coffee": "_fd_gulp",
    "gulpfile.ts": "_fd_gulp",
    "gulpfile.babel.js": "_fd_gulp",
    "gulpfile.babel.coffee": "_fd_gulp",
    "gulpfile.babel.ts": "_fd_gulp",
    ".haxelib": "_fd_haxelib",
    "haxe_libraries": "_fd_haxelib",
    "helper": "_fd_helper",
    ".helper": "_fd_helper",
    "helpers": "_fd_helper",
    ".helpers": "_fd_helper",
    ".histoire": "_fd_histoire",
    "hook": "_fd_hook",
    ".hook": "_fd_hook",
    "hooks": "_fd_hook",
    ".hooks": "_fd_hook",
    ".husky": "_fd_husky",
    ".idea": "_fd_idea",
    ".fig": "_fd_images",
    ".figs": "_fd_images",
    "images": "_fd_images",
    "image": "_fd_images",
    ".img": "_fd_images",
    "img": "_fd_images",
    ".imgs": "_fd_images",
    "imgs": "_fd_images",
    "icons": "_fd_images",
    "icon": "_fd_images",
    "ico": "_fd_images",
    "screenshot": "_fd_images",
    "screenshots": "_fd_images",
    "svg": "_fd_images",
    "texture": "_fd_images",
    "textures": "_fd_images",
    "include": "_fd_include",
    "includes": "_fd_include",
    "incl": "_fd_include",
    "inc": "_fd_include",
    ".include": "_fd_include",
    ".includes": "_fd_include",
    ".incl": "_fd_include",
    ".inc": "_fd_include",
    "_include": "_fd_include",
    "_includes": "_fd_include",
    "_incl": "_fd_include",
    "_inc": "_fd_include",
    "interface": "_fd_interfaces",
    "interfaces": "_fd_interfaces",
    "ios": "_fd_ios",
    "js": "_fd_js",
    "json": "_fd_json",
    ".junie": "_fd_junie",
    "kotlin": "_fd_kotlin",
    "Kotlin": "_fd_kotlin",
    ".kotlin": "_fd_kotlin",
    "kubernetes": "_fd_kubernetes",
    "k8s": "_fd_kubernetes",
    "kube": "_fd_kubernetes",
    "kuber": "_fd_kubernetes",
    ".kubernetes": "_fd_kubernetes",
    ".k8s": "_fd_kubernetes",
    ".kube": "_fd_kubernetes",
    ".kuber": "_fd_kubernetes",
    "less": "_fd_less",
    "_less": "_fd_less",
    "lib": "_fd_library",
    "libs": "_fd_library",
    ".lib": "_fd_library",
    ".libs": "_fd_library",
    "__lib__": "_fd_library",
    "__libs__": "_fd_library",
    "library": "_fd_library",
    "libraries": "_fd_library",
    "linux": "_fd_linux",
    "lang": "_fd_locale",
    "language": "_fd_locale",
    "languages": "_fd_locale",
    "locale": "_fd_locale",
    "locales": "_fd_locale",
    "_locale": "_fd_locale",
    "_locales": "_fd_locale",
    "internationalization": "_fd_locale",
    "globalization": "_fd_locale",
    "localization": "_fd_locale",
    "i18n": "_fd_locale",
    "g11n": "_fd_locale",
    "l10n": "_fd_locale",
    "log": "_fd_log",
    "logs": "_fd_log",
    "macos": "_fd_macos",
    "darwin": "_fd_macos",
    "mariadb": "_fd_mariadb",
    "maria": "_fd_mariadb",
    ".mvn": "_fd_maven",
    "mediawiki": "_fd_mediawiki",
    "memcached": "_fd_memcached",
    ".memcached": "_fd_memcached",
    ".meteor": "_fd_meteor",
    "middleware": "_fd_middleware",
    "middlewares": "_fd_middleware",
    ".minecraft": "_fd_minecraft",
    "minikube": "_fd_minikube",
    "minik8s": "_fd_minikube",
    "minikuber": "_fd_minikube",
    "mjml": "_fd_mjml",
    ".mjml": "_fd_mjml",
    "mocks": "_fd_mock",
    ".mocks": "_fd_mock",
    "__mocks__": "_fd_mock",
    "model": "_fd_model",
    ".model": "_fd_model",
    "models": "_fd_model",
    ".models": "_fd_model",
    "entities": "_fd_model",
    ".entities": "_fd_model",
    "modules": "_fd_module",
    "mojo": "_fd_mojo",
    "mongodb": "_fd_mongodb",
    "mongo": "_fd_mongodb",
    ".mypy_cache": "_fd_mypy",
    "mysqldb": "_fd_mysql",
    "mysql": "_fd_mysql",
    "netlify": "_fd_netlify",
    ".next": "_fd_next",
    "nginx": "_fd_nginx",
    "conf.d": "_fd_nginx",
    ".niv": "_fd_nix",
    ".nix": "_fd_nix",
    "nix": "_fd_nix",
    "niv": "_fd_nix",
    "node_modules": "_fd_node",
    "notebooks": "_fd_notebooks",
    "notebook": "_fd_notebooks",
    "notification": "_fd_notification",
    "notifications": "_fd_notification",
    "event": "_fd_notification",
    "events": "_fd_notification",
    ".nuget": "_fd_nuget",
    "nuxt": "_fd_nuxt",
    ".nuxt": "_fd_nuxt",
    "package": "_fd_package",
    "packages": "_fd_package",
    ".package": "_fd_package",
    ".packages": "_fd_package",
    "pkg": "_fd_package",
    ".paket": "_fd_paket",
    "php": "_fd_php",
    ".pio": "_fd_platformio",
    ".pioenvs": "_fd_platformio",
    "plugin": "_fd_plugin",
    ".plugin": "_fd_plugin",
    "plugins": "_fd_plugin",
    ".plugins": "_fd_plugin",
    "extension": "_fd_plugin",
    ".extension": "_fd_plugin",
    "extensions": "_fd_plugin",
    ".extensions": "_fd_plugin",
    "prisma": "_fd_prisma",
    "private": "_fd_private",
    ".private": "_fd_private",
    "public": "_fd_public",
    ".public": "_fd_public",
    ".pytest_cache": "_fd_pytest",
    ".venv": "_fd_python",
    ".virtualenv": "_fd_python",
    "__pycache__": "_fd_python",
    "ravendb": "_fd_ravendb",
    "redis": "_fd_redis",
    "redux": "_fd_redux",
    "route": "_fd_route",
    "routes": "_fd_route",
    "_route": "_fd_route",
    "_routes": "_fd_route",
    "router": "_fd_route",
    "routers": "_fd_route",
    "sass": "_fd_sass",
    "scss": "_fd_sass",
    "_sass": "_fd_sass",
    "_scss": "_fd_sass",
    "script": "_fd_script",
    "scripts": "_fd_script",
    "seedkit": "_fd_seedkit",
    ".seedkit": "_fd_seedkit",
    "server": "_fd_server",
    "service": "_fd_services",
    "services": "_fd_services",
    "share": "_fd_shared",
    "shared": "_fd_shared",
    ".share": "_fd_shared",
    ".shared": "_fd_shared",
    "__shared__": "_fd_shared",
    "__share__": "_fd_shared",
    ".snaplet": "_fd_snaplet",
    ".spin": "_fd_spin",
    "src": "_fd_src",
    "source": "_fd_src",
    "sources": "_fd_src",
    "__src__": "_fd_src",
    "sso": "_fd_sso",
    "story": "_fd_story",
    "stories": "_fd_story",
    "__stories__": "_fd_story",
    ".storybook": "_fd_story",
    "style": "_fd_style",
    "styles": "_fd_style",
    "supabase": "_fd_supabase",
    "svelte": "_fd_svelte",
    ".svelte-kit": "_fd_svelte",
    "src-tauri": "_fd_tauri",
    "temp": "_fd_temp",
    ".temp": "_fd_temp",
    "tmp": "_fd_temp",
    ".tmp": "_fd_temp",
    "template": "_fd_template",
    ".template": "_fd_template",
    "templates": "_fd_template",
    ".templates": "_fd_template",
    "tests": "_fd_test",
    ".tests": "_fd_test",
    "test": "_fd_test",
    ".test": "_fd_test",
    "__tests__": "_fd_test",
    "__test__": "_fd_test",
    "spec": "_fd_test",
    ".spec": "_fd_test",
    "specs": "_fd_test",
    ".specs": "_fd_test",
    "integration": "_fd_test",
    "theme": "_fd_theme",
    "themes": "_fd_theme",
    "tool": "_fd_tools",
    "tools": "_fd_tools",
    ".tools": "_fd_tools",
    "util": "_fd_tools",
    "utils": "_fd_tools",
    "utilities": "_fd_tools",
    "tooling": "_fd_tools",
    ".travis": "_fd_travis",
    ".trunk": "_fd_trunk",
    ".turbo": "_fd_turbo",
    "typescript": "_fd_typescript",
    "ts": "_fd_typescript",
    "typings": "_fd_typings",
    "types": "_fd_typings",
    "@types": "_fd_typings",
    "vagrant": "_fd_vagrant",
    ".vagrant": "_fd_vagrant",
    ".vercel": "_fd_vercel",
    "video": "_fd_video",
    ".video": "_fd_video",
    "videos": "_fd_video",
    ".videos": "_fd_video",
    "html": "_fd_view",
    "view": "_fd_view",
    "views": "_fd_view",
    "layout": "_fd_view",
    "layouts": "_fd_view",
    "page": "_fd_view",
    "pages": "_fd_view",
    "_view": "_fd_view",
    "_views": "_fd_view",
    "_layout": "_fd_view",
    "_layouts": "_fd_view",
    "_page": "_fd_view",
    "_pages": "_fd_view",
    ".vitepress": "_fd_vitepress",
    ".vs": "_fd_vs",
    ".vscode": "_fd_vscode",
    "vscode": "_fd_vscode",
    ".vscode-test": "_fd_vscode_test",
    "wasm": "_fd_wasm",
    "WASM": "_fd_wasm",
    "webassembly": "_fd_wasm",
    "WebAssembly": "_fd_wasm",
    "webpack": "_fd_webpack",
    ".webpack": "_fd_webpack",
    "windows": "_fd_windows",
    "win32": "_fd_windows",
    ".windsurf": "_fd_windsurf",
    "wit": "_fd_wit",
    ".web": "_fd_www",
    "www": "_fd_www",
    "wwwroot": "_fd_www",
    "web": "_fd_www",
    ".yarn": "_fd_yarn",
    ".zed": "_fd_zed"
  },
  "folderNamesExpanded": {
    "android": "_fd_android_open",
    ".angular": "_fd_angular_open",
    "apache": "_fd_apache_open",
    "apache2": "_fd_apache_open",
    "httpd": "_fd_apache_open",
    "api": "_fd_api_open",
    ".api": "_fd_api_open",
    "apis": "_fd_api_open",
    ".apis": "_fd_api_open",
    "app": "_fd_app_open",
    "apps": "_fd_app_open",
    ".app": "_fd_app_open",
    "application": "_fd_app_open",
    "applications": "_fd_app_open",
    "arangodb": "_fd_arangodb_open",
    "arango": "_fd_arangodb_open",
    "assets": "_fd_asset_open",
    ".assets": "_fd_asset_open",
    ".astro": "_fd_astro_open",
    "audio": "_fd_audio_open",
    ".audio": "_fd_audio_open",
    "audios": "_fd_audio_open",
    ".audios": "_fd_audio_open",
    "sound": "_fd_audio_open",
    ".sound": "_fd_audio_open",
    "sounds": "_fd_audio_open",
    ".sounds": "_fd_audio_open",
    "aurelia_project": "_fd_aurelia_open",
    "aws": "_fd_aws_open",
    ".aws": "_fd_aws_open",
    "azure": "_fd_azure_open",
    ".azure": "_fd_azure_open",
    "azure-pipelines": "_fd_azurepipelines_open",
    ".azure-pipelines": "_fd_azurepipelines_open",
    "bin": "_fd_binary_open",
    ".bin": "_fd_binary_open",
    "blocs": "_fd_bloc_open",
    "bloc": "_fd_bloc_open",
    "blueprint": "_fd_blueprint_open",
    ".blueprint": "_fd_blueprint_open",
    "blueprints": "_fd_blueprint_open",
    ".blueprints": "_fd_blueprint_open",
    "bot": "_fd_bot_open",
    ".bot": "_fd_bot_open",
    "bower_components": "_fd_bower_open",
    ".buildkite": "_fd_buildkite_open",
    "cake": "_fd_cake_open",
    ".cake": "_fd_cake_open",
    "cargo": "_fd_cargo_open",
    ".cargo": "_fd_cargo_open",
    "crates": "_fd_cargo_open",
    "certificates": "_fd_certificate_open",
    ".certificates": "_fd_certificate_open",
    "certs": "_fd_certificate_open",
    "certs.": "_fd_certificate_open",
    ".changeset": "_fd_changesets_open",
    "chef": "_fd_chef_open",
    ".chef": "_fd_chef_open",
    ".circleci": "_fd_circleci_open",
    ".claude": "_fd_claude_open",
    "cli": "_fd_cli_open",
    "cmd": "_fd_cli_open",
    "command": "_fd_cli_open",
    "commands": "_fd_cli_open",
    "commandline": "_fd_cli_open",
    "console": "_fd_cli_open",
    "client": "_fd_client_open",
    "clients": "_fd_client_open",
    ".cloudflare": "_fd_cloudflare_open",
    "cloudflare": "_fd_cloudflare_open",
    ".cmake": "_fd_cmake_open",
    "cmake": "_fd_cmake_open",
    "common": "_fd_common_open",
    "component": "_fd_component_open",
    "components": "_fd_component_open",
    ".components": "_fd_component_open",
    "gui": "_fd_component_open",
    "src-ui": "_fd_component_open",
    "ui": "_fd_component_open",
    "widgets": "_fd_component_open",
    "composer": "_fd_composer_open",
    ".composer": "_fd_composer_open",
    "conf": "_fd_config_open",
    ".conf": "_fd_config_open",
    "config": "_fd_config_open",
    ".config": "_fd_config_open",
    "configs": "_fd_config_open",
    ".configs": "_fd_config_open",
    "configuration": "_fd_config_open",
    ".configuration": "_fd_config_open",
    "configurations": "_fd_config_open",
    ".configurations": "_fd_config_open",
    "setting": "_fd_config_open",
    ".setting": "_fd_config_open",
    "settings": "_fd_config_open",
    ".settings": "_fd_config_open",
    "ini": "_fd_config_open",
    ".ini": "_fd_config_open",
    "initializers": "_fd_config_open",
    ".initializers": "_fd_config_open",
    "__controller__": "_fd_controller_open",
    "__controllers__": "_fd_controller_open",
    "controller": "_fd_controller_open",
    "controllers": "_fd_controller_open",
    ".controllers": "_fd_controller_open",
    "__handler__": "_fd_controller_open",
    "__handlers__": "_fd_controller_open",
    "handler": "_fd_controller_open",
    ".handler": "_fd_controller_open",
    "handlers": "_fd_controller_open",
    ".handlers": "_fd_controller_open",
    "coverage": "_fd_coverage_open",
    "css": "_fd_css_open",
    "_css": "_fd_css_open",
    "cubits": "_fd_cubit_open",
    "cubit": "_fd_cubit_open",
    ".cursor": "_fd_cursor_open",
    "cypress": "_fd_cypress_open",
    ".dapr": "_fd_dapr_open",
    "dapr": "_fd_dapr_open",
    "dart": "_fd_dart_open",
    ".dart_tool": "_fd_dart_open",
    "datadog": "_fd_datadog_open",
    ".datadog": "_fd_datadog_open",
    "db": "_fd_db_open",
    "database": "_fd_db_open",
    "sql": "_fd_db_open",
    "data": "_fd_db_open",
    "repo": "_fd_db_open",
    "repository": "_fd_db_open",
    "repositories": "_fd_db_open",
    "store": "_fd_db_open",
    "stores": "_fd_db_open",
    "debian": "_fd_debian_open",
    "deb": "_fd_debian_open",
    ".dependabot": "_fd_dependabot_open",
    ".devcontainer": "_fd_devcontainer_open",
    "dist": "_fd_dist_open",
    ".dist": "_fd_dist_open",
    "dists": "_fd_dist_open",
    "out": "_fd_dist_open",
    "outs": "_fd_dist_open",
    "export": "_fd_dist_open",
    "exports": "_fd_dist_open",
    "build": "_fd_dist_open",
    ".build": "_fd_dist_open",
    "builds": "_fd_dist_open",
    "release": "_fd_dist_open",
    "releases": "_fd_dist_open",
    "target": "_fd_dist_open",
    "targets": "_fd_dist_open",
    "docker": "_fd_docker_open",
    ".docker": "_fd_docker_open",
    "docs": "_fd_docs_open",
    "doc": "_fd_docs_open",
    "document": "_fd_docs_open",
    "documents": "_fd_docs_open",
    "e2e": "_fd_e2e_open",
    ".elasticbeanstalk": "_fd_elasticbeanstalk_open",
    ".ebextensions": "_fd_elasticbeanstalk_open",
    "electron": "_fd_electron_open",
    ".expo": "_fd_expo_open",
    ".expo-shared": "_fd_expo_open",
    "favicon": "_fd_favicon_open",
    "favicons": "_fd_favicon_open",
    "flow": "_fd_flow_open",
    "flow-typed": "_fd_flow_open",
    "flutter": "_fd_flutter_open",
    "Flutter": "_fd_flutter_open",
    "fonts": "_fd_fonts_open",
    "font": "_fd_fonts_open",
    "fnt": "_fd_fonts_open",
    "webfonts": "_fd_fonts_open",
    ".front-commerce": "_fd_frontcommerce_open",
    "gcp": "_fd_gcp_open",
    ".gcp": "_fd_gcp_open",
    ".gemini": "_fd_gemini_open",
    ".git": "_fd_git_open",
    "submodules": "_fd_git_open",
    ".submodules": "_fd_git_open",
    ".github": "_fd_github_open",
    ".gitlab": "_fd_gitlab_open",
    "godot": "_fd_godot_open",
    ".godot": "_fd_godot_open",
    "gradle": "_fd_gradle_open",
    ".gradle": "_fd_gradle_open",
    "graphql": "_fd_graphql_open",
    "grunt": "_fd_grunt_open",
    "gulp": "_fd_gulp_open",
    "gulpfile.js": "_fd_gulp_open",
    "gulpfile.coffee": "_fd_gulp_open",
    "gulpfile.ts": "_fd_gulp_open",
    "gulpfile.babel.js": "_fd_gulp_open",
    "gulpfile.babel.coffee": "_fd_gulp_open",
    "gulpfile.babel.ts": "_fd_gulp_open",
    ".haxelib": "_fd_haxelib_open",
    "haxe_libraries": "_fd_haxelib_open",
    "helper": "_fd_helper_open",
    ".helper": "_fd_helper_open",
    "helpers": "_fd_helper_open",
    ".helpers": "_fd_helper_open",
    ".histoire": "_fd_histoire_open",
    "hook": "_fd_hook_open",
    ".hook": "_fd_hook_open",
    "hooks": "_fd_hook_open",
    ".hooks": "_fd_hook_open",
    ".husky": "_fd_husky_open",
    ".idea": "_fd_idea_open",
    ".fig": "_fd_images_open",
    ".figs": "_fd_images_open",
    "images": "_fd_images_open",
    "image": "_fd_images_open",
    ".img": "_fd_images_open",
    "img": "_fd_images_open",
    ".imgs": "_fd_images_open",
    "imgs": "_fd_images_open",
    "icons": "_fd_images_open",
    "icon": "_fd_images_open",
    "ico": "_fd_images_open",
    "screenshot": "_fd_images_open",
    "screenshots": "_fd_images_open",
    "svg": "_fd_images_open",
    "texture": "_fd_images_open",
    "textures": "_fd_images_open",
    "include": "_fd_include_open",
    "includes": "_fd_include_open",
    "incl": "_fd_include_open",
    "inc": "_fd_include_open",
    ".include": "_fd_include_open",
    ".includes": "_fd_include_open",
    ".incl": "_fd_include_open",
    ".inc": "_fd_include_open",
    "_include": "_fd_include_open",
    "_includes": "_fd_include_open",
    "_incl": "_fd_include_open",
    "_inc": "_fd_include_open",
    "interface": "_fd_interfaces_open",
    "interfaces": "_fd_interfaces_open",
    "ios": "_fd_ios_open",
    "js": "_fd_js_open",
    "json": "_fd_json_open",
    ".junie": "_fd_junie_open",
    "kotlin": "_fd_kotlin_open",
    "Kotlin": "_fd_kotlin_open",
    ".kotlin": "_fd_kotlin_open",
    "kubernetes": "_fd_kubernetes_open",
    "k8s": "_fd_kubernetes_open",
    "kube": "_fd_kubernetes_open",
    "kuber": "_fd_kubernetes_open",
    ".kubernetes": "_fd_kubernetes_open",
    ".k8s": "_fd_kubernetes_open",
    ".kube": "_fd_kubernetes_open",
    ".kuber": "_fd_kubernetes_open",
    "less": "_fd_less_open",
    "_less": "_fd_less_open",
    "lib": "_fd_library_open",
    "libs": "_fd_library_open",
    ".lib": "_fd_library_open",
    ".libs": "_fd_library_open",
    "__lib__": "_fd_library_open",
    "__libs__": "_fd_library_open",
    "library": "_fd_library_open",
    "libraries": "_fd_library_open",
    "linux": "_fd_linux_open",
    "lang": "_fd_locale_open",
    "language": "_fd_locale_open",
    "languages": "_fd_locale_open",
    "locale": "_fd_locale_open",
    "locales": "_fd_locale_open",
    "_locale": "_fd_locale_open",
    "_locales": "_fd_locale_open",
    "internationalization": "_fd_locale_open",
    "globalization": "_fd_locale_open",
    "localization": "_fd_locale_open",
    "i18n": "_fd_locale_open",
    "g11n": "_fd_locale_open",
    "l10n": "_fd_locale_open",
    "log": "_fd_log_open",
    "logs": "_fd_log_open",
    "macos": "_fd_macos_open",
    "darwin": "_fd_macos_open",
    "mariadb": "_fd_mariadb_open",
    "maria": "_fd_mariadb_open",
    ".mvn": "_fd_maven_open",
    "mediawiki": "_fd_mediawiki_open",
    "memcached": "_fd_memcached_open",
    ".memcached": "_fd_memcached_open",
    ".meteor": "_fd_meteor_open",
    "middleware": "_fd_middleware_open",
    "middlewares": "_fd_middleware_open",
    ".minecraft": "_fd_minecraft_open",
    "minikube": "_fd_minikube_open",
    "minik8s": "_fd_minikube_open",
    "minikuber": "_fd_minikube_open",
    "mjml": "_fd_mjml_open",
    ".mjml": "_fd_mjml_open",
    "mocks": "_fd_mock_open",
    ".mocks": "_fd_mock_open",
    "__mocks__": "_fd_mock_open",
    "model": "_fd_model_open",
    ".model": "_fd_model_open",
    "models": "_fd_model_open",
    ".models": "_fd_model_open",
    "entities": "_fd_model_open",
    ".entities": "_fd_model_open",
    "modules": "_fd_module_open",
    "mojo": "_fd_mojo_open",
    "mongodb": "_fd_mongodb_open",
    "mongo": "_fd_mongodb_open",
    ".mypy_cache": "_fd_mypy_open",
    "mysqldb": "_fd_mysql_open",
    "mysql": "_fd_mysql_open",
    "netlify": "_fd_netlify_open",
    ".next": "_fd_next_open",
    "nginx": "_fd_nginx_open",
    "conf.d": "_fd_nginx_open",
    ".niv": "_fd_nix_open",
    ".nix": "_fd_nix_open",
    "nix": "_fd_nix_open",
    "niv": "_fd_nix_open",
    "node_modules": "_fd_node_open",
    "notebooks": "_fd_notebooks_open",
    "notebook": "_fd_notebooks_open",
    "notification": "_fd_notification_open",
    "notifications": "_fd_notification_open",
    "event": "_fd_notification_open",
    "events": "_fd_notification_open",
    ".nuget": "_fd_nuget_open",
    "nuxt": "_fd_nuxt_open",
    ".nuxt": "_fd_nuxt_open",
    "package": "_fd_package_open",
    "packages": "_fd_package_open",
    ".package": "_fd_package_open",
    ".packages": "_fd_package_open",
    "pkg": "_fd_package_open",
    ".paket": "_fd_paket_open",
    "php": "_fd_php_open",
    ".pio": "_fd_platformio_open",
    ".pioenvs": "_fd_platformio_open",
    "plugin": "_fd_plugin_open",
    ".plugin": "_fd_plugin_open",
    "plugins": "_fd_plugin_open",
    ".plugins": "_fd_plugin_open",
    "extension": "_fd_plugin_open",
    ".extension": "_fd_plugin_open",
    "extensions": "_fd_plugin_open",
    ".extensions": "_fd_plugin_open",
    "prisma": "_fd_prisma_open",
    "private": "_fd_private_open",
    ".private": "_fd_private_open",
    "public": "_fd_public_open",
    ".public": "_fd_public_open",
    ".pytest_cache": "_fd_pytest_open",
    ".venv": "_fd_python_open",
    ".virtualenv": "_fd_python_open",
    "__pycache__": "_fd_python_open",
    "ravendb": "_fd_ravendb_open",
    "redis": "_fd_redis_open",
    "redux": "_fd_redux_open",
    "route": "_fd_route_open",
    "routes": "_fd_route_open",
    "_route": "_fd_route_open",
    "_routes": "_fd_route_open",
    "router": "_fd_route_open",
    "routers": "_fd_route_open",
    "sass": "_fd_sass_open",
    "scss": "_fd_sass_open",
    "_sass": "_fd_sass_open",
    "_scss": "_fd_sass_open",
    "script": "_fd_script_open",
    "scripts": "_fd_script_open",
    "seedkit": "_fd_seedkit_open",
    ".seedkit": "_fd_seedkit_open",
    "server": "_fd_server_open",
    "service": "_fd_services_open",
    "services": "_fd_services_open",
    "share": "_fd_shared_open",
    "shared": "_fd_shared_open",
    ".share": "_fd_shared_open",
    ".shared": "_fd_shared_open",
    "__shared__": "_fd_shared_open",
    "__share__": "_fd_shared_open",
    ".snaplet": "_fd_snaplet_open",
    ".spin": "_fd_spin_open",
    "src": "_fd_src_open",
    "source": "_fd_src_open",
    "sources": "_fd_src_open",
    "__src__": "_fd_src_open",
    "sso": "_fd_sso_open",
    "story": "_fd_story_open",
    "stories": "_fd_story_open",
    "__stories__": "_fd_story_open",
    ".storybook": "_fd_story_open",
    "style": "_fd_style_open",
    "styles": "_fd_style_open",
    "supabase": "_fd_supabase_open",
    "svelte": "_fd_svelte_open",
    ".svelte-kit": "_fd_svelte_open",
    "src-tauri": "_fd_tauri_open",
    "temp": "_fd_temp_open",
    ".temp": "_fd_temp_open",
    "tmp": "_fd_temp_open",
    ".tmp": "_fd_temp_open",
    "template": "_fd_template_open",
    ".template": "_fd_template_open",
    "templates": "_fd_template_open",
    ".templates": "_fd_template_open",
    "tests": "_fd_test_open",
    ".tests": "_fd_test_open",
    "test": "_fd_test_open",
    ".test": "_fd_test_open",
    "__tests__": "_fd_test_open",
    "__test__": "_fd_test_open",
    "spec": "_fd_test_open",
    ".spec": "_fd_test_open",
    "specs": "_fd_test_open",
    ".specs": "_fd_test_open",
    "integration": "_fd_test_open",
    "theme": "_fd_theme_open",
    "themes": "_fd_theme_open",
    "tool": "_fd_tools_open",
    "tools": "_fd_tools_open",
    ".tools": "_fd_tools_open",
    "util": "_fd_tools_open",
    "utils": "_fd_tools_open",
    "utilities": "_fd_tools_open",
    "tooling": "_fd_tools_open",
    ".travis": "_fd_travis_open",
    ".trunk": "_fd_trunk_open",
    ".turbo": "_fd_turbo_open",
    "typescript": "_fd_typescript_open",
    "ts": "_fd_typescript_open",
    "typings": "_fd_typings_open",
    "types": "_fd_typings_open",
    "@types": "_fd_typings_open",
    "vagrant": "_fd_vagrant_open",
    ".vagrant": "_fd_vagrant_open",
    ".vercel": "_fd_vercel_open",
    "video": "_fd_video_open",
    ".video": "_fd_video_open",
    "videos": "_fd_video_open",
    ".videos": "_fd_video_open",
    "html": "_fd_view_open",
    "view": "_fd_view_open",
    "views": "_fd_view_open",
    "layout": "_fd_view_open",
    "layouts": "_fd_view_open",
    "page": "_fd_view_open",
    "pages": "_fd_view_open",
    "_view": "_fd_view_open",
    "_views": "_fd_view_open",
    "_layout": "_fd_view_open",
    "_layouts": "_fd_view_open",
    "_page": "_fd_view_open",
    "_pages": "_fd_view_open",
    ".vitepress": "_fd_vitepress_open",
    ".vs": "_fd_vs_open",
    ".vscode": "_fd_vscode_open",
    "vscode": "_fd_vscode_open",
    ".vscode-test": "_fd_vscode_test_open",
    "wasm": "_fd_wasm_open",
    "WASM": "_fd_wasm_open",
    "webassembly": "_fd_wasm_open",
    "WebAssembly": "_fd_wasm_open",
    "webpack": "_fd_webpack_open",
    ".webpack": "_fd_webpack_open",
    "windows": "_fd_windows_open",
    "win32": "_fd_windows_open",
    ".windsurf": "_fd_windsurf_open",
    "wit": "_fd_wit_open",
    ".web": "_fd_www_open",
    "www": "_fd_www_open",
    "wwwroot": "_fd_www_open",
    "web": "_fd_www_open",
    ".yarn": "_fd_yarn_open",
    ".zed": "_fd_zed_open"
  },
  "fileExtensions": {
    "accdb": "_f_access",
    "accdt": "_f_access",
    "mdb": "_f_access",
    "accda": "_f_access",
    "accdc": "_f_access",
    "accde": "_f_access",
    "accdp": "_f_access",
    "accdr": "_f_access",
    "accdu": "_f_access",
    "ade": "_f_access",
    "adp": "_f_access",
    "laccdb": "_f_access",
    "ldb": "_f_access",
    "mam": "_f_access",
    "maq": "_f_access",
    "mdw": "_f_access",
    "af": "_f_affinity",
    "aftemplate": "_f_affinity",
    "afdesign": "_f_affinitydesigner",
    "affinitydesigner": "_f_affinitydesigner",
    "afphoto": "_f_affinityphoto",
    "affinityphoto": "_f_affinityphoto",
    "afpub": "_f_affinitypublisher",
    "affinitypublisher": "_f_affinitypublisher",
    "ai": "_f_ai",
    "dal": "_f_al_dal",
    "gs": "_f_appscript",
    "ino": "_f_arduino",
    "pde": "_f_arduino",
    "ase": "_f_aseprite",
    "aseprite": "_f_aseprite",
    "aspx": "_f_aspx",
    "ascx": "_f_aspx",
    "asm": "_f_assembly",
    "s": "_f_assembly",
    "astro": "_f_astro",
    "atom": "_f_atom",
    "aac": "_f_audio",
    "act": "_f_audio",
    "aiff": "_f_audio",
    "amr": "_f_audio",
    "ape": "_f_audio",
    "au": "_f_audio",
    "dct": "_f_audio",
    "dss": "_f_audio",
    "dvf": "_f_audio",
    "flac": "_f_audio",
    "gsm": "_f_audio",
    "iklax": "_f_audio",
    "ivs": "_f_audio",
    "m4a": "_f_audio",
    "m4b": "_f_audio",
    "m4p": "_f_audio",
    "mmf": "_f_audio",
    "mogg": "_f_audio",
    "mp3": "_f_audio",
    "mpc": "_f_audio",
    "msv": "_f_audio",
    "oga": "_f_audio",
    "ogg": "_f_audio",
    "opus": "_f_audio",
    "ra": "_f_audio",
    "raw": "_f_audio",
    "tta": "_f_audio",
    "vox": "_f_audio",
    "wav": "_f_audio",
    "wma": "_f_audio",
    "avif": "_f_avif",
    "awk": "_f_awk",
    "back": "_f_bak",
    "backup": "_f_bak",
    "bak": "_f_bak",
    "a": "_f_binary",
    "app": "_f_binary",
    "bin": "_f_binary",
    "cmo": "_f_binary",
    "cmx": "_f_binary",
    "cma": "_f_binary",
    "cmxa": "_f_binary",
    "cmi": "_f_binary",
    "dll": "_f_binary",
    "exe": "_f_binary",
    "hl": "_f_binary",
    "ilk": "_f_binary",
    "lib": "_f_binary",
    "n": "_f_binary",
    "ndll": "_f_binary",
    "o": "_f_binary",
    "obj": "_f_binary",
    "pyc": "_f_binary",
    "pyd": "_f_binary",
    "pyo": "_f_binary",
    "pdb": "_f_binary",
    "scpt": "_f_binary",
    "scptd": "_f_binary",
    "so": "_f_binary",
    "blend": "_f_blender",
    "bb": "_f_blitzbasic",
    "buf.yaml": "_f_buf",
    "buf.yml": "_f_buf",
    "buf.gen.yml": "_f_buf",
    "buf.gen.yaml": "_f_buf",
    "buf.work.yaml": "_f_buf",
    "buf.work.yml": "_f_buf",
    "gemfile": "_f_bundler",
    "gemfile.lock": "_f_bundler",
    "cake": "_f_cake",
    "csr": "_f_cert",
    "crt": "_f_cert",
    "cer": "_f_cert",
    "der": "_f_cert",
    "pfx": "_f_cert",
    "p12": "_f_cert",
    "p7b": "_f_cert",
    "p7r": "_f_cert",
    "src": "_f_cert",
    "crl": "_f_cert",
    "sst": "_f_cert",
    "stl": "_f_cert",
    "lucee": "_f_cf",
    "h": "_f_cheader",
    "class": "_f_class",
    "cjm": "_f_clojure",
    "cljc": "_f_clojure",
    "cljs": "_f_clojurescript",
    "kit": "_f_codekit",
    "plist": "_f_config",
    "lcov": "_f_coverage",
    "hpp": "_f_cppheader",
    "hh": "_f_cppheader",
    "hxx": "_f_cppheader",
    "h++": "_f_cppheader",
    "csx": "_f_csharp",
    "csproj": "_f_csproj",
    "css.map": "_f_cssmap",
    "cy.js": "_f_cypress_spec",
    "cy.mjs": "_f_cypress_spec",
    "cy.cjs": "_f_cypress_spec",
    "cy.coffee": "_f_cypress_spec",
    "cy.ts": "_f_cypress_spec",
    "cy.tsx": "_f_cypress_spec",
    "cy.jsx": "_f_cypress_spec",
    "g.dart": "_f_dartlang_generated",
    "freezed.dart": "_f_dartlang_generated",
    "db": "_f_db",
    "deb": "_f_debian",
    "resolver.json": "_f_design_tokens",
    "resolver.json5": "_f_design_tokens",
    "resolver.jsonc": "_f_design_tokens",
    "tokens.json": "_f_design_tokens",
    "tokens.json5": "_f_design_tokens",
    "tokens.jsonc": "_f_design_tokens",
    "djt": "_f_django",
    "eco": "_f_docpad",
    "drawio": "_f_drawio",
    "dio": "_f_drawio",
    "drawio.png": "_f_drawio",
    "drawio.svg": "_f_drawio",
    "dio.png": "_f_drawio",
    "dio.svg": "_f_drawio",
    "dtd": "_f_dtd",
    "eex": "_f_eex",
    "heex": "_f_eex",
    "phoenix-heex": "_f_eex",
    "html-heex": "_f_eex",
    "ejs": "_f_ejs",
    "el": "_f_emacs",
    "elc": "_f_emacs",
    "ensime": "_f_ensime",
    "eps": "_f_eps",
    "epub": "_f_epub",
    "excalidraw": "_f_excalidraw",
    "excalidraw.json": "_f_excalidraw",
    "excalidraw.svg": "_f_excalidraw",
    "excalidraw.png": "_f_excalidraw",
    "xls": "_f_excel",
    "xlsx": "_f_excel",
    "xlsm": "_f_excel",
    "ods": "_f_libreoffice_calc",
    "fods": "_f_libreoffice_calc",
    "xlsb": "_f_excel",
    "fbx": "_f_fbx",
    "fba": "_f_fitbit",
    "fla": "_f_fla",
    "swf": "_f_flash",
    "swc": "_f_flash",
    "js.flow": "_f_flow",
    "woff": "_f_font",
    "woff2": "_f_font",
    "ttf": "_f_font",
    "otf": "_f_libreoffice_math",
    "eot": "_f_font",
    "pfa": "_f_font",
    "pfb": "_f_font",
    "sfd": "_f_font",
    "fsproj": "_f_fsproj",
    "gmx": "_f_gamemaker",
    "yy": "_f_gamemaker2",
    "yyp": "_f_gamemaker2",
    "gd.uid": "_f_gduid",
    "geojson": "_f_geojson",
    "xcf": "_f_gimp",
    "gleam": "_f_gleam",
    "glb": "_f_gltf",
    "gltf": "_f_gltf",
    "am": "_f_gnu",
    "ld": "_f_gnu",
    "m4": "_f_gnu",
    "makefile": "_f_gnu",
    "godot": "_f_godot",
    "gpg": "_f_gpg",
    "pgp": "_f_gpg",
    "gradle": "_f_gradle",
    "gr": "_f_grain",
    "hcl2": "_f_hashicorp",
    "sentinel": "_f_hashicorp",
    "hxproj": "_f_haxedevelop",
    "ejs.t": "_f_hygen",
    "idr": "_f_idris",
    "lidr": "_f_idris",
    "ibc": "_f_idrisbin",
    "ipkg": "_f_idrispkg",
    "jpeg": "_f_image",
    "jpg": "_f_image",
    "gif": "_f_image",
    "png": "_f_image",
    "bmp": "_f_image",
    "tiff": "_f_image",
    "heic": "_f_image",
    "ico": "_f_image",
    "icns": "_f_image",
    "webp": "_f_image",
    "imba": "_f_imba",
    "imba2": "_f_imba",
    "inc": "_f_inc",
    "include": "_f_inc",
    "infopathxml": "_f_infopath",
    "xsn": "_f_infopath",
    "xsf": "_f_infopath",
    "xtp2": "_f_infopath",
    "jar": "_f_jar",
    "jbuilder": "_f_jbuilder",
    "iml": "_f_jetbrains",
    "js.map": "_f_jsmap",
    "cjs.map": "_f_jsmap",
    "mjs.map": "_f_jsmap",
    "jsonl": "_f_json",
    "ndjson": "_f_json",
    "json5": "_f_json5",
    "schema.json": "_f_json_schema",
    "jsonld": "_f_jsonld",
    "json-ld": "_f_jsonld",
    "jsp": "_f_jsp",
    "jss": "_f_jss",
    "juice": "_f_juice",
    "ipynb": "_f_jupyter",
    "key": "_f_key",
    "pem": "_f_key",
    "ktm": "_f_kotlin",
    "language-configuration.json": "_f_language_configuration",
    "master": "_f_layout",
    "layout.html": "_f_layout",
    "layout.htm": "_f_layout",
    "odb": "_f_libreoffice_base",
    "otb": "_f_libreoffice_base",
    "ots": "_f_libreoffice_calc",
    "odg": "_f_libreoffice_draw",
    "otg": "_f_libreoffice_draw",
    "odp": "_f_libreoffice_impress",
    "otp": "_f_libreoffice_impress",
    "odf": "_f_libreoffice_math",
    "odt": "_f_libreoffice_writer",
    "ott": "_f_libreoffice_writer",
    "enc": "_f_license",
    "license": "_f_license",
    "lic": "_f_license",
    "hxp": "_f_lime",
    "liquid": "_f_liquid",
    "ls": "_f_livescript",
    "lnk": "_f_lnk",
    "log": "_f_log",
    "tlg": "_f_log",
    "luau": "_f_luau",
    "crec": "_f_lync",
    "ocrec": "_f_lync",
    "map": "_f_map",
    "mdown": "_f_markdown",
    "markdown": "_f_markdown",
    "marko.js": "_f_markojs",
    "fig": "_f_matlab",
    "mex": "_f_matlab",
    "mexn": "_f_matlab",
    "mexrs6": "_f_matlab",
    "mn": "_f_matlab",
    "mum": "_f_matlab",
    "mx": "_f_matlab",
    "mx3": "_f_matlab",
    "rwd": "_f_matlab",
    "slx": "_f_matlab",
    "slddc": "_f_matlab",
    "smv": "_f_matlab",
    "xvc": "_f_matlab",
    "mca": "_f_minecraft",
    "mcmeta": "_f_minecraft",
    "mojo": "_f_mojo",
    "🔥": "_f_mojo",
    "mql.yaml": "_f_mondoo",
    "mql.yml": "_f_mondoo",
    "mustache": "_f_mustache",
    "mst": "_f_mustache",
    "ndst.yaml": "_f_ndst",
    "ndst.yml": "_f_ndst",
    "ndst.json": "_f_ndst",
    "njsproj": "_f_njsproj",
    "noc": "_f_noc",
    "nupkg": "_f_nuget",
    "snupkg": "_f_nuget",
    "nuspec": "_f_nuget",
    "psmdcp": "_f_nuget",
    "npy": "_f_numpy",
    "npz": "_f_numpy",
    "nunj": "_f_nunjucks",
    "njs": "_f_nunjucks",
    "mli": "_f_ocaml_intf",
    "one": "_f_onenote",
    "onepkg": "_f_onenote",
    "onetoc": "_f_onenote",
    "onetoc2": "_f_onenote",
    "sig": "_f_onenote",
    "opam": "_f_opam",
    "cl": "_f_opencl",
    "opencl": "_f_opencl",
    "tofu": "_f_opentofu",
    "tofu.json": "_f_opentofu",
    "tofutest.hcl": "_f_opentofu",
    "tofutest.json": "_f_opentofu",
    "org": "_f_org",
    "pst": "_f_outlook",
    "bcmx": "_f_outlook",
    "otm": "_f_outlook",
    "msg": "_f_outlook",
    "oft": "_f_outlook",
    "ovpn": "_f_ovpn",
    "pkg": "_f_package",
    "paket.references": "_f_paket",
    "paket.template": "_f_paket",
    "patch": "_f_patch",
    "pcd": "_f_pcl",
    "pdf": "_f_pdf",
    "psd": "_f_photoshop",
    "php1": "_f_php",
    "php2": "_f_php",
    "php3": "_f_php",
    "php4": "_f_php",
    "php5": "_f_php",
    "php6": "_f_php",
    "phps": "_f_php",
    "phpsa": "_f_php",
    "phpt": "_f_php",
    "phtml": "_f_php",
    "phar": "_f_php",
    "pipeline": "_f_pipeline",
    "pu": "_f_plantuml",
    "plantuml": "_f_plantuml",
    "iuml": "_f_plantuml",
    "puml": "_f_plantuml",
    "pck": "_f_plsql_package",
    "pkb": "_f_plsql_package_body",
    "pkh": "_f_plsql_package_header",
    "pks": "_f_plsql_package_spec",
    "po": "_f_poedit",
    "mo": "_f_poedit",
    "postman_collection.json": "_f_postman",
    "postman_environment.json": "_f_postman",
    "postman_globals.json": "_f_postman",
    "pot": "_f_powerpoint",
    "potx": "_f_powerpoint",
    "potm": "_f_powerpoint",
    "pps": "_f_powerpoint",
    "ppsx": "_f_powerpoint",
    "ppsm": "_f_powerpoint",
    "ppt": "_f_powerpoint",
    "pptx": "_f_powerpoint",
    "pptm": "_f_powerpoint",
    "pa": "_f_powerpoint",
    "ppa": "_f_powerpoint",
    "ppam": "_f_powerpoint",
    "sldm": "_f_powerpoint",
    "sldx": "_f_powerpoint",
    "format.ps1xml": "_f_powershell_format",
    "psd1": "_f_powershell_psd",
    "psm1": "_f_powershell_psm",
    "types.ps1xml": "_f_powershell_types",
    "pro": "_f_prolog",
    "pub": "_f_publisher",
    "puz": "_f_publisher",
    "pyowo": "_f_pythowo",
    "q": "_f_q",
    "qbs": "_f_qbs",
    "qvd": "_f_qlikview",
    "qvw": "_f_qlikview",
    "rast": "_f_ra_syntax_tree",
    "rake": "_f_rake",
    "rt": "_f_reacttemplate",
    "reg": "_f_registry",
    "rego": "_f_rego",
    "ripple": "_f_ripple",
    "rnc": "_f_rnc",
    "ron": "_f_ron",
    "rproj": "_f_rproj",
    "rss": "_f_rss",
    "rbs": "_f_ruby",
    "safetensors": "_f_safetensors",
    "sls": "_f_saltstack",
    "sass": "_f_sass",
    "scssm": "_f_scss",
    "unity": "_f_shaderlab",
    "fish": "_f_shell",
    "sy": "_f_siyuan",
    "sketch": "_f_sketch",
    "eskip": "_f_skipper",
    "sln": "_f_sln",
    "slnx": "_f_sln",
    "slnf": "_f_sln",
    "spe": "_f_spacengine",
    "sqlite": "_f_sqlite",
    "sqlite3": "_f_sqlite",
    "db3": "_f_sqlite",
    "sss": "_f_sss",
    "dta": "_f_stata",
    "storyboard": "_f_storyboard",
    "story.js": "_f_storybook",
    "story.jsx": "_f_storybook",
    "story.ts": "_f_storybook",
    "story.tsx": "_f_storybook",
    "story.mdx": "_f_storybook",
    "story.svelte": "_f_storybook",
    "stories.js": "_f_storybook",
    "stories.jsx": "_f_storybook",
    "stories.ts": "_f_storybook",
    "stories.tsx": "_f_storybook",
    "stories.mdx": "_f_storybook",
    "stories.svelte": "_f_storybook",
    "sublime-project": "_f_sublime",
    "svg": "_f_svg",
    "tcl": "_f_tcl",
    "exp": "_f_tcl",
    "templ": "_f_templ",
    "tfstate": "_f_terraform",
    "tfvars": "_f_terraform",
    "tf": "_f_terraform",
    "tf.json": "_f_terraform",
    "tst": "_f_test",
    "test.js": "_f_testjs",
    "test.jsx": "_f_testjs",
    "test.mjs": "_f_testjs",
    "spec.js": "_f_testjs",
    "spec.jsx": "_f_testjs",
    "spec.mjs": "_f_testjs",
    "testplane.ts": "_f_testplane",
    "testplane.js": "_f_testplane",
    "testplane.cts": "_f_testplane",
    "testplane.cjs": "_f_testplane",
    "testplane.tsx": "_f_testplane",
    "testplane.jsx": "_f_testplane",
    "test.ts": "_f_testts",
    "test.tsx": "_f_testts",
    "test.mts": "_f_testts",
    "spec.ts": "_f_testts",
    "spec.tsx": "_f_testts",
    "spec.mts": "_f_testts",
    "e2e-test.ts": "_f_testts",
    "e2e-test.tsx": "_f_testts",
    "e2e-test.mts": "_f_testts",
    "e2e-spec.ts": "_f_testts",
    "e2e-spec.tsx": "_f_testts",
    "e2e-spec.mts": "_f_testts",
    "test-d.ts": "_f_testts",
    "test-d.tsx": "_f_testts",
    "test-d.mts": "_f_testts",
    "texi": "_f_tex",
    "tikz": "_f_tex",
    "csv": "_f_text",
    "tsv": "_f_text",
    "tm": "_f_tm",
    "tm.hcl": "_f_tm",
    "todo": "_f_todo",
    "tree": "_f_tree",
    "tres": "_f_tres",
    "tsbuildinfo": "_f_tsbuildinfo",
    "tscn": "_f_tscn",
    "tt2": "_f_tt",
    "d.ts": "_f_typescriptdef",
    "d.cts": "_f_typescriptdef",
    "d.mts": "_f_typescriptdef",
    "ua": "_f_uiua",
    "u": "_f_unison",
    "vala": "_f_vala",
    "css.ts": "_f_vanilla_extract",
    "vapi": "_f_vapi",
    "vash": "_f_vash",
    "vbhtml": "_f_vbhtml",
    "vbproj": "_f_vbproj",
    "vcxproj": "_f_vcxproj",
    "vto": "_f_vento",
    "vento": "_f_vento",
    "3g2": "_f_video",
    "3gp": "_f_video",
    "asf": "_f_video",
    "amv": "_f_video",
    "avi": "_f_video",
    "divx": "_f_video",
    "qt": "_f_video",
    "f4a": "_f_video",
    "f4b": "_f_video",
    "f4p": "_f_video",
    "f4v": "_f_video",
    "flv": "_f_video",
    "m2v": "_f_video",
    "m4v": "_f_video",
    "mkv": "_f_video",
    "mk3d": "_f_video",
    "mov": "_f_video",
    "mp2": "_f_video",
    "mp4": "_f_video",
    "mpe": "_f_video",
    "mpeg": "_f_video",
    "mpeg2": "_f_video",
    "mpg": "_f_video",
    "mpv": "_f_video",
    "nsv": "_f_video",
    "ogv": "_f_video",
    "rm": "_f_video",
    "rmvb": "_f_video",
    "svi": "_f_video",
    "vob": "_f_video",
    "webm": "_f_video",
    "wmv": "_f_video",
    "code-snippets": "_f_vscode",
    "code-workspace": "_f_vscode",
    "vsix": "_f_vsix",
    "vsixmanifest": "_f_vsixmanifest",
    "vvvvvv": "_f_vvvvvv",
    "vyi": "_f_vyper",
    "wasm": "_f_wasm",
    "wikitext": "_f_wikitext",
    "wit": "_f_wit",
    "doc": "_f_word",
    "docx": "_f_word",
    "docm": "_f_word",
    "dot": "_f_word",
    "dotx": "_f_word",
    "dotm": "_f_word",
    "wll": "_f_word",
    "wxml": "_f_wxml",
    "wxss": "_f_wxss",
    "xaml": "_f_xaml",
    "axaml": "_f_xaml",
    "xcodeproj": "_f_xcode",
    "xfl": "_f_xfl",
    "xib": "_f_xib",
    "xliff": "_f_xliff",
    "xlf": "_f_xliff",
    "pex": "_f_xml",
    "tmlanguage": "_f_xml",
    "zip": "_f_zip",
    "rar": "_f_zip",
    "7z": "_f_zip",
    "tar": "_f_zip",
    "tgz": "_f_zip",
    "bz": "_f_zip",
    "gz": "_f_zip",
    "bzip2": "_f_zip",
    "xz": "_f_zip",
    "bz2": "_f_zip",
    "whl": "_f_zip",
    "zipx": "_f_zip",
    "br": "_f_zip"
  },
  "fileNames": {
    "agents.md": "_f_agents",
    "alchemy.run.ts": "_f_alchemy",
    ".all-contributorsrc": "_f_allcontributors",
    "allurerc.js": "_f_allure",
    "allurerc.mjs": "_f_allure",
    "allurerc.cjs": "_f_allure",
    "allurerc.json": "_f_allure",
    "allurerc.yaml": "_f_allure",
    "allurerc.yml": "_f_allure",
    ".angular-cli.json": "_f_angular",
    "angular-cli.json": "_f_angular",
    "angular.json": "_f_angular",
    ".angular.json": "_f_angular",
    "antlers.html": "_f_antlers_html",
    "api-extractor.json": "_f_api_extractor",
    "api-extractor-base.json": "_f_api_extractor",
    ".appsemblerc.yaml": "_f_appsemble",
    "app-definition.yaml": "_f_appsemble",
    "appveyor.yml": "_f_appveyor",
    ".appveyor.yml": "_f_appveyor",
    "asconfig.json": "_f_assembly_script",
    "astro.config.js": "_f_astroconfig",
    "astro.config.cjs": "_f_astroconfig",
    "astro.config.mjs": "_f_astroconfig",
    "astro.config.ts": "_f_astroconfig",
    "astro.config.cts": "_f_astroconfig",
    "astro.config.mts": "_f_astroconfig",
    ".attw.json": "_f_attw",
    "aurelia.json": "_f_aurelia",
    "azure-pipelines.yml": "_f_azurepipelines",
    ".vsts-ci.yml": "_f_azurepipelines",
    ".babelrc": "_f_babel",
    ".babelignore": "_f_babel",
    ".babelrc.js": "_f_babel",
    ".babelrc.cjs": "_f_babel",
    ".babelrc.mjs": "_f_babel",
    ".babelrc.json": "_f_babel",
    "babel.config.js": "_f_babel",
    "babel.config.cjs": "_f_babel",
    "babel.config.mjs": "_f_babel",
    "babel.config.json": "_f_babel",
    ".bzrignore": "_f_bazaar",
    "BUILD.bazel": "_f_bazel",
    ".bazelrc": "_f_bazel",
    "bazel.rc": "_f_bazel",
    "bazel.bazelrc": "_f_bazel",
    ".bazelignore": "_f_bazel_ignore",
    ".bazelversion": "_f_bazel_version",
    "biome.json": "_f_biome",
    "biome.jsonc": "_f_biome",
    "bitbucket-pipelines.yml": "_f_bitbucketpipeline",
    ".bithoundrc": "_f_bithound",
    ".bowerrc": "_f_bower",
    "bower.json": "_f_bower",
    ".browserslistrc": "_f_browserslist",
    "browserslist": "_f_browserslist",
    ".buckconfig": "_f_buckbuild",
    ".bunfig.toml": "_f_bun",
    "bunfig.toml": "_f_bunfig",
    "bun.lockb": "_f_bun",
    "bun.lock": "_f_bun",
    ".bundlemonrc": "_f_bundlemon",
    "bundlemon.config.js": "_f_bundlemon",
    "bundlemon.config.mjs": "_f_bundlemon",
    "bundlemon.config.cjs": "_f_bundlemon",
    ".bundlemonrc.js": "_f_bundlemon",
    ".bundlemonrc.mjs": "_f_bundlemon",
    ".bundlemonrc.cjs": "_f_bundlemon",
    ".bundlemonrc.json": "_f_bundlemon",
    ".bundlemonrc.yaml": "_f_bundlemon",
    ".bundlemonrc.yml": "_f_bundlemon",
    "gemfile": "_f_bundler",
    "gemfile.lock": "_f_bundler",
    "capacitor.config.json": "_f_capacitor",
    "capacitor.config.ts": "_f_capacitor",
    "Cargo.toml": "_f_cargo",
    "Cargo.lock": "_f_cargo",
    ".changie.yaml": "_f_changie",
    ".changie.yml": "_f_changie",
    "chefignore": "_f_chef",
    "berksfile": "_f_chef",
    "berksfile.lock": "_f_chef",
    "policyfile.rb": "_f_chef",
    "policyfile.lock.json": "_f_chef",
    "circle.yml": "_f_circleci",
    "claude.md": "_f_claude",
    "wrangler.toml": "_f_cloudflare",
    ".cfignore": "_f_cloudfoundry",
    ".codacy.yml": "_f_codacy",
    ".codacy.yaml": "_f_codacy",
    ".codeclimate.yml": "_f_codeclimate",
    "codecov.yml": "_f_codecov",
    ".codecov.yml": "_f_codecov",
    "config.codekit": "_f_codekit",
    "config.codekit2": "_f_codekit",
    "config.codekit3": "_f_codekit",
    ".config.codekit": "_f_codekit",
    ".config.codekit2": "_f_codekit",
    ".config.codekit3": "_f_codekit",
    "codemagic.yaml": "_f_codemagic",
    "codeowners": "_f_codeowners",
    ".coderabbit.yaml": "_f_coderabbit",
    "coffeelint.json": "_f_coffeelint",
    ".coffeelintignore": "_f_coffeelint",
    ".czrc": "_f_commitizen",
    ".cz.json": "_f_commitizen",
    ".commitlintrc": "_f_commitlint",
    "commitlint.config.js": "_f_commitlint",
    "commitlint.config.cjs": "_f_commitlint",
    "commitlint.config.mjs": "_f_commitlint",
    "commitlint.config.ts": "_f_commitlint",
    "commitlint.config.cts": "_f_commitlint",
    ".commitlintrc.json": "_f_commitlint",
    ".commitlintrc.yaml": "_f_commitlint",
    ".commitlintrc.yml": "_f_commitlint",
    ".commitlintrc.js": "_f_commitlint",
    ".commitlintrc.cjs": "_f_commitlint",
    ".commitlintrc.mjs": "_f_commitlint",
    ".commitlintrc.ts": "_f_commitlint",
    ".commitlintrc.cts": "_f_commitlint",
    "composer.json": "_f_composer",
    "composer.lock": "_f_composer",
    "conanfile.txt": "_f_conan",
    "conanfile.py": "_f_conan",
    ".condarc": "_f_conda",
    ".tool-versions": "_f_config",
    "copilot-instructions.md": "_f_copilot",
    "github-copilot.xml": "_f_copilot",
    ".coverage": "_f_coverage",
    "lcov.info": "_f_coverage",
    ".coveralls.yml": "_f_coveralls",
    "craco.config.ts": "_f_craco",
    "craco.config.js": "_f_craco",
    "craco.config.cjs": "_f_craco",
    ".cracorc.ts": "_f_craco",
    ".cracorc.js": "_f_craco",
    ".cracorc": "_f_craco",
    "crowdin.yml": "_f_crowdin",
    "cspell.config.json": "_f_cspell",
    "cspell.config.js": "_f_cspell",
    "cspell.config.mjs": "_f_cspell",
    "cspell.config.cjs": "_f_cspell",
    "cspell.config.yaml": "_f_cspell",
    "cspell.config.yml": "_f_cspell",
    "cspell.json": "_f_cspell",
    "cspell.js": "_f_cspell",
    "cspell.mjs": "_f_cspell",
    "cspell.cjs": "_f_cspell",
    "cspell.yaml": "_f_cspell",
    "cspell.yml": "_f_cspell",
    ".cspell.json": "_f_cspell",
    ".cspell.js": "_f_cspell",
    ".cspell.mjs": "_f_cspell",
    ".cspell.cjs": "_f_cspell",
    ".cspell.yaml": "_f_cspell",
    ".cspell.yml": "_f_cspell",
    ".csscomb.json": "_f_csscomb",
    ".csslintrc": "_f_csslint",
    ".cursorignore": "_f_cursorrules",
    ".cursorindexingignore": "_f_cursorrules",
    ".cursorrules": "_f_cursorrules",
    ".cvsignore": "_f_cvs",
    "cypress.json": "_f_cypress",
    "cypress.env.json": "_f_cypress",
    "cypress.config.js": "_f_cypress",
    "cypress.config.ts": "_f_cypress",
    "cypress.config.cjs": "_f_cypress",
    "cypress.config.mjs": "_f_cypress",
    ".boringignore": "_f_darcs",
    ".pubignore": "_f_dartlang_ignore",
    "service.datadog.yaml": "_f_datadog",
    "datadog-ci.json": "_f_datadog",
    "static-analysis.datadog.yml": "_f_datadog",
    "static-analysis.datadog.yaml": "_f_datadog",
    "aptfile": "_f_debian",
    "deno.json": "_f_deno",
    "deno.jsonc": "_f_deno",
    "deno.lock": "_f_deno",
    ".denoifyrc": "_f_denoify",
    "denoify.config.json": "_f_denoify",
    "denoify.config.js": "_f_denoify",
    "dependabot.yml": "_f_dependabot",
    "dependabot.yaml": "_f_dependabot",
    "dependencies.yml": "_f_dependencies",
    "devcontainer.json": "_f_devcontainer",
    ".devcontainer.json": "_f_devcontainer",
    "devvit.json": "_f_devvit",
    "devvit.dev.json": "_f_devvit",
    "devvit.prod.json": "_f_devvit",
    "devvit.test.json": "_f_devvit",
    "devvit.config.js": "_f_devvit",
    "devvit.config.cjs": "_f_devvit",
    "devvit.config.mjs": "_f_devvit",
    "devvit.config.ts": "_f_devvit",
    "devvit.config.mts": "_f_devvit",
    "devvit.config.dev.js": "_f_devvit",
    "devvit.config.dev.cjs": "_f_devvit",
    "devvit.config.dev.mjs": "_f_devvit",
    "devvit.config.dev.ts": "_f_devvit",
    "devvit.config.dev.mts": "_f_devvit",
    "devvit.config.prod.js": "_f_devvit",
    "devvit.config.prod.cjs": "_f_devvit",
    "devvit.config.prod.mjs": "_f_devvit",
    "devvit.config.prod.ts": "_f_devvit",
    "devvit.config.prod.mts": "_f_devvit",
    "devvit.config.test.js": "_f_devvit",
    "devvit.config.test.cjs": "_f_devvit",
    "devvit.config.test.mjs": "_f_devvit",
    "devvit.config.test.ts": "_f_devvit",
    "devvit.config.test.mts": "_f_devvit",
    ".dockerignore": "_f_docker",
    "compose.yaml": "_f_docker",
    "compose.yml": "_f_docker",
    "docker-compose.yaml": "_f_docker",
    "docker-compose.yml": "_f_docker",
    "docker-compose.debug.yaml": "_f_docker",
    "docker-compose.debug.yml": "_f_docker",
    "docker-compose.ci-build.yaml": "_f_docker",
    "docker-compose.ci-build.yml": "_f_docker",
    "docker-compose.override.yaml": "_f_docker",
    "docker-compose.override.yml": "_f_docker",
    "docker-compose.vs.debug.yaml": "_f_docker",
    "docker-compose.vs.debug.yml": "_f_docker",
    "docker-compose.vs.release.yaml": "_f_docker",
    "docker-compose.vs.release.yml": "_f_docker",
    "docker-cloud.yaml": "_f_docker",
    "docker-cloud.yml": "_f_docker",
    "docker-compose.test.yml": "_f_dockertest",
    "docusaurus.config.ts": "_f_docusaurus",
    "docusaurus.config.mts": "_f_docusaurus",
    "docusaurus.config.cts": "_f_docusaurus",
    "docusaurus.config.js": "_f_docusaurus",
    "docusaurus.config.mjs": "_f_docusaurus",
    "docusaurus.config.cjs": "_f_docusaurus",
    ".doczrc": "_f_docz",
    "docz.js": "_f_docz",
    "docz.json": "_f_docz",
    ".docz.js": "_f_docz",
    ".docz.json": "_f_docz",
    "doczrc.js": "_f_docz",
    "doczrc.json": "_f_docz",
    "docz.config.js": "_f_docz",
    "docz.config.json": "_f_docz",
    ".dojorc": "_f_dojo",
    "doppler.yaml": "_f_doppler",
    "doppler-template.yaml": "_f_doppler",
    ".drone.yml": "_f_drone",
    ".drone.yml.sig": "_f_drone",
    "dune": "_f_dune",
    "dune-project": "_f_dune",
    "dune-workspace": "_f_dune",
    ".dvc": "_f_dvc",
    ".earthlyignore": "_f_earthly",
    "Earthfile": "_f_earthly",
    "store.config.json": "_f_eas-metadata",
    ".editorconfig": "_f_editorconfig",
    "forge.config.js": "_f_electron",
    "forge.config.ts": "_f_electron",
    ".eleventy.js": "_f_eleventy",
    "eleventy.config.js": "_f_eleventy",
    "eleventy.config.cjs": "_f_eleventy",
    "eleventy.config.mjs": "_f_eleventy",
    "elm-package.json": "_f_elm",
    ".ember-cli": "_f_ember",
    "emakefile": "_f_erlang",
    ".emakerfile": "_f_erlang",
    "esbuild.js": "_f_esbuild",
    "esbuild.mjs": "_f_esbuild",
    "esbuild.cjs": "_f_esbuild",
    "esbuild.ts": "_f_esbuild",
    "esbuild.config.js": "_f_esbuild",
    "esbuild.config.mjs": "_f_esbuild",
    "esbuild.config.cjs": "_f_esbuild",
    "esbuild.config.ts": "_f_esbuild",
    ".eslintrc": "_f_eslint",
    ".eslintignore": "_f_eslint",
    ".eslintcache": "_f_eslint",
    "eslint.config.js": "_f_eslint",
    "eslint.config.mjs": "_f_eslint",
    "eslint.config.cjs": "_f_eslint",
    "eslint.config.ts": "_f_eslint",
    "eslint.config.mts": "_f_eslint",
    "eslint.config.cts": "_f_eslint",
    ".eslintrc.js": "_f_eslint",
    ".eslintrc.mjs": "_f_eslint",
    ".eslintrc.cjs": "_f_eslint",
    ".eslintrc.ts": "_f_eslint",
    ".eslintrc.mts": "_f_eslint",
    ".eslintrc.cts": "_f_eslint",
    ".eslintrc.json": "_f_eslint",
    ".eslintrc.yaml": "_f_eslint",
    ".eslintrc.yml": "_f_eslint",
    "app.json": "_f_expo",
    "app.config.js": "_f_expo",
    "app.config.json": "_f_expo",
    "app.config.json5": "_f_expo",
    ".fantasticonrc": "_f_fantasticon",
    "fantasticonrc": "_f_fantasticon",
    ".fantasticonrc.json": "_f_fantasticon",
    "fantasticonrc.json": "_f_fantasticon",
    ".fantasticonrc.js": "_f_fantasticon",
    "fantasticonrc.js": "_f_fantasticon",
    "fastly.toml": "_f_fastly",
    ".faunarc": "_f_fauna",
    "favicon.ico": "_f_favicon",
    ".firebaserc": "_f_firebase",
    "firebase.json": "_f_firebasehosting",
    "storage.rules": "_f_firebasestorage",
    "firestore.rules": "_f_firestore",
    "firestore.indexes.json": "_f_firestore",
    "flareact.config.js": "_f_flareact",
    ".flooignore": "_f_floobits",
    ".flowconfig": "_f_flow",
    ".flutter-plugins": "_f_flutter",
    ".metadata": "_f_flutter",
    ".flutter-plugins-dependencies": "_f_flutter",
    "pubspec.lock": "_f_flutter_package",
    "pubspec.yaml": "_f_flutter_package",
    ".packages": "_f_flutter_package",
    "fly.toml": "_f_flyio",
    "formkit.config.js": "_f_formkit",
    "formkit.config.mjs": "_f_formkit",
    "formkit.config.cjs": "_f_formkit",
    "formkit.config.ts": "_f_formkit",
    ".fossaignore": "_f_fossa",
    "ignore-glob": "_f_fossil",
    ".front-commerce.js": "_f_frontcommerce",
    "front-commerce.config.ts": "_f_frontcommerce",
    "funding.yml": "_f_funding",
    "fuse.js": "_f_fusebox",
    "gatsby-browser.js": "_f_gatsby",
    "gatsby-browser.ts": "_f_gatsby",
    "gatsby-browser.tsx": "_f_gatsby",
    "gatsby-ssr.js": "_f_gatsby",
    "gatsby-ssr.ts": "_f_gatsby",
    "gatsby-ssr.tsx": "_f_gatsby",
    "gatsby-config.js": "_f_gatsby",
    "gatsby-config.ts": "_f_gatsby",
    "gatsby-config.mjs": "_f_gatsby",
    "gatsby-node.js": "_f_gatsby",
    "gatsby-node.ts": "_f_gatsby",
    "gatsby-node.mjs": "_f_gatsby",
    ".gcloudignore": "_f_gcloud",
    "gemini.md": "_f_gemini",
    "GEMINI.md": "_f_gemini",
    ".git": "_f_git",
    ".gitattributes": "_f_git",
    ".gitconfig": "_f_git",
    ".gitignore": "_f_git",
    ".gitmodules": "_f_git",
    ".gitkeep": "_f_git",
    ".git-blame-ignore-revs": "_f_git",
    ".mailmap": "_f_git",
    ".issuetracker": "_f_git",
    ".gitlab-ci.yml": "_f_gitlab",
    ".gitpod.yaml": "_f_gitpod",
    ".gitpod.yml": "_f_gitpod",
    "gitpod.yaml": "_f_gitpod",
    "gitpod.yml": "_f_gitpod",
    "gleam.toml": "_f_gleamconfig",
    "glide.yml": "_f_glide",
    ".glitterrc": "_f_glitter",
    "go.sum": "_f_go_package",
    "go.mod": "_f_go_package",
    "go.work": "_f_go_work",
    "go.work.sum": "_f_go_work",
    ".gqlconfig": "_f_graphql",
    ".graphqlconfig": "_f_graphql_config",
    ".graphqlconfig.yml": "_f_graphql_config",
    ".graphqlconfig.yaml": "_f_graphql_config",
    "greenkeeper.json": "_f_greenkeeper",
    "gridsome.config.js": "_f_gridsome",
    "gridsome.config.ts": "_f_gridsome",
    "gridsome.server.js": "_f_gridsome",
    "gridsome.server.ts": "_f_gridsome",
    "gridsome.client.js": "_f_gridsome",
    "gridsome.client.ts": "_f_gridsome",
    "gruntfile.js": "_f_grunt",
    "gruntfile.cjs": "_f_grunt",
    "gruntfile.coffee": "_f_grunt",
    "gruntfile.ts": "_f_grunt",
    "gruntfile.babel.js": "_f_grunt",
    "gruntfile.babel.cjs": "_f_grunt",
    "gruntfile.babel.coffee": "_f_grunt",
    "gruntfile.babel.ts": "_f_grunt",
    "gulpfile.js": "_f_gulp",
    "gulpfile.coffee": "_f_gulp",
    "gulpfile.ts": "_f_gulp",
    "gulpfile.mjs": "_f_gulp",
    "gulpfile.esm.js": "_f_gulp",
    "gulpfile.esm.coffee": "_f_gulp",
    "gulpfile.esm.ts": "_f_gulp",
    "gulpfile.esm.mjs": "_f_gulp",
    "gulpfile.babel.js": "_f_gulp",
    "gulpfile.babel.coffee": "_f_gulp",
    "gulpfile.babel.ts": "_f_gulp",
    "gulpfile.babel.mjs": "_f_gulp",
    "hardhat.config.cjs": "_f_hardhat",
    "hardhat.config.js": "_f_hardhat",
    "hardhat.config.ts": "_f_hardhat",
    "haxelib.json": "_f_haxe",
    "checkstyle.json": "_f_haxecheckstyle",
    ".p4ignore": "_f_helix",
    "chart.lock": "_f_helm",
    "chart.yaml": "_f_helm",
    "histoire.config.ts": "_f_histoire",
    "histoire.config.js": "_f_histoire",
    ".histoire.ts": "_f_histoire",
    ".histoire.js": "_f_histoire",
    "horusec-config.json": "_f_horusec",
    ".htmlhintrc": "_f_htmlhint",
    ".htmlvalidateignore": "_f_htmlvalidate",
    ".htmlvalidate.js": "_f_htmlvalidate",
    ".htmlvalidate.cjs": "_f_htmlvalidate",
    ".htmlvalidate.json": "_f_htmlvalidate",
    "hugo.json": "_f_hugo",
    "hugo.toml": "_f_hugo",
    "hugo.yaml": "_f_hugo",
    ".hugo_build.lock": "_f_hugo",
    "humans.txt": "_f_humanstxt",
    ".huskyrc": "_f_husky",
    "husky.config.js": "_f_husky",
    ".huskyrc.js": "_f_husky",
    ".huskyrc.json": "_f_husky",
    ".huskyrc.yaml": "_f_husky",
    ".huskyrc.yml": "_f_husky",
    "ionic.project": "_f_ionic",
    "ionic.config.json": "_f_ionic",
    "jakefile": "_f_jake",
    "jakefile.js": "_f_jake",
    "jasmine.json": "_f_jasmine",
    ".nojekyll": "_f_jekyll",
    "jest.json": "_f_jest",
    "jest.config.babel.js": "_f_jest",
    ".jestrc": "_f_jest",
    ".jestrc.js": "_f_jest",
    ".jestrc.json": "_f_jest",
    "jest.config.js": "_f_jest",
    "jest.config.cjs": "_f_jest",
    "jest.config.mjs": "_f_jest",
    "jest.config.json": "_f_jest",
    "jest.config.ts": "_f_jest",
    "jest.config.base.js": "_f_jest",
    "jest.config.base.cjs": "_f_jest",
    "jest.config.base.mjs": "_f_jest",
    "jest.config.base.json": "_f_jest",
    "jest.config.base.ts": "_f_jest",
    "jest.config.common.js": "_f_jest",
    "jest.config.common.cjs": "_f_jest",
    "jest.config.common.mjs": "_f_jest",
    "jest.config.common.json": "_f_jest",
    "jest.config.common.ts": "_f_jest",
    "jest.config.e2e.js": "_f_jest",
    "jest.config.e2e.cjs": "_f_jest",
    "jest.config.e2e.mjs": "_f_jest",
    "jest.config.e2e.json": "_f_jest",
    "jest.config.e2e.ts": "_f_jest",
    "jest.config.int.js": "_f_jest",
    "jest.config.int.cjs": "_f_jest",
    "jest.config.int.mjs": "_f_jest",
    "jest.config.int.json": "_f_jest",
    "jest.config.int.ts": "_f_jest",
    "jest.config.integration.js": "_f_jest",
    "jest.config.integration.cjs": "_f_jest",
    "jest.config.integration.mjs": "_f_jest",
    "jest.config.integration.json": "_f_jest",
    "jest.config.integration.ts": "_f_jest",
    "jest.config.unit.js": "_f_jest",
    "jest.config.unit.cjs": "_f_jest",
    "jest.config.unit.mjs": "_f_jest",
    "jest.config.unit.json": "_f_jest",
    "jest.config.unit.ts": "_f_jest",
    ".jpmignore": "_f_jpm",
    ".jsbeautifyrc": "_f_jsbeautify",
    "jsbeautifyrc": "_f_jsbeautify",
    ".jsbeautify": "_f_jsbeautify",
    "jsbeautify": "_f_jsbeautify",
    "jsconfig.json": "_f_jsconfig",
    ".jscpd.json": "_f_jscpd",
    "jscpd-report.xml": "_f_jscpd",
    "jscpd-report.json": "_f_jscpd",
    "jscpd-report.html": "_f_jscpd",
    ".jshintrc": "_f_jshint",
    ".jshintignore": "_f_jshint",
    "jsr.json": "_f_jsr",
    "karma.conf.js": "_f_karma",
    "karma.conf.coffee": "_f_karma",
    "karma.conf.ts": "_f_karma",
    ".kitchen.yml": "_f_kitchenci",
    "kitchen.yml": "_f_kitchenci",
    ".kiteignore": "_f_kite",
    "knip.json": "_f_knip",
    "knip.jsonc": "_f_knip",
    ".knip.json": "_f_knip",
    ".knip.jsonc": "_f_knip",
    "knip.ts": "_f_knip",
    "knip.js": "_f_knip",
    "knip.config.ts": "_f_knip",
    "knip.config.js": "_f_knip",
    "language-configuration.json": "_f_language_configuration",
    "layout.html": "_f_layout",
    "layout.htm": "_f_layout",
    "lakefile.lean": "_f_leanconfig",
    "lakefile.toml": "_f_leanconfig",
    "lake-manifest.json": "_f_leanconfig",
    "lean-toolchain": "_f_leanconfig",
    "lefthook.json": "_f_lefthook",
    "lefthook.toml": "_f_lefthook",
    "lefthook.yaml": "_f_lefthook",
    "lefthook.yml": "_f_lefthook",
    "lefthook-local.json": "_f_lefthook",
    "lefthook-local.toml": "_f_lefthook",
    "lefthook-local.yaml": "_f_lefthook",
    "lefthook-local.yml": "_f_lefthook",
    ".lefthook.json": "_f_lefthook",
    ".lefthook.toml": "_f_lefthook",
    ".lefthook.yaml": "_f_lefthook",
    ".lefthook.yml": "_f_lefthook",
    ".lefthook-local.json": "_f_lefthook",
    ".lefthook-local.toml": "_f_lefthook",
    ".lefthook-local.yaml": "_f_lefthook",
    ".lefthook-local.yml": "_f_lefthook",
    "lerna.json": "_f_lerna",
    "liara.json": "_f_liara",
    ".liaraignore": "_f_liara",
    "licence": "_f_license",
    "LICENCE": "_f_license",
    "license": "_f_license",
    "LICENSE": "_f_license",
    "copying": "_f_license",
    "copying.lesser": "_f_license",
    "LICENSE-MIT": "_f_license",
    "license-mit": "_f_license",
    "LICENSE-APACHE": "_f_license",
    "license-apache": "_f_license",
    "LICENSE-GPL": "_f_license",
    "license-gpl": "_f_license",
    "LICENSE-AGPL": "_f_license",
    "license-agpl": "_f_license",
    "LICENCE.md": "_f_license",
    "LICENCE.txt": "_f_license",
    "licence.md": "_f_license",
    "licence.txt": "_f_license",
    "LICENSE.md": "_f_license",
    "LICENSE.txt": "_f_license",
    "license.md": "_f_license",
    "license.txt": "_f_license",
    "copying.md": "_f_license",
    "copying.txt": "_f_license",
    "copying.lesser.md": "_f_license",
    "copying.lesser.txt": "_f_license",
    "LICENSE-MIT.md": "_f_license",
    "LICENSE-MIT.txt": "_f_license",
    "license-mit.md": "_f_license",
    "license-mit.txt": "_f_license",
    "LICENSE-APACHE.md": "_f_license",
    "LICENSE-APACHE.txt": "_f_license",
    "license-apache.md": "_f_license",
    "license-apache.txt": "_f_license",
    "LICENSE-GPL.md": "_f_license",
    "LICENSE-GPL.txt": "_f_license",
    "license-gpl.md": "_f_license",
    "license-gpl.txt": "_f_license",
    "LICENSE-AGPL.md": "_f_license",
    "LICENSE-AGPL.txt": "_f_license",
    "license-agpl.md": "_f_license",
    "license-agpl.txt": "_f_license",
    ".licrc": "_f_licensebat",
    "budget.json": "_f_lighthouse",
    "budgets.json": "_f_lighthouse",
    ".lighthouserc.cjs": "_f_lighthouse",
    ".lighthouserc.js": "_f_lighthouse",
    ".lighthouserc.json": "_f_lighthouse",
    ".lighthouserc.yaml": "_f_lighthouse",
    ".lighthouserc.yml": "_f_lighthouse",
    "include.xml": "_f_lime",
    ".lintstagedrc": "_f_lintstagedrc",
    ".lintstagedrc.json": "_f_lintstagedrc",
    ".lintstagedrc.yaml": "_f_lintstagedrc",
    ".lintstagedrc.yml": "_f_lintstagedrc",
    ".lintstagedrc.mjs": "_f_lintstagedrc",
    ".lintstagedrc.mts": "_f_lintstagedrc",
    ".lintstagedrc.js": "_f_lintstagedrc",
    ".lintstagedrc.ts": "_f_lintstagedrc",
    ".lintstagedrc.cjs": "_f_lintstagedrc",
    ".lintstagedrc.cts": "_f_lintstagedrc",
    "lint-staged.config.mjs": "_f_lintstagedrc",
    "lint-staged.config.mts": "_f_lintstagedrc",
    "lint-staged.config.js": "_f_lintstagedrc",
    "lint-staged.config.ts": "_f_lintstagedrc",
    "lint-staged.config.cjs": "_f_lintstagedrc",
    "lint-staged.config.cts": "_f_lintstagedrc",
    "mailing.config.json": "_f_mailing",
    "manifest": "_f_manifest",
    "manifest.bak": "_f_manifest_bak",
    "manifest.skip": "_f_manifest_skip",
    ".markdownlintrc": "_f_markdownlint",
    ".markdownlint.json": "_f_markdownlint",
    ".markdownlint.jsonc": "_f_markdownlint",
    ".markdownlint.yml": "_f_markdownlint",
    ".markdownlint.yaml": "_f_markdownlint",
    ".markdownlint.cjs": "_f_markdownlint",
    ".markdownlint-cli2.json": "_f_markdownlint",
    ".markdownlint-cli2.jsonc": "_f_markdownlint",
    ".markdownlint-cli2.yml": "_f_markdownlint",
    ".markdownlint-cli2.yaml": "_f_markdownlint",
    ".markdownlint-cli2.cjs": "_f_markdownlint",
    ".markdownlintignore": "_f_markdownlint_ignore",
    ".markuplintrc": "_f_markuplint",
    ".markuplintrc.json": "_f_markuplint",
    ".markuplintrc.yaml": "_f_markuplint",
    ".markuplintrc.yml": "_f_markuplint",
    ".markuplintrc.js": "_f_markuplint",
    ".markuplintrc.cjs": "_f_markuplint",
    ".markuplintrc.mjs": "_f_markuplint",
    ".markuplintrc.ts": "_f_markuplint",
    "markuplint.config.json": "_f_markuplint",
    "markuplint.config.yaml": "_f_markuplint",
    "markuplint.config.yml": "_f_markuplint",
    "markuplint.config.js": "_f_markuplint",
    "markuplint.config.cjs": "_f_markuplint",
    "markuplint.config.mjs": "_f_markuplint",
    "markuplint.config.ts": "_f_markuplint",
    "master.js": "_f_master-co",
    "master.ts": "_f_master-co",
    "master.mjs": "_f_master-co",
    "master.json": "_f_master-co",
    "master.css.js": "_f_master-co",
    "master.css.ts": "_f_master-co",
    "master.css.mjs": "_f_master-co",
    "master.css.json": "_f_master-co",
    "maven.config": "_f_maven",
    "pom.xml": "_f_maven",
    "extensions.xml": "_f_maven",
    "settings.xml": "_f_maven",
    "mcp.json": "_f_mcp",
    "mdx-components.cjs": "_f_mdx-components",
    "mdx-components.cts": "_f_mdx-components",
    "mdx-components.js": "_f_mdx-components",
    "mdx-components.jsx": "_f_mdx-components",
    "mdx-components.mjs": "_f_mdx-components",
    "mdx-components.mts": "_f_mdx-components",
    "mdx-components.ts": "_f_mdx-components",
    "mdx-components.tsx": "_f_mdx-components",
    ".mdxlintrc": "_f_mdxlint",
    ".mdxlintignore": "_f_mdxlint",
    ".mdxlintrc.cjs": "_f_mdxlint",
    ".mdxlintrc.js": "_f_mdxlint",
    ".mdxlintrc.json": "_f_mdxlint",
    ".mdxlintrc.mjs": "_f_mdxlint",
    ".mdxlintrc.yml": "_f_mdxlint",
    ".mdxlintrc.yaml": "_f_mdxlint",
    ".hgignore": "_f_mercurial",
    "mocha.opts": "_f_mocha",
    ".mocharc.cjs": "_f_mocha",
    ".mocharc.js": "_f_mocha",
    ".mocharc.json": "_f_mocha",
    ".mocharc.jsonc": "_f_mocha",
    ".mocharc.mjs": "_f_mocha",
    ".mocharc.yaml": "_f_mocha",
    ".mocharc.yml": "_f_mocha",
    "modernizr": "_f_modernizr",
    "modernizr.js": "_f_modernizr",
    "modernizrrc.js": "_f_modernizr",
    ".modernizr.js": "_f_modernizr",
    ".modernizrrc.js": "_f_modernizr",
    "moleculer.config.js": "_f_moleculer",
    "moleculer.config.json": "_f_moleculer",
    "moleculer.config.ts": "_f_moleculer",
    ".mtn-ignore": "_f_monotone",
    "motif.json": "_f_motif",
    "mypy.ini": "_f_mypy",
    ".mypy.ini": "_f_mypy",
    ".nano-staged.js": "_f_nanostaged",
    "nano-staged.js": "_f_nanostaged",
    ".nano-staged.cjs": "_f_nanostaged",
    "nano-staged.cjs": "_f_nanostaged",
    ".nano-staged.mjs": "_f_nanostaged",
    "nano-staged.mjs": "_f_nanostaged",
    ".nano-staged.json": "_f_nanostaged",
    "nano-staged.json": "_f_nanostaged",
    ".nanostagedrc": "_f_nanostaged",
    ".nest-cli.json": "_f_nestjs",
    "nest-cli.json": "_f_nestjs",
    "nestconfig.json": "_f_nestjs",
    ".nestconfig.json": "_f_nestjs",
    "netlify.toml": "_f_netlify",
    "next.config.js": "_f_next",
    "next.config.cjs": "_f_next",
    "next.config.mjs": "_f_next",
    "next.config.ts": "_f_next",
    ".nf": "_f_nextflow",
    "ng-tailwind.js": "_f_ng_tailwind",
    "nginx.conf": "_f_nginx",
    "build.ninja": "_f_ninja",
    "flake.lock": "_f_nix",
    ".node-version": "_f_node",
    ".nvmrc": "_f_node",
    "node.config.json": "_f_node",
    "nodemon.json": "_f_nodemon",
    ".npmignore": "_f_npm",
    ".npmrc": "_f_npm",
    ".package-lock.json": "_f_npm",
    "package.json": "_f_npm",
    "package-lock.json": "_f_npm",
    "npm-shrinkwrap.json": "_f_npm",
    ".npmpackagejsonlintrc": "_f_npmpackagejsonlint",
    ".npmpackagejsonlintrc.cjs": "_f_npmpackagejsonlint",
    ".npmpackagejsonlintrc.js": "_f_npmpackagejsonlint",
    ".npmpackagejsonlintrc.json": "_f_npmpackagejsonlint",
    ".npmpackagejsonlintrc.yaml": "_f_npmpackagejsonlint",
    ".npmpackagejsonlintrc.yml": "_f_npmpackagejsonlint",
    ".npmpackagejsonlintrc.mjs": "_f_npmpackagejsonlint",
    ".npmpackagejsonlintignore": "_f_npmpackagejsonlint",
    "npmpackagejsonlint.config.cjs": "_f_npmpackagejsonlint",
    "npmpackagejsonlint.config.js": "_f_npmpackagejsonlint",
    "npmpackagejsonlint.config.mjs": "_f_npmpackagejsonlint",
    ".nsrirc": "_f_nsri",
    ".nsriignore": "_f_nsri",
    "nsri.config.js": "_f_nsri",
    ".nsrirc.js": "_f_nsri",
    ".nsrirc.json": "_f_nsri",
    ".nsrirc.yaml": "_f_nsri",
    ".nsrirc.yml": "_f_nsri",
    ".integrity.json": "_f_nsri-integrity",
    ".nuxtignore": "_f_nuxt",
    ".nuxtrc": "_f_nuxt",
    "nuxt.config.js": "_f_nuxt",
    "nuxt.config.ts": "_f_nuxt",
    "nuxt.config.mjs": "_f_nuxt",
    "nuxt.js": "_f_nuxt",
    "nuxt.ts": "_f_nuxt",
    "nuxt.mjs": "_f_nuxt",
    "nx.json": "_f_nx",
    ".nycrc": "_f_nyc",
    ".nycrc.json": "_f_nyc",
    ".objidconfig": "_f_objidconfig",
    ".merlin": "_f_ocaml",
    ".oxlintignore": "_f_oxc",
    ".oxlintrc.json": "_f_oxc",
    ".oxlintrc.jsonc": "_f_oxc",
    ".oxfmtrc.json": "_f_oxc",
    ".oxfmtrc.jsonc": "_f_oxc",
    ".packshiprc": "_f_packship",
    ".packshiprc.json": "_f_packship",
    ".packshiprc.js": "_f_packship",
    ".packshiprc.ts": "_f_packship",
    "packship.config.js": "_f_packship",
    "packship.config.ts": "_f_packship",
    "packship.config.mjs": "_f_packship",
    "packship.config.mts": "_f_packship",
    "packship.config.json": "_f_packship",
    "paket.dependencies": "_f_paket",
    "paket.lock": "_f_paket",
    "paket.references": "_f_paket",
    "paket.template": "_f_paket",
    "paket.local": "_f_paket",
    "panda.config.js": "_f_pandacss",
    "panda.config.mjs": "_f_pandacss",
    "panda.config.ts": "_f_pandacss",
    ".pdm-python": "_f_pdm",
    "pdm.lock": "_f_pdm",
    "pdm.toml": "_f_pdm",
    "peeky.config.ts": "_f_peeky",
    "peeky.config.js": "_f_peeky",
    "peeky.config.mjs": "_f_peeky",
    ".php-cs-fixer.php": "_f_phpcsfixer",
    ".php-cs-fixer.dist.php": "_f_phpcsfixer",
    ".php_cs": "_f_phpcsfixer",
    ".php_cs.dist": "_f_phpcsfixer",
    "phpstan.neon": "_f_phpstan",
    "phpstan.dist.neon": "_f_phpstan",
    "phpunit": "_f_phpunit",
    "phpunit.xml": "_f_phpunit",
    "phpunit.xml.dist": "_f_phpunit",
    ".phraseapp.yml": "_f_phraseapp",
    "pipfile": "_f_pip",
    "pipfile.lock": "_f_pip",
    "platformio.ini": "_f_platformio",
    "playwright.config.js": "_f_playwright",
    "playwright.config.ts": "_f_playwright",
    "playwright.config.mts": "_f_playwright",
    "playwright.config.mjs": "_f_playwright",
    "playwright.config.cts": "_f_playwright",
    "playwright.config.cjs": "_f_playwright",
    "ecosystem.config.js": "_f_pm2",
    "ecosystem.config.cjs": "_f_pm2",
    "ecosystem.config.json": "_f_pm2",
    "ecosystem.config.yaml": "_f_pm2",
    "ecosystem.config.yml": "_f_pm2",
    ".pnpmfile.cjs": "_f_pnpm",
    "pnpmfile.js": "_f_pnpm",
    "pnpm-lock.yaml": "_f_pnpm",
    "pnpm-workspace.yaml": "_f_pnpm",
    "poetry.lock": "_f_poetry",
    ".postcssrc": "_f_postcssconfig",
    ".postcssrc.json": "_f_postcssconfig",
    ".postcssrc.yaml": "_f_postcssconfig",
    ".postcssrc.yml": "_f_postcssconfig",
    ".postcssrc.ts": "_f_postcssconfig",
    ".postcssrc.cts": "_f_postcssconfig",
    ".postcssrc.mts": "_f_postcssconfig",
    ".postcssrc.js": "_f_postcssconfig",
    ".postcssrc.cjs": "_f_postcssconfig",
    ".postcssrc.mjs": "_f_postcssconfig",
    "postcss.config.ts": "_f_postcssconfig",
    "postcss.config.cts": "_f_postcssconfig",
    "postcss.config.mts": "_f_postcssconfig",
    "postcss.config.js": "_f_postcssconfig",
    "postcss.config.cjs": "_f_postcssconfig",
    "postcss.config.mjs": "_f_postcssconfig",
    "preact.config.js": "_f_preact",
    ".pre-commit-config.yaml": "_f_precommit",
    ".prettierrc": "_f_prettier",
    ".prettierignore": "_f_prettier",
    "prettier.config.js": "_f_prettier",
    "prettier.config.cjs": "_f_prettier",
    "prettier.config.mjs": "_f_prettier",
    "prettier.config.ts": "_f_prettier",
    "prettier.config.coffee": "_f_prettier",
    ".prettierrc.js": "_f_prettier",
    ".prettierrc.cjs": "_f_prettier",
    ".prettierrc.mjs": "_f_prettier",
    ".prettierrc.json": "_f_prettier",
    ".prettierrc.json5": "_f_prettier",
    ".prettierrc.yml": "_f_prettier",
    ".prettierrc.yaml": "_f_prettier",
    ".prettierrc.toml": "_f_prettier",
    "prisma.config.js": "_f_prismaconfig",
    "prisma.config.ts": "_f_prismaconfig",
    "procfile": "_f_procfile",
    "protractor.conf.js": "_f_protractor",
    "protractor.conf.coffee": "_f_protractor",
    "protractor.conf.ts": "_f_protractor",
    "publiccode.yml": "_f_publiccode",
    ".jade-lintrc": "_f_pug",
    ".pug-lintrc": "_f_pug",
    ".jade-lint.json": "_f_pug",
    ".pug-lintrc.js": "_f_pug",
    ".pug-lintrc.json": "_f_pug",
    "Pulumi.yaml": "_f_pulumi",
    "Pulumi.yml": "_f_pulumi",
    "Pulumi.dev.yaml": "_f_pulumi",
    "Pulumi.dev.yml": "_f_pulumi",
    "Pulumi.prod.yaml": "_f_pulumi",
    "Pulumi.prod.yml": "_f_pulumi",
    "purgecss.config.js": "_f_purgecss",
    ".python-version": "_f_pyenv",
    "pyproject.toml": "_f_pypi",
    "pytest.ini": "_f_pytest",
    ".pytest.ini": "_f_pytest",
    "pytest.toml": "_f_pytest",
    ".pytest.toml": "_f_pytest",
    "py.typed": "_f_pytyped",
    ".pyup": "_f_pyup",
    ".pyup.yml": "_f_pyup",
    "qmldir": "_f_qmldir",
    "quasar.conf.js": "_f_quasar",
    "quasar.config.js": "_f_quasar",
    "quasar.config.mjs": "_f_quasar",
    "quasar.config.cjs": "_f_quasar",
    "quasar.config.ts": "_f_quasar",
    "Rakefile": "_f_rake",
    "razzle.config.js": "_f_razzle",
    "react-router.config.js": "_f_reactrouter",
    "react-router.config.ts": "_f_reactrouter",
    ".rehyperc": "_f_rehype",
    ".rehypeignore": "_f_rehype",
    ".rehyperc.cjs": "_f_rehype",
    ".rehyperc.js": "_f_rehype",
    ".rehyperc.json": "_f_rehype",
    ".rehyperc.mjs": "_f_rehype",
    ".rehyperc.yml": "_f_rehype",
    ".rehyperc.yaml": "_f_rehype",
    ".remarkrc": "_f_remark",
    ".remarkignore": "_f_remark",
    ".remarkrc.cjs": "_f_remark",
    ".remarkrc.js": "_f_remark",
    ".remarkrc.json": "_f_remark",
    ".remarkrc.mjs": "_f_remark",
    ".remarkrc.yml": "_f_remark",
    ".remarkrc.yaml": "_f_remark",
    ".renovaterc": "_f_renovate",
    ".renovaterc.json": "_f_renovate",
    "renovate.json": "_f_renovate",
    "renovate.json5": "_f_renovate",
    ".replit": "_f_replit",
    "replit.nix": "_f_replit",
    ".retextrc": "_f_retext",
    ".retextignore": "_f_retext",
    ".retextrc.cjs": "_f_retext",
    ".retextrc.js": "_f_retext",
    ".retextrc.json": "_f_retext",
    ".retextrc.mjs": "_f_retext",
    ".retextrc.yml": "_f_retext",
    ".retextrc.yaml": "_f_retext",
    "robots.txt": "_f_robots",
    "rolldown.config.js": "_f_rolldown",
    "rolldown.config.cjs": "_f_rolldown",
    "rolldown.config.mjs": "_f_rolldown",
    "rolldown.config.coffee": "_f_rolldown",
    "rolldown.config.ts": "_f_rolldown",
    "rolldown.config.mts": "_f_rolldown",
    "rolldown.config.cts": "_f_rolldown",
    "rolldown.config.common.js": "_f_rolldown",
    "rolldown.config.common.cjs": "_f_rolldown",
    "rolldown.config.common.mjs": "_f_rolldown",
    "rolldown.config.common.coffee": "_f_rolldown",
    "rolldown.config.common.ts": "_f_rolldown",
    "rolldown.config.common.mts": "_f_rolldown",
    "rolldown.config.common.cts": "_f_rolldown",
    "rolldown.config.dev.js": "_f_rolldown",
    "rolldown.config.dev.cjs": "_f_rolldown",
    "rolldown.config.dev.mjs": "_f_rolldown",
    "rolldown.config.dev.coffee": "_f_rolldown",
    "rolldown.config.dev.ts": "_f_rolldown",
    "rolldown.config.dev.mts": "_f_rolldown",
    "rolldown.config.dev.cts": "_f_rolldown",
    "rolldown.config.prod.js": "_f_rolldown",
    "rolldown.config.prod.cjs": "_f_rolldown",
    "rolldown.config.prod.mjs": "_f_rolldown",
    "rolldown.config.prod.coffee": "_f_rolldown",
    "rolldown.config.prod.ts": "_f_rolldown",
    "rolldown.config.prod.mts": "_f_rolldown",
    "rolldown.config.prod.cts": "_f_rolldown",
    "rollup.config.js": "_f_rollup",
    "rollup.config.cjs": "_f_rollup",
    "rollup.config.mjs": "_f_rollup",
    "rollup.config.coffee": "_f_rollup",
    "rollup.config.ts": "_f_rollup",
    "rollup.config.common.js": "_f_rollup",
    "rollup.config.common.cjs": "_f_rollup",
    "rollup.config.common.mjs": "_f_rollup",
    "rollup.config.common.coffee": "_f_rollup",
    "rollup.config.common.ts": "_f_rollup",
    "rollup.config.dev.js": "_f_rollup",
    "rollup.config.dev.cjs": "_f_rollup",
    "rollup.config.dev.mjs": "_f_rollup",
    "rollup.config.dev.coffee": "_f_rollup",
    "rollup.config.dev.ts": "_f_rollup",
    "rollup.config.prod.js": "_f_rollup",
    "rollup.config.prod.cjs": "_f_rollup",
    "rollup.config.prod.mjs": "_f_rollup",
    "rollup.config.prod.coffee": "_f_rollup",
    "rollup.config.prod.ts": "_f_rollup",
    "rome.json": "_f_rome",
    ".rspec": "_f_rspec",
    ".rubocop.yml": "_f_rubocop",
    ".rubocop_todo.yml": "_f_rubocop",
    ".ruby-version": "_f_ruby",
    "rust-toolchain": "_f_rust_toolchain",
    "rust-toolchain.toml": "_f_rust_toolchain",
    ".slshrc": "_f_s-lang",
    ".isisrc": "_f_s-lang",
    ".jedrc": "_f_s-lang",
    ".sailsrc": "_f_sails",
    ".sapphirerc.json": "_f_sapphire_framework_cli",
    ".sapphirerc.yml": "_f_sapphire_framework_cli",
    ".sapphirerc": "_f_sapphire_framework_cli",
    "seedkit.config.js": "_f_seedkit",
    "seedkit.config.ts": "_f_seedkit",
    "seedkit.config.mjs": "_f_seedkit",
    ".sentryclirc": "_f_sentry",
    ".sequelizerc": "_f_sequelize",
    ".sequelizerc.js": "_f_sequelize",
    ".sequelizerc.json": "_f_sequelize",
    "serverless.yml": "_f_serverless",
    "serverless.json": "_f_serverless",
    "serverless.js": "_f_serverless",
    "serverless.ts": "_f_serverless",
    "components.json": "_f_shadcn",
    ".shellcheckrc": "_f_shellcheck",
    "Shuttle.toml": "_f_shuttle",
    "sitemap.xml": "_f_sitemap",
    "sitemap.rss": "_f_sitemap",
    "sitemap.txt": "_f_sitemap",
    "sitemap.atom": "_f_sitemap",
    "slash-up.config.js": "_f_slashup",
    "smithery.yaml": "_f_smithery",
    "snapcraft.yaml": "_f_snapcraft",
    "snaplet.config.js": "_f_snaplet",
    "snaplet.config.ts": "_f_snaplet",
    ".snyk": "_f_snyk",
    ".solidarity": "_f_solidarity",
    ".solidarity.json": "_f_solidarity",
    "spin.toml": "_f_spin",
    "sst-env.d.ts": "_f_sst",
    "sst-env.ts": "_f_sst",
    "sst-env.js": "_f_sst",
    "sst.config.d.ts": "_f_sst",
    "sst.config.ts": "_f_sst",
    "sst.config.js": "_f_sst",
    ".stackblitzrc": "_f_stackblitz",
    "stryker.conf.mjs": "_f_stryker",
    "stryker.conf.cjs": "_f_stryker",
    "stryker.conf.js": "_f_stryker",
    "stryker.conf.conf": "_f_stryker",
    "stryker.conf.json": "_f_stryker",
    ".stryker.conf.mjs": "_f_stryker",
    ".stryker.conf.cjs": "_f_stryker",
    ".stryker.conf.js": "_f_stryker",
    ".stryker.conf.conf": "_f_stryker",
    ".stryker.conf.json": "_f_stryker",
    "stryker.config.mjs": "_f_stryker",
    "stryker.config.cjs": "_f_stryker",
    "stryker.config.js": "_f_stryker",
    "stryker.config.conf": "_f_stryker",
    "stryker.config.json": "_f_stryker",
    ".stryker.config.mjs": "_f_stryker",
    ".stryker.config.cjs": "_f_stryker",
    ".stryker.config.js": "_f_stryker",
    ".stryker.config.conf": "_f_stryker",
    ".stryker.config.json": "_f_stryker",
    "stryker-config.mjs": "_f_stryker",
    "stryker-config.cjs": "_f_stryker",
    "stryker-config.js": "_f_stryker",
    "stryker-config.conf": "_f_stryker",
    "stryker-config.json": "_f_stryker",
    "stryker4s.mjs": "_f_stryker",
    "stryker4s.cjs": "_f_stryker",
    "stryker4s.js": "_f_stryker",
    "stryker4s.conf": "_f_stryker",
    "stryker4s.json": "_f_stryker",
    ".stylelintrc": "_f_stylelint",
    ".stylelintignore": "_f_stylelint",
    ".stylelintcache": "_f_stylelint",
    "stylelint.config.js": "_f_stylelint",
    "stylelint.config.json": "_f_stylelint",
    "stylelint.config.yaml": "_f_stylelint",
    "stylelint.config.yml": "_f_stylelint",
    "stylelint.config.ts": "_f_stylelint",
    "stylelint.config.cjs": "_f_stylelint",
    "stylelint.config.mjs": "_f_stylelint",
    ".stylelintrc.js": "_f_stylelint",
    ".stylelintrc.json": "_f_stylelint",
    ".stylelintrc.yaml": "_f_stylelint",
    ".stylelintrc.yml": "_f_stylelint",
    ".stylelintrc.ts": "_f_stylelint",
    ".stylelintrc.cjs": "_f_stylelint",
    ".stylelintrc.mjs": "_f_stylelint",
    ".stylish-haskell.yaml": "_f_stylish_haskell",
    ".svnignore": "_f_subversion",
    "svelte.config.js": "_f_svelteconfig",
    "svelte.config.ts": "_f_svelteconfig",
    "svgo.config.cjs": "_f_svgo",
    "svgo.config.js": "_f_svgo",
    "svgo.config.mjs": "_f_svgo",
    ".swcrc": "_f_swc",
    "package.pins": "_f_swift",
    "symfony.lock": "_f_symfony",
    ".syncpackrc": "_f_syncpack",
    ".syncpackrc.json": "_f_syncpack",
    ".syncpackrc.yaml": "_f_syncpack",
    ".syncpackrc.yml": "_f_syncpack",
    ".syncpackrc.js": "_f_syncpack",
    ".syncpackrc.cjs": "_f_syncpack",
    "syncpack.config.js": "_f_syncpack",
    "syncpack.config.cjs": "_f_syncpack",
    "tailwind.js": "_f_tailwind",
    "tailwind.cjs": "_f_tailwind",
    "tailwind.coffee": "_f_tailwind",
    "tailwind.ts": "_f_tailwind",
    "tailwind.json": "_f_tailwind",
    "tailwind.mjs": "_f_tailwind",
    "tailwind.config.js": "_f_tailwind",
    "tailwind.config.cjs": "_f_tailwind",
    "tailwind.config.coffee": "_f_tailwind",
    "tailwind.config.ts": "_f_tailwind",
    "tailwind.config.json": "_f_tailwind",
    "tailwind.config.mjs": "_f_tailwind",
    ".tailwind.js": "_f_tailwind",
    ".tailwind.cjs": "_f_tailwind",
    ".tailwind.coffee": "_f_tailwind",
    ".tailwind.ts": "_f_tailwind",
    ".tailwind.json": "_f_tailwind",
    ".tailwind.mjs": "_f_tailwind",
    ".tailwindrc.js": "_f_tailwind",
    ".tailwindrc.cjs": "_f_tailwind",
    ".tailwindrc.coffee": "_f_tailwind",
    ".tailwindrc.ts": "_f_tailwind",
    ".tailwindrc.json": "_f_tailwind",
    ".tailwindrc.mjs": "_f_tailwind",
    "tamagui.js": "_f_tamagui",
    "tamagui.mjs": "_f_tamagui",
    "tamagui.cjs": "_f_tamagui",
    "tamagui.ts": "_f_tamagui",
    "tamagui.mts": "_f_tamagui",
    "tamagui.cts": "_f_tamagui",
    "tamagui.config.js": "_f_tamagui",
    "tamagui.config.mjs": "_f_tamagui",
    "tamagui.config.cjs": "_f_tamagui",
    "tamagui.config.ts": "_f_tamagui",
    "tamagui.config.mts": "_f_tamagui",
    "tamagui.config.cts": "_f_tamagui",
    ".taplo.toml": "_f_taplo",
    "taplo.toml": "_f_taplo",
    "taskfile.yml": "_f_taskfile",
    "taskfile.yaml": "_f_taskfile",
    "taskfile.dist.yml": "_f_taskfile",
    "taskfile.dist.yaml": "_f_taskfile",
    "tauri.conf.json": "_f_tauri",
    ".taurignore": "_f_tauri",
    ".testcaferc.json": "_f_testcafe",
    "testplane.conf.ts": "_f_testplane",
    "testplane.conf.js": "_f_testplane",
    "testplane.conf.cts": "_f_testplane",
    "testplane.conf.cjs": "_f_testplane",
    "testplane.config.ts": "_f_testplane",
    "testplane.config.js": "_f_testplane",
    "testplane.config.cts": "_f_testplane",
    "testplane.config.cjs": "_f_testplane",
    ".tfignore": "_f_tfs",
    ".tiltignore": "_f_tiltfile",
    ".tmux.conf": "_f_tmux",
    "tox.ini": "_f_tox",
    ".travis.yml": "_f_travis",
    "truffle-config.js": "_f_truffle",
    "truffle-config.ts": "_f_truffle",
    "trunk.yaml": "_f_trunk",
    "tsconfig.json": "_f_tsconfig",
    "tsconfig.app.json": "_f_tsconfig",
    "tsconfig.base.json": "_f_tsconfig",
    "tsconfig.build.json": "_f_tsconfig",
    "tsconfig.cjs.json": "_f_tsconfig",
    "tsconfig.common.json": "_f_tsconfig",
    "tsconfig.debug.json": "_f_tsconfig",
    "tsconfig.dev.json": "_f_tsconfig",
    "tsconfig.development.json": "_f_tsconfig",
    "tsconfig.e2e.json": "_f_tsconfig",
    "tsconfig.eslint.json": "_f_tsconfig",
    "tsconfig.esm.json": "_f_tsconfig",
    "tsconfig.mjs.json": "_f_tsconfig",
    "tsconfig.node.json": "_f_tsconfig",
    "tsconfig.prod.json": "_f_tsconfig",
    "tsconfig.production.json": "_f_tsconfig",
    "tsconfig.release.json": "_f_tsconfig",
    "tsconfig.server.json": "_f_tsconfig",
    "tsconfig.spec.json": "_f_tsconfig",
    "tsconfig.staging.json": "_f_tsconfig",
    "tsconfig.test.json": "_f_tsconfig",
    "tsconfig.types.json": "_f_tsconfig",
    "tsconfig.lib.json": "_f_tsconfig",
    "tsconfig.lib.prod.json": "_f_tsconfig",
    "tsdoc.json": "_f_tsdoc",
    "tsdown.config.ts": "_f_tsdown",
    "tsdown.config.mts": "_f_tsdown",
    "tsdown.config.cts": "_f_tsdown",
    "tsdown.config.js": "_f_tsdown",
    "tsdown.config.mjs": "_f_tsdown",
    "tsdown.config.cjs": "_f_tsdown",
    "tsdown.config.json": "_f_tsdown",
    "tslint.json": "_f_tslint",
    "tslint.yaml": "_f_tslint",
    "tslint.yml": "_f_tslint",
    "turbo.json": "_f_turbo",
    "turbo.jsonc": "_f_turbo",
    "microfrontends.json": "_f_turbo",
    "microfrontends.jsonc": "_f_turbo",
    "typedoc.cjs": "_f_typedoc",
    "typedoc.js": "_f_typedoc",
    "typedoc.json": "_f_typedoc",
    "typedoc.jsonc": "_f_typedoc",
    "typedoc.mjs": "_f_typedoc",
    "typedoc.config.cjs": "_f_typedoc",
    "typedoc.config.js": "_f_typedoc",
    "typedoc.config.json": "_f_typedoc",
    "typedoc.config.jsonc": "_f_typedoc",
    "typedoc.config.mjs": "_f_typedoc",
    ".unibeautifyrc": "_f_unibeautify",
    "unibeautify.config.js": "_f_unibeautify",
    ".unibeautifyrc.js": "_f_unibeautify",
    ".unibeautifyrc.json": "_f_unibeautify",
    ".unibeautifyrc.yaml": "_f_unibeautify",
    ".unibeautifyrc.yml": "_f_unibeautify",
    "unlicense": "_f_unlicense",
    "unlicence": "_f_unlicense",
    "UNLICENSE": "_f_unlicense",
    "UNLICENCE": "_f_unlicense",
    "unlicense.md": "_f_unlicense",
    "unlicense.txt": "_f_unlicense",
    "unlicence.md": "_f_unlicense",
    "unlicence.txt": "_f_unlicense",
    "UNLICENSE.md": "_f_unlicense",
    "UNLICENSE.txt": "_f_unlicense",
    "UNLICENCE.md": "_f_unlicense",
    "UNLICENCE.txt": "_f_unlicense",
    "uno.config.js": "_f_unocss",
    "uno.config.mjs": "_f_unocss",
    "uno.config.ts": "_f_unocss",
    "uno.config.mts": "_f_unocss",
    "unocss.config.js": "_f_unocss",
    "unocss.config.mjs": "_f_unocss",
    "unocss.config.ts": "_f_unocss",
    "unocss.config.mts": "_f_unocss",
    "uv.lock": "_f_uv",
    "vagrantfile": "_f_vagrant",
    "vapor.yml": "_f_vapor",
    "now.json": "_f_vercel",
    ".nowignore": "_f_vercel",
    "vercel.json": "_f_vercel",
    ".vercelignore": "_f_vercel",
    ".vimrc": "_f_vim",
    ".gvimrc": "_f_vim",
    "vite.config.js": "_f_vite",
    "vite.config.mjs": "_f_vite",
    "vite.config.ts": "_f_vite",
    "vite.config.cjs": "_f_vite",
    "vite.config.mts": "_f_vite",
    "vite.config.cts": "_f_vite",
    "vitest.config.js": "_f_vitest",
    "vitest.config.mjs": "_f_vitest",
    "vitest.config.ts": "_f_vitest",
    "vitest.config.cjs": "_f_vitest",
    "vitest.config.mts": "_f_vitest",
    "vitest.config.cts": "_f_vitest",
    "vitest.workspace.json": "_f_vitest",
    "vitest.workspace.js": "_f_vitest",
    "vitest.workspace.mjs": "_f_vitest",
    "vitest.workspace.ts": "_f_vitest",
    "vitest.workspace.cjs": "_f_vitest",
    "vitest.workspace.mts": "_f_vitest",
    "vitest.workspace.cts": "_f_vitest",
    "vitest.projects.json": "_f_vitest",
    "vitest.projects.js": "_f_vitest",
    "vitest.projects.mjs": "_f_vitest",
    "vitest.projects.ts": "_f_vitest",
    "vitest.projects.cjs": "_f_vitest",
    "vitest.projects.mts": "_f_vitest",
    "vitest.projects.cts": "_f_vitest",
    ".vscodeignore": "_f_vscode",
    "launch.json": "_f_vscode",
    "tasks.json": "_f_vscode",
    "vscodeignore.json": "_f_vscode",
    ".vscode-test.js": "_f_vscode_test",
    ".vscode-test.json": "_f_vscode_test",
    ".vscode-test.mjs": "_f_vscode_test",
    ".vuerc": "_f_vueconfig",
    "vue.config.js": "_f_vueconfig",
    "vue.config.cjs": "_f_vueconfig",
    "vue.config.mjs": "_f_vueconfig",
    "wallaby.json": "_f_wallaby",
    "wallaby.js": "_f_wallaby",
    "wallaby.ts": "_f_wallaby",
    "wallaby.coffee": "_f_wallaby",
    "wallaby.conf.json": "_f_wallaby",
    "wallaby.conf.js": "_f_wallaby",
    "wallaby.conf.ts": "_f_wallaby",
    "wallaby.conf.coffee": "_f_wallaby",
    ".wallaby.json": "_f_wallaby",
    ".wallaby.js": "_f_wallaby",
    ".wallaby.ts": "_f_wallaby",
    ".wallaby.coffee": "_f_wallaby",
    ".wallaby.conf.json": "_f_wallaby",
    ".wallaby.conf.js": "_f_wallaby",
    ".wallaby.conf.ts": "_f_wallaby",
    ".wallaby.conf.coffee": "_f_wallaby",
    "wally.toml": "_f_wally",
    "wally.lock": "_f_wally",
    ".watchmanconfig": "_f_watchmanconfig",
    "wdio.json": "_f_wdio",
    "wdio.js": "_f_wdio",
    "wdio.mjs": "_f_wdio",
    "wdio.cjs": "_f_wdio",
    "wdio.ts": "_f_wdio",
    "wdio.mts": "_f_wdio",
    "wdio.cts": "_f_wdio",
    "wdio.conf.json": "_f_wdio",
    "wdio.conf.js": "_f_wdio",
    "wdio.conf.mjs": "_f_wdio",
    "wdio.conf.cjs": "_f_wdio",
    "wdio.conf.ts": "_f_wdio",
    "wdio.conf.mts": "_f_wdio",
    "wdio.conf.cts": "_f_wdio",
    ".weblate": "_f_weblate",
    ".weblate.ini": "_f_weblate",
    "weblate": "_f_weblate",
    "weblate.ini": "_f_weblate",
    "webpack.base.conf.js": "_f_webpack",
    "webpack.base.conf.cjs": "_f_webpack",
    "webpack.base.conf.mjs": "_f_webpack",
    "webpack.base.conf.coffee": "_f_webpack",
    "webpack.base.conf.ts": "_f_webpack",
    "webpack.common.js": "_f_webpack",
    "webpack.common.cjs": "_f_webpack",
    "webpack.common.mjs": "_f_webpack",
    "webpack.common.coffee": "_f_webpack",
    "webpack.common.ts": "_f_webpack",
    "webpack.config.js": "_f_webpack",
    "webpack.config.cjs": "_f_webpack",
    "webpack.config.mjs": "_f_webpack",
    "webpack.config.coffee": "_f_webpack",
    "webpack.config.ts": "_f_webpack",
    "webpack.config.base.js": "_f_webpack",
    "webpack.config.base.cjs": "_f_webpack",
    "webpack.config.base.mjs": "_f_webpack",
    "webpack.config.base.coffee": "_f_webpack",
    "webpack.config.base.ts": "_f_webpack",
    "webpack.config.build.js": "_f_webpack",
    "webpack.config.build.cjs": "_f_webpack",
    "webpack.config.build.mjs": "_f_webpack",
    "webpack.config.build.coffee": "_f_webpack",
    "webpack.config.build.ts": "_f_webpack",
    "webpack.config.common.js": "_f_webpack",
    "webpack.config.common.cjs": "_f_webpack",
    "webpack.config.common.mjs": "_f_webpack",
    "webpack.config.common.coffee": "_f_webpack",
    "webpack.config.common.ts": "_f_webpack",
    "webpack.config.dev.js": "_f_webpack",
    "webpack.config.dev.cjs": "_f_webpack",
    "webpack.config.dev.mjs": "_f_webpack",
    "webpack.config.dev.coffee": "_f_webpack",
    "webpack.config.dev.ts": "_f_webpack",
    "webpack.config.development.js": "_f_webpack",
    "webpack.config.development.cjs": "_f_webpack",
    "webpack.config.development.mjs": "_f_webpack",
    "webpack.config.development.coffee": "_f_webpack",
    "webpack.config.development.ts": "_f_webpack",
    "webpack.config.staging.js": "_f_webpack",
    "webpack.config.staging.cjs": "_f_webpack",
    "webpack.config.staging.mjs": "_f_webpack",
    "webpack.config.staging.coffee": "_f_webpack",
    "webpack.config.staging.ts": "_f_webpack",
    "webpack.config.test.js": "_f_webpack",
    "webpack.config.test.cjs": "_f_webpack",
    "webpack.config.test.mjs": "_f_webpack",
    "webpack.config.test.coffee": "_f_webpack",
    "webpack.config.test.ts": "_f_webpack",
    "webpack.config.prod.js": "_f_webpack",
    "webpack.config.prod.cjs": "_f_webpack",
    "webpack.config.prod.mjs": "_f_webpack",
    "webpack.config.prod.coffee": "_f_webpack",
    "webpack.config.prod.ts": "_f_webpack",
    "webpack.config.production.js": "_f_webpack",
    "webpack.config.production.cjs": "_f_webpack",
    "webpack.config.production.mjs": "_f_webpack",
    "webpack.config.production.coffee": "_f_webpack",
    "webpack.config.production.ts": "_f_webpack",
    "webpack.config.babel.js": "_f_webpack",
    "webpack.config.babel.cjs": "_f_webpack",
    "webpack.config.babel.mjs": "_f_webpack",
    "webpack.config.babel.coffee": "_f_webpack",
    "webpack.config.babel.ts": "_f_webpack",
    "webpack.config.base.babel.js": "_f_webpack",
    "webpack.config.base.babel.cjs": "_f_webpack",
    "webpack.config.base.babel.mjs": "_f_webpack",
    "webpack.config.base.babel.coffee": "_f_webpack",
    "webpack.config.base.babel.ts": "_f_webpack",
    "webpack.config.common.babel.js": "_f_webpack",
    "webpack.config.common.babel.cjs": "_f_webpack",
    "webpack.config.common.babel.mjs": "_f_webpack",
    "webpack.config.common.babel.coffee": "_f_webpack",
    "webpack.config.common.babel.ts": "_f_webpack",
    "webpack.config.dev.babel.js": "_f_webpack",
    "webpack.config.dev.babel.cjs": "_f_webpack",
    "webpack.config.dev.babel.mjs": "_f_webpack",
    "webpack.config.dev.babel.coffee": "_f_webpack",
    "webpack.config.dev.babel.ts": "_f_webpack",
    "webpack.config.development.babel.js": "_f_webpack",
    "webpack.config.development.babel.cjs": "_f_webpack",
    "webpack.config.development.babel.mjs": "_f_webpack",
    "webpack.config.development.babel.coffee": "_f_webpack",
    "webpack.config.development.babel.ts": "_f_webpack",
    "webpack.config.staging.babel.js": "_f_webpack",
    "webpack.config.staging.babel.cjs": "_f_webpack",
    "webpack.config.staging.babel.mjs": "_f_webpack",
    "webpack.config.staging.babel.coffee": "_f_webpack",
    "webpack.config.staging.babel.ts": "_f_webpack",
    "webpack.config.test.babel.js": "_f_webpack",
    "webpack.config.test.babel.cjs": "_f_webpack",
    "webpack.config.test.babel.mjs": "_f_webpack",
    "webpack.config.test.babel.coffee": "_f_webpack",
    "webpack.config.test.babel.ts": "_f_webpack",
    "webpack.config.prod.babel.js": "_f_webpack",
    "webpack.config.prod.babel.cjs": "_f_webpack",
    "webpack.config.prod.babel.mjs": "_f_webpack",
    "webpack.config.prod.babel.coffee": "_f_webpack",
    "webpack.config.prod.babel.ts": "_f_webpack",
    "webpack.config.production.babel.js": "_f_webpack",
    "webpack.config.production.babel.cjs": "_f_webpack",
    "webpack.config.production.babel.mjs": "_f_webpack",
    "webpack.config.production.babel.coffee": "_f_webpack",
    "webpack.config.production.babel.ts": "_f_webpack",
    "webpack.dev.js": "_f_webpack",
    "webpack.dev.cjs": "_f_webpack",
    "webpack.dev.mjs": "_f_webpack",
    "webpack.dev.coffee": "_f_webpack",
    "webpack.dev.ts": "_f_webpack",
    "webpack.dev.conf.js": "_f_webpack",
    "webpack.dev.conf.cjs": "_f_webpack",
    "webpack.dev.conf.mjs": "_f_webpack",
    "webpack.dev.conf.coffee": "_f_webpack",
    "webpack.dev.conf.ts": "_f_webpack",
    "webpack.local.js": "_f_webpack",
    "webpack.local.cjs": "_f_webpack",
    "webpack.local.mjs": "_f_webpack",
    "webpack.local.coffee": "_f_webpack",
    "webpack.local.ts": "_f_webpack",
    "webpack.prod.js": "_f_webpack",
    "webpack.prod.cjs": "_f_webpack",
    "webpack.prod.mjs": "_f_webpack",
    "webpack.prod.coffee": "_f_webpack",
    "webpack.prod.ts": "_f_webpack",
    "webpack.prod.conf.js": "_f_webpack",
    "webpack.prod.conf.cjs": "_f_webpack",
    "webpack.prod.conf.mjs": "_f_webpack",
    "webpack.prod.conf.coffee": "_f_webpack",
    "webpack.prod.conf.ts": "_f_webpack",
    "webpack.main.config.js": "_f_webpack",
    "webpack.main.config.cjs": "_f_webpack",
    "webpack.main.config.mjs": "_f_webpack",
    "webpack.main.config.coffee": "_f_webpack",
    "webpack.main.config.ts": "_f_webpack",
    "webpack.mix.js": "_f_webpack",
    "webpack.mix.cjs": "_f_webpack",
    "webpack.mix.mjs": "_f_webpack",
    "webpack.mix.coffee": "_f_webpack",
    "webpack.mix.ts": "_f_webpack",
    "webpack.plugins.js": "_f_webpack",
    "webpack.plugins.cjs": "_f_webpack",
    "webpack.plugins.mjs": "_f_webpack",
    "webpack.plugins.coffee": "_f_webpack",
    "webpack.plugins.ts": "_f_webpack",
    "webpack.renderer.config.js": "_f_webpack",
    "webpack.renderer.config.cjs": "_f_webpack",
    "webpack.renderer.config.mjs": "_f_webpack",
    "webpack.renderer.config.coffee": "_f_webpack",
    "webpack.renderer.config.ts": "_f_webpack",
    "webpack.rules.js": "_f_webpack",
    "webpack.rules.cjs": "_f_webpack",
    "webpack.rules.mjs": "_f_webpack",
    "webpack.rules.coffee": "_f_webpack",
    "webpack.rules.ts": "_f_webpack",
    "webpack.test.conf.js": "_f_webpack",
    "webpack.test.conf.cjs": "_f_webpack",
    "webpack.test.conf.mjs": "_f_webpack",
    "webpack.test.conf.coffee": "_f_webpack",
    "webpack.test.conf.ts": "_f_webpack",
    "wercker.yml": "_f_wercker",
    "windi.config.ts": "_f_windi",
    "windi.config.js": "_f_windi",
    "wpml-config.xml": "_f_wpml",
    "wxt.config.js": "_f_wxt",
    "wxt.config.cjs": "_f_wxt",
    "wxt.config.mjs": "_f_wxt",
    "wxt.config.ts": "_f_wxt",
    "wxt.config.cts": "_f_wxt",
    "wxt.config.mts": "_f_wxt",
    ".xo-config": "_f_xo",
    "xo.config.js": "_f_xo",
    "xo.config.cjs": "_f_xo",
    "xo.config.mjs": "_f_xo",
    "xo.config.ts": "_f_xo",
    "xo.config.cts": "_f_xo",
    "xo.config.mts": "_f_xo",
    ".xo-config.js": "_f_xo",
    ".xo-config.json": "_f_xo",
    ".xo-config.cjs": "_f_xo",
    ".xcompose": "_f_xorg",
    ".yamllint": "_f_yamllint",
    ".yaspellerrc": "_f_yandex",
    ".yaspeller.json": "_f_yandex",
    "yarn.lock": "_f_yarn",
    ".yarnrc": "_f_yarn",
    ".yarnrc.yml": "_f_yarn",
    ".yarnclean": "_f_yarn",
    ".yarn-integrity": "_f_yarn",
    ".yarn-metadata.json": "_f_yarn",
    ".yarn-state.yml": "_f_yarn",
    ".yarnignore": "_f_yarn",
    ".yo-rc.json": "_f_yeoman"
  },
  "languageIds": {
    "actionscript": "_f_actionscript",
    "ada": "_f_ada",
    "advpl": "_f_advpl",
    "affectscript": "_f_affectscript",
    "agda": "_f_agda",
    "lagda-md": "_f_agda",
    "lagda-rst": "_f_agda",
    "lagda-tex": "_f_agda",
    "al": "_f_al",
    "alloy": "_f_alloy",
    "ansible": "_f_ansible",
    "antlr": "_f_antlr",
    "anyscript": "_f_anyscript",
    "apacheconf": "_f_apache",
    "apex": "_f_apex",
    "apiblueprint": "_f_apib",
    "apl": "_f_apl",
    "applescript": "_f_applescript",
    "asciidoc": "_f_asciidoc",
    "asp": "_f_asp",
    "asp (html)": "_f_asp",
    "arm": "_f_assembly",
    "asm": "_f_assembly",
    "asm-intel-x86-generic": "_f_assembly",
    "platformio-debug.asm": "_f_platformio",
    "asm-collection": "_f_assembly",
    "astro": "_f_astro",
    "ats": "_f_ats",
    "ahk": "_f_autohotkey",
    "ahk2": "_f_autohotkey",
    "autoit": "_f_autoit",
    "avro": "_f_avro",
    "azcli": "_f_azure",
    "azure-pipelines": "_f_azurepipelines",
    "ballerina": "_f_ballerina",
    "bat": "_f_bat",
    "bats": "_f_bats",
    "bazel": "_f_bazel",
    "bazelrc": "_f_bazel",
    "starlark": "_f_bazel",
    "befunge": "_f_befunge",
    "befunge98": "_f_befunge",
    "bicep": "_f_bicep",
    "biml": "_f_biml",
    "code-text-binary": "_f_binary",
    "biome_syntax_tree": "_f_biome",
    "blade": "_f_blade",
    "laravel-blade": "_f_blade",
    "blitzbasic": "_f_blitzbasic",
    "bolt": "_f_bolt",
    "bosque": "_f_bosque",
    "browserslist": "_f_browserslist",
    "bruno": "_f_bruno",
    "buf": "_f_buf",
    "buf-gen": "_f_buf",
    "bun.lockb": "_f_bun",
    "c": "_f_c",
    "c3": "_f_c3",
    "c-al": "_f_c_al",
    "cabal": "_f_cabal",
    "caddyfile": "_f_caddy",
    "capnp": "_f_capnp",
    "capnproto": "_f_capnp",
    "casc": "_f_casc",
    "cddl": "_f_cddl",
    "ceylon": "_f_ceylon",
    "cfml": "_f_cf",
    "lang-cfml": "_f_cf",
    "cfc": "_f_cfc",
    "cfmhtml": "_f_cfm",
    "cookbook": "_f_chef_cookbook",
    "circom": "_f_circom",
    "clojure": "_f_clojure",
    "clojurescript": "_f_clojurescript",
    "manifest-yaml": "_f_cloudfoundry",
    "cmake": "_f_cmake",
    "cmake-cache": "_f_cmake",
    "cobol": "_f_cobol",
    "ql": "_f_codeql",
    "coffeescript": "_f_coffeescript",
    "java-properties": "_f_config",
    "properties": "_f_config",
    "spring-boot-properties": "_f_config",
    "confluence": "_f_confluence",
    "instructions": "_f_copilot",
    "prompt": "_f_copilot",
    "cpp": "_f_cpp",
    "crystal": "_f_crystal",
    "csharp": "_f_csharp",
    "css": "_f_css",
    "cucumber": "_f_cucumber",
    "feature": "_f_cucumber",
    "cuda": "_f_cuda",
    "cuda-cpp": "_f_cuda",
    "cython": "_f_cython",
    "dal": "_f_dal",
    "dart": "_f_dartlang",
    "debian-changelog": "_f_debian",
    "debian-control": "_f_debian",
    "debian-copyright": "_f_debian",
    "debian-upstream-metadata": "_f_debian",
    "pascal": "_f_delphi",
    "objectpascal": "_f_delphi",
    "dhall": "_f_dhall",
    "diff": "_f_diff",
    "django-html": "_f_django",
    "django-txt": "_f_django",
    "d": "_f_dlang",
    "dscript": "_f_dlang",
    "dml": "_f_dlang",
    "diet": "_f_dlang",
    "dockerbake": "_f_docker",
    "dockercompose": "_f_docker",
    "dockerfile": "_f_docker",
    "dotenv": "_f_dotenv",
    "env": "_f_dotenv",
    "dotjs": "_f_dotjs",
    "doxygen": "_f_doxygen",
    "drawio": "_f_drawio",
    "drools": "_f_drools",
    "dtd": "_f_dtd",
    "dustjs": "_f_dustjs",
    "dylan": "_f_dylan",
    "dylan-lid": "_f_dylan",
    "earthfile": "_f_earthly",
    "edge": "_f_edge",
    "editorconfig": "_f_editorconfig",
    "eex": "_f_eex",
    "html-eex": "_f_eex",
    "es": "_f_elastic",
    "elixir": "_f_elixir",
    "elm": "_f_elm",
    "erb": "_f_erb",
    "html.erb": "_f_erb",
    "erlang": "_f_erlang",
    "esphome": "_f_esphome",
    "excel": "_f_excel",
    "falcon": "_f_falcon",
    "fql": "_f_fauna",
    "fortran": "_f_fortran",
    "fortran-modern": "_f_fortran",
    "FortranFreeForm": "_f_fortran",
    "FortranFixedForm": "_f_fortran",
    "fortran_fixed-form": "_f_fortran",
    "ftl": "_f_freemarker",
    "fsharp": "_f_fsharp",
    "fthtml": "_f_fthtml",
    "galen": "_f_galen",
    "gml-gms": "_f_gamemaker",
    "gml-gms2": "_f_gamemaker2",
    "gml-gm81": "_f_gamemaker81",
    "gcode": "_f_gcode",
    "gdscript": "_f_gdscript",
    "genstat": "_f_genstat",
    "git-commit": "_f_git",
    "git-rebase": "_f_git",
    "ignore": "_f_git",
    "gleam": "_f_gleam",
    "glimmer-js": "_f_glimmer",
    "glimmer-ts": "_f_glimmer",
    "glsl": "_f_glsl",
    "glyphs": "_f_glyphs",
    "automake": "_f_gnu",
    "m4": "_f_gnu",
    "makefile": "_f_gnu",
    "makefile2": "_f_gnu",
    "gnuplot": "_f_gnuplot",
    "go": "_f_go",
    "go.mod": "_f_go_package",
    "go.work": "_f_go_work",
    "goctl": "_f_goctl",
    "gradle-kotlin-dsl": "_f_gradle",
    "grain": "_f_grain",
    "graphql": "_f_graphql",
    "dot": "_f_graphviz",
    "grit": "_f_grit",
    "groovy": "_f_groovy",
    "haml": "_f_haml",
    "handlebars": "_f_handlebars",
    "harbour": "_f_harbour",
    "hcl": "_f_hashicorp",
    "haskell": "_f_haskell",
    "literate haskell": "_f_haskell",
    "haxe": "_f_haxe",
    "hxml": "_f_haxe",
    "Haxe AST dump": "_f_haxe",
    "helm": "_f_helm",
    "hjson": "_f_hjson",
    "hlsl": "_f_hlsl",
    "home-assistant": "_f_homeassistant",
    "hosts": "_f_host",
    "html": "_f_html",
    "http": "_f_http",
    "hunspell.aff": "_f_hunspell",
    "hunspell.dic": "_f_hunspell",
    "hy": "_f_hy",
    "hypr": "_f_hypr",
    "icl": "_f_icl",
    "imba": "_f_imba",
    "4GL": "_f_informix",
    "ini": "_f_ini",
    "ink": "_f_ink",
    "innosetup": "_f_innosetup",
    "io": "_f_io",
    "iodine": "_f_iodine",
    "janet": "_f_janet",
    "java": "_f_java",
    "jekyll": "_f_jekyll",
    "jenkins": "_f_jenkins",
    "declarative": "_f_jenkins",
    "jenkinsfile": "_f_jenkins",
    "jest-snapshot": "_f_jest_snapshot",
    "jinja": "_f_jinja",
    "jinja-java": "_f_jinja",
    "jinja-html": "_f_jinja",
    "jinja-xml": "_f_jinja",
    "jinja-css": "_f_jinja",
    "jinja-json": "_f_jinja",
    "jinja-md": "_f_jinja",
    "jinja-py": "_f_jinja",
    "jinja-rb": "_f_jinja",
    "jinja-js": "_f_jinja",
    "jinja-yaml": "_f_jinja",
    "jinja-toml": "_f_jinja",
    "jinja-latex": "_f_jinja",
    "jinja-lua": "_f_jinja",
    "jinja-properties": "_f_jinja",
    "jinja-shell": "_f_jinja",
    "jinja-dockerfile": "_f_jinja",
    "jinja-sql": "_f_jinja",
    "jinja-terraform": "_f_jinja",
    "jinja-nginx": "_f_jinja",
    "jinja-groovy": "_f_jinja",
    "jinja-systemd": "_f_jinja",
    "jinja-cpp": "_f_jinja",
    "javascript": "_f_js",
    "json": "_f_json",
    "json-tmlanguage": "_f_json",
    "jsonc": "_f_json",
    "jsonl": "_f_json",
    "json5": "_f_json5",
    "jsonnet": "_f_jsonnet",
    "julia": "_f_julia",
    "juliamarkdown": "_f_julia",
    "just": "_f_just",
    "k": "_f_k",
    "kivy": "_f_kivy",
    "kos": "_f_kos",
    "kotlin": "_f_kotlin",
    "kotlinscript": "_f_kotlin",
    "kusto": "_f_kusto",
    "lark": "_f_lark",
    "latino": "_f_latino",
    "lean4": "_f_lean",
    "lean4markdown": "_f_lean",
    "less": "_f_less",
    "lex": "_f_lex",
    "lilypond": "_f_lilypond",
    "lisp": "_f_lisp",
    "autolisp": "_f_lisp",
    "autolispdcl": "_f_lisp",
    "log": "_f_log",
    "lolcode": "_f_lolcode",
    "lsl": "_f_lsl",
    "lua": "_f_lua",
    "markdown": "_f_markdown",
    "marko": "_f_marko",
    "matlab": "_f_matlab",
    "maxscript": "_f_maxscript",
    "mel": "_f_maya",
    "mdx": "_f_mdx",
    "mediawiki": "_f_mediawiki",
    "mermaid": "_f_mermaid",
    "meson": "_f_meson",
    "metal": "_f_metal",
    "bc-mcfunction": "_f_minecraft",
    "bc-minecraft-language": "_f_minecraft",
    "bc-minecraft-molang": "_f_minecraft",
    "bc-minecraft-project": "_f_minecraft",
    "mcdoc": "_f_minecraft",
    "mcfunction": "_f_minecraft",
    "mcmeta": "_f_minecraft",
    "mcscript": "_f_minecraft",
    "minecraft-lang": "_f_minecraft",
    "options-txt": "_f_minecraft",
    "snbt": "_f_minecraft",
    "mv": "_f_mivascript",
    "mjml": "_f_mjml",
    "powerquery": "_f_mlang",
    "mojo": "_f_mojo",
    "mojolicious": "_f_mojolicious",
    "mongo": "_f_mongo",
    "mson": "_f_mson",
    "mvt": "_f_mvt",
    "mvtcss": "_f_mvtcss",
    "mvtjs": "_f_mvtjs",
    "nearley": "_f_nearly",
    "cypher": "_f_neo4j",
    "nginx": "_f_nginx",
    "nim": "_f_nim",
    "nimble": "_f_nimble",
    "nix": "_f_nix",
    "nsis": "_f_nsi",
    "nfl": "_f_nsi",
    "nsl": "_f_nsi",
    "bridlensis": "_f_nsi",
    "nunjucks": "_f_nunjucks",
    "nushell": "_f_nushell",
    "objective-c": "_f_objectivec",
    "objective-cpp": "_f_objectivecpp",
    "ocaml": "_f_ocaml",
    "ocamllex": "_f_ocaml",
    "menhir": "_f_ocaml",
    "ogone": "_f_ogone",
    "openhab": "_f_openHAB",
    "scad": "_f_openscad",
    "org": "_f_org",
    "pddl": "_f_pddl",
    "happenings": "_f_pddl_happenings",
    "plan": "_f_pddl_plan",
    "perl": "_f_perl",
    "perl6": "_f_perl6",
    "pgsql": "_f_pgsql",
    "php": "_f_php",
    "pine": "_f_pine",
    "pinescript": "_f_pine",
    "pip-requirements": "_f_pip",
    "platformio-debug.disassembly": "_f_platformio",
    "platformio-debug.memoryview": "_f_platformio",
    "plsql": "_f_plsql",
    "oracle": "_f_plsql",
    "oraclesql": "_f_plsql",
    "oracle-sql": "_f_plsql",
    "po": "_f_poedit",
    "polyglot-notebook": "_f_polyglot",
    "polymer": "_f_polymer",
    "pony": "_f_pony",
    "postcss": "_f_postcss",
    "postscript": "_f_postscript",
    "powershell": "_f_powershell",
    "prisma": "_f_prisma",
    "pde": "_f_processinglang",
    "abl": "_f_progress",
    "prolog": "_f_prolog",
    "prometheus": "_f_prometheus",
    "proto3": "_f_protobuf",
    "proto": "_f_protobuf",
    "prototext": "_f_protobuf",
    "jade": "_f_pug",
    "puppet": "_f_puppet",
    "purescript": "_f_purescript",
    "pyret": "_f_pyret",
    "pyscript": "_f_pyscript",
    "python": "_f_python",
    "pythowo": "_f_pythowo",
    "qlik": "_f_qlikview",
    "qml": "_f_qml",
    "qsharp": "_f_qsharp",
    "r": "_f_r",
    "ra_syntax_tree": "_f_ra_syntax_tree",
    "racket": "_f_racket",
    "raku": "_f_raku",
    "raml": "_f_raml",
    "razor": "_f_razor",
    "aspnetcorerazor": "_f_razor",
    "javascriptreact": "_f_reactjs",
    "typescriptreact": "_f_reactts",
    "reason": "_f_reason",
    "red": "_f_red",
    "rescript": "_f_rescript",
    "restructuredtext": "_f_rest",
    "rexx": "_f_rexx",
    "riot": "_f_riot",
    "ripple": "_f_ripple",
    "rmd": "_f_rmd",
    "rnc": "_f_rnc",
    "robot": "_f_robotframework",
    "robots-txt": "_f_robots",
    "ruby": "_f_ruby",
    "rust": "_f_rust",
    "s-lang": "_f_s-lang",
    "san": "_f_san",
    "SAS": "_f_sas",
    "sass": "_f_sass",
    "sass.hover": "_f_sass",
    "sbt": "_f_sbt",
    "scala": "_f_scala",
    "scilab": "_f_scilab",
    "vbscript": "_f_script",
    "scss": "_f_scss",
    "sdl": "_f_sdlang",
    "search-result": "_f_search_result",
    "shaderlab": "_f_shaderlab",
    "shellscript": "_f_shell",
    "silverstripe": "_f_silverstripe",
    "sino": "_f_sino",
    "eskip": "_f_skipper",
    "slang": "_f_slang",
    "slice": "_f_slice",
    "slim": "_f_slim",
    "slint": "_f_slint",
    "sln": "_f_sln",
    "smarty": "_f_smarty",
    "snakemake": "_f_snakemake",
    "snort": "_f_snort",
    "solidity": "_f_solidity",
    "sparql": "_f_sparql",
    "sqf": "_f_sqf",
    "sql": "_f_sql",
    "squirrel": "_f_squirrel",
    "stan": "_f_stan",
    "stata": "_f_stata",
    "stencil": "_f_stencil",
    "stencil-html": "_f_stencil",
    "stylable": "_f_stylable",
    "source.css.styled": "_f_styled",
    "stylus": "_f_stylus",
    "svelte": "_f_svelte",
    "svg": "_f_svg",
    "Swagger": "_f_swagger",
    "swagger": "_f_swagger",
    "swift": "_f_swift",
    "swig": "_f_swig",
    "systemd-conf": "_f_systemd",
    "systemd-unit-file": "_f_systemd",
    "systemverilog": "_f_systemverilog",
    "t4": "_f_t4tt",
    "tailwindcss": "_f_tailwind",
    "teal": "_f_teal",
    "templ": "_f_templ",
    "tera": "_f_tera",
    "terraform": "_f_terraform",
    "tex": "_f_tex",
    "latex": "_f_tex",
    "bibtex": "_f_tex",
    "doctex": "_f_tex",
    "csv": "_f_text",
    "csv (pipe)": "_f_text",
    "csv (semicolon)": "_f_text",
    "csv (whitespace)": "_f_text",
    "dynamic csv": "_f_text",
    "tsv": "_f_text",
    "plaintext": "_f_text",
    "vim-help": "_f_text",
    "textile": "_f_textile",
    "tiltfile": "_f_tiltfile",
    "toit": "_f_toit",
    "toml": "_f_toml",
    "toon": "_f_toon",
    "tt": "_f_tt",
    "ttcn": "_f_ttcn",
    "tuc": "_f_tuc",
    "twig": "_f_twig",
    "typescript": "_f_typescript",
    "typoscript": "_f_typo3",
    "uiua": "_f_uiua",
    "unison": "_f_unison",
    "vb": "_f_vb",
    "vba": "_f_vba",
    "velocity": "_f_velocity",
    "vento": "_f_vento",
    "verilog": "_f_verilog",
    "vhdl": "_f_vhdl",
    "viml": "_f_vim",
    "vim-snippet": "_f_vim",
    "vitest-snapshot": "_f_vitest",
    "v": "_f_vlang",
    "volt": "_f_volt",
    "vroom": "_f_vroom",
    "snippets": "_f_vscode",
    "vue": "_f_vue",
    "vyper": "_f_vyper",
    "wasm": "_f_wasm",
    "wat": "_f_wasm",
    "wenyan": "_f_wenyan",
    "wgsl": "_f_wgsl",
    "wikitext": "_f_wikitext",
    "wai": "_f_wit",
    "wolfram": "_f_wolfram",
    "wurstlang": "_f_wurst",
    "wurst": "_f_wurst",
    "xmake": "_f_xmake",
    "xml": "_f_xml",
    "xcompose": "_f_xorg",
    "xquery": "_f_xquery",
    "xsl": "_f_xsl",
    "xslt": "_f_xsl",
    "yacc": "_f_yacc",
    "yaml": "_f_yaml",
    "yaml-tmlanguage": "_f_yaml",
    "spring-boot-properties-yaml": "_f_yaml",
    "yang": "_f_yang",
    "yarnlock": "_f_yarn",
    "zig": "_f_zig",
    "zip": "_f_zip"
  },
  "light": {
    "file": "_file_light",
    "folder": "_folder_light",
    "folderExpanded": "_folder_light_open",
    "rootFolder": "_root_folder_light",
    "rootFolderExpanded": "_root_folder_light_open",
    "folderNames": {
      "android": "_fd_android",
      ".angular": "_fd_angular",
      "apache": "_fd_apache",
      "apache2": "_fd_apache",
      "httpd": "_fd_apache",
      "api": "_fd_api",
      ".api": "_fd_api",
      "apis": "_fd_api",
      ".apis": "_fd_api",
      "app": "_fd_app",
      "apps": "_fd_app",
      ".app": "_fd_app",
      "application": "_fd_app",
      "applications": "_fd_app",
      "arangodb": "_fd_arangodb",
      "arango": "_fd_arangodb",
      "assets": "_fd_asset",
      ".assets": "_fd_asset",
      ".astro": "_fd_astro",
      "audio": "_fd_audio",
      ".audio": "_fd_audio",
      "audios": "_fd_audio",
      ".audios": "_fd_audio",
      "sound": "_fd_audio",
      ".sound": "_fd_audio",
      "sounds": "_fd_audio",
      ".sounds": "_fd_audio",
      "aurelia_project": "_fd_aurelia",
      "aws": "_fd_aws",
      ".aws": "_fd_aws",
      "azure": "_fd_azure",
      ".azure": "_fd_azure",
      "azure-pipelines": "_fd_azurepipelines",
      ".azure-pipelines": "_fd_azurepipelines",
      "bin": "_fd_binary",
      ".bin": "_fd_binary",
      "blocs": "_fd_bloc",
      "bloc": "_fd_bloc",
      "blueprint": "_fd_blueprint",
      ".blueprint": "_fd_blueprint",
      "blueprints": "_fd_blueprint",
      ".blueprints": "_fd_blueprint",
      "bot": "_fd_bot",
      ".bot": "_fd_bot",
      "bower_components": "_fd_bower",
      ".buildkite": "_fd_buildkite",
      "cake": "_fd_cake",
      ".cake": "_fd_cake",
      "cargo": "_fd_cargo",
      ".cargo": "_fd_cargo",
      "crates": "_fd_cargo",
      "certificates": "_fd_certificate",
      ".certificates": "_fd_certificate",
      "certs": "_fd_certificate",
      "certs.": "_fd_certificate",
      ".changeset": "_fd_changesets",
      "chef": "_fd_chef",
      ".chef": "_fd_chef",
      ".circleci": "_fd_circleci",
      ".claude": "_fd_claude",
      "cli": "_fd_cli",
      "cmd": "_fd_cli",
      "command": "_fd_cli",
      "commands": "_fd_cli",
      "commandline": "_fd_cli",
      "console": "_fd_cli",
      "client": "_fd_client",
      "clients": "_fd_client",
      ".cloudflare": "_fd_cloudflare",
      "cloudflare": "_fd_cloudflare",
      ".cmake": "_fd_cmake",
      "cmake": "_fd_cmake",
      "common": "_fd_common",
      "component": "_fd_component",
      "components": "_fd_component",
      ".components": "_fd_component",
      "gui": "_fd_component",
      "src-ui": "_fd_component",
      "ui": "_fd_component",
      "widgets": "_fd_component",
      "composer": "_fd_composer",
      ".composer": "_fd_composer",
      "conf": "_fd_config",
      ".conf": "_fd_config",
      "config": "_fd_config",
      ".config": "_fd_config",
      "configs": "_fd_config",
      ".configs": "_fd_config",
      "configuration": "_fd_config",
      ".configuration": "_fd_config",
      "configurations": "_fd_config",
      ".configurations": "_fd_config",
      "setting": "_fd_config",
      ".setting": "_fd_config",
      "settings": "_fd_config",
      ".settings": "_fd_config",
      "ini": "_fd_config",
      ".ini": "_fd_config",
      "initializers": "_fd_config",
      ".initializers": "_fd_config",
      "__controller__": "_fd_controller",
      "__controllers__": "_fd_controller",
      "controller": "_fd_controller",
      "controllers": "_fd_controller",
      ".controllers": "_fd_controller",
      "__handler__": "_fd_controller",
      "__handlers__": "_fd_controller",
      "handler": "_fd_controller",
      ".handler": "_fd_controller",
      "handlers": "_fd_controller",
      ".handlers": "_fd_controller",
      "coverage": "_fd_coverage",
      "css": "_fd_css",
      "_css": "_fd_css",
      "cubits": "_fd_cubit",
      "cubit": "_fd_cubit",
      ".cursor": "_fd_light_cursor",
      "cypress": "_fd_light_cypress",
      ".dapr": "_fd_dapr",
      "dapr": "_fd_dapr",
      "dart": "_fd_dart",
      ".dart_tool": "_fd_dart",
      "datadog": "_fd_datadog",
      ".datadog": "_fd_datadog",
      "db": "_fd_db",
      "database": "_fd_db",
      "sql": "_fd_db",
      "data": "_fd_db",
      "repo": "_fd_db",
      "repository": "_fd_db",
      "repositories": "_fd_db",
      "store": "_fd_db",
      "stores": "_fd_db",
      "debian": "_fd_debian",
      "deb": "_fd_debian",
      ".dependabot": "_fd_dependabot",
      ".devcontainer": "_fd_devcontainer",
      "dist": "_fd_dist",
      ".dist": "_fd_dist",
      "dists": "_fd_dist",
      "out": "_fd_dist",
      "outs": "_fd_dist",
      "export": "_fd_dist",
      "exports": "_fd_dist",
      "build": "_fd_dist",
      ".build": "_fd_dist",
      "builds": "_fd_dist",
      "release": "_fd_dist",
      "releases": "_fd_dist",
      "target": "_fd_dist",
      "targets": "_fd_dist",
      "docker": "_fd_docker",
      ".docker": "_fd_docker",
      "docs": "_fd_docs",
      "doc": "_fd_docs",
      "document": "_fd_docs",
      "documents": "_fd_docs",
      "e2e": "_fd_e2e",
      ".elasticbeanstalk": "_fd_elasticbeanstalk",
      ".ebextensions": "_fd_elasticbeanstalk",
      "electron": "_fd_light_electron",
      ".expo": "_fd_light_expo",
      ".expo-shared": "_fd_light_expo",
      "favicon": "_fd_favicon",
      "favicons": "_fd_favicon",
      "flow": "_fd_flow",
      "flow-typed": "_fd_flow",
      "flutter": "_fd_flutter",
      "Flutter": "_fd_flutter",
      "fonts": "_fd_light_fonts",
      "font": "_fd_light_fonts",
      "fnt": "_fd_light_fonts",
      "webfonts": "_fd_light_fonts",
      ".front-commerce": "_fd_frontcommerce",
      "gcp": "_fd_gcp",
      ".gcp": "_fd_gcp",
      ".gemini": "_fd_gemini",
      ".git": "_fd_git",
      "submodules": "_fd_git",
      ".submodules": "_fd_git",
      ".github": "_fd_github",
      ".gitlab": "_fd_gitlab",
      "godot": "_fd_godot",
      ".godot": "_fd_godot",
      "gradle": "_fd_light_gradle",
      ".gradle": "_fd_light_gradle",
      "graphql": "_fd_graphql",
      "grunt": "_fd_grunt",
      "gulp": "_fd_gulp",
      "gulpfile.js": "_fd_gulp",
      "gulpfile.coffee": "_fd_gulp",
      "gulpfile.ts": "_fd_gulp",
      "gulpfile.babel.js": "_fd_gulp",
      "gulpfile.babel.coffee": "_fd_gulp",
      "gulpfile.babel.ts": "_fd_gulp",
      ".haxelib": "_fd_haxelib",
      "haxe_libraries": "_fd_haxelib",
      "helper": "_fd_helper",
      ".helper": "_fd_helper",
      "helpers": "_fd_helper",
      ".helpers": "_fd_helper",
      ".histoire": "_fd_histoire",
      "hook": "_fd_hook",
      ".hook": "_fd_hook",
      "hooks": "_fd_hook",
      ".hooks": "_fd_hook",
      ".husky": "_fd_husky",
      ".idea": "_fd_idea",
      ".fig": "_fd_images",
      ".figs": "_fd_images",
      "images": "_fd_images",
      "image": "_fd_images",
      ".img": "_fd_images",
      "img": "_fd_images",
      ".imgs": "_fd_images",
      "imgs": "_fd_images",
      "icons": "_fd_images",
      "icon": "_fd_images",
      "ico": "_fd_images",
      "screenshot": "_fd_images",
      "screenshots": "_fd_images",
      "svg": "_fd_images",
      "texture": "_fd_images",
      "textures": "_fd_images",
      "include": "_fd_include",
      "includes": "_fd_include",
      "incl": "_fd_include",
      "inc": "_fd_include",
      ".include": "_fd_include",
      ".includes": "_fd_include",
      ".incl": "_fd_include",
      ".inc": "_fd_include",
      "_include": "_fd_include",
      "_includes": "_fd_include",
      "_incl": "_fd_include",
      "_inc": "_fd_include",
      "interface": "_fd_interfaces",
      "interfaces": "_fd_interfaces",
      "ios": "_fd_ios",
      "js": "_fd_js",
      "json": "_fd_json",
      ".junie": "_fd_junie",
      "kotlin": "_fd_kotlin",
      "Kotlin": "_fd_kotlin",
      ".kotlin": "_fd_kotlin",
      "kubernetes": "_fd_kubernetes",
      "k8s": "_fd_kubernetes",
      "kube": "_fd_kubernetes",
      "kuber": "_fd_kubernetes",
      ".kubernetes": "_fd_kubernetes",
      ".k8s": "_fd_kubernetes",
      ".kube": "_fd_kubernetes",
      ".kuber": "_fd_kubernetes",
      "less": "_fd_less",
      "_less": "_fd_less",
      "lib": "_fd_library",
      "libs": "_fd_library",
      ".lib": "_fd_library",
      ".libs": "_fd_library",
      "__lib__": "_fd_library",
      "__libs__": "_fd_library",
      "library": "_fd_library",
      "libraries": "_fd_library",
      "linux": "_fd_linux",
      "lang": "_fd_locale",
      "language": "_fd_locale",
      "languages": "_fd_locale",
      "locale": "_fd_locale",
      "locales": "_fd_locale",
      "_locale": "_fd_locale",
      "_locales": "_fd_locale",
      "internationalization": "_fd_locale",
      "globalization": "_fd_locale",
      "localization": "_fd_locale",
      "i18n": "_fd_locale",
      "g11n": "_fd_locale",
      "l10n": "_fd_locale",
      "log": "_fd_log",
      "logs": "_fd_log",
      "macos": "_fd_macos",
      "darwin": "_fd_macos",
      "mariadb": "_fd_mariadb",
      "maria": "_fd_mariadb",
      ".mvn": "_fd_maven",
      "mediawiki": "_fd_mediawiki",
      "memcached": "_fd_memcached",
      ".memcached": "_fd_memcached",
      ".meteor": "_fd_light_meteor",
      "middleware": "_fd_middleware",
      "middlewares": "_fd_middleware",
      ".minecraft": "_fd_minecraft",
      "minikube": "_fd_minikube",
      "minik8s": "_fd_minikube",
      "minikuber": "_fd_minikube",
      "mjml": "_fd_mjml",
      ".mjml": "_fd_mjml",
      "mocks": "_fd_mock",
      ".mocks": "_fd_mock",
      "__mocks__": "_fd_mock",
      "model": "_fd_model",
      ".model": "_fd_model",
      "models": "_fd_model",
      ".models": "_fd_model",
      "entities": "_fd_model",
      ".entities": "_fd_model",
      "modules": "_fd_module",
      "mojo": "_fd_mojo",
      "mongodb": "_fd_mongodb",
      "mongo": "_fd_mongodb",
      ".mypy_cache": "_fd_light_mypy",
      "mysqldb": "_fd_light_mysql",
      "mysql": "_fd_light_mysql",
      "netlify": "_fd_netlify",
      ".next": "_fd_next",
      "nginx": "_fd_nginx",
      "conf.d": "_fd_nginx",
      ".niv": "_fd_nix",
      ".nix": "_fd_nix",
      "nix": "_fd_nix",
      "niv": "_fd_nix",
      "node_modules": "_fd_light_node",
      "notebooks": "_fd_notebooks",
      "notebook": "_fd_notebooks",
      "notification": "_fd_notification",
      "notifications": "_fd_notification",
      "event": "_fd_notification",
      "events": "_fd_notification",
      ".nuget": "_fd_nuget",
      "nuxt": "_fd_nuxt",
      ".nuxt": "_fd_nuxt",
      "package": "_fd_package",
      "packages": "_fd_package",
      ".package": "_fd_package",
      ".packages": "_fd_package",
      "pkg": "_fd_package",
      ".paket": "_fd_paket",
      "php": "_fd_php",
      ".pio": "_fd_platformio",
      ".pioenvs": "_fd_platformio",
      "plugin": "_fd_plugin",
      ".plugin": "_fd_plugin",
      "plugins": "_fd_plugin",
      ".plugins": "_fd_plugin",
      "extension": "_fd_plugin",
      ".extension": "_fd_plugin",
      "extensions": "_fd_plugin",
      ".extensions": "_fd_plugin",
      "prisma": "_fd_prisma",
      "private": "_fd_private",
      ".private": "_fd_private",
      "public": "_fd_public",
      ".public": "_fd_public",
      ".pytest_cache": "_fd_pytest",
      ".venv": "_fd_python",
      ".virtualenv": "_fd_python",
      "__pycache__": "_fd_python",
      "ravendb": "_fd_ravendb",
      "redis": "_fd_redis",
      "redux": "_fd_light_redux",
      "route": "_fd_route",
      "routes": "_fd_route",
      "_route": "_fd_route",
      "_routes": "_fd_route",
      "router": "_fd_route",
      "routers": "_fd_route",
      "sass": "_fd_light_sass",
      "scss": "_fd_light_sass",
      "_sass": "_fd_light_sass",
      "_scss": "_fd_light_sass",
      "script": "_fd_script",
      "scripts": "_fd_script",
      "seedkit": "_fd_seedkit",
      ".seedkit": "_fd_seedkit",
      "server": "_fd_server",
      "service": "_fd_services",
      "services": "_fd_services",
      "share": "_fd_shared",
      "shared": "_fd_shared",
      ".share": "_fd_shared",
      ".shared": "_fd_shared",
      "__shared__": "_fd_shared",
      "__share__": "_fd_shared",
      ".snaplet": "_fd_snaplet",
      ".spin": "_fd_spin",
      "src": "_fd_src",
      "source": "_fd_src",
      "sources": "_fd_src",
      "__src__": "_fd_src",
      "sso": "_fd_sso",
      "story": "_fd_story",
      "stories": "_fd_story",
      "__stories__": "_fd_story",
      ".storybook": "_fd_story",
      "style": "_fd_style",
      "styles": "_fd_style",
      "supabase": "_fd_supabase",
      "svelte": "_fd_svelte",
      ".svelte-kit": "_fd_svelte",
      "src-tauri": "_fd_tauri",
      "temp": "_fd_temp",
      ".temp": "_fd_temp",
      "tmp": "_fd_temp",
      ".tmp": "_fd_temp",
      "template": "_fd_template",
      ".template": "_fd_template",
      "templates": "_fd_template",
      ".templates": "_fd_template",
      "tests": "_fd_test",
      ".tests": "_fd_test",
      "test": "_fd_test",
      ".test": "_fd_test",
      "__tests__": "_fd_test",
      "__test__": "_fd_test",
      "spec": "_fd_test",
      ".spec": "_fd_test",
      "specs": "_fd_test",
      ".specs": "_fd_test",
      "integration": "_fd_test",
      "theme": "_fd_theme",
      "themes": "_fd_theme",
      "tool": "_fd_tools",
      "tools": "_fd_tools",
      ".tools": "_fd_tools",
      "util": "_fd_tools",
      "utils": "_fd_tools",
      "utilities": "_fd_tools",
      "tooling": "_fd_tools",
      ".travis": "_fd_travis",
      ".trunk": "_fd_trunk",
      ".turbo": "_fd_turbo",
      "typescript": "_fd_typescript",
      "ts": "_fd_typescript",
      "typings": "_fd_typings",
      "types": "_fd_typings",
      "@types": "_fd_typings",
      "vagrant": "_fd_vagrant",
      ".vagrant": "_fd_vagrant",
      ".vercel": "_fd_vercel",
      "video": "_fd_video",
      ".video": "_fd_video",
      "videos": "_fd_video",
      ".videos": "_fd_video",
      "html": "_fd_view",
      "view": "_fd_view",
      "views": "_fd_view",
      "layout": "_fd_view",
      "layouts": "_fd_view",
      "page": "_fd_view",
      "pages": "_fd_view",
      "_view": "_fd_view",
      "_views": "_fd_view",
      "_layout": "_fd_view",
      "_layouts": "_fd_view",
      "_page": "_fd_view",
      "_pages": "_fd_view",
      ".vitepress": "_fd_vitepress",
      ".vs": "_fd_vs",
      ".vscode": "_fd_vscode",
      "vscode": "_fd_vscode",
      ".vscode-test": "_fd_vscode_test",
      "wasm": "_fd_wasm",
      "WASM": "_fd_wasm",
      "webassembly": "_fd_wasm",
      "WebAssembly": "_fd_wasm",
      "webpack": "_fd_webpack",
      ".webpack": "_fd_webpack",
      "windows": "_fd_windows",
      "win32": "_fd_windows",
      ".windsurf": "_fd_windsurf",
      "wit": "_fd_wit",
      ".web": "_fd_www",
      "www": "_fd_www",
      "wwwroot": "_fd_www",
      "web": "_fd_www",
      ".yarn": "_fd_yarn",
      ".zed": "_fd_light_zed"
    },
    "folderNamesExpanded": {
      "android": "_fd_android_open",
      ".angular": "_fd_angular_open",
      "apache": "_fd_apache_open",
      "apache2": "_fd_apache_open",
      "httpd": "_fd_apache_open",
      "api": "_fd_api_open",
      ".api": "_fd_api_open",
      "apis": "_fd_api_open",
      ".apis": "_fd_api_open",
      "app": "_fd_app_open",
      "apps": "_fd_app_open",
      ".app": "_fd_app_open",
      "application": "_fd_app_open",
      "applications": "_fd_app_open",
      "arangodb": "_fd_arangodb_open",
      "arango": "_fd_arangodb_open",
      "assets": "_fd_asset_open",
      ".assets": "_fd_asset_open",
      ".astro": "_fd_astro_open",
      "audio": "_fd_audio_open",
      ".audio": "_fd_audio_open",
      "audios": "_fd_audio_open",
      ".audios": "_fd_audio_open",
      "sound": "_fd_audio_open",
      ".sound": "_fd_audio_open",
      "sounds": "_fd_audio_open",
      ".sounds": "_fd_audio_open",
      "aurelia_project": "_fd_aurelia_open",
      "aws": "_fd_aws_open",
      ".aws": "_fd_aws_open",
      "azure": "_fd_azure_open",
      ".azure": "_fd_azure_open",
      "azure-pipelines": "_fd_azurepipelines_open",
      ".azure-pipelines": "_fd_azurepipelines_open",
      "bin": "_fd_binary_open",
      ".bin": "_fd_binary_open",
      "blocs": "_fd_bloc_open",
      "bloc": "_fd_bloc_open",
      "blueprint": "_fd_blueprint_open",
      ".blueprint": "_fd_blueprint_open",
      "blueprints": "_fd_blueprint_open",
      ".blueprints": "_fd_blueprint_open",
      "bot": "_fd_bot_open",
      ".bot": "_fd_bot_open",
      "bower_components": "_fd_bower_open",
      ".buildkite": "_fd_buildkite_open",
      "cake": "_fd_cake_open",
      ".cake": "_fd_cake_open",
      "cargo": "_fd_cargo_open",
      ".cargo": "_fd_cargo_open",
      "crates": "_fd_cargo_open",
      "certificates": "_fd_certificate_open",
      ".certificates": "_fd_certificate_open",
      "certs": "_fd_certificate_open",
      "certs.": "_fd_certificate_open",
      ".changeset": "_fd_changesets_open",
      "chef": "_fd_chef_open",
      ".chef": "_fd_chef_open",
      ".circleci": "_fd_circleci_open",
      ".claude": "_fd_claude_open",
      "cli": "_fd_cli_open",
      "cmd": "_fd_cli_open",
      "command": "_fd_cli_open",
      "commands": "_fd_cli_open",
      "commandline": "_fd_cli_open",
      "console": "_fd_cli_open",
      "client": "_fd_client_open",
      "clients": "_fd_client_open",
      ".cloudflare": "_fd_cloudflare_open",
      "cloudflare": "_fd_cloudflare_open",
      ".cmake": "_fd_cmake_open",
      "cmake": "_fd_cmake_open",
      "common": "_fd_common_open",
      "component": "_fd_component_open",
      "components": "_fd_component_open",
      ".components": "_fd_component_open",
      "gui": "_fd_component_open",
      "src-ui": "_fd_component_open",
      "ui": "_fd_component_open",
      "widgets": "_fd_component_open",
      "composer": "_fd_composer_open",
      ".composer": "_fd_composer_open",
      "conf": "_fd_config_open",
      ".conf": "_fd_config_open",
      "config": "_fd_config_open",
      ".config": "_fd_config_open",
      "configs": "_fd_config_open",
      ".configs": "_fd_config_open",
      "configuration": "_fd_config_open",
      ".configuration": "_fd_config_open",
      "configurations": "_fd_config_open",
      ".configurations": "_fd_config_open",
      "setting": "_fd_config_open",
      ".setting": "_fd_config_open",
      "settings": "_fd_config_open",
      ".settings": "_fd_config_open",
      "ini": "_fd_config_open",
      ".ini": "_fd_config_open",
      "initializers": "_fd_config_open",
      ".initializers": "_fd_config_open",
      "__controller__": "_fd_controller_open",
      "__controllers__": "_fd_controller_open",
      "controller": "_fd_controller_open",
      "controllers": "_fd_controller_open",
      ".controllers": "_fd_controller_open",
      "__handler__": "_fd_controller_open",
      "__handlers__": "_fd_controller_open",
      "handler": "_fd_controller_open",
      ".handler": "_fd_controller_open",
      "handlers": "_fd_controller_open",
      ".handlers": "_fd_controller_open",
      "coverage": "_fd_coverage_open",
      "css": "_fd_css_open",
      "_css": "_fd_css_open",
      "cubits": "_fd_cubit_open",
      "cubit": "_fd_cubit_open",
      ".cursor": "_fd_light_cursor_open",
      "cypress": "_fd_light_cypress_open",
      ".dapr": "_fd_dapr_open",
      "dapr": "_fd_dapr_open",
      "dart": "_fd_dart_open",
      ".dart_tool": "_fd_dart_open",
      "datadog": "_fd_datadog_open",
      ".datadog": "_fd_datadog_open",
      "db": "_fd_db_open",
      "database": "_fd_db_open",
      "sql": "_fd_db_open",
      "data": "_fd_db_open",
      "repo": "_fd_db_open",
      "repository": "_fd_db_open",
      "repositories": "_fd_db_open",
      "store": "_fd_db_open",
      "stores": "_fd_db_open",
      "debian": "_fd_debian_open",
      "deb": "_fd_debian_open",
      ".dependabot": "_fd_dependabot_open",
      ".devcontainer": "_fd_devcontainer_open",
      "dist": "_fd_dist_open",
      ".dist": "_fd_dist_open",
      "dists": "_fd_dist_open",
      "out": "_fd_dist_open",
      "outs": "_fd_dist_open",
      "export": "_fd_dist_open",
      "exports": "_fd_dist_open",
      "build": "_fd_dist_open",
      ".build": "_fd_dist_open",
      "builds": "_fd_dist_open",
      "release": "_fd_dist_open",
      "releases": "_fd_dist_open",
      "target": "_fd_dist_open",
      "targets": "_fd_dist_open",
      "docker": "_fd_docker_open",
      ".docker": "_fd_docker_open",
      "docs": "_fd_docs_open",
      "doc": "_fd_docs_open",
      "document": "_fd_docs_open",
      "documents": "_fd_docs_open",
      "e2e": "_fd_e2e_open",
      ".elasticbeanstalk": "_fd_elasticbeanstalk_open",
      ".ebextensions": "_fd_elasticbeanstalk_open",
      "electron": "_fd_light_electron_open",
      ".expo": "_fd_light_expo_open",
      ".expo-shared": "_fd_light_expo_open",
      "favicon": "_fd_favicon_open",
      "favicons": "_fd_favicon_open",
      "flow": "_fd_flow_open",
      "flow-typed": "_fd_flow_open",
      "flutter": "_fd_flutter_open",
      "Flutter": "_fd_flutter_open",
      "fonts": "_fd_light_fonts_open",
      "font": "_fd_light_fonts_open",
      "fnt": "_fd_light_fonts_open",
      "webfonts": "_fd_light_fonts_open",
      ".front-commerce": "_fd_frontcommerce_open",
      "gcp": "_fd_gcp_open",
      ".gcp": "_fd_gcp_open",
      ".gemini": "_fd_gemini_open",
      ".git": "_fd_git_open",
      "submodules": "_fd_git_open",
      ".submodules": "_fd_git_open",
      ".github": "_fd_github_open",
      ".gitlab": "_fd_gitlab_open",
      "godot": "_fd_godot_open",
      ".godot": "_fd_godot_open",
      "gradle": "_fd_light_gradle_open",
      ".gradle": "_fd_light_gradle_open",
      "graphql": "_fd_graphql_open",
      "grunt": "_fd_grunt_open",
      "gulp": "_fd_gulp_open",
      "gulpfile.js": "_fd_gulp_open",
      "gulpfile.coffee": "_fd_gulp_open",
      "gulpfile.ts": "_fd_gulp_open",
      "gulpfile.babel.js": "_fd_gulp_open",
      "gulpfile.babel.coffee": "_fd_gulp_open",
      "gulpfile.babel.ts": "_fd_gulp_open",
      ".haxelib": "_fd_haxelib_open",
      "haxe_libraries": "_fd_haxelib_open",
      "helper": "_fd_helper_open",
      ".helper": "_fd_helper_open",
      "helpers": "_fd_helper_open",
      ".helpers": "_fd_helper_open",
      ".histoire": "_fd_histoire_open",
      "hook": "_fd_hook_open",
      ".hook": "_fd_hook_open",
      "hooks": "_fd_hook_open",
      ".hooks": "_fd_hook_open",
      ".husky": "_fd_husky_open",
      ".idea": "_fd_idea_open",
      ".fig": "_fd_images_open",
      ".figs": "_fd_images_open",
      "images": "_fd_images_open",
      "image": "_fd_images_open",
      ".img": "_fd_images_open",
      "img": "_fd_images_open",
      ".imgs": "_fd_images_open",
      "imgs": "_fd_images_open",
      "icons": "_fd_images_open",
      "icon": "_fd_images_open",
      "ico": "_fd_images_open",
      "screenshot": "_fd_images_open",
      "screenshots": "_fd_images_open",
      "svg": "_fd_images_open",
      "texture": "_fd_images_open",
      "textures": "_fd_images_open",
      "include": "_fd_include_open",
      "includes": "_fd_include_open",
      "incl": "_fd_include_open",
      "inc": "_fd_include_open",
      ".include": "_fd_include_open",
      ".includes": "_fd_include_open",
      ".incl": "_fd_include_open",
      ".inc": "_fd_include_open",
      "_include": "_fd_include_open",
      "_includes": "_fd_include_open",
      "_incl": "_fd_include_open",
      "_inc": "_fd_include_open",
      "interface": "_fd_interfaces_open",
      "interfaces": "_fd_interfaces_open",
      "ios": "_fd_ios_open",
      "js": "_fd_js_open",
      "json": "_fd_json_open",
      ".junie": "_fd_junie_open",
      "kotlin": "_fd_kotlin_open",
      "Kotlin": "_fd_kotlin_open",
      ".kotlin": "_fd_kotlin_open",
      "kubernetes": "_fd_kubernetes_open",
      "k8s": "_fd_kubernetes_open",
      "kube": "_fd_kubernetes_open",
      "kuber": "_fd_kubernetes_open",
      ".kubernetes": "_fd_kubernetes_open",
      ".k8s": "_fd_kubernetes_open",
      ".kube": "_fd_kubernetes_open",
      ".kuber": "_fd_kubernetes_open",
      "less": "_fd_less_open",
      "_less": "_fd_less_open",
      "lib": "_fd_library_open",
      "libs": "_fd_library_open",
      ".lib": "_fd_library_open",
      ".libs": "_fd_library_open",
      "__lib__": "_fd_library_open",
      "__libs__": "_fd_library_open",
      "library": "_fd_library_open",
      "libraries": "_fd_library_open",
      "linux": "_fd_linux_open",
      "lang": "_fd_locale_open",
      "language": "_fd_locale_open",
      "languages": "_fd_locale_open",
      "locale": "_fd_locale_open",
      "locales": "_fd_locale_open",
      "_locale": "_fd_locale_open",
      "_locales": "_fd_locale_open",
      "internationalization": "_fd_locale_open",
      "globalization": "_fd_locale_open",
      "localization": "_fd_locale_open",
      "i18n": "_fd_locale_open",
      "g11n": "_fd_locale_open",
      "l10n": "_fd_locale_open",
      "log": "_fd_log_open",
      "logs": "_fd_log_open",
      "macos": "_fd_macos_open",
      "darwin": "_fd_macos_open",
      "mariadb": "_fd_mariadb_open",
      "maria": "_fd_mariadb_open",
      ".mvn": "_fd_maven_open",
      "mediawiki": "_fd_mediawiki_open",
      "memcached": "_fd_memcached_open",
      ".memcached": "_fd_memcached_open",
      ".meteor": "_fd_light_meteor_open",
      "middleware": "_fd_middleware_open",
      "middlewares": "_fd_middleware_open",
      ".minecraft": "_fd_minecraft_open",
      "minikube": "_fd_minikube_open",
      "minik8s": "_fd_minikube_open",
      "minikuber": "_fd_minikube_open",
      "mjml": "_fd_mjml_open",
      ".mjml": "_fd_mjml_open",
      "mocks": "_fd_mock_open",
      ".mocks": "_fd_mock_open",
      "__mocks__": "_fd_mock_open",
      "model": "_fd_model_open",
      ".model": "_fd_model_open",
      "models": "_fd_model_open",
      ".models": "_fd_model_open",
      "entities": "_fd_model_open",
      ".entities": "_fd_model_open",
      "modules": "_fd_module_open",
      "mojo": "_fd_mojo_open",
      "mongodb": "_fd_mongodb_open",
      "mongo": "_fd_mongodb_open",
      ".mypy_cache": "_fd_light_mypy_open",
      "mysqldb": "_fd_light_mysql_open",
      "mysql": "_fd_light_mysql_open",
      "netlify": "_fd_netlify_open",
      ".next": "_fd_next_open",
      "nginx": "_fd_nginx_open",
      "conf.d": "_fd_nginx_open",
      ".niv": "_fd_nix_open",
      ".nix": "_fd_nix_open",
      "nix": "_fd_nix_open",
      "niv": "_fd_nix_open",
      "node_modules": "_fd_light_node_open",
      "notebooks": "_fd_notebooks_open",
      "notebook": "_fd_notebooks_open",
      "notification": "_fd_notification_open",
      "notifications": "_fd_notification_open",
      "event": "_fd_notification_open",
      "events": "_fd_notification_open",
      ".nuget": "_fd_nuget_open",
      "nuxt": "_fd_nuxt_open",
      ".nuxt": "_fd_nuxt_open",
      "package": "_fd_package_open",
      "packages": "_fd_package_open",
      ".package": "_fd_package_open",
      ".packages": "_fd_package_open",
      "pkg": "_fd_package_open",
      ".paket": "_fd_paket_open",
      "php": "_fd_php_open",
      ".pio": "_fd_platformio_open",
      ".pioenvs": "_fd_platformio_open",
      "plugin": "_fd_plugin_open",
      ".plugin": "_fd_plugin_open",
      "plugins": "_fd_plugin_open",
      ".plugins": "_fd_plugin_open",
      "extension": "_fd_plugin_open",
      ".extension": "_fd_plugin_open",
      "extensions": "_fd_plugin_open",
      ".extensions": "_fd_plugin_open",
      "prisma": "_fd_prisma_open",
      "private": "_fd_private_open",
      ".private": "_fd_private_open",
      "public": "_fd_public_open",
      ".public": "_fd_public_open",
      ".pytest_cache": "_fd_pytest_open",
      ".venv": "_fd_python_open",
      ".virtualenv": "_fd_python_open",
      "__pycache__": "_fd_python_open",
      "ravendb": "_fd_ravendb_open",
      "redis": "_fd_redis_open",
      "redux": "_fd_light_redux_open",
      "route": "_fd_route_open",
      "routes": "_fd_route_open",
      "_route": "_fd_route_open",
      "_routes": "_fd_route_open",
      "router": "_fd_route_open",
      "routers": "_fd_route_open",
      "sass": "_fd_light_sass_open",
      "scss": "_fd_light_sass_open",
      "_sass": "_fd_light_sass_open",
      "_scss": "_fd_light_sass_open",
      "script": "_fd_script_open",
      "scripts": "_fd_script_open",
      "seedkit": "_fd_seedkit_open",
      ".seedkit": "_fd_seedkit_open",
      "server": "_fd_server_open",
      "service": "_fd_services_open",
      "services": "_fd_services_open",
      "share": "_fd_shared_open",
      "shared": "_fd_shared_open",
      ".share": "_fd_shared_open",
      ".shared": "_fd_shared_open",
      "__shared__": "_fd_shared_open",
      "__share__": "_fd_shared_open",
      ".snaplet": "_fd_snaplet_open",
      ".spin": "_fd_spin_open",
      "src": "_fd_src_open",
      "source": "_fd_src_open",
      "sources": "_fd_src_open",
      "__src__": "_fd_src_open",
      "sso": "_fd_sso_open",
      "story": "_fd_story_open",
      "stories": "_fd_story_open",
      "__stories__": "_fd_story_open",
      ".storybook": "_fd_story_open",
      "style": "_fd_style_open",
      "styles": "_fd_style_open",
      "supabase": "_fd_supabase_open",
      "svelte": "_fd_svelte_open",
      ".svelte-kit": "_fd_svelte_open",
      "src-tauri": "_fd_tauri_open",
      "temp": "_fd_temp_open",
      ".temp": "_fd_temp_open",
      "tmp": "_fd_temp_open",
      ".tmp": "_fd_temp_open",
      "template": "_fd_template_open",
      ".template": "_fd_template_open",
      "templates": "_fd_template_open",
      ".templates": "_fd_template_open",
      "tests": "_fd_test_open",
      ".tests": "_fd_test_open",
      "test": "_fd_test_open",
      ".test": "_fd_test_open",
      "__tests__": "_fd_test_open",
      "__test__": "_fd_test_open",
      "spec": "_fd_test_open",
      ".spec": "_fd_test_open",
      "specs": "_fd_test_open",
      ".specs": "_fd_test_open",
      "integration": "_fd_test_open",
      "theme": "_fd_theme_open",
      "themes": "_fd_theme_open",
      "tool": "_fd_tools_open",
      "tools": "_fd_tools_open",
      ".tools": "_fd_tools_open",
      "util": "_fd_tools_open",
      "utils": "_fd_tools_open",
      "utilities": "_fd_tools_open",
      "tooling": "_fd_tools_open",
      ".travis": "_fd_travis_open",
      ".trunk": "_fd_trunk_open",
      ".turbo": "_fd_turbo_open",
      "typescript": "_fd_typescript_open",
      "ts": "_fd_typescript_open",
      "typings": "_fd_typings_open",
      "types": "_fd_typings_open",
      "@types": "_fd_typings_open",
      "vagrant": "_fd_vagrant_open",
      ".vagrant": "_fd_vagrant_open",
      ".vercel": "_fd_vercel_open",
      "video": "_fd_video_open",
      ".video": "_fd_video_open",
      "videos": "_fd_video_open",
      ".videos": "_fd_video_open",
      "html": "_fd_view_open",
      "view": "_fd_view_open",
      "views": "_fd_view_open",
      "layout": "_fd_view_open",
      "layouts": "_fd_view_open",
      "page": "_fd_view_open",
      "pages": "_fd_view_open",
      "_view": "_fd_view_open",
      "_views": "_fd_view_open",
      "_layout": "_fd_view_open",
      "_layouts": "_fd_view_open",
      "_page": "_fd_view_open",
      "_pages": "_fd_view_open",
      ".vitepress": "_fd_vitepress_open",
      ".vs": "_fd_vs_open",
      ".vscode": "_fd_vscode_open",
      "vscode": "_fd_vscode_open",
      ".vscode-test": "_fd_vscode_test_open",
      "wasm": "_fd_wasm_open",
      "WASM": "_fd_wasm_open",
      "webassembly": "_fd_wasm_open",
      "WebAssembly": "_fd_wasm_open",
      "webpack": "_fd_webpack_open",
      ".webpack": "_fd_webpack_open",
      "windows": "_fd_windows_open",
      "win32": "_fd_windows_open",
      ".windsurf": "_fd_windsurf_open",
      "wit": "_fd_wit_open",
      ".web": "_fd_www_open",
      "www": "_fd_www_open",
      "wwwroot": "_fd_www_open",
      "web": "_fd_www_open",
      ".yarn": "_fd_yarn_open",
      ".zed": "_fd_light_zed_open"
    },
    "fileExtensions": {
      "accdb": "_f_access",
      "accdt": "_f_access",
      "mdb": "_f_access",
      "accda": "_f_access",
      "accdc": "_f_access",
      "accde": "_f_access",
      "accdp": "_f_access",
      "accdr": "_f_access",
      "accdu": "_f_access",
      "ade": "_f_access",
      "adp": "_f_access",
      "laccdb": "_f_access",
      "ldb": "_f_access",
      "mam": "_f_access",
      "maq": "_f_access",
      "mdw": "_f_access",
      "af": "_f_affinity",
      "aftemplate": "_f_affinity",
      "afdesign": "_f_affinitydesigner",
      "affinitydesigner": "_f_affinitydesigner",
      "afphoto": "_f_affinityphoto",
      "affinityphoto": "_f_affinityphoto",
      "afpub": "_f_affinitypublisher",
      "affinitypublisher": "_f_affinitypublisher",
      "ai": "_f_ai",
      "dal": "_f_al_dal",
      "gs": "_f_appscript",
      "ino": "_f_arduino",
      "pde": "_f_arduino",
      "ase": "_f_aseprite",
      "aseprite": "_f_aseprite",
      "aspx": "_f_aspx",
      "ascx": "_f_aspx",
      "asm": "_f_assembly",
      "s": "_f_assembly",
      "astro": "_f_light_astro",
      "atom": "_f_atom",
      "aac": "_f_audio",
      "act": "_f_audio",
      "aiff": "_f_audio",
      "amr": "_f_audio",
      "ape": "_f_audio",
      "au": "_f_audio",
      "dct": "_f_audio",
      "dss": "_f_audio",
      "dvf": "_f_audio",
      "flac": "_f_audio",
      "gsm": "_f_audio",
      "iklax": "_f_audio",
      "ivs": "_f_audio",
      "m4a": "_f_audio",
      "m4b": "_f_audio",
      "m4p": "_f_audio",
      "mmf": "_f_audio",
      "mogg": "_f_audio",
      "mp3": "_f_audio",
      "mpc": "_f_audio",
      "msv": "_f_audio",
      "oga": "_f_audio",
      "ogg": "_f_audio",
      "opus": "_f_audio",
      "ra": "_f_audio",
      "raw": "_f_audio",
      "tta": "_f_audio",
      "vox": "_f_audio",
      "wav": "_f_audio",
      "wma": "_f_audio",
      "avif": "_f_avif",
      "awk": "_f_awk",
      "back": "_f_bak",
      "backup": "_f_bak",
      "bak": "_f_bak",
      "a": "_f_binary",
      "app": "_f_binary",
      "bin": "_f_binary",
      "cmo": "_f_binary",
      "cmx": "_f_binary",
      "cma": "_f_binary",
      "cmxa": "_f_binary",
      "cmi": "_f_binary",
      "dll": "_f_binary",
      "exe": "_f_binary",
      "hl": "_f_binary",
      "ilk": "_f_binary",
      "lib": "_f_binary",
      "n": "_f_binary",
      "ndll": "_f_binary",
      "o": "_f_binary",
      "obj": "_f_binary",
      "pyc": "_f_binary",
      "pyd": "_f_binary",
      "pyo": "_f_binary",
      "pdb": "_f_binary",
      "scpt": "_f_binary",
      "scptd": "_f_binary",
      "so": "_f_binary",
      "blend": "_f_blender",
      "bb": "_f_blitzbasic",
      "buf.yaml": "_f_buf",
      "buf.yml": "_f_buf",
      "buf.gen.yml": "_f_buf",
      "buf.gen.yaml": "_f_buf",
      "buf.work.yaml": "_f_buf",
      "buf.work.yml": "_f_buf",
      "gemfile": "_f_bundler",
      "gemfile.lock": "_f_bundler",
      "cake": "_f_cake",
      "csr": "_f_cert",
      "crt": "_f_cert",
      "cer": "_f_cert",
      "der": "_f_cert",
      "pfx": "_f_cert",
      "p12": "_f_cert",
      "p7b": "_f_cert",
      "p7r": "_f_cert",
      "src": "_f_cert",
      "crl": "_f_cert",
      "sst": "_f_cert",
      "stl": "_f_cert",
      "lucee": "_f_cf",
      "h": "_f_cheader",
      "class": "_f_class",
      "cjm": "_f_clojure",
      "cljc": "_f_clojure",
      "cljs": "_f_clojurescript",
      "kit": "_f_codekit",
      "plist": "_f_light_config",
      "lcov": "_f_coverage",
      "hpp": "_f_cppheader",
      "hh": "_f_cppheader",
      "hxx": "_f_cppheader",
      "h++": "_f_cppheader",
      "csx": "_f_csharp",
      "csproj": "_f_csproj",
      "css.map": "_f_cssmap",
      "cy.js": "_f_light_cypress_spec",
      "cy.mjs": "_f_light_cypress_spec",
      "cy.cjs": "_f_light_cypress_spec",
      "cy.coffee": "_f_light_cypress_spec",
      "cy.ts": "_f_light_cypress_spec",
      "cy.tsx": "_f_light_cypress_spec",
      "cy.jsx": "_f_light_cypress_spec",
      "g.dart": "_f_dartlang_generated",
      "freezed.dart": "_f_dartlang_generated",
      "db": "_f_light_db",
      "deb": "_f_debian",
      "resolver.json": "_f_design_tokens",
      "resolver.json5": "_f_design_tokens",
      "resolver.jsonc": "_f_design_tokens",
      "tokens.json": "_f_design_tokens",
      "tokens.json5": "_f_design_tokens",
      "tokens.jsonc": "_f_design_tokens",
      "djt": "_f_django",
      "eco": "_f_light_docpad",
      "drawio": "_f_drawio",
      "dio": "_f_drawio",
      "drawio.png": "_f_drawio",
      "drawio.svg": "_f_drawio",
      "dio.png": "_f_drawio",
      "dio.svg": "_f_drawio",
      "dtd": "_f_dtd",
      "eex": "_f_eex",
      "heex": "_f_eex",
      "phoenix-heex": "_f_eex",
      "html-heex": "_f_eex",
      "ejs": "_f_ejs",
      "el": "_f_emacs",
      "elc": "_f_emacs",
      "ensime": "_f_ensime",
      "eps": "_f_eps",
      "epub": "_f_epub",
      "excalidraw": "_f_excalidraw",
      "excalidraw.json": "_f_excalidraw",
      "excalidraw.svg": "_f_excalidraw",
      "excalidraw.png": "_f_excalidraw",
      "xls": "_f_excel",
      "xlsx": "_f_excel",
      "xlsm": "_f_excel",
      "ods": "_f_libreoffice_calc",
      "fods": "_f_libreoffice_calc",
      "xlsb": "_f_excel",
      "fbx": "_f_fbx",
      "fba": "_f_fitbit",
      "fla": "_f_light_fla",
      "swf": "_f_flash",
      "swc": "_f_flash",
      "js.flow": "_f_flow",
      "woff": "_f_light_font",
      "woff2": "_f_light_font",
      "ttf": "_f_light_font",
      "otf": "_f_libreoffice_math",
      "eot": "_f_light_font",
      "pfa": "_f_light_font",
      "pfb": "_f_light_font",
      "sfd": "_f_light_font",
      "fsproj": "_f_fsproj",
      "gmx": "_f_gamemaker",
      "yy": "_f_light_gamemaker2",
      "yyp": "_f_light_gamemaker2",
      "gd.uid": "_f_gduid",
      "geojson": "_f_geojson",
      "xcf": "_f_gimp",
      "gleam": "_f_gleam",
      "glb": "_f_gltf",
      "gltf": "_f_gltf",
      "am": "_f_gnu",
      "ld": "_f_gnu",
      "m4": "_f_gnu",
      "makefile": "_f_gnu",
      "godot": "_f_godot",
      "gpg": "_f_gpg",
      "pgp": "_f_gpg",
      "gradle": "_f_light_gradle",
      "gr": "_f_grain",
      "hcl2": "_f_light_hashicorp",
      "sentinel": "_f_light_hashicorp",
      "hxproj": "_f_haxedevelop",
      "ejs.t": "_f_hygen",
      "idr": "_f_idris",
      "lidr": "_f_idris",
      "ibc": "_f_idrisbin",
      "ipkg": "_f_idrispkg",
      "jpeg": "_f_image",
      "jpg": "_f_image",
      "gif": "_f_image",
      "png": "_f_image",
      "bmp": "_f_image",
      "tiff": "_f_image",
      "heic": "_f_image",
      "ico": "_f_image",
      "icns": "_f_image",
      "webp": "_f_image",
      "imba": "_f_imba",
      "imba2": "_f_imba",
      "inc": "_f_inc",
      "include": "_f_inc",
      "infopathxml": "_f_infopath",
      "xsn": "_f_infopath",
      "xsf": "_f_infopath",
      "xtp2": "_f_infopath",
      "jar": "_f_jar",
      "jbuilder": "_f_jbuilder",
      "iml": "_f_jetbrains",
      "js.map": "_f_light_jsmap",
      "cjs.map": "_f_light_jsmap",
      "mjs.map": "_f_light_jsmap",
      "jsonl": "_f_light_json",
      "ndjson": "_f_light_json",
      "json5": "_f_light_json5",
      "schema.json": "_f_light_json_schema",
      "jsonld": "_f_light_jsonld",
      "json-ld": "_f_light_jsonld",
      "jsp": "_f_jsp",
      "jss": "_f_jss",
      "juice": "_f_juice",
      "ipynb": "_f_jupyter",
      "key": "_f_key",
      "pem": "_f_key",
      "ktm": "_f_kotlin",
      "language-configuration.json": "_f_language_configuration",
      "master": "_f_layout",
      "layout.html": "_f_layout",
      "layout.htm": "_f_layout",
      "odb": "_f_libreoffice_base",
      "otb": "_f_libreoffice_base",
      "ots": "_f_libreoffice_calc",
      "odg": "_f_libreoffice_draw",
      "otg": "_f_libreoffice_draw",
      "odp": "_f_libreoffice_impress",
      "otp": "_f_libreoffice_impress",
      "odf": "_f_libreoffice_math",
      "odt": "_f_libreoffice_writer",
      "ott": "_f_libreoffice_writer",
      "enc": "_f_license",
      "license": "_f_license",
      "lic": "_f_license",
      "hxp": "_f_lime",
      "liquid": "_f_liquid",
      "ls": "_f_livescript",
      "lnk": "_f_lnk",
      "log": "_f_log",
      "tlg": "_f_log",
      "luau": "_f_luau",
      "crec": "_f_lync",
      "ocrec": "_f_lync",
      "map": "_f_map",
      "mdown": "_f_markdown",
      "markdown": "_f_markdown",
      "marko.js": "_f_markojs",
      "fig": "_f_matlab",
      "mex": "_f_matlab",
      "mexn": "_f_matlab",
      "mexrs6": "_f_matlab",
      "mn": "_f_matlab",
      "mum": "_f_matlab",
      "mx": "_f_matlab",
      "mx3": "_f_matlab",
      "rwd": "_f_matlab",
      "slx": "_f_matlab",
      "slddc": "_f_matlab",
      "smv": "_f_matlab",
      "xvc": "_f_matlab",
      "mca": "_f_minecraft",
      "mcmeta": "_f_minecraft",
      "mojo": "_f_mojo",
      "🔥": "_f_mojo",
      "mql.yaml": "_f_mondoo",
      "mql.yml": "_f_mondoo",
      "mustache": "_f_light_mustache",
      "mst": "_f_light_mustache",
      "ndst.yaml": "_f_ndst",
      "ndst.yml": "_f_ndst",
      "ndst.json": "_f_ndst",
      "njsproj": "_f_njsproj",
      "noc": "_f_noc",
      "nupkg": "_f_nuget",
      "snupkg": "_f_nuget",
      "nuspec": "_f_nuget",
      "psmdcp": "_f_nuget",
      "npy": "_f_numpy",
      "npz": "_f_numpy",
      "nunj": "_f_nunjucks",
      "njs": "_f_nunjucks",
      "mli": "_f_ocaml_intf",
      "one": "_f_onenote",
      "onepkg": "_f_onenote",
      "onetoc": "_f_onenote",
      "onetoc2": "_f_onenote",
      "sig": "_f_onenote",
      "opam": "_f_opam",
      "cl": "_f_opencl",
      "opencl": "_f_opencl",
      "tofu": "_f_opentofu",
      "tofu.json": "_f_opentofu",
      "tofutest.hcl": "_f_opentofu",
      "tofutest.json": "_f_opentofu",
      "org": "_f_org",
      "pst": "_f_outlook",
      "bcmx": "_f_outlook",
      "otm": "_f_outlook",
      "msg": "_f_outlook",
      "oft": "_f_outlook",
      "ovpn": "_f_ovpn",
      "pkg": "_f_package",
      "paket.references": "_f_paket",
      "paket.template": "_f_paket",
      "patch": "_f_patch",
      "pcd": "_f_light_pcl",
      "pdf": "_f_pdf",
      "psd": "_f_photoshop",
      "php1": "_f_php",
      "php2": "_f_php",
      "php3": "_f_php",
      "php4": "_f_php",
      "php5": "_f_php",
      "php6": "_f_php",
      "phps": "_f_php",
      "phpsa": "_f_php",
      "phpt": "_f_php",
      "phtml": "_f_php",
      "phar": "_f_php",
      "pipeline": "_f_pipeline",
      "pu": "_f_plantuml",
      "plantuml": "_f_plantuml",
      "iuml": "_f_plantuml",
      "puml": "_f_plantuml",
      "pck": "_f_plsql_package",
      "pkb": "_f_plsql_package_body",
      "pkh": "_f_plsql_package_header",
      "pks": "_f_plsql_package_spec",
      "po": "_f_poedit",
      "mo": "_f_poedit",
      "postman_collection.json": "_f_postman",
      "postman_environment.json": "_f_postman",
      "postman_globals.json": "_f_postman",
      "pot": "_f_powerpoint",
      "potx": "_f_powerpoint",
      "potm": "_f_powerpoint",
      "pps": "_f_powerpoint",
      "ppsx": "_f_powerpoint",
      "ppsm": "_f_powerpoint",
      "ppt": "_f_powerpoint",
      "pptx": "_f_powerpoint",
      "pptm": "_f_powerpoint",
      "pa": "_f_powerpoint",
      "ppa": "_f_powerpoint",
      "ppam": "_f_powerpoint",
      "sldm": "_f_powerpoint",
      "sldx": "_f_powerpoint",
      "format.ps1xml": "_f_powershell_format",
      "psd1": "_f_powershell_psd",
      "psm1": "_f_powershell_psm",
      "types.ps1xml": "_f_powershell_types",
      "pro": "_f_prolog",
      "pub": "_f_publisher",
      "puz": "_f_publisher",
      "pyowo": "_f_pythowo",
      "q": "_f_q",
      "qbs": "_f_qbs",
      "qvd": "_f_qlikview",
      "qvw": "_f_qlikview",
      "rast": "_f_ra_syntax_tree",
      "rake": "_f_rake",
      "rt": "_f_reacttemplate",
      "reg": "_f_registry",
      "rego": "_f_rego",
      "ripple": "_f_ripple",
      "rnc": "_f_rnc",
      "ron": "_f_ron",
      "rproj": "_f_rproj",
      "rss": "_f_rss",
      "rbs": "_f_ruby",
      "safetensors": "_f_light_safetensors",
      "sls": "_f_saltstack",
      "sass": "_f_sass",
      "scssm": "_f_scss",
      "unity": "_f_light_shaderlab",
      "fish": "_f_shell",
      "sy": "_f_siyuan",
      "sketch": "_f_sketch",
      "eskip": "_f_skipper",
      "sln": "_f_sln",
      "slnx": "_f_sln",
      "slnf": "_f_sln",
      "spe": "_f_spacengine",
      "sqlite": "_f_sqlite",
      "sqlite3": "_f_sqlite",
      "db3": "_f_sqlite",
      "sss": "_f_sss",
      "dta": "_f_stata",
      "storyboard": "_f_storyboard",
      "story.js": "_f_storybook",
      "story.jsx": "_f_storybook",
      "story.ts": "_f_storybook",
      "story.tsx": "_f_storybook",
      "story.mdx": "_f_storybook",
      "story.svelte": "_f_storybook",
      "stories.js": "_f_storybook",
      "stories.jsx": "_f_storybook",
      "stories.ts": "_f_storybook",
      "stories.tsx": "_f_storybook",
      "stories.mdx": "_f_storybook",
      "stories.svelte": "_f_storybook",
      "sublime-project": "_f_sublime",
      "svg": "_f_svg",
      "tcl": "_f_tcl",
      "exp": "_f_tcl",
      "templ": "_f_templ",
      "tfstate": "_f_terraform",
      "tfvars": "_f_terraform",
      "tf": "_f_terraform",
      "tf.json": "_f_terraform",
      "tst": "_f_test",
      "test.js": "_f_light_testjs",
      "test.jsx": "_f_light_testjs",
      "test.mjs": "_f_light_testjs",
      "spec.js": "_f_light_testjs",
      "spec.jsx": "_f_light_testjs",
      "spec.mjs": "_f_light_testjs",
      "testplane.ts": "_f_testplane",
      "testplane.js": "_f_testplane",
      "testplane.cts": "_f_testplane",
      "testplane.cjs": "_f_testplane",
      "testplane.tsx": "_f_testplane",
      "testplane.jsx": "_f_testplane",
      "test.ts": "_f_testts",
      "test.tsx": "_f_testts",
      "test.mts": "_f_testts",
      "spec.ts": "_f_testts",
      "spec.tsx": "_f_testts",
      "spec.mts": "_f_testts",
      "e2e-test.ts": "_f_testts",
      "e2e-test.tsx": "_f_testts",
      "e2e-test.mts": "_f_testts",
      "e2e-spec.ts": "_f_testts",
      "e2e-spec.tsx": "_f_testts",
      "e2e-spec.mts": "_f_testts",
      "test-d.ts": "_f_testts",
      "test-d.tsx": "_f_testts",
      "test-d.mts": "_f_testts",
      "texi": "_f_light_tex",
      "tikz": "_f_light_tex",
      "csv": "_f_text",
      "tsv": "_f_text",
      "tm": "_f_light_tm",
      "tm.hcl": "_f_light_tm",
      "todo": "_f_light_todo",
      "tree": "_f_light_tree",
      "tres": "_f_tres",
      "tsbuildinfo": "_f_tsbuildinfo",
      "tscn": "_f_tscn",
      "tt2": "_f_tt",
      "d.ts": "_f_typescriptdef",
      "d.cts": "_f_typescriptdef",
      "d.mts": "_f_typescriptdef",
      "ua": "_f_uiua",
      "u": "_f_unison",
      "vala": "_f_vala",
      "css.ts": "_f_vanilla_extract",
      "vapi": "_f_vapi",
      "vash": "_f_light_vash",
      "vbhtml": "_f_vbhtml",
      "vbproj": "_f_vbproj",
      "vcxproj": "_f_vcxproj",
      "vto": "_f_vento",
      "vento": "_f_vento",
      "3g2": "_f_video",
      "3gp": "_f_video",
      "asf": "_f_video",
      "amv": "_f_video",
      "avi": "_f_video",
      "divx": "_f_video",
      "qt": "_f_video",
      "f4a": "_f_video",
      "f4b": "_f_video",
      "f4p": "_f_video",
      "f4v": "_f_video",
      "flv": "_f_video",
      "m2v": "_f_video",
      "m4v": "_f_video",
      "mkv": "_f_video",
      "mk3d": "_f_video",
      "mov": "_f_video",
      "mp2": "_f_video",
      "mp4": "_f_video",
      "mpe": "_f_video",
      "mpeg": "_f_video",
      "mpeg2": "_f_video",
      "mpg": "_f_video",
      "mpv": "_f_video",
      "nsv": "_f_video",
      "ogv": "_f_video",
      "rm": "_f_video",
      "rmvb": "_f_video",
      "svi": "_f_video",
      "vob": "_f_video",
      "webm": "_f_video",
      "wmv": "_f_video",
      "code-snippets": "_f_vscode",
      "code-workspace": "_f_vscode",
      "vsix": "_f_light_vsix",
      "vsixmanifest": "_f_light_vsixmanifest",
      "vvvvvv": "_f_vvvvvv",
      "vyi": "_f_vyper",
      "wasm": "_f_wasm",
      "wikitext": "_f_wikitext",
      "wit": "_f_wit",
      "doc": "_f_word",
      "docx": "_f_word",
      "docm": "_f_word",
      "dot": "_f_word",
      "dotx": "_f_word",
      "dotm": "_f_word",
      "wll": "_f_word",
      "wxml": "_f_wxml",
      "wxss": "_f_wxss",
      "xaml": "_f_xaml",
      "axaml": "_f_xaml",
      "xcodeproj": "_f_xcode",
      "xfl": "_f_light_xfl",
      "xib": "_f_xib",
      "xliff": "_f_xliff",
      "xlf": "_f_xliff",
      "pex": "_f_xml",
      "tmlanguage": "_f_xml",
      "zip": "_f_zip",
      "rar": "_f_zip",
      "7z": "_f_zip",
      "tar": "_f_zip",
      "tgz": "_f_zip",
      "bz": "_f_zip",
      "gz": "_f_zip",
      "bzip2": "_f_zip",
      "xz": "_f_zip",
      "bz2": "_f_zip",
      "whl": "_f_zip",
      "zipx": "_f_zip",
      "br": "_f_zip"
    },
    "fileNames": {
      "agents.md": "_f_light_agents",
      "alchemy.run.ts": "_f_alchemy",
      ".all-contributorsrc": "_f_allcontributors",
      "allurerc.js": "_f_allure",
      "allurerc.mjs": "_f_allure",
      "allurerc.cjs": "_f_allure",
      "allurerc.json": "_f_allure",
      "allurerc.yaml": "_f_allure",
      "allurerc.yml": "_f_allure",
      ".angular-cli.json": "_f_angular",
      "angular-cli.json": "_f_angular",
      "angular.json": "_f_angular",
      ".angular.json": "_f_angular",
      "antlers.html": "_f_antlers_html",
      "api-extractor.json": "_f_api_extractor",
      "api-extractor-base.json": "_f_api_extractor",
      ".appsemblerc.yaml": "_f_appsemble",
      "app-definition.yaml": "_f_appsemble",
      "appveyor.yml": "_f_appveyor",
      ".appveyor.yml": "_f_appveyor",
      "asconfig.json": "_f_assembly_script",
      "astro.config.js": "_f_light_astroconfig",
      "astro.config.cjs": "_f_light_astroconfig",
      "astro.config.mjs": "_f_light_astroconfig",
      "astro.config.ts": "_f_light_astroconfig",
      "astro.config.cts": "_f_light_astroconfig",
      "astro.config.mts": "_f_light_astroconfig",
      ".attw.json": "_f_attw",
      "aurelia.json": "_f_aurelia",
      "azure-pipelines.yml": "_f_azurepipelines",
      ".vsts-ci.yml": "_f_azurepipelines",
      ".babelrc": "_f_light_babel",
      ".babelignore": "_f_light_babel",
      ".babelrc.js": "_f_light_babel",
      ".babelrc.cjs": "_f_light_babel",
      ".babelrc.mjs": "_f_light_babel",
      ".babelrc.json": "_f_light_babel",
      "babel.config.js": "_f_light_babel",
      "babel.config.cjs": "_f_light_babel",
      "babel.config.mjs": "_f_light_babel",
      "babel.config.json": "_f_light_babel",
      ".bzrignore": "_f_bazaar",
      "BUILD.bazel": "_f_bazel",
      ".bazelrc": "_f_bazel",
      "bazel.rc": "_f_bazel",
      "bazel.bazelrc": "_f_bazel",
      ".bazelignore": "_f_bazel_ignore",
      ".bazelversion": "_f_bazel_version",
      "biome.json": "_f_biome",
      "biome.jsonc": "_f_biome",
      "bitbucket-pipelines.yml": "_f_bitbucketpipeline",
      ".bithoundrc": "_f_bithound",
      ".bowerrc": "_f_bower",
      "bower.json": "_f_bower",
      ".browserslistrc": "_f_browserslist",
      "browserslist": "_f_browserslist",
      ".buckconfig": "_f_buckbuild",
      ".bunfig.toml": "_f_bun",
      "bunfig.toml": "_f_bunfig",
      "bun.lockb": "_f_bun",
      "bun.lock": "_f_bun",
      ".bundlemonrc": "_f_bundlemon",
      "bundlemon.config.js": "_f_bundlemon",
      "bundlemon.config.mjs": "_f_bundlemon",
      "bundlemon.config.cjs": "_f_bundlemon",
      ".bundlemonrc.js": "_f_bundlemon",
      ".bundlemonrc.mjs": "_f_bundlemon",
      ".bundlemonrc.cjs": "_f_bundlemon",
      ".bundlemonrc.json": "_f_bundlemon",
      ".bundlemonrc.yaml": "_f_bundlemon",
      ".bundlemonrc.yml": "_f_bundlemon",
      "gemfile": "_f_bundler",
      "gemfile.lock": "_f_bundler",
      "capacitor.config.json": "_f_capacitor",
      "capacitor.config.ts": "_f_capacitor",
      "Cargo.toml": "_f_cargo",
      "Cargo.lock": "_f_cargo",
      ".changie.yaml": "_f_changie",
      ".changie.yml": "_f_changie",
      "chefignore": "_f_chef",
      "berksfile": "_f_chef",
      "berksfile.lock": "_f_chef",
      "policyfile.rb": "_f_chef",
      "policyfile.lock.json": "_f_chef",
      "circle.yml": "_f_light_circleci",
      "claude.md": "_f_claude",
      "wrangler.toml": "_f_cloudflare",
      ".cfignore": "_f_light_cloudfoundry",
      ".codacy.yml": "_f_light_codacy",
      ".codacy.yaml": "_f_light_codacy",
      ".codeclimate.yml": "_f_light_codeclimate",
      "codecov.yml": "_f_codecov",
      ".codecov.yml": "_f_codecov",
      "config.codekit": "_f_codekit",
      "config.codekit2": "_f_codekit",
      "config.codekit3": "_f_codekit",
      ".config.codekit": "_f_codekit",
      ".config.codekit2": "_f_codekit",
      ".config.codekit3": "_f_codekit",
      "codemagic.yaml": "_f_codemagic",
      "codeowners": "_f_light_codeowners",
      ".coderabbit.yaml": "_f_coderabbit",
      "coffeelint.json": "_f_coffeelint",
      ".coffeelintignore": "_f_coffeelint",
      ".czrc": "_f_commitizen",
      ".cz.json": "_f_commitizen",
      ".commitlintrc": "_f_commitlint",
      "commitlint.config.js": "_f_commitlint",
      "commitlint.config.cjs": "_f_commitlint",
      "commitlint.config.mjs": "_f_commitlint",
      "commitlint.config.ts": "_f_commitlint",
      "commitlint.config.cts": "_f_commitlint",
      ".commitlintrc.json": "_f_commitlint",
      ".commitlintrc.yaml": "_f_commitlint",
      ".commitlintrc.yml": "_f_commitlint",
      ".commitlintrc.js": "_f_commitlint",
      ".commitlintrc.cjs": "_f_commitlint",
      ".commitlintrc.mjs": "_f_commitlint",
      ".commitlintrc.ts": "_f_commitlint",
      ".commitlintrc.cts": "_f_commitlint",
      "composer.json": "_f_composer",
      "composer.lock": "_f_composer",
      "conanfile.txt": "_f_conan",
      "conanfile.py": "_f_conan",
      ".condarc": "_f_conda",
      ".tool-versions": "_f_light_config",
      "copilot-instructions.md": "_f_light_copilot",
      "github-copilot.xml": "_f_light_copilot",
      ".coverage": "_f_coverage",
      "lcov.info": "_f_coverage",
      ".coveralls.yml": "_f_coveralls",
      "craco.config.ts": "_f_craco",
      "craco.config.js": "_f_craco",
      "craco.config.cjs": "_f_craco",
      ".cracorc.ts": "_f_craco",
      ".cracorc.js": "_f_craco",
      ".cracorc": "_f_craco",
      "crowdin.yml": "_f_crowdin",
      "cspell.config.json": "_f_cspell",
      "cspell.config.js": "_f_cspell",
      "cspell.config.mjs": "_f_cspell",
      "cspell.config.cjs": "_f_cspell",
      "cspell.config.yaml": "_f_cspell",
      "cspell.config.yml": "_f_cspell",
      "cspell.json": "_f_cspell",
      "cspell.js": "_f_cspell",
      "cspell.mjs": "_f_cspell",
      "cspell.cjs": "_f_cspell",
      "cspell.yaml": "_f_cspell",
      "cspell.yml": "_f_cspell",
      ".cspell.json": "_f_cspell",
      ".cspell.js": "_f_cspell",
      ".cspell.mjs": "_f_cspell",
      ".cspell.cjs": "_f_cspell",
      ".cspell.yaml": "_f_cspell",
      ".cspell.yml": "_f_cspell",
      ".csscomb.json": "_f_csscomb",
      ".csslintrc": "_f_csslint",
      ".cursorignore": "_f_cursorrules",
      ".cursorindexingignore": "_f_cursorrules",
      ".cursorrules": "_f_cursorrules",
      ".cvsignore": "_f_cvs",
      "cypress.json": "_f_light_cypress",
      "cypress.env.json": "_f_light_cypress",
      "cypress.config.js": "_f_light_cypress",
      "cypress.config.ts": "_f_light_cypress",
      "cypress.config.cjs": "_f_light_cypress",
      "cypress.config.mjs": "_f_light_cypress",
      ".boringignore": "_f_darcs",
      ".pubignore": "_f_dartlang_ignore",
      "service.datadog.yaml": "_f_datadog",
      "datadog-ci.json": "_f_datadog",
      "static-analysis.datadog.yml": "_f_datadog",
      "static-analysis.datadog.yaml": "_f_datadog",
      "aptfile": "_f_debian",
      "deno.json": "_f_deno",
      "deno.jsonc": "_f_deno",
      "deno.lock": "_f_deno",
      ".denoifyrc": "_f_denoify",
      "denoify.config.json": "_f_denoify",
      "denoify.config.js": "_f_denoify",
      "dependabot.yml": "_f_dependabot",
      "dependabot.yaml": "_f_dependabot",
      "dependencies.yml": "_f_dependencies",
      "devcontainer.json": "_f_devcontainer",
      ".devcontainer.json": "_f_devcontainer",
      "devvit.json": "_f_devvit",
      "devvit.dev.json": "_f_devvit",
      "devvit.prod.json": "_f_devvit",
      "devvit.test.json": "_f_devvit",
      "devvit.config.js": "_f_devvit",
      "devvit.config.cjs": "_f_devvit",
      "devvit.config.mjs": "_f_devvit",
      "devvit.config.ts": "_f_devvit",
      "devvit.config.mts": "_f_devvit",
      "devvit.config.dev.js": "_f_devvit",
      "devvit.config.dev.cjs": "_f_devvit",
      "devvit.config.dev.mjs": "_f_devvit",
      "devvit.config.dev.ts": "_f_devvit",
      "devvit.config.dev.mts": "_f_devvit",
      "devvit.config.prod.js": "_f_devvit",
      "devvit.config.prod.cjs": "_f_devvit",
      "devvit.config.prod.mjs": "_f_devvit",
      "devvit.config.prod.ts": "_f_devvit",
      "devvit.config.prod.mts": "_f_devvit",
      "devvit.config.test.js": "_f_devvit",
      "devvit.config.test.cjs": "_f_devvit",
      "devvit.config.test.mjs": "_f_devvit",
      "devvit.config.test.ts": "_f_devvit",
      "devvit.config.test.mts": "_f_devvit",
      ".dockerignore": "_f_docker",
      "compose.yaml": "_f_docker",
      "compose.yml": "_f_docker",
      "docker-compose.yaml": "_f_docker",
      "docker-compose.yml": "_f_docker",
      "docker-compose.debug.yaml": "_f_docker",
      "docker-compose.debug.yml": "_f_docker",
      "docker-compose.ci-build.yaml": "_f_docker",
      "docker-compose.ci-build.yml": "_f_docker",
      "docker-compose.override.yaml": "_f_docker",
      "docker-compose.override.yml": "_f_docker",
      "docker-compose.vs.debug.yaml": "_f_docker",
      "docker-compose.vs.debug.yml": "_f_docker",
      "docker-compose.vs.release.yaml": "_f_docker",
      "docker-compose.vs.release.yml": "_f_docker",
      "docker-cloud.yaml": "_f_docker",
      "docker-cloud.yml": "_f_docker",
      "docker-compose.test.yml": "_f_dockertest",
      "docusaurus.config.ts": "_f_docusaurus",
      "docusaurus.config.mts": "_f_docusaurus",
      "docusaurus.config.cts": "_f_docusaurus",
      "docusaurus.config.js": "_f_docusaurus",
      "docusaurus.config.mjs": "_f_docusaurus",
      "docusaurus.config.cjs": "_f_docusaurus",
      ".doczrc": "_f_docz",
      "docz.js": "_f_docz",
      "docz.json": "_f_docz",
      ".docz.js": "_f_docz",
      ".docz.json": "_f_docz",
      "doczrc.js": "_f_docz",
      "doczrc.json": "_f_docz",
      "docz.config.js": "_f_docz",
      "docz.config.json": "_f_docz",
      ".dojorc": "_f_dojo",
      "doppler.yaml": "_f_doppler",
      "doppler-template.yaml": "_f_doppler",
      ".drone.yml": "_f_light_drone",
      ".drone.yml.sig": "_f_light_drone",
      "dune": "_f_dune",
      "dune-project": "_f_dune",
      "dune-workspace": "_f_dune",
      ".dvc": "_f_dvc",
      ".earthlyignore": "_f_earthly",
      "Earthfile": "_f_earthly",
      "store.config.json": "_f_light_eas-metadata",
      ".editorconfig": "_f_editorconfig",
      "forge.config.js": "_f_electron",
      "forge.config.ts": "_f_electron",
      ".eleventy.js": "_f_light_eleventy",
      "eleventy.config.js": "_f_light_eleventy",
      "eleventy.config.cjs": "_f_light_eleventy",
      "eleventy.config.mjs": "_f_light_eleventy",
      "elm-package.json": "_f_elm",
      ".ember-cli": "_f_ember",
      "emakefile": "_f_erlang",
      ".emakerfile": "_f_erlang",
      "esbuild.js": "_f_esbuild",
      "esbuild.mjs": "_f_esbuild",
      "esbuild.cjs": "_f_esbuild",
      "esbuild.ts": "_f_esbuild",
      "esbuild.config.js": "_f_esbuild",
      "esbuild.config.mjs": "_f_esbuild",
      "esbuild.config.cjs": "_f_esbuild",
      "esbuild.config.ts": "_f_esbuild",
      ".eslintrc": "_f_eslint",
      ".eslintignore": "_f_eslint",
      ".eslintcache": "_f_eslint",
      "eslint.config.js": "_f_eslint",
      "eslint.config.mjs": "_f_eslint",
      "eslint.config.cjs": "_f_eslint",
      "eslint.config.ts": "_f_eslint",
      "eslint.config.mts": "_f_eslint",
      "eslint.config.cts": "_f_eslint",
      ".eslintrc.js": "_f_eslint",
      ".eslintrc.mjs": "_f_eslint",
      ".eslintrc.cjs": "_f_eslint",
      ".eslintrc.ts": "_f_eslint",
      ".eslintrc.mts": "_f_eslint",
      ".eslintrc.cts": "_f_eslint",
      ".eslintrc.json": "_f_eslint",
      ".eslintrc.yaml": "_f_eslint",
      ".eslintrc.yml": "_f_eslint",
      "app.json": "_f_light_expo",
      "app.config.js": "_f_light_expo",
      "app.config.json": "_f_light_expo",
      "app.config.json5": "_f_light_expo",
      ".fantasticonrc": "_f_fantasticon",
      "fantasticonrc": "_f_fantasticon",
      ".fantasticonrc.json": "_f_fantasticon",
      "fantasticonrc.json": "_f_fantasticon",
      ".fantasticonrc.js": "_f_fantasticon",
      "fantasticonrc.js": "_f_fantasticon",
      "fastly.toml": "_f_fastly",
      ".faunarc": "_f_fauna",
      "favicon.ico": "_f_favicon",
      ".firebaserc": "_f_firebase",
      "firebase.json": "_f_light_firebasehosting",
      "storage.rules": "_f_firebasestorage",
      "firestore.rules": "_f_firestore",
      "firestore.indexes.json": "_f_firestore",
      "flareact.config.js": "_f_flareact",
      ".flooignore": "_f_floobits",
      ".flowconfig": "_f_flow",
      ".flutter-plugins": "_f_flutter",
      ".metadata": "_f_flutter",
      ".flutter-plugins-dependencies": "_f_flutter",
      "pubspec.lock": "_f_flutter_package",
      "pubspec.yaml": "_f_flutter_package",
      ".packages": "_f_flutter_package",
      "fly.toml": "_f_flyio",
      "formkit.config.js": "_f_formkit",
      "formkit.config.mjs": "_f_formkit",
      "formkit.config.cjs": "_f_formkit",
      "formkit.config.ts": "_f_formkit",
      ".fossaignore": "_f_fossa",
      "ignore-glob": "_f_fossil",
      ".front-commerce.js": "_f_frontcommerce",
      "front-commerce.config.ts": "_f_frontcommerce",
      "funding.yml": "_f_funding",
      "fuse.js": "_f_fusebox",
      "gatsby-browser.js": "_f_gatsby",
      "gatsby-browser.ts": "_f_gatsby",
      "gatsby-browser.tsx": "_f_gatsby",
      "gatsby-ssr.js": "_f_gatsby",
      "gatsby-ssr.ts": "_f_gatsby",
      "gatsby-ssr.tsx": "_f_gatsby",
      "gatsby-config.js": "_f_gatsby",
      "gatsby-config.ts": "_f_gatsby",
      "gatsby-config.mjs": "_f_gatsby",
      "gatsby-node.js": "_f_gatsby",
      "gatsby-node.ts": "_f_gatsby",
      "gatsby-node.mjs": "_f_gatsby",
      ".gcloudignore": "_f_gcloud",
      "gemini.md": "_f_gemini",
      "GEMINI.md": "_f_gemini",
      ".git": "_f_git",
      ".gitattributes": "_f_git",
      ".gitconfig": "_f_git",
      ".gitignore": "_f_git",
      ".gitmodules": "_f_git",
      ".gitkeep": "_f_git",
      ".git-blame-ignore-revs": "_f_git",
      ".mailmap": "_f_git",
      ".issuetracker": "_f_git",
      ".gitlab-ci.yml": "_f_gitlab",
      ".gitpod.yaml": "_f_gitpod",
      ".gitpod.yml": "_f_gitpod",
      "gitpod.yaml": "_f_gitpod",
      "gitpod.yml": "_f_gitpod",
      "gleam.toml": "_f_gleamconfig",
      "glide.yml": "_f_glide",
      ".glitterrc": "_f_glitter",
      "go.sum": "_f_go_package",
      "go.mod": "_f_go_package",
      "go.work": "_f_go_work",
      "go.work.sum": "_f_go_work",
      ".gqlconfig": "_f_graphql",
      ".graphqlconfig": "_f_graphql_config",
      ".graphqlconfig.yml": "_f_graphql_config",
      ".graphqlconfig.yaml": "_f_graphql_config",
      "greenkeeper.json": "_f_greenkeeper",
      "gridsome.config.js": "_f_gridsome",
      "gridsome.config.ts": "_f_gridsome",
      "gridsome.server.js": "_f_gridsome",
      "gridsome.server.ts": "_f_gridsome",
      "gridsome.client.js": "_f_gridsome",
      "gridsome.client.ts": "_f_gridsome",
      "gruntfile.js": "_f_grunt",
      "gruntfile.cjs": "_f_grunt",
      "gruntfile.coffee": "_f_grunt",
      "gruntfile.ts": "_f_grunt",
      "gruntfile.babel.js": "_f_grunt",
      "gruntfile.babel.cjs": "_f_grunt",
      "gruntfile.babel.coffee": "_f_grunt",
      "gruntfile.babel.ts": "_f_grunt",
      "gulpfile.js": "_f_gulp",
      "gulpfile.coffee": "_f_gulp",
      "gulpfile.ts": "_f_gulp",
      "gulpfile.mjs": "_f_gulp",
      "gulpfile.esm.js": "_f_gulp",
      "gulpfile.esm.coffee": "_f_gulp",
      "gulpfile.esm.ts": "_f_gulp",
      "gulpfile.esm.mjs": "_f_gulp",
      "gulpfile.babel.js": "_f_gulp",
      "gulpfile.babel.coffee": "_f_gulp",
      "gulpfile.babel.ts": "_f_gulp",
      "gulpfile.babel.mjs": "_f_gulp",
      "hardhat.config.cjs": "_f_hardhat",
      "hardhat.config.js": "_f_hardhat",
      "hardhat.config.ts": "_f_hardhat",
      "haxelib.json": "_f_haxe",
      "checkstyle.json": "_f_haxecheckstyle",
      ".p4ignore": "_f_helix",
      "chart.lock": "_f_helm",
      "chart.yaml": "_f_helm",
      "histoire.config.ts": "_f_histoire",
      "histoire.config.js": "_f_histoire",
      ".histoire.ts": "_f_histoire",
      ".histoire.js": "_f_histoire",
      "horusec-config.json": "_f_horusec",
      ".htmlhintrc": "_f_htmlhint",
      ".htmlvalidateignore": "_f_htmlvalidate",
      ".htmlvalidate.js": "_f_htmlvalidate",
      ".htmlvalidate.cjs": "_f_htmlvalidate",
      ".htmlvalidate.json": "_f_htmlvalidate",
      "hugo.json": "_f_hugo",
      "hugo.toml": "_f_hugo",
      "hugo.yaml": "_f_hugo",
      ".hugo_build.lock": "_f_hugo",
      "humans.txt": "_f_humanstxt",
      ".huskyrc": "_f_husky",
      "husky.config.js": "_f_husky",
      ".huskyrc.js": "_f_husky",
      ".huskyrc.json": "_f_husky",
      ".huskyrc.yaml": "_f_husky",
      ".huskyrc.yml": "_f_husky",
      "ionic.project": "_f_ionic",
      "ionic.config.json": "_f_ionic",
      "jakefile": "_f_jake",
      "jakefile.js": "_f_jake",
      "jasmine.json": "_f_jasmine",
      ".nojekyll": "_f_jekyll",
      "jest.json": "_f_jest",
      "jest.config.babel.js": "_f_jest",
      ".jestrc": "_f_jest",
      ".jestrc.js": "_f_jest",
      ".jestrc.json": "_f_jest",
      "jest.config.js": "_f_jest",
      "jest.config.cjs": "_f_jest",
      "jest.config.mjs": "_f_jest",
      "jest.config.json": "_f_jest",
      "jest.config.ts": "_f_jest",
      "jest.config.base.js": "_f_jest",
      "jest.config.base.cjs": "_f_jest",
      "jest.config.base.mjs": "_f_jest",
      "jest.config.base.json": "_f_jest",
      "jest.config.base.ts": "_f_jest",
      "jest.config.common.js": "_f_jest",
      "jest.config.common.cjs": "_f_jest",
      "jest.config.common.mjs": "_f_jest",
      "jest.config.common.json": "_f_jest",
      "jest.config.common.ts": "_f_jest",
      "jest.config.e2e.js": "_f_jest",
      "jest.config.e2e.cjs": "_f_jest",
      "jest.config.e2e.mjs": "_f_jest",
      "jest.config.e2e.json": "_f_jest",
      "jest.config.e2e.ts": "_f_jest",
      "jest.config.int.js": "_f_jest",
      "jest.config.int.cjs": "_f_jest",
      "jest.config.int.mjs": "_f_jest",
      "jest.config.int.json": "_f_jest",
      "jest.config.int.ts": "_f_jest",
      "jest.config.integration.js": "_f_jest",
      "jest.config.integration.cjs": "_f_jest",
      "jest.config.integration.mjs": "_f_jest",
      "jest.config.integration.json": "_f_jest",
      "jest.config.integration.ts": "_f_jest",
      "jest.config.unit.js": "_f_jest",
      "jest.config.unit.cjs": "_f_jest",
      "jest.config.unit.mjs": "_f_jest",
      "jest.config.unit.json": "_f_jest",
      "jest.config.unit.ts": "_f_jest",
      ".jpmignore": "_f_jpm",
      ".jsbeautifyrc": "_f_jsbeautify",
      "jsbeautifyrc": "_f_jsbeautify",
      ".jsbeautify": "_f_jsbeautify",
      "jsbeautify": "_f_jsbeautify",
      "jsconfig.json": "_f_light_jsconfig",
      ".jscpd.json": "_f_jscpd",
      "jscpd-report.xml": "_f_jscpd",
      "jscpd-report.json": "_f_jscpd",
      "jscpd-report.html": "_f_jscpd",
      ".jshintrc": "_f_jshint",
      ".jshintignore": "_f_jshint",
      "jsr.json": "_f_jsr",
      "karma.conf.js": "_f_karma",
      "karma.conf.coffee": "_f_karma",
      "karma.conf.ts": "_f_karma",
      ".kitchen.yml": "_f_kitchenci",
      "kitchen.yml": "_f_kitchenci",
      ".kiteignore": "_f_light_kite",
      "knip.json": "_f_knip",
      "knip.jsonc": "_f_knip",
      ".knip.json": "_f_knip",
      ".knip.jsonc": "_f_knip",
      "knip.ts": "_f_knip",
      "knip.js": "_f_knip",
      "knip.config.ts": "_f_knip",
      "knip.config.js": "_f_knip",
      "language-configuration.json": "_f_language_configuration",
      "layout.html": "_f_layout",
      "layout.htm": "_f_layout",
      "lakefile.lean": "_f_light_leanconfig",
      "lakefile.toml": "_f_light_leanconfig",
      "lake-manifest.json": "_f_light_leanconfig",
      "lean-toolchain": "_f_light_leanconfig",
      "lefthook.json": "_f_lefthook",
      "lefthook.toml": "_f_lefthook",
      "lefthook.yaml": "_f_lefthook",
      "lefthook.yml": "_f_lefthook",
      "lefthook-local.json": "_f_lefthook",
      "lefthook-local.toml": "_f_lefthook",
      "lefthook-local.yaml": "_f_lefthook",
      "lefthook-local.yml": "_f_lefthook",
      ".lefthook.json": "_f_lefthook",
      ".lefthook.toml": "_f_lefthook",
      ".lefthook.yaml": "_f_lefthook",
      ".lefthook.yml": "_f_lefthook",
      ".lefthook-local.json": "_f_lefthook",
      ".lefthook-local.toml": "_f_lefthook",
      ".lefthook-local.yaml": "_f_lefthook",
      ".lefthook-local.yml": "_f_lefthook",
      "lerna.json": "_f_light_lerna",
      "liara.json": "_f_liara",
      ".liaraignore": "_f_liara",
      "licence": "_f_license",
      "LICENCE": "_f_license",
      "license": "_f_license",
      "LICENSE": "_f_license",
      "copying": "_f_license",
      "copying.lesser": "_f_license",
      "LICENSE-MIT": "_f_license",
      "license-mit": "_f_license",
      "LICENSE-APACHE": "_f_license",
      "license-apache": "_f_license",
      "LICENSE-GPL": "_f_license",
      "license-gpl": "_f_license",
      "LICENSE-AGPL": "_f_license",
      "license-agpl": "_f_license",
      "LICENCE.md": "_f_license",
      "LICENCE.txt": "_f_license",
      "licence.md": "_f_license",
      "licence.txt": "_f_license",
      "LICENSE.md": "_f_license",
      "LICENSE.txt": "_f_license",
      "license.md": "_f_license",
      "license.txt": "_f_license",
      "copying.md": "_f_license",
      "copying.txt": "_f_license",
      "copying.lesser.md": "_f_license",
      "copying.lesser.txt": "_f_license",
      "LICENSE-MIT.md": "_f_license",
      "LICENSE-MIT.txt": "_f_license",
      "license-mit.md": "_f_license",
      "license-mit.txt": "_f_license",
      "LICENSE-APACHE.md": "_f_license",
      "LICENSE-APACHE.txt": "_f_license",
      "license-apache.md": "_f_license",
      "license-apache.txt": "_f_license",
      "LICENSE-GPL.md": "_f_license",
      "LICENSE-GPL.txt": "_f_license",
      "license-gpl.md": "_f_license",
      "license-gpl.txt": "_f_license",
      "LICENSE-AGPL.md": "_f_license",
      "LICENSE-AGPL.txt": "_f_license",
      "license-agpl.md": "_f_license",
      "license-agpl.txt": "_f_license",
      ".licrc": "_f_licensebat",
      "budget.json": "_f_lighthouse",
      "budgets.json": "_f_lighthouse",
      ".lighthouserc.cjs": "_f_lighthouse",
      ".lighthouserc.js": "_f_lighthouse",
      ".lighthouserc.json": "_f_lighthouse",
      ".lighthouserc.yaml": "_f_lighthouse",
      ".lighthouserc.yml": "_f_lighthouse",
      "include.xml": "_f_lime",
      ".lintstagedrc": "_f_lintstagedrc",
      ".lintstagedrc.json": "_f_lintstagedrc",
      ".lintstagedrc.yaml": "_f_lintstagedrc",
      ".lintstagedrc.yml": "_f_lintstagedrc",
      ".lintstagedrc.mjs": "_f_lintstagedrc",
      ".lintstagedrc.mts": "_f_lintstagedrc",
      ".lintstagedrc.js": "_f_lintstagedrc",
      ".lintstagedrc.ts": "_f_lintstagedrc",
      ".lintstagedrc.cjs": "_f_lintstagedrc",
      ".lintstagedrc.cts": "_f_lintstagedrc",
      "lint-staged.config.mjs": "_f_lintstagedrc",
      "lint-staged.config.mts": "_f_lintstagedrc",
      "lint-staged.config.js": "_f_lintstagedrc",
      "lint-staged.config.ts": "_f_lintstagedrc",
      "lint-staged.config.cjs": "_f_lintstagedrc",
      "lint-staged.config.cts": "_f_lintstagedrc",
      "mailing.config.json": "_f_light_mailing",
      "manifest": "_f_manifest",
      "manifest.bak": "_f_manifest_bak",
      "manifest.skip": "_f_manifest_skip",
      ".markdownlintrc": "_f_markdownlint",
      ".markdownlint.json": "_f_markdownlint",
      ".markdownlint.jsonc": "_f_markdownlint",
      ".markdownlint.yml": "_f_markdownlint",
      ".markdownlint.yaml": "_f_markdownlint",
      ".markdownlint.cjs": "_f_markdownlint",
      ".markdownlint-cli2.json": "_f_markdownlint",
      ".markdownlint-cli2.jsonc": "_f_markdownlint",
      ".markdownlint-cli2.yml": "_f_markdownlint",
      ".markdownlint-cli2.yaml": "_f_markdownlint",
      ".markdownlint-cli2.cjs": "_f_markdownlint",
      ".markdownlintignore": "_f_markdownlint_ignore",
      ".markuplintrc": "_f_light_markuplint",
      ".markuplintrc.json": "_f_light_markuplint",
      ".markuplintrc.yaml": "_f_light_markuplint",
      ".markuplintrc.yml": "_f_light_markuplint",
      ".markuplintrc.js": "_f_light_markuplint",
      ".markuplintrc.cjs": "_f_light_markuplint",
      ".markuplintrc.mjs": "_f_light_markuplint",
      ".markuplintrc.ts": "_f_light_markuplint",
      "markuplint.config.json": "_f_light_markuplint",
      "markuplint.config.yaml": "_f_light_markuplint",
      "markuplint.config.yml": "_f_light_markuplint",
      "markuplint.config.js": "_f_light_markuplint",
      "markuplint.config.cjs": "_f_light_markuplint",
      "markuplint.config.mjs": "_f_light_markuplint",
      "markuplint.config.ts": "_f_light_markuplint",
      "master.js": "_f_master-co",
      "master.ts": "_f_master-co",
      "master.mjs": "_f_master-co",
      "master.json": "_f_master-co",
      "master.css.js": "_f_master-co",
      "master.css.ts": "_f_master-co",
      "master.css.mjs": "_f_master-co",
      "master.css.json": "_f_master-co",
      "maven.config": "_f_maven",
      "pom.xml": "_f_maven",
      "extensions.xml": "_f_maven",
      "settings.xml": "_f_maven",
      "mcp.json": "_f_light_mcp",
      "mdx-components.cjs": "_f_light_mdx-components",
      "mdx-components.cts": "_f_light_mdx-components",
      "mdx-components.js": "_f_light_mdx-components",
      "mdx-components.jsx": "_f_light_mdx-components",
      "mdx-components.mjs": "_f_light_mdx-components",
      "mdx-components.mts": "_f_light_mdx-components",
      "mdx-components.ts": "_f_light_mdx-components",
      "mdx-components.tsx": "_f_light_mdx-components",
      ".mdxlintrc": "_f_mdxlint",
      ".mdxlintignore": "_f_mdxlint",
      ".mdxlintrc.cjs": "_f_mdxlint",
      ".mdxlintrc.js": "_f_mdxlint",
      ".mdxlintrc.json": "_f_mdxlint",
      ".mdxlintrc.mjs": "_f_mdxlint",
      ".mdxlintrc.yml": "_f_mdxlint",
      ".mdxlintrc.yaml": "_f_mdxlint",
      ".hgignore": "_f_mercurial",
      "mocha.opts": "_f_mocha",
      ".mocharc.cjs": "_f_mocha",
      ".mocharc.js": "_f_mocha",
      ".mocharc.json": "_f_mocha",
      ".mocharc.jsonc": "_f_mocha",
      ".mocharc.mjs": "_f_mocha",
      ".mocharc.yaml": "_f_mocha",
      ".mocharc.yml": "_f_mocha",
      "modernizr": "_f_modernizr",
      "modernizr.js": "_f_modernizr",
      "modernizrrc.js": "_f_modernizr",
      ".modernizr.js": "_f_modernizr",
      ".modernizrrc.js": "_f_modernizr",
      "moleculer.config.js": "_f_moleculer",
      "moleculer.config.json": "_f_moleculer",
      "moleculer.config.ts": "_f_moleculer",
      ".mtn-ignore": "_f_monotone",
      "motif.json": "_f_motif",
      "mypy.ini": "_f_light_mypy",
      ".mypy.ini": "_f_light_mypy",
      ".nano-staged.js": "_f_nanostaged",
      "nano-staged.js": "_f_nanostaged",
      ".nano-staged.cjs": "_f_nanostaged",
      "nano-staged.cjs": "_f_nanostaged",
      ".nano-staged.mjs": "_f_nanostaged",
      "nano-staged.mjs": "_f_nanostaged",
      ".nano-staged.json": "_f_nanostaged",
      "nano-staged.json": "_f_nanostaged",
      ".nanostagedrc": "_f_nanostaged",
      ".nest-cli.json": "_f_nestjs",
      "nest-cli.json": "_f_nestjs",
      "nestconfig.json": "_f_nestjs",
      ".nestconfig.json": "_f_nestjs",
      "netlify.toml": "_f_light_netlify",
      "next.config.js": "_f_light_next",
      "next.config.cjs": "_f_light_next",
      "next.config.mjs": "_f_light_next",
      "next.config.ts": "_f_light_next",
      ".nf": "_f_nextflow",
      "ng-tailwind.js": "_f_ng_tailwind",
      "nginx.conf": "_f_nginx",
      "build.ninja": "_f_ninja",
      "flake.lock": "_f_nix",
      ".node-version": "_f_node",
      ".nvmrc": "_f_node",
      "node.config.json": "_f_node",
      "nodemon.json": "_f_nodemon",
      ".npmignore": "_f_npm",
      ".npmrc": "_f_npm",
      ".package-lock.json": "_f_npm",
      "package.json": "_f_npm",
      "package-lock.json": "_f_npm",
      "npm-shrinkwrap.json": "_f_npm",
      ".npmpackagejsonlintrc": "_f_npmpackagejsonlint",
      ".npmpackagejsonlintrc.cjs": "_f_npmpackagejsonlint",
      ".npmpackagejsonlintrc.js": "_f_npmpackagejsonlint",
      ".npmpackagejsonlintrc.json": "_f_npmpackagejsonlint",
      ".npmpackagejsonlintrc.yaml": "_f_npmpackagejsonlint",
      ".npmpackagejsonlintrc.yml": "_f_npmpackagejsonlint",
      ".npmpackagejsonlintrc.mjs": "_f_npmpackagejsonlint",
      ".npmpackagejsonlintignore": "_f_npmpackagejsonlint",
      "npmpackagejsonlint.config.cjs": "_f_npmpackagejsonlint",
      "npmpackagejsonlint.config.js": "_f_npmpackagejsonlint",
      "npmpackagejsonlint.config.mjs": "_f_npmpackagejsonlint",
      ".nsrirc": "_f_nsri",
      ".nsriignore": "_f_nsri",
      "nsri.config.js": "_f_nsri",
      ".nsrirc.js": "_f_nsri",
      ".nsrirc.json": "_f_nsri",
      ".nsrirc.yaml": "_f_nsri",
      ".nsrirc.yml": "_f_nsri",
      ".integrity.json": "_f_nsri-integrity",
      ".nuxtignore": "_f_nuxt",
      ".nuxtrc": "_f_nuxt",
      "nuxt.config.js": "_f_nuxt",
      "nuxt.config.ts": "_f_nuxt",
      "nuxt.config.mjs": "_f_nuxt",
      "nuxt.js": "_f_nuxt",
      "nuxt.ts": "_f_nuxt",
      "nuxt.mjs": "_f_nuxt",
      "nx.json": "_f_light_nx",
      ".nycrc": "_f_nyc",
      ".nycrc.json": "_f_nyc",
      ".objidconfig": "_f_light_objidconfig",
      ".merlin": "_f_ocaml",
      ".oxlintignore": "_f_light_oxc",
      ".oxlintrc.json": "_f_light_oxc",
      ".oxlintrc.jsonc": "_f_light_oxc",
      ".oxfmtrc.json": "_f_light_oxc",
      ".oxfmtrc.jsonc": "_f_light_oxc",
      ".packshiprc": "_f_light_packship",
      ".packshiprc.json": "_f_light_packship",
      ".packshiprc.js": "_f_light_packship",
      ".packshiprc.ts": "_f_light_packship",
      "packship.config.js": "_f_light_packship",
      "packship.config.ts": "_f_light_packship",
      "packship.config.mjs": "_f_light_packship",
      "packship.config.mts": "_f_light_packship",
      "packship.config.json": "_f_light_packship",
      "paket.dependencies": "_f_paket",
      "paket.lock": "_f_paket",
      "paket.references": "_f_paket",
      "paket.template": "_f_paket",
      "paket.local": "_f_paket",
      "panda.config.js": "_f_pandacss",
      "panda.config.mjs": "_f_pandacss",
      "panda.config.ts": "_f_pandacss",
      ".pdm-python": "_f_pdm",
      "pdm.lock": "_f_pdm",
      "pdm.toml": "_f_pdm",
      "peeky.config.ts": "_f_peeky",
      "peeky.config.js": "_f_peeky",
      "peeky.config.mjs": "_f_peeky",
      ".php-cs-fixer.php": "_f_phpcsfixer",
      ".php-cs-fixer.dist.php": "_f_phpcsfixer",
      ".php_cs": "_f_phpcsfixer",
      ".php_cs.dist": "_f_phpcsfixer",
      "phpstan.neon": "_f_phpstan",
      "phpstan.dist.neon": "_f_phpstan",
      "phpunit": "_f_phpunit",
      "phpunit.xml": "_f_phpunit",
      "phpunit.xml.dist": "_f_phpunit",
      ".phraseapp.yml": "_f_phraseapp",
      "pipfile": "_f_pip",
      "pipfile.lock": "_f_pip",
      "platformio.ini": "_f_platformio",
      "playwright.config.js": "_f_playwright",
      "playwright.config.ts": "_f_playwright",
      "playwright.config.mts": "_f_playwright",
      "playwright.config.mjs": "_f_playwright",
      "playwright.config.cts": "_f_playwright",
      "playwright.config.cjs": "_f_playwright",
      "ecosystem.config.js": "_f_pm2",
      "ecosystem.config.cjs": "_f_pm2",
      "ecosystem.config.json": "_f_pm2",
      "ecosystem.config.yaml": "_f_pm2",
      "ecosystem.config.yml": "_f_pm2",
      ".pnpmfile.cjs": "_f_light_pnpm",
      "pnpmfile.js": "_f_light_pnpm",
      "pnpm-lock.yaml": "_f_light_pnpm",
      "pnpm-workspace.yaml": "_f_light_pnpm",
      "poetry.lock": "_f_poetry",
      ".postcssrc": "_f_postcssconfig",
      ".postcssrc.json": "_f_postcssconfig",
      ".postcssrc.yaml": "_f_postcssconfig",
      ".postcssrc.yml": "_f_postcssconfig",
      ".postcssrc.ts": "_f_postcssconfig",
      ".postcssrc.cts": "_f_postcssconfig",
      ".postcssrc.mts": "_f_postcssconfig",
      ".postcssrc.js": "_f_postcssconfig",
      ".postcssrc.cjs": "_f_postcssconfig",
      ".postcssrc.mjs": "_f_postcssconfig",
      "postcss.config.ts": "_f_postcssconfig",
      "postcss.config.cts": "_f_postcssconfig",
      "postcss.config.mts": "_f_postcssconfig",
      "postcss.config.js": "_f_postcssconfig",
      "postcss.config.cjs": "_f_postcssconfig",
      "postcss.config.mjs": "_f_postcssconfig",
      "preact.config.js": "_f_preact",
      ".pre-commit-config.yaml": "_f_precommit",
      ".prettierrc": "_f_light_prettier",
      ".prettierignore": "_f_light_prettier",
      "prettier.config.js": "_f_light_prettier",
      "prettier.config.cjs": "_f_light_prettier",
      "prettier.config.mjs": "_f_light_prettier",
      "prettier.config.ts": "_f_light_prettier",
      "prettier.config.coffee": "_f_light_prettier",
      ".prettierrc.js": "_f_light_prettier",
      ".prettierrc.cjs": "_f_light_prettier",
      ".prettierrc.mjs": "_f_light_prettier",
      ".prettierrc.json": "_f_light_prettier",
      ".prettierrc.json5": "_f_light_prettier",
      ".prettierrc.yml": "_f_light_prettier",
      ".prettierrc.yaml": "_f_light_prettier",
      ".prettierrc.toml": "_f_light_prettier",
      "prisma.config.js": "_f_prismaconfig",
      "prisma.config.ts": "_f_prismaconfig",
      "procfile": "_f_procfile",
      "protractor.conf.js": "_f_protractor",
      "protractor.conf.coffee": "_f_protractor",
      "protractor.conf.ts": "_f_protractor",
      "publiccode.yml": "_f_publiccode",
      ".jade-lintrc": "_f_pug",
      ".pug-lintrc": "_f_pug",
      ".jade-lint.json": "_f_pug",
      ".pug-lintrc.js": "_f_pug",
      ".pug-lintrc.json": "_f_pug",
      "Pulumi.yaml": "_f_pulumi",
      "Pulumi.yml": "_f_pulumi",
      "Pulumi.dev.yaml": "_f_pulumi",
      "Pulumi.dev.yml": "_f_pulumi",
      "Pulumi.prod.yaml": "_f_pulumi",
      "Pulumi.prod.yml": "_f_pulumi",
      "purgecss.config.js": "_f_purgecss",
      ".python-version": "_f_pyenv",
      "pyproject.toml": "_f_pypi",
      "pytest.ini": "_f_pytest",
      ".pytest.ini": "_f_pytest",
      "pytest.toml": "_f_pytest",
      ".pytest.toml": "_f_pytest",
      "py.typed": "_f_pytyped",
      ".pyup": "_f_pyup",
      ".pyup.yml": "_f_pyup",
      "qmldir": "_f_qmldir",
      "quasar.conf.js": "_f_light_quasar",
      "quasar.config.js": "_f_light_quasar",
      "quasar.config.mjs": "_f_light_quasar",
      "quasar.config.cjs": "_f_light_quasar",
      "quasar.config.ts": "_f_light_quasar",
      "Rakefile": "_f_rake",
      "razzle.config.js": "_f_light_razzle",
      "react-router.config.js": "_f_light_reactrouter",
      "react-router.config.ts": "_f_light_reactrouter",
      ".rehyperc": "_f_light_rehype",
      ".rehypeignore": "_f_light_rehype",
      ".rehyperc.cjs": "_f_light_rehype",
      ".rehyperc.js": "_f_light_rehype",
      ".rehyperc.json": "_f_light_rehype",
      ".rehyperc.mjs": "_f_light_rehype",
      ".rehyperc.yml": "_f_light_rehype",
      ".rehyperc.yaml": "_f_light_rehype",
      ".remarkrc": "_f_light_remark",
      ".remarkignore": "_f_light_remark",
      ".remarkrc.cjs": "_f_light_remark",
      ".remarkrc.js": "_f_light_remark",
      ".remarkrc.json": "_f_light_remark",
      ".remarkrc.mjs": "_f_light_remark",
      ".remarkrc.yml": "_f_light_remark",
      ".remarkrc.yaml": "_f_light_remark",
      ".renovaterc": "_f_renovate",
      ".renovaterc.json": "_f_renovate",
      "renovate.json": "_f_renovate",
      "renovate.json5": "_f_renovate",
      ".replit": "_f_light_replit",
      "replit.nix": "_f_light_replit",
      ".retextrc": "_f_light_retext",
      ".retextignore": "_f_light_retext",
      ".retextrc.cjs": "_f_light_retext",
      ".retextrc.js": "_f_light_retext",
      ".retextrc.json": "_f_light_retext",
      ".retextrc.mjs": "_f_light_retext",
      ".retextrc.yml": "_f_light_retext",
      ".retextrc.yaml": "_f_light_retext",
      "robots.txt": "_f_robots",
      "rolldown.config.js": "_f_light_rolldown",
      "rolldown.config.cjs": "_f_light_rolldown",
      "rolldown.config.mjs": "_f_light_rolldown",
      "rolldown.config.coffee": "_f_light_rolldown",
      "rolldown.config.ts": "_f_light_rolldown",
      "rolldown.config.mts": "_f_light_rolldown",
      "rolldown.config.cts": "_f_light_rolldown",
      "rolldown.config.common.js": "_f_light_rolldown",
      "rolldown.config.common.cjs": "_f_light_rolldown",
      "rolldown.config.common.mjs": "_f_light_rolldown",
      "rolldown.config.common.coffee": "_f_light_rolldown",
      "rolldown.config.common.ts": "_f_light_rolldown",
      "rolldown.config.common.mts": "_f_light_rolldown",
      "rolldown.config.common.cts": "_f_light_rolldown",
      "rolldown.config.dev.js": "_f_light_rolldown",
      "rolldown.config.dev.cjs": "_f_light_rolldown",
      "rolldown.config.dev.mjs": "_f_light_rolldown",
      "rolldown.config.dev.coffee": "_f_light_rolldown",
      "rolldown.config.dev.ts": "_f_light_rolldown",
      "rolldown.config.dev.mts": "_f_light_rolldown",
      "rolldown.config.dev.cts": "_f_light_rolldown",
      "rolldown.config.prod.js": "_f_light_rolldown",
      "rolldown.config.prod.cjs": "_f_light_rolldown",
      "rolldown.config.prod.mjs": "_f_light_rolldown",
      "rolldown.config.prod.coffee": "_f_light_rolldown",
      "rolldown.config.prod.ts": "_f_light_rolldown",
      "rolldown.config.prod.mts": "_f_light_rolldown",
      "rolldown.config.prod.cts": "_f_light_rolldown",
      "rollup.config.js": "_f_rollup",
      "rollup.config.cjs": "_f_rollup",
      "rollup.config.mjs": "_f_rollup",
      "rollup.config.coffee": "_f_rollup",
      "rollup.config.ts": "_f_rollup",
      "rollup.config.common.js": "_f_rollup",
      "rollup.config.common.cjs": "_f_rollup",
      "rollup.config.common.mjs": "_f_rollup",
      "rollup.config.common.coffee": "_f_rollup",
      "rollup.config.common.ts": "_f_rollup",
      "rollup.config.dev.js": "_f_rollup",
      "rollup.config.dev.cjs": "_f_rollup",
      "rollup.config.dev.mjs": "_f_rollup",
      "rollup.config.dev.coffee": "_f_rollup",
      "rollup.config.dev.ts": "_f_rollup",
      "rollup.config.prod.js": "_f_rollup",
      "rollup.config.prod.cjs": "_f_rollup",
      "rollup.config.prod.mjs": "_f_rollup",
      "rollup.config.prod.coffee": "_f_rollup",
      "rollup.config.prod.ts": "_f_rollup",
      "rome.json": "_f_light_rome",
      ".rspec": "_f_rspec",
      ".rubocop.yml": "_f_light_rubocop",
      ".rubocop_todo.yml": "_f_light_rubocop",
      ".ruby-version": "_f_ruby",
      "rust-toolchain": "_f_light_rust_toolchain",
      "rust-toolchain.toml": "_f_light_rust_toolchain",
      ".slshrc": "_f_s-lang",
      ".isisrc": "_f_s-lang",
      ".jedrc": "_f_s-lang",
      ".sailsrc": "_f_sails",
      ".sapphirerc.json": "_f_sapphire_framework_cli",
      ".sapphirerc.yml": "_f_sapphire_framework_cli",
      ".sapphirerc": "_f_sapphire_framework_cli",
      "seedkit.config.js": "_f_seedkit",
      "seedkit.config.ts": "_f_seedkit",
      "seedkit.config.mjs": "_f_seedkit",
      ".sentryclirc": "_f_sentry",
      ".sequelizerc": "_f_sequelize",
      ".sequelizerc.js": "_f_sequelize",
      ".sequelizerc.json": "_f_sequelize",
      "serverless.yml": "_f_serverless",
      "serverless.json": "_f_serverless",
      "serverless.js": "_f_serverless",
      "serverless.ts": "_f_serverless",
      "components.json": "_f_light_shadcn",
      ".shellcheckrc": "_f_shellcheck",
      "Shuttle.toml": "_f_shuttle",
      "sitemap.xml": "_f_sitemap",
      "sitemap.rss": "_f_sitemap",
      "sitemap.txt": "_f_sitemap",
      "sitemap.atom": "_f_sitemap",
      "slash-up.config.js": "_f_slashup",
      "smithery.yaml": "_f_smithery",
      "snapcraft.yaml": "_f_snapcraft",
      "snaplet.config.js": "_f_snaplet",
      "snaplet.config.ts": "_f_snaplet",
      ".snyk": "_f_snyk",
      ".solidarity": "_f_solidarity",
      ".solidarity.json": "_f_solidarity",
      "spin.toml": "_f_light_spin",
      "sst-env.d.ts": "_f_sst",
      "sst-env.ts": "_f_sst",
      "sst-env.js": "_f_sst",
      "sst.config.d.ts": "_f_sst",
      "sst.config.ts": "_f_sst",
      "sst.config.js": "_f_sst",
      ".stackblitzrc": "_f_stackblitz",
      "stryker.conf.mjs": "_f_stryker",
      "stryker.conf.cjs": "_f_stryker",
      "stryker.conf.js": "_f_stryker",
      "stryker.conf.conf": "_f_stryker",
      "stryker.conf.json": "_f_stryker",
      ".stryker.conf.mjs": "_f_stryker",
      ".stryker.conf.cjs": "_f_stryker",
      ".stryker.conf.js": "_f_stryker",
      ".stryker.conf.conf": "_f_stryker",
      ".stryker.conf.json": "_f_stryker",
      "stryker.config.mjs": "_f_stryker",
      "stryker.config.cjs": "_f_stryker",
      "stryker.config.js": "_f_stryker",
      "stryker.config.conf": "_f_stryker",
      "stryker.config.json": "_f_stryker",
      ".stryker.config.mjs": "_f_stryker",
      ".stryker.config.cjs": "_f_stryker",
      ".stryker.config.js": "_f_stryker",
      ".stryker.config.conf": "_f_stryker",
      ".stryker.config.json": "_f_stryker",
      "stryker-config.mjs": "_f_stryker",
      "stryker-config.cjs": "_f_stryker",
      "stryker-config.js": "_f_stryker",
      "stryker-config.conf": "_f_stryker",
      "stryker-config.json": "_f_stryker",
      "stryker4s.mjs": "_f_stryker",
      "stryker4s.cjs": "_f_stryker",
      "stryker4s.js": "_f_stryker",
      "stryker4s.conf": "_f_stryker",
      "stryker4s.json": "_f_stryker",
      ".stylelintrc": "_f_light_stylelint",
      ".stylelintignore": "_f_light_stylelint",
      ".stylelintcache": "_f_light_stylelint",
      "stylelint.config.js": "_f_light_stylelint",
      "stylelint.config.json": "_f_light_stylelint",
      "stylelint.config.yaml": "_f_light_stylelint",
      "stylelint.config.yml": "_f_light_stylelint",
      "stylelint.config.ts": "_f_light_stylelint",
      "stylelint.config.cjs": "_f_light_stylelint",
      "stylelint.config.mjs": "_f_light_stylelint",
      ".stylelintrc.js": "_f_light_stylelint",
      ".stylelintrc.json": "_f_light_stylelint",
      ".stylelintrc.yaml": "_f_light_stylelint",
      ".stylelintrc.yml": "_f_light_stylelint",
      ".stylelintrc.ts": "_f_light_stylelint",
      ".stylelintrc.cjs": "_f_light_stylelint",
      ".stylelintrc.mjs": "_f_light_stylelint",
      ".stylish-haskell.yaml": "_f_stylish_haskell",
      ".svnignore": "_f_subversion",
      "svelte.config.js": "_f_svelteconfig",
      "svelte.config.ts": "_f_svelteconfig",
      "svgo.config.cjs": "_f_svgo",
      "svgo.config.js": "_f_svgo",
      "svgo.config.mjs": "_f_svgo",
      ".swcrc": "_f_swc",
      "package.pins": "_f_swift",
      "symfony.lock": "_f_light_symfony",
      ".syncpackrc": "_f_syncpack",
      ".syncpackrc.json": "_f_syncpack",
      ".syncpackrc.yaml": "_f_syncpack",
      ".syncpackrc.yml": "_f_syncpack",
      ".syncpackrc.js": "_f_syncpack",
      ".syncpackrc.cjs": "_f_syncpack",
      "syncpack.config.js": "_f_syncpack",
      "syncpack.config.cjs": "_f_syncpack",
      "tailwind.js": "_f_tailwind",
      "tailwind.cjs": "_f_tailwind",
      "tailwind.coffee": "_f_tailwind",
      "tailwind.ts": "_f_tailwind",
      "tailwind.json": "_f_tailwind",
      "tailwind.mjs": "_f_tailwind",
      "tailwind.config.js": "_f_tailwind",
      "tailwind.config.cjs": "_f_tailwind",
      "tailwind.config.coffee": "_f_tailwind",
      "tailwind.config.ts": "_f_tailwind",
      "tailwind.config.json": "_f_tailwind",
      "tailwind.config.mjs": "_f_tailwind",
      ".tailwind.js": "_f_tailwind",
      ".tailwind.cjs": "_f_tailwind",
      ".tailwind.coffee": "_f_tailwind",
      ".tailwind.ts": "_f_tailwind",
      ".tailwind.json": "_f_tailwind",
      ".tailwind.mjs": "_f_tailwind",
      ".tailwindrc.js": "_f_tailwind",
      ".tailwindrc.cjs": "_f_tailwind",
      ".tailwindrc.coffee": "_f_tailwind",
      ".tailwindrc.ts": "_f_tailwind",
      ".tailwindrc.json": "_f_tailwind",
      ".tailwindrc.mjs": "_f_tailwind",
      "tamagui.js": "_f_tamagui",
      "tamagui.mjs": "_f_tamagui",
      "tamagui.cjs": "_f_tamagui",
      "tamagui.ts": "_f_tamagui",
      "tamagui.mts": "_f_tamagui",
      "tamagui.cts": "_f_tamagui",
      "tamagui.config.js": "_f_tamagui",
      "tamagui.config.mjs": "_f_tamagui",
      "tamagui.config.cjs": "_f_tamagui",
      "tamagui.config.ts": "_f_tamagui",
      "tamagui.config.mts": "_f_tamagui",
      "tamagui.config.cts": "_f_tamagui",
      ".taplo.toml": "_f_taplo",
      "taplo.toml": "_f_taplo",
      "taskfile.yml": "_f_taskfile",
      "taskfile.yaml": "_f_taskfile",
      "taskfile.dist.yml": "_f_taskfile",
      "taskfile.dist.yaml": "_f_taskfile",
      "tauri.conf.json": "_f_tauri",
      ".taurignore": "_f_tauri",
      ".testcaferc.json": "_f_light_testcafe",
      "testplane.conf.ts": "_f_testplane",
      "testplane.conf.js": "_f_testplane",
      "testplane.conf.cts": "_f_testplane",
      "testplane.conf.cjs": "_f_testplane",
      "testplane.config.ts": "_f_testplane",
      "testplane.config.js": "_f_testplane",
      "testplane.config.cts": "_f_testplane",
      "testplane.config.cjs": "_f_testplane",
      ".tfignore": "_f_tfs",
      ".tiltignore": "_f_tiltfile",
      ".tmux.conf": "_f_light_tmux",
      "tox.ini": "_f_tox",
      ".travis.yml": "_f_travis",
      "truffle-config.js": "_f_truffle",
      "truffle-config.ts": "_f_truffle",
      "trunk.yaml": "_f_trunk",
      "tsconfig.json": "_f_tsconfig",
      "tsconfig.app.json": "_f_tsconfig",
      "tsconfig.base.json": "_f_tsconfig",
      "tsconfig.build.json": "_f_tsconfig",
      "tsconfig.cjs.json": "_f_tsconfig",
      "tsconfig.common.json": "_f_tsconfig",
      "tsconfig.debug.json": "_f_tsconfig",
      "tsconfig.dev.json": "_f_tsconfig",
      "tsconfig.development.json": "_f_tsconfig",
      "tsconfig.e2e.json": "_f_tsconfig",
      "tsconfig.eslint.json": "_f_tsconfig",
      "tsconfig.esm.json": "_f_tsconfig",
      "tsconfig.mjs.json": "_f_tsconfig",
      "tsconfig.node.json": "_f_tsconfig",
      "tsconfig.prod.json": "_f_tsconfig",
      "tsconfig.production.json": "_f_tsconfig",
      "tsconfig.release.json": "_f_tsconfig",
      "tsconfig.server.json": "_f_tsconfig",
      "tsconfig.spec.json": "_f_tsconfig",
      "tsconfig.staging.json": "_f_tsconfig",
      "tsconfig.test.json": "_f_tsconfig",
      "tsconfig.types.json": "_f_tsconfig",
      "tsconfig.lib.json": "_f_tsconfig",
      "tsconfig.lib.prod.json": "_f_tsconfig",
      "tsdoc.json": "_f_tsdoc",
      "tsdown.config.ts": "_f_tsdown",
      "tsdown.config.mts": "_f_tsdown",
      "tsdown.config.cts": "_f_tsdown",
      "tsdown.config.js": "_f_tsdown",
      "tsdown.config.mjs": "_f_tsdown",
      "tsdown.config.cjs": "_f_tsdown",
      "tsdown.config.json": "_f_tsdown",
      "tslint.json": "_f_tslint",
      "tslint.yaml": "_f_tslint",
      "tslint.yml": "_f_tslint",
      "turbo.json": "_f_light_turbo",
      "turbo.jsonc": "_f_light_turbo",
      "microfrontends.json": "_f_light_turbo",
      "microfrontends.jsonc": "_f_light_turbo",
      "typedoc.cjs": "_f_typedoc",
      "typedoc.js": "_f_typedoc",
      "typedoc.json": "_f_typedoc",
      "typedoc.jsonc": "_f_typedoc",
      "typedoc.mjs": "_f_typedoc",
      "typedoc.config.cjs": "_f_typedoc",
      "typedoc.config.js": "_f_typedoc",
      "typedoc.config.json": "_f_typedoc",
      "typedoc.config.jsonc": "_f_typedoc",
      "typedoc.config.mjs": "_f_typedoc",
      ".unibeautifyrc": "_f_light_unibeautify",
      "unibeautify.config.js": "_f_light_unibeautify",
      ".unibeautifyrc.js": "_f_light_unibeautify",
      ".unibeautifyrc.json": "_f_light_unibeautify",
      ".unibeautifyrc.yaml": "_f_light_unibeautify",
      ".unibeautifyrc.yml": "_f_light_unibeautify",
      "unlicense": "_f_unlicense",
      "unlicence": "_f_unlicense",
      "UNLICENSE": "_f_unlicense",
      "UNLICENCE": "_f_unlicense",
      "unlicense.md": "_f_unlicense",
      "unlicense.txt": "_f_unlicense",
      "unlicence.md": "_f_unlicense",
      "unlicence.txt": "_f_unlicense",
      "UNLICENSE.md": "_f_unlicense",
      "UNLICENSE.txt": "_f_unlicense",
      "UNLICENCE.md": "_f_unlicense",
      "UNLICENCE.txt": "_f_unlicense",
      "uno.config.js": "_f_unocss",
      "uno.config.mjs": "_f_unocss",
      "uno.config.ts": "_f_unocss",
      "uno.config.mts": "_f_unocss",
      "unocss.config.js": "_f_unocss",
      "unocss.config.mjs": "_f_unocss",
      "unocss.config.ts": "_f_unocss",
      "unocss.config.mts": "_f_unocss",
      "uv.lock": "_f_uv",
      "vagrantfile": "_f_vagrant",
      "vapor.yml": "_f_vapor",
      "now.json": "_f_light_vercel",
      ".nowignore": "_f_light_vercel",
      "vercel.json": "_f_light_vercel",
      ".vercelignore": "_f_light_vercel",
      ".vimrc": "_f_vim",
      ".gvimrc": "_f_vim",
      "vite.config.js": "_f_light_vite",
      "vite.config.mjs": "_f_light_vite",
      "vite.config.ts": "_f_light_vite",
      "vite.config.cjs": "_f_light_vite",
      "vite.config.mts": "_f_light_vite",
      "vite.config.cts": "_f_light_vite",
      "vitest.config.js": "_f_light_vitest",
      "vitest.config.mjs": "_f_light_vitest",
      "vitest.config.ts": "_f_light_vitest",
      "vitest.config.cjs": "_f_light_vitest",
      "vitest.config.mts": "_f_light_vitest",
      "vitest.config.cts": "_f_light_vitest",
      "vitest.workspace.json": "_f_light_vitest",
      "vitest.workspace.js": "_f_light_vitest",
      "vitest.workspace.mjs": "_f_light_vitest",
      "vitest.workspace.ts": "_f_light_vitest",
      "vitest.workspace.cjs": "_f_light_vitest",
      "vitest.workspace.mts": "_f_light_vitest",
      "vitest.workspace.cts": "_f_light_vitest",
      "vitest.projects.json": "_f_light_vitest",
      "vitest.projects.js": "_f_light_vitest",
      "vitest.projects.mjs": "_f_light_vitest",
      "vitest.projects.ts": "_f_light_vitest",
      "vitest.projects.cjs": "_f_light_vitest",
      "vitest.projects.mts": "_f_light_vitest",
      "vitest.projects.cts": "_f_light_vitest",
      ".vscodeignore": "_f_vscode",
      "launch.json": "_f_vscode",
      "tasks.json": "_f_vscode",
      "vscodeignore.json": "_f_vscode",
      ".vscode-test.js": "_f_vscode_test",
      ".vscode-test.json": "_f_vscode_test",
      ".vscode-test.mjs": "_f_vscode_test",
      ".vuerc": "_f_vueconfig",
      "vue.config.js": "_f_vueconfig",
      "vue.config.cjs": "_f_vueconfig",
      "vue.config.mjs": "_f_vueconfig",
      "wallaby.json": "_f_wallaby",
      "wallaby.js": "_f_wallaby",
      "wallaby.ts": "_f_wallaby",
      "wallaby.coffee": "_f_wallaby",
      "wallaby.conf.json": "_f_wallaby",
      "wallaby.conf.js": "_f_wallaby",
      "wallaby.conf.ts": "_f_wallaby",
      "wallaby.conf.coffee": "_f_wallaby",
      ".wallaby.json": "_f_wallaby",
      ".wallaby.js": "_f_wallaby",
      ".wallaby.ts": "_f_wallaby",
      ".wallaby.coffee": "_f_wallaby",
      ".wallaby.conf.json": "_f_wallaby",
      ".wallaby.conf.js": "_f_wallaby",
      ".wallaby.conf.ts": "_f_wallaby",
      ".wallaby.conf.coffee": "_f_wallaby",
      "wally.toml": "_f_wally",
      "wally.lock": "_f_wally",
      ".watchmanconfig": "_f_watchmanconfig",
      "wdio.json": "_f_wdio",
      "wdio.js": "_f_wdio",
      "wdio.mjs": "_f_wdio",
      "wdio.cjs": "_f_wdio",
      "wdio.ts": "_f_wdio",
      "wdio.mts": "_f_wdio",
      "wdio.cts": "_f_wdio",
      "wdio.conf.json": "_f_wdio",
      "wdio.conf.js": "_f_wdio",
      "wdio.conf.mjs": "_f_wdio",
      "wdio.conf.cjs": "_f_wdio",
      "wdio.conf.ts": "_f_wdio",
      "wdio.conf.mts": "_f_wdio",
      "wdio.conf.cts": "_f_wdio",
      ".weblate": "_f_weblate",
      ".weblate.ini": "_f_weblate",
      "weblate": "_f_weblate",
      "weblate.ini": "_f_weblate",
      "webpack.base.conf.js": "_f_webpack",
      "webpack.base.conf.cjs": "_f_webpack",
      "webpack.base.conf.mjs": "_f_webpack",
      "webpack.base.conf.coffee": "_f_webpack",
      "webpack.base.conf.ts": "_f_webpack",
      "webpack.common.js": "_f_webpack",
      "webpack.common.cjs": "_f_webpack",
      "webpack.common.mjs": "_f_webpack",
      "webpack.common.coffee": "_f_webpack",
      "webpack.common.ts": "_f_webpack",
      "webpack.config.js": "_f_webpack",
      "webpack.config.cjs": "_f_webpack",
      "webpack.config.mjs": "_f_webpack",
      "webpack.config.coffee": "_f_webpack",
      "webpack.config.ts": "_f_webpack",
      "webpack.config.base.js": "_f_webpack",
      "webpack.config.base.cjs": "_f_webpack",
      "webpack.config.base.mjs": "_f_webpack",
      "webpack.config.base.coffee": "_f_webpack",
      "webpack.config.base.ts": "_f_webpack",
      "webpack.config.build.js": "_f_webpack",
      "webpack.config.build.cjs": "_f_webpack",
      "webpack.config.build.mjs": "_f_webpack",
      "webpack.config.build.coffee": "_f_webpack",
      "webpack.config.build.ts": "_f_webpack",
      "webpack.config.common.js": "_f_webpack",
      "webpack.config.common.cjs": "_f_webpack",
      "webpack.config.common.mjs": "_f_webpack",
      "webpack.config.common.coffee": "_f_webpack",
      "webpack.config.common.ts": "_f_webpack",
      "webpack.config.dev.js": "_f_webpack",
      "webpack.config.dev.cjs": "_f_webpack",
      "webpack.config.dev.mjs": "_f_webpack",
      "webpack.config.dev.coffee": "_f_webpack",
      "webpack.config.dev.ts": "_f_webpack",
      "webpack.config.development.js": "_f_webpack",
      "webpack.config.development.cjs": "_f_webpack",
      "webpack.config.development.mjs": "_f_webpack",
      "webpack.config.development.coffee": "_f_webpack",
      "webpack.config.development.ts": "_f_webpack",
      "webpack.config.staging.js": "_f_webpack",
      "webpack.config.staging.cjs": "_f_webpack",
      "webpack.config.staging.mjs": "_f_webpack",
      "webpack.config.staging.coffee": "_f_webpack",
      "webpack.config.staging.ts": "_f_webpack",
      "webpack.config.test.js": "_f_webpack",
      "webpack.config.test.cjs": "_f_webpack",
      "webpack.config.test.mjs": "_f_webpack",
      "webpack.config.test.coffee": "_f_webpack",
      "webpack.config.test.ts": "_f_webpack",
      "webpack.config.prod.js": "_f_webpack",
      "webpack.config.prod.cjs": "_f_webpack",
      "webpack.config.prod.mjs": "_f_webpack",
      "webpack.config.prod.coffee": "_f_webpack",
      "webpack.config.prod.ts": "_f_webpack",
      "webpack.config.production.js": "_f_webpack",
      "webpack.config.production.cjs": "_f_webpack",
      "webpack.config.production.mjs": "_f_webpack",
      "webpack.config.production.coffee": "_f_webpack",
      "webpack.config.production.ts": "_f_webpack",
      "webpack.config.babel.js": "_f_webpack",
      "webpack.config.babel.cjs": "_f_webpack",
      "webpack.config.babel.mjs": "_f_webpack",
      "webpack.config.babel.coffee": "_f_webpack",
      "webpack.config.babel.ts": "_f_webpack",
      "webpack.config.base.babel.js": "_f_webpack",
      "webpack.config.base.babel.cjs": "_f_webpack",
      "webpack.config.base.babel.mjs": "_f_webpack",
      "webpack.config.base.babel.coffee": "_f_webpack",
      "webpack.config.base.babel.ts": "_f_webpack",
      "webpack.config.common.babel.js": "_f_webpack",
      "webpack.config.common.babel.cjs": "_f_webpack",
      "webpack.config.common.babel.mjs": "_f_webpack",
      "webpack.config.common.babel.coffee": "_f_webpack",
      "webpack.config.common.babel.ts": "_f_webpack",
      "webpack.config.dev.babel.js": "_f_webpack",
      "webpack.config.dev.babel.cjs": "_f_webpack",
      "webpack.config.dev.babel.mjs": "_f_webpack",
      "webpack.config.dev.babel.coffee": "_f_webpack",
      "webpack.config.dev.babel.ts": "_f_webpack",
      "webpack.config.development.babel.js": "_f_webpack",
      "webpack.config.development.babel.cjs": "_f_webpack",
      "webpack.config.development.babel.mjs": "_f_webpack",
      "webpack.config.development.babel.coffee": "_f_webpack",
      "webpack.config.development.babel.ts": "_f_webpack",
      "webpack.config.staging.babel.js": "_f_webpack",
      "webpack.config.staging.babel.cjs": "_f_webpack",
      "webpack.config.staging.babel.mjs": "_f_webpack",
      "webpack.config.staging.babel.coffee": "_f_webpack",
      "webpack.config.staging.babel.ts": "_f_webpack",
      "webpack.config.test.babel.js": "_f_webpack",
      "webpack.config.test.babel.cjs": "_f_webpack",
      "webpack.config.test.babel.mjs": "_f_webpack",
      "webpack.config.test.babel.coffee": "_f_webpack",
      "webpack.config.test.babel.ts": "_f_webpack",
      "webpack.config.prod.babel.js": "_f_webpack",
      "webpack.config.prod.babel.cjs": "_f_webpack",
      "webpack.config.prod.babel.mjs": "_f_webpack",
      "webpack.config.prod.babel.coffee": "_f_webpack",
      "webpack.config.prod.babel.ts": "_f_webpack",
      "webpack.config.production.babel.js": "_f_webpack",
      "webpack.config.production.babel.cjs": "_f_webpack",
      "webpack.config.production.babel.mjs": "_f_webpack",
      "webpack.config.production.babel.coffee": "_f_webpack",
      "webpack.config.production.babel.ts": "_f_webpack",
      "webpack.dev.js": "_f_webpack",
      "webpack.dev.cjs": "_f_webpack",
      "webpack.dev.mjs": "_f_webpack",
      "webpack.dev.coffee": "_f_webpack",
      "webpack.dev.ts": "_f_webpack",
      "webpack.dev.conf.js": "_f_webpack",
      "webpack.dev.conf.cjs": "_f_webpack",
      "webpack.dev.conf.mjs": "_f_webpack",
      "webpack.dev.conf.coffee": "_f_webpack",
      "webpack.dev.conf.ts": "_f_webpack",
      "webpack.local.js": "_f_webpack",
      "webpack.local.cjs": "_f_webpack",
      "webpack.local.mjs": "_f_webpack",
      "webpack.local.coffee": "_f_webpack",
      "webpack.local.ts": "_f_webpack",
      "webpack.prod.js": "_f_webpack",
      "webpack.prod.cjs": "_f_webpack",
      "webpack.prod.mjs": "_f_webpack",
      "webpack.prod.coffee": "_f_webpack",
      "webpack.prod.ts": "_f_webpack",
      "webpack.prod.conf.js": "_f_webpack",
      "webpack.prod.conf.cjs": "_f_webpack",
      "webpack.prod.conf.mjs": "_f_webpack",
      "webpack.prod.conf.coffee": "_f_webpack",
      "webpack.prod.conf.ts": "_f_webpack",
      "webpack.main.config.js": "_f_webpack",
      "webpack.main.config.cjs": "_f_webpack",
      "webpack.main.config.mjs": "_f_webpack",
      "webpack.main.config.coffee": "_f_webpack",
      "webpack.main.config.ts": "_f_webpack",
      "webpack.mix.js": "_f_webpack",
      "webpack.mix.cjs": "_f_webpack",
      "webpack.mix.mjs": "_f_webpack",
      "webpack.mix.coffee": "_f_webpack",
      "webpack.mix.ts": "_f_webpack",
      "webpack.plugins.js": "_f_webpack",
      "webpack.plugins.cjs": "_f_webpack",
      "webpack.plugins.mjs": "_f_webpack",
      "webpack.plugins.coffee": "_f_webpack",
      "webpack.plugins.ts": "_f_webpack",
      "webpack.renderer.config.js": "_f_webpack",
      "webpack.renderer.config.cjs": "_f_webpack",
      "webpack.renderer.config.mjs": "_f_webpack",
      "webpack.renderer.config.coffee": "_f_webpack",
      "webpack.renderer.config.ts": "_f_webpack",
      "webpack.rules.js": "_f_webpack",
      "webpack.rules.cjs": "_f_webpack",
      "webpack.rules.mjs": "_f_webpack",
      "webpack.rules.coffee": "_f_webpack",
      "webpack.rules.ts": "_f_webpack",
      "webpack.test.conf.js": "_f_webpack",
      "webpack.test.conf.cjs": "_f_webpack",
      "webpack.test.conf.mjs": "_f_webpack",
      "webpack.test.conf.coffee": "_f_webpack",
      "webpack.test.conf.ts": "_f_webpack",
      "wercker.yml": "_f_wercker",
      "windi.config.ts": "_f_windi",
      "windi.config.js": "_f_windi",
      "wpml-config.xml": "_f_wpml",
      "wxt.config.js": "_f_wxt",
      "wxt.config.cjs": "_f_wxt",
      "wxt.config.mjs": "_f_wxt",
      "wxt.config.ts": "_f_wxt",
      "wxt.config.cts": "_f_wxt",
      "wxt.config.mts": "_f_wxt",
      ".xo-config": "_f_xo",
      "xo.config.js": "_f_xo",
      "xo.config.cjs": "_f_xo",
      "xo.config.mjs": "_f_xo",
      "xo.config.ts": "_f_xo",
      "xo.config.cts": "_f_xo",
      "xo.config.mts": "_f_xo",
      ".xo-config.js": "_f_xo",
      ".xo-config.json": "_f_xo",
      ".xo-config.cjs": "_f_xo",
      ".xcompose": "_f_light_xorg",
      ".yamllint": "_f_yamllint",
      ".yaspellerrc": "_f_yandex",
      ".yaspeller.json": "_f_yandex",
      "yarn.lock": "_f_yarn",
      ".yarnrc": "_f_yarn",
      ".yarnrc.yml": "_f_yarn",
      ".yarnclean": "_f_yarn",
      ".yarn-integrity": "_f_yarn",
      ".yarn-metadata.json": "_f_yarn",
      ".yarn-state.yml": "_f_yarn",
      ".yarnignore": "_f_yarn",
      ".yo-rc.json": "_f_yeoman"
    },
    "languageIds": {
      "actionscript": "_f_actionscript",
      "ada": "_f_light_ada",
      "advpl": "_f_advpl",
      "affectscript": "_f_affectscript",
      "agda": "_f_light_agda",
      "lagda-md": "_f_light_agda",
      "lagda-rst": "_f_light_agda",
      "lagda-tex": "_f_light_agda",
      "al": "_f_al",
      "alloy": "_f_alloy",
      "ansible": "_f_ansible",
      "antlr": "_f_antlr",
      "anyscript": "_f_anyscript",
      "apacheconf": "_f_apache",
      "apex": "_f_apex",
      "apiblueprint": "_f_apib",
      "apl": "_f_light_apl",
      "applescript": "_f_applescript",
      "asciidoc": "_f_asciidoc",
      "asp": "_f_asp",
      "asp (html)": "_f_asp",
      "arm": "_f_assembly",
      "asm": "_f_assembly",
      "asm-intel-x86-generic": "_f_assembly",
      "platformio-debug.asm": "_f_platformio",
      "asm-collection": "_f_assembly",
      "astro": "_f_light_astro",
      "ats": "_f_ats",
      "ahk": "_f_autohotkey",
      "ahk2": "_f_autohotkey",
      "autoit": "_f_autoit",
      "avro": "_f_avro",
      "azcli": "_f_azure",
      "azure-pipelines": "_f_azurepipelines",
      "ballerina": "_f_ballerina",
      "bat": "_f_bat",
      "bats": "_f_bats",
      "bazel": "_f_bazel",
      "bazelrc": "_f_bazel",
      "starlark": "_f_bazel",
      "befunge": "_f_befunge",
      "befunge98": "_f_befunge",
      "bicep": "_f_bicep",
      "biml": "_f_biml",
      "code-text-binary": "_f_binary",
      "biome_syntax_tree": "_f_biome",
      "blade": "_f_blade",
      "laravel-blade": "_f_blade",
      "blitzbasic": "_f_blitzbasic",
      "bolt": "_f_bolt",
      "bosque": "_f_bosque",
      "browserslist": "_f_browserslist",
      "bruno": "_f_bruno",
      "buf": "_f_buf",
      "buf-gen": "_f_buf",
      "bun.lockb": "_f_bun",
      "c": "_f_c",
      "c3": "_f_c3",
      "c-al": "_f_c_al",
      "cabal": "_f_cabal",
      "caddyfile": "_f_caddy",
      "capnp": "_f_capnp",
      "capnproto": "_f_capnp",
      "casc": "_f_casc",
      "cddl": "_f_cddl",
      "ceylon": "_f_ceylon",
      "cfml": "_f_cf",
      "lang-cfml": "_f_cf",
      "cfc": "_f_cfc",
      "cfmhtml": "_f_cfm",
      "cookbook": "_f_chef_cookbook",
      "circom": "_f_circom",
      "clojure": "_f_clojure",
      "clojurescript": "_f_clojurescript",
      "manifest-yaml": "_f_light_cloudfoundry",
      "cmake": "_f_cmake",
      "cmake-cache": "_f_cmake",
      "cobol": "_f_cobol",
      "ql": "_f_codeql",
      "coffeescript": "_f_coffeescript",
      "java-properties": "_f_light_config",
      "properties": "_f_light_config",
      "spring-boot-properties": "_f_light_config",
      "confluence": "_f_confluence",
      "instructions": "_f_light_copilot",
      "prompt": "_f_light_copilot",
      "cpp": "_f_cpp",
      "crystal": "_f_light_crystal",
      "csharp": "_f_csharp",
      "css": "_f_css",
      "cucumber": "_f_cucumber",
      "feature": "_f_cucumber",
      "cuda": "_f_cuda",
      "cuda-cpp": "_f_cuda",
      "cython": "_f_cython",
      "dal": "_f_dal",
      "dart": "_f_dartlang",
      "debian-changelog": "_f_debian",
      "debian-control": "_f_debian",
      "debian-copyright": "_f_debian",
      "debian-upstream-metadata": "_f_debian",
      "pascal": "_f_delphi",
      "objectpascal": "_f_delphi",
      "dhall": "_f_light_dhall",
      "diff": "_f_diff",
      "django-html": "_f_django",
      "django-txt": "_f_django",
      "d": "_f_dlang",
      "dscript": "_f_dlang",
      "dml": "_f_dlang",
      "diet": "_f_dlang",
      "dockerbake": "_f_docker",
      "dockercompose": "_f_docker",
      "dockerfile": "_f_docker",
      "dotenv": "_f_dotenv",
      "env": "_f_dotenv",
      "dotjs": "_f_dotjs",
      "doxygen": "_f_doxygen",
      "drawio": "_f_drawio",
      "drools": "_f_drools",
      "dtd": "_f_dtd",
      "dustjs": "_f_dustjs",
      "dylan": "_f_dylan",
      "dylan-lid": "_f_dylan",
      "earthfile": "_f_earthly",
      "edge": "_f_edge",
      "editorconfig": "_f_editorconfig",
      "eex": "_f_eex",
      "html-eex": "_f_eex",
      "es": "_f_elastic",
      "elixir": "_f_elixir",
      "elm": "_f_elm",
      "erb": "_f_erb",
      "html.erb": "_f_erb",
      "erlang": "_f_erlang",
      "esphome": "_f_light_esphome",
      "excel": "_f_excel",
      "falcon": "_f_falcon",
      "fql": "_f_fauna",
      "fortran": "_f_fortran",
      "fortran-modern": "_f_fortran",
      "FortranFreeForm": "_f_fortran",
      "FortranFixedForm": "_f_fortran",
      "fortran_fixed-form": "_f_fortran",
      "ftl": "_f_freemarker",
      "fsharp": "_f_fsharp",
      "fthtml": "_f_fthtml",
      "galen": "_f_galen",
      "gml-gms": "_f_gamemaker",
      "gml-gms2": "_f_light_gamemaker2",
      "gml-gm81": "_f_gamemaker81",
      "gcode": "_f_gcode",
      "gdscript": "_f_gdscript",
      "genstat": "_f_genstat",
      "git-commit": "_f_git",
      "git-rebase": "_f_git",
      "ignore": "_f_git",
      "gleam": "_f_gleam",
      "glimmer-js": "_f_glimmer",
      "glimmer-ts": "_f_glimmer",
      "glsl": "_f_glsl",
      "glyphs": "_f_glyphs",
      "automake": "_f_gnu",
      "m4": "_f_gnu",
      "makefile": "_f_gnu",
      "makefile2": "_f_gnu",
      "gnuplot": "_f_gnuplot",
      "go": "_f_go",
      "go.mod": "_f_go_package",
      "go.work": "_f_go_work",
      "goctl": "_f_goctl",
      "gradle-kotlin-dsl": "_f_light_gradle",
      "grain": "_f_grain",
      "graphql": "_f_graphql",
      "dot": "_f_graphviz",
      "grit": "_f_grit",
      "groovy": "_f_groovy",
      "haml": "_f_haml",
      "handlebars": "_f_handlebars",
      "harbour": "_f_harbour",
      "hcl": "_f_light_hashicorp",
      "haskell": "_f_haskell",
      "literate haskell": "_f_haskell",
      "haxe": "_f_haxe",
      "hxml": "_f_haxe",
      "Haxe AST dump": "_f_haxe",
      "helm": "_f_helm",
      "hjson": "_f_light_hjson",
      "hlsl": "_f_hlsl",
      "home-assistant": "_f_homeassistant",
      "hosts": "_f_host",
      "html": "_f_html",
      "http": "_f_http",
      "hunspell.aff": "_f_hunspell",
      "hunspell.dic": "_f_hunspell",
      "hy": "_f_hy",
      "hypr": "_f_hypr",
      "icl": "_f_icl",
      "imba": "_f_imba",
      "4GL": "_f_informix",
      "ini": "_f_light_ini",
      "ink": "_f_ink",
      "innosetup": "_f_innosetup",
      "io": "_f_light_io",
      "iodine": "_f_iodine",
      "janet": "_f_janet",
      "java": "_f_java",
      "jekyll": "_f_jekyll",
      "jenkins": "_f_jenkins",
      "declarative": "_f_jenkins",
      "jenkinsfile": "_f_jenkins",
      "jest-snapshot": "_f_jest_snapshot",
      "jinja": "_f_jinja",
      "jinja-java": "_f_jinja",
      "jinja-html": "_f_jinja",
      "jinja-xml": "_f_jinja",
      "jinja-css": "_f_jinja",
      "jinja-json": "_f_jinja",
      "jinja-md": "_f_jinja",
      "jinja-py": "_f_jinja",
      "jinja-rb": "_f_jinja",
      "jinja-js": "_f_jinja",
      "jinja-yaml": "_f_jinja",
      "jinja-toml": "_f_jinja",
      "jinja-latex": "_f_jinja",
      "jinja-lua": "_f_jinja",
      "jinja-properties": "_f_jinja",
      "jinja-shell": "_f_jinja",
      "jinja-dockerfile": "_f_jinja",
      "jinja-sql": "_f_jinja",
      "jinja-terraform": "_f_jinja",
      "jinja-nginx": "_f_jinja",
      "jinja-groovy": "_f_jinja",
      "jinja-systemd": "_f_jinja",
      "jinja-cpp": "_f_jinja",
      "javascript": "_f_light_js",
      "json": "_f_light_json",
      "json-tmlanguage": "_f_light_json",
      "jsonc": "_f_light_json",
      "jsonl": "_f_light_json",
      "json5": "_f_light_json5",
      "jsonnet": "_f_jsonnet",
      "julia": "_f_julia",
      "juliamarkdown": "_f_julia",
      "just": "_f_just",
      "k": "_f_k",
      "kivy": "_f_kivy",
      "kos": "_f_kos",
      "kotlin": "_f_kotlin",
      "kotlinscript": "_f_kotlin",
      "kusto": "_f_kusto",
      "lark": "_f_light_lark",
      "latino": "_f_latino",
      "lean4": "_f_light_lean",
      "lean4markdown": "_f_light_lean",
      "less": "_f_less",
      "lex": "_f_lex",
      "lilypond": "_f_lilypond",
      "lisp": "_f_lisp",
      "autolisp": "_f_lisp",
      "autolispdcl": "_f_lisp",
      "log": "_f_log",
      "lolcode": "_f_lolcode",
      "lsl": "_f_lsl",
      "lua": "_f_lua",
      "markdown": "_f_markdown",
      "marko": "_f_marko",
      "matlab": "_f_matlab",
      "maxscript": "_f_maxscript",
      "mel": "_f_maya",
      "mdx": "_f_light_mdx",
      "mediawiki": "_f_mediawiki",
      "mermaid": "_f_mermaid",
      "meson": "_f_meson",
      "metal": "_f_metal",
      "bc-mcfunction": "_f_minecraft",
      "bc-minecraft-language": "_f_minecraft",
      "bc-minecraft-molang": "_f_minecraft",
      "bc-minecraft-project": "_f_minecraft",
      "mcdoc": "_f_minecraft",
      "mcfunction": "_f_minecraft",
      "mcmeta": "_f_minecraft",
      "mcscript": "_f_minecraft",
      "minecraft-lang": "_f_minecraft",
      "options-txt": "_f_minecraft",
      "snbt": "_f_minecraft",
      "mv": "_f_mivascript",
      "mjml": "_f_mjml",
      "powerquery": "_f_light_mlang",
      "mojo": "_f_mojo",
      "mojolicious": "_f_mojolicious",
      "mongo": "_f_mongo",
      "mson": "_f_mson",
      "mvt": "_f_mvt",
      "mvtcss": "_f_mvtcss",
      "mvtjs": "_f_mvtjs",
      "nearley": "_f_nearly",
      "cypher": "_f_light_neo4j",
      "nginx": "_f_nginx",
      "nim": "_f_nim",
      "nimble": "_f_nimble",
      "nix": "_f_nix",
      "nsis": "_f_nsi",
      "nfl": "_f_nsi",
      "nsl": "_f_nsi",
      "bridlensis": "_f_nsi",
      "nunjucks": "_f_nunjucks",
      "nushell": "_f_nushell",
      "objective-c": "_f_objectivec",
      "objective-cpp": "_f_objectivecpp",
      "ocaml": "_f_ocaml",
      "ocamllex": "_f_ocaml",
      "menhir": "_f_ocaml",
      "ogone": "_f_ogone",
      "openhab": "_f_light_openHAB",
      "scad": "_f_openscad",
      "org": "_f_org",
      "pddl": "_f_pddl",
      "happenings": "_f_pddl_happenings",
      "plan": "_f_pddl_plan",
      "perl": "_f_perl",
      "perl6": "_f_perl6",
      "pgsql": "_f_pgsql",
      "php": "_f_php",
      "pine": "_f_pine",
      "pinescript": "_f_pine",
      "pip-requirements": "_f_pip",
      "platformio-debug.disassembly": "_f_platformio",
      "platformio-debug.memoryview": "_f_platformio",
      "plsql": "_f_plsql",
      "oracle": "_f_plsql",
      "oraclesql": "_f_plsql",
      "oracle-sql": "_f_plsql",
      "po": "_f_poedit",
      "polyglot-notebook": "_f_polyglot",
      "polymer": "_f_polymer",
      "pony": "_f_pony",
      "postcss": "_f_postcss",
      "postscript": "_f_postscript",
      "powershell": "_f_powershell",
      "prisma": "_f_light_prisma",
      "pde": "_f_processinglang",
      "abl": "_f_progress",
      "prolog": "_f_prolog",
      "prometheus": "_f_prometheus",
      "proto3": "_f_protobuf",
      "proto": "_f_protobuf",
      "prototext": "_f_protobuf",
      "jade": "_f_pug",
      "puppet": "_f_puppet",
      "purescript": "_f_light_purescript",
      "pyret": "_f_pyret",
      "pyscript": "_f_pyscript",
      "python": "_f_python",
      "pythowo": "_f_pythowo",
      "qlik": "_f_qlikview",
      "qml": "_f_qml",
      "qsharp": "_f_qsharp",
      "r": "_f_r",
      "ra_syntax_tree": "_f_ra_syntax_tree",
      "racket": "_f_racket",
      "raku": "_f_light_raku",
      "raml": "_f_raml",
      "razor": "_f_razor",
      "aspnetcorerazor": "_f_razor",
      "javascriptreact": "_f_reactjs",
      "typescriptreact": "_f_reactts",
      "reason": "_f_reason",
      "red": "_f_red",
      "rescript": "_f_rescript",
      "restructuredtext": "_f_rest",
      "rexx": "_f_rexx",
      "riot": "_f_riot",
      "ripple": "_f_ripple",
      "rmd": "_f_rmd",
      "rnc": "_f_rnc",
      "robot": "_f_robotframework",
      "robots-txt": "_f_robots",
      "ruby": "_f_ruby",
      "rust": "_f_light_rust",
      "s-lang": "_f_s-lang",
      "san": "_f_san",
      "SAS": "_f_sas",
      "sass": "_f_sass",
      "sass.hover": "_f_sass",
      "sbt": "_f_sbt",
      "scala": "_f_scala",
      "scilab": "_f_scilab",
      "vbscript": "_f_script",
      "scss": "_f_scss",
      "sdl": "_f_sdlang",
      "search-result": "_f_search_result",
      "shaderlab": "_f_light_shaderlab",
      "shellscript": "_f_shell",
      "silverstripe": "_f_silverstripe",
      "sino": "_f_sino",
      "eskip": "_f_skipper",
      "slang": "_f_slang",
      "slice": "_f_slice",
      "slim": "_f_slim",
      "slint": "_f_slint",
      "sln": "_f_sln",
      "smarty": "_f_smarty",
      "snakemake": "_f_snakemake",
      "snort": "_f_snort",
      "solidity": "_f_light_solidity",
      "sparql": "_f_sparql",
      "sqf": "_f_sqf",
      "sql": "_f_sql",
      "squirrel": "_f_squirrel",
      "stan": "_f_stan",
      "stata": "_f_stata",
      "stencil": "_f_stencil",
      "stencil-html": "_f_stencil",
      "stylable": "_f_stylable",
      "source.css.styled": "_f_styled",
      "stylus": "_f_light_stylus",
      "svelte": "_f_svelte",
      "svg": "_f_svg",
      "Swagger": "_f_swagger",
      "swagger": "_f_swagger",
      "swift": "_f_swift",
      "swig": "_f_swig",
      "systemd-conf": "_f_light_systemd",
      "systemd-unit-file": "_f_light_systemd",
      "systemverilog": "_f_light_systemverilog",
      "t4": "_f_t4tt",
      "tailwindcss": "_f_tailwind",
      "teal": "_f_teal",
      "templ": "_f_templ",
      "tera": "_f_tera",
      "terraform": "_f_terraform",
      "tex": "_f_light_tex",
      "latex": "_f_light_tex",
      "bibtex": "_f_light_tex",
      "doctex": "_f_light_tex",
      "csv": "_f_text",
      "csv (pipe)": "_f_text",
      "csv (semicolon)": "_f_text",
      "csv (whitespace)": "_f_text",
      "dynamic csv": "_f_text",
      "tsv": "_f_text",
      "plaintext": "_f_text",
      "vim-help": "_f_text",
      "textile": "_f_textile",
      "tiltfile": "_f_tiltfile",
      "toit": "_f_light_toit",
      "toml": "_f_light_toml",
      "toon": "_f_light_toon",
      "tt": "_f_tt",
      "ttcn": "_f_ttcn",
      "tuc": "_f_tuc",
      "twig": "_f_twig",
      "typescript": "_f_typescript",
      "typoscript": "_f_typo3",
      "uiua": "_f_uiua",
      "unison": "_f_unison",
      "vb": "_f_vb",
      "vba": "_f_vba",
      "velocity": "_f_velocity",
      "vento": "_f_vento",
      "verilog": "_f_verilog",
      "vhdl": "_f_vhdl",
      "viml": "_f_vim",
      "vim-snippet": "_f_vim",
      "vitest-snapshot": "_f_light_vitest",
      "v": "_f_vlang",
      "volt": "_f_volt",
      "vroom": "_f_vroom",
      "snippets": "_f_vscode",
      "vue": "_f_vue",
      "vyper": "_f_vyper",
      "wasm": "_f_wasm",
      "wat": "_f_wasm",
      "wenyan": "_f_wenyan",
      "wgsl": "_f_wgsl",
      "wikitext": "_f_wikitext",
      "wai": "_f_wit",
      "wolfram": "_f_wolfram",
      "wurstlang": "_f_wurst",
      "wurst": "_f_wurst",
      "xmake": "_f_xmake",
      "xml": "_f_xml",
      "xcompose": "_f_light_xorg",
      "xquery": "_f_xquery",
      "xsl": "_f_xsl",
      "xslt": "_f_xsl",
      "yacc": "_f_yacc",
      "yaml": "_f_light_yaml",
      "yaml-tmlanguage": "_f_light_yaml",
      "spring-boot-properties-yaml": "_f_light_yaml",
      "yang": "_f_yang",
      "yarnlock": "_f_yarn",
      "zig": "_f_zig",
      "zip": "_f_zip"
    }
  },
  "hidesExplorerArrows": false
}
